import React from 'react';
import FooterWrapper from '../components/FooterWrapper';


const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-black-pure flex flex-col overflow-hidden">
      
      <section className="relative z-10 bg-black-pure pt-32 pb-24 px-4 text-[#787c87] max-w-6xl mx-auto w-full">
        <>
            <h1 className="font-geist text-white text-[24px] font-normal mb-8">DATENSCHUTZERKLÄRUNG</h1>
            <h2 className="font-geist text-white text-[20px] font-normal mb-8">Inhaltsverzeichnis</h2>
            <ul>
                <li>
                <a href="#einleitung-ueberblick">Einleitung und Überblick</a>
                </li>
                <li>
                <a href="#anwendungsbereich">Anwendungsbereich</a>
                </li>
                <li>
                <a href="#rechtsgrundlagen">Rechtsgrundlagen</a>
                </li>
                <li>
                <a href="#kontaktdaten-verantwortliche">
                    Kontaktdaten des Verantwortlichen
                </a>
                </li>
                <li>
                <a href="#speicherdauer">Speicherdauer</a>
                </li>
                <li>
                <a href="#rechte-dsgvo">Rechte laut Datenschutz-Grundverordnung</a>
                </li>
                <li>
                <a href="#datenuebertragung-drittlaender">
                    Datenübertragung in Drittländer
                </a>
                </li>
                <li>
                <a href="#sicherheit-datenverarbeitung">
                    Sicherheit der Datenverarbeitung
                </a>
                </li>
                <li>
                <a href="#kommunikation">Kommunikation</a>
                </li>
                <li>
                <a href="#auftragsverarbeitungsvertrag-avv">
                    Auftragsverarbeitungsvertrag (AVV)
                </a>
                </li>
                <li>
                <a href="#cookies">Cookies</a>
                </li>
                <li>
                <a href="#webhosting-einleitung">Webhosting Einleitung</a>
                </li>
                <li>
                <a href="#website-baukastensysteme-einleitung">
                    Website Baukastensysteme Einleitung
                </a>
                </li>
                <li>
                <a href="#web-analytics-einleitung">Web Analytics Einleitung</a>
                </li>
                <li>
                <a href="#e-mail-marketing-einleitung">E-Mail-Marketing Einleitung</a>
                </li>
                <li>
                <a href="#push-nachrichten-einleitung">Push-Nachrichten Einleitung</a>
                </li>
                <li>
                <a href="#messenger-kommunikation-einleitung">
                    Messenger &amp; Kommunikation Einleitung
                </a>
                </li>
                <li>
                <a href="#chatbots-einleitung">Chatbots Einleitung</a>
                </li>
                <li>
                <a href="#social-media-einleitung">Social Media Einleitung</a>
                </li>
                <li>
                <a href="#blogs-und-publikationsmedien-einleitung">
                    Blogs und Publikationsmedien Einleitung
                </a>
                </li>
                <li>
                <a href="#online-marketing-einleitung">Online-Marketing Einleitung</a>
                </li>
                <li>
                <a href="#content-delivery-networks-einleitung">
                    Content Delivery Networks Einleitung
                </a>
                </li>
                <li>
                <a href="#cookie-consent-management-platform-einleitung">
                    Cookie Consent Management Platform Einleitung
                </a>
                </li>
                <li>
                <a href="#security-anti-spam">Security &amp; Anti-Spam</a>
                </li>
                <li>
                <a href="#cloud-dienste">Cloud-Dienste</a>
                </li>
                <li>
                <a href="#zahlungsanbieter-einleitung">Zahlungsanbieter Einleitung</a>
                </li>
                <li>
                <a href="#externe-onlineplattformen-einleitung">
                    Externe Onlineplattformen Einleitung
                </a>
                </li>
                <li>
                <a href="#audio-video-einleitung">Audio &amp; Video Einleitung</a>
                </li>
                <li>
                <a href="#videokonferenzen-streaming-einleitung">
                    Videokonferenzen &amp; Streaming Einleitung
                </a>
                </li>
                <li>
                <a href="#recruiting-tools-einleitung">Recruiting Tools Einleitung</a>
                </li>
                <li>
                <a href="#single-sign-on-anmeldungen-einleitung">
                    Single-Sign-On-Anmeldungen Einleitung
                </a>
                </li>
                <li>
                <a href="#umfrage-und-befragungssysteme-einleitung">
                    Umfrage- und Befragungssysteme Einleitung
                </a>
                </li>
                <li>
                <a href="#bewertungsplattformen-einleitung">
                    Bewertungsplattformen Einleitung
                </a>
                </li>
                <li>
                <a href="#webdesign-einleitung">Webdesign Einleitung</a>
                </li>
                <li>
                <a href="#content-suchanbieter-einleitung">
                    Content-Suchanbieter Einleitung
                </a>
                </li>
                <li>
                <a href="#online-buchungssysteme-einleitung">
                    Online-Buchungssysteme Einleitung
                </a>
                </li>
                <li>
                <a href="#sonstiges-einleitung">Sonstiges Einleitung</a>
                </li>
                <li>
                <a href="#erklaerung-verwendeter-begriffe">
                    Erklärung verwendeter Begriffe
                </a>
                </li>
                <li>
                <a href="#schlusswort">Schlusswort</a>
                </li>
            </ul>
            <h2 id="einleitung-ueberblick" className="adsimple-112958647 text-white text-2xl font-semibold mt-12 mb-6">
                Einleitung und Überblick
            </h2>
            <p>
                Wir haben diese Datenschutzerklärung (Fassung 05.03.2025-112958647)
                verfasst, um Ihnen gemäß der Vorgaben der{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=112958647#d1e2269-1-1"
                target="_blank"
                rel="noopener"
                >
                Datenschutz-Grundverordnung (EU) 2016/679
                </a>{" "}
                und anwendbaren nationalen Gesetzen zu erklären, welche personenbezogenen
                Daten (kurz Daten) wir als Verantwortliche – und die von uns beauftragten
                Auftragsverarbeiter (z. B. Provider) – verarbeiten, zukünftig verarbeiten
                werden und welche rechtmäßigen Möglichkeiten Sie haben. Die verwendeten
                Begriffe sind geschlechtsneutral zu verstehen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Kurz gesagt:</strong> Wir informieren
                Sie umfassend über Daten, die wir über Sie verarbeiten.
            </p>
            <p>
                Datenschutzerklärungen klingen für gewöhnlich sehr technisch und verwenden
                juristische Fachbegriffe. Diese Datenschutzerklärung soll Ihnen hingegen die
                wichtigsten Dinge so einfach und transparent wie möglich beschreiben. Soweit
                es der Transparenz förderlich ist, werden technische{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Begriffe leserfreundlich erklärt
                </strong>
                , Links zu weiterführenden Informationen geboten und{" "}
                <strong className="adsimple-112958647 text-[#787c87]">Grafiken</strong> zum Einsatz
                gebracht. Wir informieren damit in klarer und einfacher Sprache, dass wir im
                Rahmen unserer Geschäftstätigkeiten nur dann personenbezogene Daten
                verarbeiten, wenn eine entsprechende gesetzliche Grundlage gegeben ist. Das
                ist sicher nicht möglich, wenn man möglichst knappe, unklare und
                juristisch-technische Erklärungen abgibt, so wie sie im Internet oft
                Standard sind, wenn es um Datenschutz geht. Ich hoffe, Sie finden die
                folgenden Erläuterungen interessant und informativ und vielleicht ist die
                eine oder andere Information dabei, die Sie noch nicht kannten.
                <br />
                Wenn trotzdem Fragen bleiben, möchten wir Sie bitten, sich an die unten bzw.
                im Impressum genannte verantwortliche Stelle zu wenden, den vorhandenen
                Links zu folgen und sich weitere Informationen auf Drittseiten anzusehen.
                Unsere Kontaktdaten finden Sie selbstverständlich auch im Impressum.
            </p>
            <h2 id="anwendungsbereich" className="adsimple-112958647">
                Anwendungsbereich
            </h2>
            <p>
                Diese Datenschutzerklärung gilt für alle von uns im Unternehmen
                verarbeiteten personenbezogenen Daten und für alle personenbezogenen Daten,
                die von uns beauftragte Firmen (Auftragsverarbeiter) verarbeiten. Mit
                personenbezogenen Daten meinen wir Informationen im Sinne des Art. 4 Nr. 1
                DSGVO wie zum Beispiel Name, E-Mail-Adresse und postalische Anschrift einer
                Person. Die Verarbeitung personenbezogener Daten sorgt dafür, dass wir
                unsere Dienstleistungen und Produkte anbieten und abrechnen können, sei es
                online oder offline. Der Anwendungsbereich dieser Datenschutzerklärung
                umfasst:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                alle Onlineauftritte (Websites, Onlineshops), die wir betreiben
                </li>
                <li className="adsimple-112958647">
                Social Media Auftritte und E-Mail-Kommunikation
                </li>
                <li className="adsimple-112958647">
                mobile Apps für Smartphones und andere Geräte
                </li>
            </ul>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Kurz gesagt:</strong> Die
                Datenschutzerklärung gilt für alle Bereiche, in denen personenbezogene Daten
                im Unternehmen über die genannten Kanäle strukturiert verarbeitet werden.
                Sollten wir außerhalb dieser Kanäle mit Ihnen in Rechtsbeziehungen
                eintreten, werden wir Sie gegebenenfalls gesondert informieren.
            </p>
            <h2 id="rechtsgrundlagen" className="adsimple-112958647">
                Rechtsgrundlagen
            </h2>
            <p>
                In der folgenden Datenschutzerklärung geben wir Ihnen transparente
                Informationen zu den rechtlichen Grundsätzen und Vorschriften, also den
                Rechtsgrundlagen der Datenschutz-Grundverordnung, die uns ermöglichen,
                personenbezogene Daten zu verarbeiten.
                <br />
                Was das EU-Recht betrifft, beziehen wir uns auf die VERORDNUNG (EU) 2016/679
                DES EUROPÄISCHEN PARLAMENTS UND DES RATES vom 27. April 2016. Diese
                Datenschutz-Grundverordnung der EU können Sie selbstverständlich online auf
                EUR-Lex, dem Zugang zum EU-Recht, unter{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679"
                >
                https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679
                </a>
                nachlesen.
            </p>
            <p>
                Wir verarbeiten Ihre Daten nur, wenn mindestens eine der folgenden
                Bedingungen zutrifft:
            </p>
            <ol>
                <li className="adsimple-112958647">
                <strong className="adsimple-112958647 text-[#787c87]">Einwilligung</strong> (Artikel 6
                Absatz 1 lit. a DSGVO): Sie haben uns Ihre Einwilligung gegeben, Daten zu
                einem bestimmten Zweck zu verarbeiten. Ein Beispiel wäre die Speicherung
                Ihrer eingegebenen Daten eines Kontaktformulars.
                </li>
                <li className="adsimple-112958647">
                <strong className="adsimple-112958647 text-[#787c87]">Vertrag</strong> (Artikel 6 Absatz
                1 lit. b DSGVO): Um einen Vertrag oder vorvertragliche Verpflichtungen mit
                Ihnen zu erfüllen, verarbeiten wir Ihre Daten. Wenn wir zum Beispiel einen
                Kaufvertrag mit Ihnen abschließen, benötigen wir vorab personenbezogene
                Informationen.
                </li>
                <li className="adsimple-112958647">
                <strong className="adsimple-112958647 text-[#787c87]">Rechtliche Verpflichtung</strong>{" "}
                (Artikel 6 Absatz 1 lit. c DSGVO): Wenn wir einer rechtlichen
                Verpflichtung unterliegen, verarbeiten wir Ihre Daten. Zum Beispiel sind
                wir gesetzlich verpflichtet Rechnungen für die Buchhaltung aufzuheben.
                Diese enthalten in der Regel personenbezogene Daten.
                </li>
                <li className="adsimple-112958647">
                <strong className="adsimple-112958647 text-[#787c87]">Berechtigte Interessen</strong>{" "}
                (Artikel 6 Absatz 1 lit. f DSGVO): Im Falle berechtigter Interessen, die
                Ihre Grundrechte nicht einschränken, behalten wir uns die Verarbeitung
                personenbezogener Daten vor. Wir müssen zum Beispiel gewisse Daten
                verarbeiten, um unsere Website sicher und wirtschaftlich effizient
                betreiben zu können. Diese Verarbeitung ist somit ein berechtigtes
                Interesse.
                </li>
            </ol>
            <p>
                Weitere Bedingungen wie die Wahrnehmung von Aufnahmen im öffentlichen
                Interesse und Ausübung öffentlicher Gewalt sowie dem Schutz lebenswichtiger
                Interessen treten bei uns in der Regel nicht auf. Soweit eine solche
                Rechtsgrundlage doch einschlägig sein sollte, wird diese an der
                entsprechenden Stelle ausgewiesen.
            </p>
            <p>Zusätzlich zu der EU-Verordnung gelten auch noch nationale Gesetze:</p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                In <strong className="adsimple-112958647">Österreich</strong> ist dies das
                Bundesgesetz zum Schutz natürlicher Personen bei der Verarbeitung
                personenbezogener Daten (
                <strong className="adsimple-112958647 text-[#787c87]">Datenschutzgesetz</strong>), kurz{" "}
                <strong className="adsimple-112958647 text-[#787c87]">DSG</strong>.
                </li>
                <li className="adsimple-112958647">
                In <strong className="adsimple-112958647">Deutschland</strong> gilt das{" "}
                <strong className="adsimple-112958647 text-[#787c87]">Bundesdatenschutzgesetz</strong>,
                kurz<strong className="adsimple-112958647">BDSG</strong>.
                </li>
            </ul>
            <p>
                Sofern weitere regionale oder nationale Gesetze zur Anwendung kommen,
                informieren wir Sie in den folgenden Abschnitten darüber.
            </p>
            <h2 id="kontaktdaten-verantwortliche" className="adsimple-112958647">
                Kontaktdaten des Verantwortlichen
            </h2>
            <p>
                Sollten Sie Fragen zum Datenschutz oder zur Verarbeitung personenbezogener
                Daten haben, finden Sie nachfolgend die Kontaktdaten des Verantwortlichen
                gemäß Artikel 4 Absatz 7 EU-Datenschutz-Grundverordnung (DSGVO):
                <br />
                <span className="adsimple-112958647" style={{ fontWeight: 400 }}>
                Philipp Fuchs
                <br />
                Heinrich-Casper-Gasse 29/9
                <br />
                8010 Graz
                <br />
                Österreich
                </span>
            </p>
            <p>
                E-Mail: <a href="mailto:hello@blcks.at">hello@blcks.at</a>
            </p>
            <p>
                Impressum:{" "}
                <a href="https://www.blcks.at/impressum/">
                https://www.blcks.at/impressum/
                </a>
            </p>
            <h2 id="speicherdauer" className="adsimple-112958647">
                Speicherdauer
            </h2>
            <p>
                Dass wir personenbezogene Daten nur so lange speichern, wie es für die
                Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig
                ist, gilt als generelles Kriterium bei uns. Das bedeutet, dass wir
                personenbezogene Daten löschen, sobald der Grund für die Datenverarbeitung
                nicht mehr vorhanden ist. In einigen Fällen sind wir gesetzlich dazu
                verpflichtet, bestimmte Daten auch nach Wegfall des ursprüngliches Zwecks zu
                speichern, zum Beispiel zu Zwecken der Buchführung.
            </p>
            <p>
                Sollten Sie die Löschung Ihrer Daten wünschen oder die Einwilligung zur
                Datenverarbeitung widerrufen, werden die Daten so rasch wie möglich und
                soweit keine Pflicht zur Speicherung besteht, gelöscht.
            </p>
            <p>
                Über die konkrete Dauer der jeweiligen Datenverarbeitung informieren wir Sie
                weiter unten, sofern wir weitere Informationen dazu haben.
            </p>
            <h2 id="rechte-dsgvo" className="adsimple-112958647">
                Rechte laut Datenschutz-Grundverordnung
            </h2>
            <p>
                Gemäß Artikel 13, 14 DSGVO informieren wir Sie über die folgenden Rechte,
                die Ihnen zustehen, damit es zu einer fairen und transparenten Verarbeitung
                von Daten kommt:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                Sie haben laut Artikel 15 DSGVO ein Auskunftsrecht darüber, ob wir Daten
                von Ihnen verarbeiten. Sollte das zutreffen, haben Sie Recht darauf eine
                Kopie der Daten zu erhalten und die folgenden Informationen zu erfahren:
                <ul className="adsimple-112958647">
                    <li className="adsimple-112958647">
                    zu welchem Zweck wir die Verarbeitung durchführen;
                    </li>
                    <li className="adsimple-112958647">
                    die Kategorien, also die Arten von Daten, die verarbeitet werden;
                    </li>
                    <li className="adsimple-112958647">
                    wer diese Daten erhält und wenn die Daten an Drittländer übermittelt
                    werden, wie die Sicherheit garantiert werden kann;
                    </li>
                    <li className="adsimple-112958647">
                    wie lange die Daten gespeichert werden;
                    </li>
                    <li className="adsimple-112958647">
                    das Bestehen des Rechts auf Berichtigung, Löschung oder Einschränkung
                    der Verarbeitung und dem Widerspruchsrecht gegen die Verarbeitung;
                    </li>
                    <li className="adsimple-112958647">
                    dass Sie sich bei einer Aufsichtsbehörde beschweren können (Links zu
                    diesen Behörden finden Sie weiter unten);
                    </li>
                    <li className="adsimple-112958647">
                    die Herkunft der Daten, wenn wir sie nicht bei Ihnen erhoben haben;
                    </li>
                    <li className="adsimple-112958647">
                    ob Profiling durchgeführt wird, ob also Daten automatisch ausgewertet
                    werden, um zu einem persönlichen Profil von Ihnen zu gelangen.
                    </li>
                </ul>
                </li>
                <li className="adsimple-112958647">
                Sie haben laut Artikel 16 DSGVO ein Recht auf Berichtigung der Daten, was
                bedeutet, dass wir Daten richtig stellen müssen, falls Sie Fehler finden.
                </li>
                <li className="adsimple-112958647">
                Sie haben laut Artikel 17 DSGVO das Recht auf Löschung („Recht auf
                Vergessenwerden“), was konkret bedeutet, dass Sie die Löschung Ihrer Daten
                verlangen dürfen.
                </li>
                <li className="adsimple-112958647">
                Sie haben laut Artikel 18 DSGVO das Recht auf Einschränkung der
                Verarbeitung, was bedeutet, dass wir die Daten nur mehr speichern dürfen
                aber nicht weiter verwenden.
                </li>
                <li className="adsimple-112958647">
                Sie haben laut Artikel 20 DSGVO das Recht auf Datenübertragbarkeit, was
                bedeutet, dass wir Ihnen auf Anfrage Ihre Daten in einem gängigen Format
                zur Verfügung stellen.
                </li>
                <li className="adsimple-112958647">
                Sie haben laut Artikel 21 DSGVO ein Widerspruchsrecht, welches nach
                Durchsetzung eine Änderung der Verarbeitung mit sich bringt.
                <ul className="adsimple-112958647">
                    <li className="adsimple-112958647">
                    Wenn die Verarbeitung Ihrer Daten auf Artikel 6 Abs. 1 lit. e
                    (öffentliches Interesse, Ausübung öffentlicher Gewalt) oder Artikel 6
                    Abs. 1 lit. f (berechtigtes Interesse) basiert, können Sie gegen die
                    Verarbeitung Widerspruch einlegen. Wir prüfen danach so rasch wie
                    möglich, ob wir diesem Widerspruch rechtlich nachkommen können.
                    </li>
                    <li className="adsimple-112958647">
                    Werden Daten verwendet, um Direktwerbung zu betreiben, können Sie
                    jederzeit gegen diese Art der Datenverarbeitung widersprechen. Wir
                    dürfen Ihre Daten danach nicht mehr für Direktmarketing verwenden.
                    </li>
                    <li className="adsimple-112958647">
                    Werden Daten verwendet, um Profiling zu betreiben, können Sie
                    jederzeit gegen diese Art der Datenverarbeitung widersprechen. Wir
                    dürfen Ihre Daten danach nicht mehr für Profiling verwenden.
                    </li>
                </ul>
                </li>
                <li className="adsimple-112958647">
                Sie haben laut Artikel 22 DSGVO unter Umständen das Recht, nicht einer
                ausschließlich auf einer automatisierten Verarbeitung (zum Beispiel
                Profiling) beruhenden Entscheidung unterworfen zu werden.
                </li>
                <li className="adsimple-112958647">
                Sie haben laut Artikel 77 DSGVO das Recht auf Beschwerde. Das heißt, Sie
                können sich jederzeit bei der Datenschutzbehörde beschweren, wenn Sie der
                Meinung sind, dass die Datenverarbeitung von personenbezogenen Daten gegen
                die DSGVO verstößt.
                </li>
            </ul>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Kurz gesagt:</strong> Sie haben
                Rechte – zögern Sie nicht, die oben gelistete verantwortliche Stelle bei uns
                zu kontaktieren!
            </p>
            <p>
                Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das
                Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche in
                sonst einer Weise verletzt worden sind, können Sie sich bei der
                Aufsichtsbehörde beschweren. Diese ist für Österreich die
                Datenschutzbehörde, deren Website Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.dsb.gv.at/?tid=112958647"
                target="_blank"
                rel="noopener"
                >
                https://www.dsb.gv.at/
                </a>{" "}
                finden. In Deutschland gibt es für jedes Bundesland einen
                Datenschutzbeauftragten. Für nähere Informationen können Sie sich an die{" "}
                <a
                className="adsimple-112958647"
                href="https://www.bfdi.bund.de/DE/Home/home_node.html"
                target="_blank"
                rel="noopener"
                >
                Bundesbeauftragte für den Datenschutz und die Informationsfreiheit (BfDI)
                </a>{" "}
                wenden. Für unser Unternehmen ist die folgende lokale Datenschutzbehörde
                zuständig:
            </p>
            <h2 id="oesterreich-datenschutzbehoerde" className="adsimple-112958647">
                Österreich Datenschutzbehörde
            </h2>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Leiter: </strong>Dr. Matthias Schmidl
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                Adresse:{" "}
                </strong>
                Barichgasse 40-42, 1030 Wien
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                Telefonnr.:{" "}
                </strong>
                +43 1 52&nbsp;152-0
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                E-Mail-Adresse:{" "}
                </strong>
                <a
                className="adsimple-112958647"
                href="mailto:dsb@dsb.gv.at"
                target="_blank"
                rel="noopener"
                >
                dsb@dsb.gv.at
                </a>
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                Website:{" "}
                </strong>
                <a
                className="adsimple-112958647"
                href="https://www.dsb.gv.at/"
                target="_blank"
                rel="noopener"
                >
                https://www.dsb.gv.at/
                </a>
            </p>
            <h2 id="datenuebertragung-drittlaender" className="adsimple-112958647">
                Datenübertragung in Drittländer
            </h2>
            <p>
                Wir übertragen oder verarbeiten Daten nur dann in Länder außerhalb des
                Geltungsbereichs der DSGVO (Drittländer), wenn Sie in diese Verarbeitung
                einwilligen oder eine sonstige gesetzliche Erlaubnis besteht. Dies trifft
                insbesondere zu, wenn die Verarbeitung gesetzlich vorgeschrieben oder zur
                Erfüllung eines Vertragsverhältnisses notwendig und in jedem Fall nur soweit
                dies generell erlaubt ist. Ihre Zustimmung ist in den meisten Fällen der
                wichtigste Grund, dass wir Daten in Drittländern verarbeiten lassen. Die
                Verarbeitung personenbezogener Daten in Drittländern wie den USA, wo viele
                Softwarehersteller Dienstleistungen anbieten und Ihre Serverstandorte haben,
                kann bedeuten, dass personenbezogene Daten auf unerwartete Weise verarbeitet
                und gespeichert werden.
            </p>
            <p>
                Wir weisen ausdrücklich darauf hin, dass nach Meinung des Europäischen
                Gerichtshofs derzeit nur dann ein angemessenes Schutzniveau für den
                Datentransfer in die USA besteht, wenn ein US-Unternehmen, das
                personenbezogene Daten von EU-Bürgern in den USA verarbeitet, aktiver
                Teilnehmer des EU-US Data Privacy Frameworks ist. Mehr Informationen dazu
                finden Sie unter:{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
            </p>
            <p>
                Die Datenverarbeitung durch US-Dienste, die nicht aktive Teilnehmer des
                EU-US Data Privacy Frameworks sind, kann dazu führen, dass gegebenenfalls
                Daten nicht anonymisiert verarbeitet und gespeichert werden. Ferner können
                gegebenenfalls US-amerikanische staatliche Behörden Zugriff auf einzelne
                Daten nehmen. Zudem kann es vorkommen, dass erhobene Daten mit Daten aus
                anderen Diensten desselben Anbieters, sofern Sie ein entsprechendes
                Nutzerkonto haben, verknüpft werden. Nach Möglichkeit versuchen wir
                Serverstandorte innerhalb der EU zu nutzen, sofern das angeboten wird.
                <br />
                Wir informieren Sie an den passenden Stellen dieser Datenschutzerklärung
                genauer über Datenübertragung in Drittländer, sofern diese zutrifft.
            </p>
            <h2 id="sicherheit-datenverarbeitung" className="adsimple-112958647">
                Sicherheit der Datenverarbeitung
            </h2>
            <p>
                Um personenbezogene Daten zu schützen, haben wir sowohl technische als auch
                organisatorische Maßnahmen umgesetzt. Wo es uns möglich ist, verschlüsseln
                oder pseudonymisieren wir personenbezogene Daten. Dadurch machen wir es im
                Rahmen unserer Möglichkeiten so schwer wie möglich, dass Dritte aus unseren
                Daten auf persönliche Informationen schließen können.
            </p>
            <p>
                Art. 25 DSGVO spricht hier von “Datenschutz durch Technikgestaltung und
                durch datenschutzfreundliche Voreinstellungen” und meint damit, dass man
                sowohl bei Software (z. B. Formularen) also auch Hardware (z. B. Zugang zum
                Serverraum) immer an Sicherheit denkt und entsprechende Maßnahmen setzt. Im
                Folgenden gehen wir, falls erforderlich, noch auf konkrete Maßnahmen ein.
            </p>
            <h2 id="tls-verschluesselung-https" className="adsimple-112958647">
                TLS-Verschlüsselung mit https
            </h2>
            <p>
                TLS, Verschlüsselung und https klingen sehr technisch und sind es auch. Wir
                verwenden HTTPS (das Hypertext Transfer Protocol Secure steht für „sicheres
                Hypertext-Übertragungsprotokoll“), um Daten abhörsicher im Internet zu
                übertragen.
                <br />
                Das bedeutet, dass die komplette Übertragung aller Daten von Ihrem Browser
                zu unserem Webserver abgesichert ist – niemand kann “mithören”.
            </p>
            <p>
                Damit haben wir eine zusätzliche Sicherheitsschicht eingeführt und erfüllen
                den Datenschutz durch Technikgestaltung (
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=112958647"
                target="_blank"
                rel="noopener"
                >
                Artikel 25 Absatz 1 DSGVO
                </a>
                ). Durch den Einsatz von TLS (Transport Layer Security), einem
                Verschlüsselungsprotokoll zur sicheren Datenübertragung im Internet, können
                wir den Schutz vertraulicher Daten sicherstellen.
                <br />
                Sie erkennen die Benutzung dieser Absicherung der Datenübertragung am
                kleinen Schlosssymbol{" "}
                <img
                role="img"
                src="https://www.adsimple.at/wp-content/uploads/2018/03/schlosssymbol-https.svg"
                width={17}
                height={18}
                />{" "}
                links oben im Browser, links von der Internetadresse (z. B.
                beispielseite.de) und der Verwendung des Schemas https (anstatt http) als
                Teil unserer Internetadresse.
                <br />
                Wenn Sie mehr zum Thema Verschlüsselung wissen möchten, empfehlen wir die
                Google Suche nach “Hypertext Transfer Protocol Secure wiki” um gute Links zu
                weiterführenden Informationen zu erhalten.
            </p>
            <h2 id="kommunikation" className="adsimple-112958647">
                Kommunikation
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Kommunikation Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Alle, die mit uns per Telefon, E-Mail oder
                    Online-Formular kommunizieren
                    <br />
                    📓 Verarbeitete Daten: z. B. Telefonnummer, Name, E-Mail-Adresse,
                    eingegebene Formulardaten. Mehr Details dazu finden Sie bei der
                    jeweils eingesetzten Kontaktart
                    <br />
                    🤝 Zweck: Abwicklung der Kommunikation mit Kunden, Geschäftspartnern
                    usw.
                    <br />
                    📅 Speicherdauer: Dauer des Geschäftsfalls und der gesetzlichen
                    Vorschriften
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. b DSGVO (Vertrag), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                    Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <p>
                Wenn Sie mit uns Kontakt aufnehmen und per Telefon, E-Mail oder
                Online-Formular kommunizieren, kann es zur Verarbeitung personenbezogener
                Daten kommen.
            </p>
            <p>
                Die Daten werden für die Abwicklung und Bearbeitung Ihrer Frage und des
                damit zusammenhängenden Geschäftsvorgangs verarbeitet. Die Daten während
                eben solange gespeichert bzw. solange es das Gesetz vorschreibt.
            </p>
            <h3 className="adsimple-112958647">Betroffene Personen</h3>
            <p>
                Von den genannten Vorgängen sind alle betroffen, die über die von uns bereit
                gestellten Kommunikationswege den Kontakt zu uns suchen.
            </p>
            <h3 className="adsimple-112958647">Telefon</h3>
            <p>
                Wenn Sie uns anrufen, werden die Anrufdaten auf dem jeweiligen Endgerät und
                beim eingesetzten Telekommunikationsanbieter pseudonymisiert gespeichert.
                Außerdem können Daten wie Name und Telefonnummer im Anschluss per E-Mail
                versendet und zur Anfragebeantwortung gespeichert werden. Die Daten werden
                gelöscht, sobald der Geschäftsfall beendet wurde und es gesetzliche Vorgaben
                erlauben.
            </p>
            <h3 className="adsimple-112958647">E-Mail</h3>
            <p>
                Wenn Sie mit uns per E-Mail kommunizieren, werden Daten gegebenenfalls auf
                dem jeweiligen Endgerät (Computer, Laptop, Smartphone,…) gespeichert und es
                kommt zur Speicherung von Daten auf dem E-Mail-Server. Die Daten werden
                gelöscht, sobald der Geschäftsfall beendet wurde und es gesetzliche Vorgaben
                erlauben.
            </p>
            <h3 className="adsimple-112958647">Online Formulare</h3>
            <p>
                Wenn Sie mit uns mittels Online-Formular kommunizieren, werden Daten auf
                unserem Webserver gespeichert und gegebenenfalls an eine E-Mail-Adresse von
                uns weitergeleitet. Die Daten werden gelöscht, sobald der Geschäftsfall
                beendet wurde und es gesetzliche Vorgaben erlauben.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlagen</h3>
            <p>Die Verarbeitung der Daten basiert auf den folgenden Rechtsgrundlagen:</p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung): Sie geben uns die Einwilligung
                Ihre Daten zu speichern und weiter für den Geschäftsfall betreffende
                Zwecke zu verwenden;
                </li>
                <li className="adsimple-112958647">
                Art. 6 Abs. 1 lit. b DSGVO (Vertrag): Es besteht die Notwendigkeit für die
                Erfüllung eines Vertrags mit Ihnen oder einem Auftragsverarbeiter wie z.
                B. dem Telefonanbieter oder wir müssen die Daten für vorvertragliche
                Tätigkeiten, wie z. B. die Vorbereitung eines Angebots, verarbeiten;
                </li>
                <li className="adsimple-112958647">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen): Wir wollen
                Kundenanfragen und geschäftliche Kommunikation in einem professionellen
                Rahmen betreiben. Dazu sind gewisse technische Einrichtungen wie z. B.
                E-Mail-Programme, Exchange-Server und Mobilfunkbetreiber notwendig, um die
                Kommunikation effizient betreiben zu können.
                </li>
            </ul>
            <h2 id="auftragsverarbeitungsvertrag-avv" className="adsimple-112958647">
                Auftragsverarbeitungsvertrag (AVV)
            </h2>
            <p>
                In diesem Abschnitt möchten wir Ihnen erklären, was ein
                Auftragsverarbeitungsvertrag ist und warum dieser benötigt wird. Weil das
                Wort “Auftragsverarbeitungsvertrag” ein ziemlicher Zungenbrecher ist, werden
                wir hier im Text auch öfters nur das Akronym AVV benutzen. Wie die meisten
                Unternehmen arbeiten wir nicht alleine, sondern nehmen auch selbst
                Dienstleistungen anderer Unternehmen oder Einzelpersonen in Anspruch.&nbsp;
                Durch die Einbeziehung verschiedener Unternehmen bzw. Dienstleister kann es
                sein, dass wir&nbsp; personenbezogene Daten zur Verarbeitung weitergeben.
                Diese Partner fungieren dann als Auftragsverarbeiter, mit denen wir einen
                Vertrag, den sogenannten Auftragsverarbeitungsvertrag (AVV), abschließen.
                Für Sie am wichtigsten zu wissen ist, dass die Verarbeitung Ihrer
                personenbezogenen Daten ausschließlich nach unserer Weisung erfolgt und
                durch den AVV geregelt werden muss.
            </p>
            <h3 className="adsimple-112958647">Wer sind Auftragsverarbeiter?</h3>
            <p>
                Wir sind als Unternehmen und Websiteinhaber für alle Daten, die wir von
                Ihnen verarbeiten verantwortlich. Neben den Verantwortlichen kann es auch
                sogenannte Auftragsverarbeiter geben. Dazu zählt jedes Unternehmen bzw. jede
                Person, die in unserem Auftrag personenbezogene Daten verarbeitet. Genauer
                und nach der DSGVO-Definition gesagt: jede natürliche oder juristische
                Person, Behörde, Einrichtung oder eine andere Stelle, die in unserem Auftrag
                personenbezogene Daten verarbeitet, gilt als Auftragsverarbeiter.
                Auftragsverarbeiter können folglich Dienstleister wie Hosting- oder
                Cloudanbieter, Bezahlungs- oder Newsletter-Anbieter oder große Unternehmen
                wie beispielsweise Google oder Microsoft sein.
            </p>
            <p>
                Zur besseren Verständlichkeit der Begrifflichkeiten hier ein Überblick über
                die drei Rollen in der DSGVO:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Betroffener</strong>&nbsp;(Sie als
                Kunde oder Interessent) →{" "}
                <strong className="adsimple-112958647 text-[#787c87]">Verantwortlicher</strong> (wir als
                Unternehmen und Auftraggeber) →{" "}
                <strong className="adsimple-112958647 text-[#787c87]">Auftragsverarbeiter</strong>{" "}
                (Dienstleister wie z. B. Webhoster oder Cloudanbieter)
            </p>
            <h3 className="adsimple-112958647">
                Inhalt eines Auftragsverarbeitungsvertrages
            </h3>
            <p>
                Wie bereits oben erwähnt, haben wir mit unseren Partnern, die als
                Auftragsverarbeiter fungieren, einen AVV abgeschlossen. Darin wird allen
                voran festgehalten, dass der Auftragsverarbeiter die zu bearbeitenden Daten
                ausschließlich gemäß der DSGVO verarbeitet. Der Vertrag muss schriftlich
                abgeschlossen werden, allerdings gilt in diesem Zusammenhang auch der
                elektronische Vertragsabschluss als „schriftlich“. Erst auf der Grundlage
                des Vertrags erfolgt die Verarbeitung der personenbezogenen Daten. Im
                Vertrag muss folgendes enthalten sein:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">Bindung an uns als Verantwortlichen</li>
                <li className="adsimple-112958647">
                Pflichten und Rechte des Verantwortlichen
                </li>
                <li className="adsimple-112958647">Kategorien betroffener Personen</li>
                <li className="adsimple-112958647">Art der personenbezogenen Daten</li>
                <li className="adsimple-112958647">Art und Zweck der Datenverarbeitung</li>
                <li className="adsimple-112958647">
                Gegenstand und Dauer der Datenverarbeitung
                </li>
                <li className="adsimple-112958647">
                Durchführungsort der Datenverarbeitung
                </li>
            </ul>
            <p>
                Weiters enthält der Vertrag alle Pflichten des Auftragsverarbeiters. Die
                wichtigsten Pflichten sind:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                Maßnahmen zur Datensicherheit zu gewährleisten
                </li>
                <li className="adsimple-112958647">
                mögliche technische und organisatorischen Maßnahmen zu treffen, um die
                Rechte der betroffenen Person zu schützen
                </li>
                <li className="adsimple-112958647">
                ein Daten-Verarbeitungsverzeichnis zu führen
                </li>
                <li className="adsimple-112958647">
                auf Anfrage der Datenschutz-Aufsichtsbehörde mit dieser zusammenzuarbeiten
                </li>
                <li className="adsimple-112958647">
                eine Risikoanalyse in Bezug auf die erhaltenen personenbezogenen Daten
                durchzuführen
                </li>
                <li className="adsimple-112958647">
                Sub-Auftragsverarbeiter dürfen nur mit schriftlicher Genehmigung des
                Verantwortlichen beauftragt werden
                </li>
            </ul>
            <p>
                Wie so eine AVV konkret aussieht, können Sie sich beispielsweise unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.wko.at/service/wirtschaftsrecht-gewerberecht/eu-dsgvo-mustervertrag-auftragsverarbeitung.html"
                >
                https://www.wko.at/service/wirtschaftsrecht-gewerberecht/eu-dsgvo-mustervertrag-auftragsverarbeitung.html
                </a>
                ansehen. Hier wird ein Mustervertrag vorgestellt.
            </p>
            <h2 id="cookies" className="adsimple-112958647">
                Cookies
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Cookies Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: abhängig vom jeweiligen Cookie. Mehr Details dazu finden Sie
                    weiter unten bzw. beim Hersteller der Software, der das Cookie setzt.
                    <br />
                    📓 Verarbeitete Daten: Abhängig vom jeweils eingesetzten Cookie. Mehr
                    Details dazu finden Sie weiter unten bzw. beim Hersteller der
                    Software, der das Cookie setzt.
                    <br />
                    📅 Speicherdauer: abhängig vom jeweiligen Cookie, kann von Stunden bis
                    hin zu Jahren variieren
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit.f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Cookies?</h3>
            <p>
                Unsere Website verwendet HTTP-Cookies, um nutzerspezifische Daten zu
                speichern.
                <br />
                Im Folgenden erklären wir, was Cookies sind und warum Sie genutzt werden,
                damit Sie die folgende Datenschutzerklärung besser verstehen.
            </p>
            <p>
                Immer wenn Sie durch das Internet surfen, verwenden Sie einen Browser.
                Bekannte Browser sind beispielsweise Chrome, Safari, Firefox, Internet
                Explorer und Microsoft Edge. Die meisten Websites speichern kleine
                Text-Dateien in Ihrem Browser. Diese Dateien nennt man Cookies.
            </p>
            <p>
                Eines ist nicht von der Hand zu weisen: Cookies sind echt nützliche
                Helferlein. Fast alle Websites verwenden Cookies. Genauer gesprochen sind es
                HTTP-Cookies, da es auch noch andere Cookies für andere Anwendungsbereiche
                gibt. HTTP-Cookies sind kleine Dateien, die von unserer Website auf Ihrem
                Computer gespeichert werden. Diese Cookie-Dateien werden automatisch im
                Cookie-Ordner, quasi dem “Hirn” Ihres Browsers, untergebracht. Ein Cookie
                besteht aus einem Namen und einem Wert. Bei der Definition eines Cookies
                müssen zusätzlich ein oder mehrere Attribute angegeben werden.
            </p>
            <p>
                Cookies speichern gewisse Nutzerdaten von Ihnen, wie beispielsweise Sprache
                oder persönliche Seiteneinstellungen. Wenn Sie unsere Seite wieder aufrufen,
                übermittelt Ihr Browser die „userbezogenen“ Informationen an unsere Seite
                zurück. Dank der Cookies weiß unsere Website, wer Sie sind und bietet Ihnen
                die Einstellung, die Sie gewohnt sind. In einigen Browsern hat jedes Cookie
                eine eigene Datei, in anderen wie beispielsweise Firefox sind alle Cookies
                in einer einzigen Datei gespeichert.
            </p>
            <p>
                Die folgende Grafik zeigt eine mögliche Interaktion zwischen einem
                Webbrowser wie z. B. Chrome und dem Webserver. Dabei fordert der Webbrowser
                eine Website an und erhält vom Server ein Cookie zurück, welches der Browser
                erneut verwendet, sobald eine andere Seite angefordert wird.
            </p>
            <p>
                <img
                role="img"
                src="https://www.adsimple.at/wp-content/uploads/2018/03/http-cookie-interaction.svg"
                alt="HTTP Cookie Interaktion zwischen Browser und Webserver"
                width="100%"
                />
            </p>
            <p>
                Es gibt sowohl Erstanbieter Cookies als auch Drittanbieter-Cookies.
                Erstanbieter-Cookies werden direkt von unserer Seite erstellt,
                Drittanbieter-Cookies werden von Partner-Websites (z.B. Google Analytics)
                erstellt. Jedes Cookie ist individuell zu bewerten, da jedes Cookie andere
                Daten speichert. Auch die Ablaufzeit eines Cookies variiert von ein paar
                Minuten bis hin zu ein paar Jahren. Cookies sind keine Software-Programme
                und enthalten keine Viren, Trojaner oder andere „Schädlinge“. Cookies können
                auch nicht auf Informationen Ihres PCs zugreifen.
            </p>
            <p>So können zum Beispiel Cookie-Daten aussehen:</p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _ga
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>
                &nbsp;GA1.2.1326744211.152112958647-9
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong>{" "}
                Unterscheidung der Websitebesucher
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 2
                Jahren
            </p>
            <p>Diese Mindestgrößen sollte ein Browser unterstützen können:</p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">Mindestens 4096 Bytes pro Cookie</li>
                <li className="adsimple-112958647">Mindestens 50 Cookies pro Domain</li>
                <li className="adsimple-112958647">Mindestens 3000 Cookies insgesamt</li>
            </ul>
            <h3 className="adsimple-112958647">Welche Arten von Cookies gibt es?</h3>
            <p>
                Die Frage welche Cookies wir im Speziellen verwenden, hängt von den
                verwendeten Diensten ab und wird in den folgenden Abschnitten der
                Datenschutzerklärung geklärt. An dieser Stelle möchten wir kurz auf die
                verschiedenen Arten von HTTP-Cookies eingehen.
            </p>
            <p>Man kann 4 Arten von Cookies unterscheiden:</p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Unerlässliche Cookies
                <br />
                </strong>
                Diese Cookies sind nötig, um grundlegende Funktionen der Website
                sicherzustellen. Zum Beispiel braucht es diese Cookies, wenn ein User ein
                Produkt in den Warenkorb legt, dann auf anderen Seiten weitersurft und
                später erst zur Kasse geht. Durch diese Cookies wird der Warenkorb nicht
                gelöscht, selbst wenn der User sein Browserfenster schließt.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Zweckmäßige Cookies
                <br />
                </strong>
                Diese Cookies sammeln Infos über das Userverhalten und ob der User etwaige
                Fehlermeldungen bekommt. Zudem werden mithilfe dieser Cookies auch die
                Ladezeit und das Verhalten der Website bei verschiedenen Browsern gemessen.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Zielorientierte Cookies
                <br />
                </strong>
                Diese Cookies sorgen für eine bessere Nutzerfreundlichkeit. Beispielsweise
                werden eingegebene Standorte, Schriftgrößen oder Formulardaten gespeichert.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Werbe-Cookies
                <br />
                </strong>
                Diese Cookies werden auch Targeting-Cookies genannt. Sie dienen dazu dem
                User individuell angepasste Werbung zu liefern. Das kann sehr praktisch,
                aber auch sehr nervig sein.
            </p>
            <p>
                Üblicherweise werden Sie beim erstmaligen Besuch einer Website gefragt,
                welche dieser Cookiearten Sie zulassen möchten. Und natürlich wird diese
                Entscheidung auch in einem Cookie gespeichert.
            </p>
            <p>
                Wenn Sie mehr über Cookies wissen möchten und technische Dokumentationen
                nicht scheuen, empfehlen wir{" "}
                <a
                className="adsimple-112958647"
                href="https://datatracker.ietf.org/doc/html/rfc6265"
                >
                https://datatracker.ietf.org/doc/html/rfc6265
                </a>
                ,&nbsp;dem Request for Comments der Internet Engineering Task Force (IETF)
                namens “HTTP State Management Mechanism”.
            </p>
            <h3 className="adsimple-112958647">Zweck der Verarbeitung über Cookies</h3>
            <p>
                Der Zweck ist letztendlich abhängig vom jeweiligen Cookie. Mehr Details dazu
                finden Sie weiter unten bzw. beim Hersteller der Software, die das Cookie
                setzt.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Cookies sind kleine Gehilfen für eine viele verschiedene Aufgaben. Welche
                Daten in Cookies gespeichert werden, kann man leider nicht verallgemeinern,
                aber wir werden Sie im Rahmen der folgenden Datenschutzerklärung über die
                verarbeiteten bzw. gespeicherten Daten informieren.
            </p>
            <h3 className="adsimple-112958647">Speicherdauer von Cookies</h3>
            <p>
                Die Speicherdauer hängt vom jeweiligen Cookie ab und wird weiter unter
                präzisiert. Manche Cookies werden nach weniger als einer Stunde gelöscht,
                andere können mehrere Jahre auf einem Computer gespeichert bleiben.
            </p>
            <p>
                Sie haben außerdem selbst Einfluss auf die Speicherdauer. Sie können über
                ihren Browser sämtliche Cookies jederzeit manuell löschen (siehe auch unten
                “Widerspruchsrecht”). Ferner werden Cookies, die auf einer Einwilligung
                beruhen, spätestens nach Widerruf Ihrer Einwilligung gelöscht, wobei die
                Rechtmäßigkeit der Speicherung bis dahin unberührt bleibt.
            </p>
            <h3 className="adsimple-112958647">
                Widerspruchsrecht – wie kann ich Cookies löschen?
            </h3>
            <p>
                Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst. Unabhängig
                von welchem Service oder welcher Website die Cookies stammen, haben Sie
                immer die Möglichkeit Cookies zu löschen, zu deaktivieren oder nur teilweise
                zuzulassen. Zum Beispiel können Sie Cookies von Drittanbietern blockieren,
                aber alle anderen Cookies zulassen.
            </p>
            <p>
                Wenn Sie feststellen möchten, welche Cookies in Ihrem Browser gespeichert
                wurden, wenn Sie Cookie-Einstellungen ändern oder löschen wollen, können Sie
                dies in Ihren Browser-Einstellungen finden:
            </p>
            <p>
                <a
                className="adsimple-112958647"
                href="https://support.google.com/chrome/answer/95647?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                Chrome: Cookies in Chrome löschen, aktivieren und verwalten
                </a>
            </p>
            <p>
                <a
                className="adsimple-112958647"
                href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                Safari: Verwalten von Cookies und Websitedaten mit Safari
                </a>
            </p>
            <p>
                <a
                className="adsimple-112958647"
                href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem
                Computer abgelegt haben
                </a>
            </p>
            <p>
                <a
                className="adsimple-112958647"
                href="https://support.microsoft.com/de-de/windows/l%C3%B6schen-und-verwalten-von-cookies-168dab11-0753-043d-7c16-ede5947fc64d?tid=112958647"
                >
                Internet Explorer: Löschen und Verwalten von Cookies
                </a>
            </p>
            <p>
                <a
                className="adsimple-112958647"
                href="https://support.microsoft.com/de-de/microsoft-edge/cookies-in-microsoft-edge-l%C3%B6schen-63947406-40ac-c3b8-57b9-2a946a29ae09?tid=112958647"
                >
                Microsoft Edge: Löschen und Verwalten von Cookies
                </a>
            </p>
            <p>
                Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser
                so einrichten, dass er Sie immer informiert, wenn ein Cookie gesetzt werden
                soll. So können Sie bei jedem einzelnen Cookie entscheiden, ob Sie das
                Cookie erlauben oder nicht. Die Vorgangsweise ist je nach Browser
                verschieden. Am besten Sie suchen die Anleitung in Google mit dem
                Suchbegriff “Cookies löschen Chrome” oder “Cookies deaktivieren Chrome” im
                Falle eines Chrome Browsers.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Seit 2009 gibt es die sogenannten „Cookie-Richtlinien“. Darin ist
                festgehalten, dass das Speichern von Cookies eine
                <strong className="adsimple-112958647 text-[#787c87]">Einwilligung</strong> (Artikel 6 Abs.
                1 lit. a DSGVO) von Ihnen verlangt. Innerhalb der EU-Länder gibt es
                allerdings noch sehr unterschiedliche Reaktionen auf diese Richtlinien. In
                Österreich erfolgte aber die Umsetzung dieser Richtlinie in § 165 Abs. 3 des
                Telekommunikationsgesetzes (2021). In Deutschland wurden die
                Cookie-Richtlinien nicht als nationales Recht umgesetzt. Stattdessen
                erfolgte die Umsetzung dieser Richtlinie weitgehend in § 15 Abs. 3 des
                Telemediengesetzes (TMG), welches seit Mai 2024 durch das
                Digitale-Dienste-Gesetz (DDG) ersetzt wurde.
            </p>
            <p>
                Für unbedingt notwendige Cookies, auch soweit keine Einwilligung vorliegt,
                bestehen{" "}
                <strong className="adsimple-112958647 text-[#787c87]">berechtigte Interessen</strong>{" "}
                (Artikel 6 Abs. 1 lit. f DSGVO), die in den meisten Fällen wirtschaftlicher
                Natur sind. Wir möchten den Besuchern der Website eine angenehme
                Benutzererfahrung bescheren und dafür sind bestimmte Cookies oft unbedingt
                notwendig.
            </p>
            <p>
                Soweit nicht unbedingt erforderliche Cookies zum Einsatz kommen, geschieht
                dies nur im Falle Ihrer Einwilligung. Rechtsgrundlage ist insoweit Art. 6
                Abs. 1 lit. a DSGVO.
            </p>
            <p>
                In den folgenden Abschnitten werden Sie genauer über den Einsatz von Cookies
                informiert, sofern eingesetzte Software Cookies verwendet.
            </p>
            <h2 id="webhosting-einleitung" className="adsimple-112958647">
                Webhosting Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Webhosting Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: professionelles Hosting der Website und Absicherung des
                    Betriebs
                    <br />
                    📓 Verarbeitete Daten: IP-Adresse, Zeitpunkt des Websitebesuchs,
                    verwendeter Browser und weitere Daten. Mehr Details dazu finden Sie
                    weiter unten bzw. beim jeweils eingesetzten Webhosting Provider.
                    <br />
                    📅 Speicherdauer: abhängig vom jeweiligen Provider, aber in der Regel
                    2 Wochen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit.f DSGVO (Berechtigte
                    Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Webhosting?</h3>
            <p>
                Wenn Sie heutzutage Websites besuchen, werden gewisse Informationen – auch
                personenbezogene Daten – automatisch erstellt und gespeichert, so auch auf
                dieser Website. Diese Daten sollten möglichst sparsam und nur mit Begründung
                verarbeitet werden. Mit Website meinen wir übrigens die Gesamtheit aller
                Webseiten auf einer Domain, d.h. alles von der Startseite (Homepage) bis hin
                zur aller letzten Unterseite (wie dieser hier). Mit Domain meinen wir zum
                Beispiel beispiel.de oder musterbeispiel.com.
            </p>
            <p>
                Wenn Sie eine Website auf einem Computer, Tablet oder Smartphone ansehen
                möchten, verwenden Sie dafür ein Programm, das sich Webbrowser nennt. Sie
                kennen vermutlich einige Webbrowser beim Namen: Google Chrome, Microsoft
                Edge, Mozilla Firefox und Apple Safari. Wir sagen kurz Browser oder
                Webbrowser dazu.
            </p>
            <p>
                Um die Website anzuzeigen, muss sich der Browser zu einem anderen Computer
                verbinden, wo der Code der Website gespeichert ist: dem Webserver. Der
                Betrieb eines Webservers ist eine komplizierte und aufwendige Aufgabe,
                weswegen dies in der Regel von professionellen Anbietern, den Providern,
                übernommen wird. Diese bieten Webhosting an und sorgen damit für eine
                verlässliche und fehlerfreie Speicherung der Daten von Websites. Eine ganze
                Menge Fachbegriffe, aber bitte bleiben Sie dran, es wird noch besser!
            </p>
            <p>
                Bei der Verbindungsaufnahme des Browsers auf Ihrem Computer (Desktop,
                Laptop, Tablet oder Smartphone) und während der Datenübertragung zu und vom
                Webserver kann es zu einer Verarbeitung personenbezogener Daten kommen.
                Einerseits speichert Ihr Computer Daten, andererseits muss auch der
                Webserver Daten eine Zeit lang speichern, um einen ordentlichen Betrieb zu
                gewährleisten.
            </p>
            <p>
                Ein Bild sagt mehr als tausend Worte, daher zeigt folgende Grafik zur
                Veranschaulichung das Zusammenspiel zwischen Browser, dem Internet und dem
                Hosting-Provider.
            </p>
            <p>
                <img
                role="img"
                src="https://www.adsimple.at/wp-content/uploads/2018/03/browser-und-webserver.svg"
                alt="Browser und Webserver"
                width="100%"
                />
            </p>
            <h3 className="adsimple-112958647">
                Warum verarbeiten wir personenbezogene Daten?
            </h3>
            <p>Die Zwecke der Datenverarbeitung sind:</p>
            <ol>
                <li className="adsimple-112958647">
                Professionelles Hosting der Website und Absicherung des Betriebs
                </li>
                <li className="adsimple-112958647">
                zur Aufrechterhaltung der Betriebs- und IT-Sicherheit
                </li>
                <li className="adsimple-112958647">
                Anonyme Auswertung des Zugriffsverhaltens zur Verbesserung unseres
                Angebots und ggf. zur Strafverfolgung bzw. Verfolgung von Ansprüchen
                </li>
            </ol>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Auch während Sie unsere Website jetzt gerade besuchen, speichert unser
                Webserver, das ist der Computer auf dem diese Webseite gespeichert ist, in
                der Regel automatisch Daten wie
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                die komplette Internetadresse (URL) der aufgerufenen Webseite
                </li>
                <li className="adsimple-112958647">
                Browser und Browserversion (z. B. Chrome 87)
                </li>
                <li className="adsimple-112958647">
                das verwendete Betriebssystem (z. B. Windows 10)
                </li>
                <li className="adsimple-112958647">
                die Adresse (URL) der zuvor besuchten Seite (Referrer URL) (z. B.{" "}
                <a
                    className="adsimple-112958647"
                    href="https://www.beispielquellsite.de/vondabinichgekommen/"
                    target="_blank"
                    rel="follow noopener"
                >
                    https://www.beispielquellsite.de/vondabinichgekommen/
                </a>
                )
                </li>
                <li className="adsimple-112958647">
                den Hostnamen und die IP-Adresse des Geräts von welchem aus zugegriffen
                wird (z. B. COMPUTERNAME und 194.23.43.121)
                </li>
                <li className="adsimple-112958647">Datum und Uhrzeit</li>
                <li className="adsimple-112958647">
                in Dateien, den sogenannten Webserver-Logfiles
                </li>
            </ul>
            <h3 className="adsimple-112958647">Wie lange werden Daten gespeichert?</h3>
            <p>
                In der Regel werden die oben genannten Daten zwei Wochen gespeichert und
                danach automatisch gelöscht. Wir geben diese Daten nicht weiter, können
                jedoch nicht ausschließen, dass diese Daten beim Vorliegen von
                rechtswidrigem Verhalten von Behörden eingesehen werden.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Kurz gesagt:</strong> Ihr Besuch wird
                durch unseren Provider (Firma, die unsere Website auf speziellen Computern
                (Servern) laufen lässt), protokolliert, aber wir geben Ihre Daten nicht ohne
                Zustimmung weiter!
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Die Rechtmäßigkeit der Verarbeitung personenbezogener Daten im Rahmen des
                Webhosting ergibt sich aus Art. 6 Abs. 1 lit. f DSGVO (Wahrung der
                berechtigten Interessen), denn die Nutzung von professionellem Hosting bei
                einem Provider ist notwendig, um das Unternehmen im Internet sicher und
                nutzerfreundlich präsentieren und Angriffe und Forderungen hieraus
                gegebenenfalls verfolgen zu können.
            </p>
            <p>
                Zwischen uns und dem Hosting-Provider besteht in der Regel ein Vertrag über
                die Auftragsverarbeitung gemäß Art. 28 f. DSGVO, der die Einhaltung von
                Datenschutz gewährleistet und Datensicherheit garantiert.
            </p>
            <h2 id="webhosting-provider-extern" className="adsimple-112958647">
                Webhosting-Provider Extern Datenschutzerklärung
            </h2>
            <p>
                Nachfolgend finden Sie die Kontaktdaten unseres externen Hosting-Providers,
                wo Sie, zusätzlich zu den Informationen oben, mehr zur Datenverarbeitung
                erfahren können:
            </p>
            <p>
                webflow.com
                <br />
                cloudflare.com
            </p>
            <p>
                Mehr über die Datenverarbeitung bei diesem Provider erfahren Sie in der{" "}
                <a
                className="adsimple-112958647"
                href="https://webflow.com/legal/privacy"
                target="_blank"
                rel="noopener"
                >
                Datenschutzerklärung
                </a>
                .
            </p>
            <h2 id="website-baukastensysteme-einleitung" className="adsimple-112958647">
                Website Baukastensysteme Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Website Baukastensysteme Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa technische Nutzungsinformationen
                    wie Browseraktivität, Clickstream-Aktivitäten, Sitzungs-Heatmaps sowie
                    Kontaktdaten, IP-Adresse oder Ihr geografischer Standort. Mehr Details
                    dazu finden Sie weiter unten in dieser Datenschutzerklärung und in der
                    Datenschutzerklärung der Anbieter.
                    <br />
                    📅 Speicherdauer: hängt vom Anbieter ab
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                    Interessen), Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Website Baukastensysteme?</h3>
            <p>
                Wir verwenden für unsere Website ein Website Baukastensystem.
                Baukastensysteme sind besondere Formen eines Content-Management-Systems
                (CMS). Mit einem Baukastensystem können Websitebetreiber sehr leicht und
                ohne Programmierkenntnisse eine Website erstellen. In vielen Fällen bieten
                auch Webhoster Baukastensysteme an. Durch die Verwendung eines
                Baukastensystems können auch personenbezogene Daten von Ihnen erhoben,
                gespeichert und verarbeitet werden. In diesem Datenschutztext geben wir
                Ihnen allgemeine Informationen über die Datenverarbeitung durch
                Baukastensysteme. Nähere Informationen finden Sie in den
                Datenschutzerklärungen des Anbieters.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Website Baukastensysteme für unsere Website?
            </h3>
            <p>
                Der größte Vorteil eines Baukastensystems ist die einfache Bedienbarkeit.
                Wir wollen Ihnen eine klare, einfache und übersichtliche Website bieten, die
                wir selbst – ohne externe Unterstützung – problemlos bedienen und warten
                können. Ein Baukastensystem bietet mittlerweile viele hilfreiche Funktionen,
                die wir auch ohne Programmierkenntnisse anwenden können. Dadurch können wir
                unsere Webpräsenz nach unseren Wünschen gestalten und Ihnen eine informative
                und angenehme Zeit auf unserer Website bieten.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von einem Baukastensystem gespeichert?
            </h3>
            <p>
                Welche Daten genau gespeichert werden hängt natürlich vom verwendeten
                Website-Baukastensystem ab. Jeder Anbieter verarbeitet und erhebt
                unterschiedliche Daten des Websitebesuchers. Doch in der Regel werden
                technische Nutzungsinformationen wie etwa etwa Betriebssystem, Browser,
                Bildschirmauflösung, Sprach- und Tastatureinstellungen, Hostinganbieter und
                das Datum Ihres Websitebesuches erhoben. Weiter können auch Trackingdaten
                (z.B. Browseraktivität, Clickstreamaktivitäten, Sitzungs-Heatmaps u.a.)
                verarbeitet werden. Zudem können auch personenbezogene Daten erfasst und
                gespeichert werden. Dabei handelt es sich meistens um Kontaktdaten wie
                E-Mail-Adresse, Telefonnummer (falls Sie diese angegeben haben), IP-Adresse
                und geografischen Standortdaten. Welche Daten genau gespeichert werden,
                finden Sie in der Datenschutzerklärung des Anbieters.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten im
                Zusammenhang mit dem verwendeten Website Baukastensystem, sofern wir weitere
                Informationen dazu haben. In den Datenschutzerklärung des Anbieters finden
                Sie detaillierte Informationen darüber. Generell verarbeiten wir
                personenbezogene Daten nur so lange wie es für die Bereitstellung unserer
                Dienstleistungen und Produkte unbedingt notwendig ist. Es kann sein, dass
                der Anbieter nach eigenen Maßgaben Daten von Ihnen speichert, worauf wir
                keinen Einfluss haben.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben immer das Recht auf Auskunft, Berichtigung und Löschung Ihrer
                personenbezogenen Daten. Bei Fragen können Sie auch jederzeit
                Verantwortliche des verwendeten Website Baukastensystems kontaktieren.
                Kontaktdaten finden Sie entweder in unserer Datenschutzerklärung oder auf
                der Website des entsprechenden Anbieters.
            </p>
            <p>
                Cookies, die Anbieter für ihre Funktionen verwenden, können Sie in Ihrem
                Browser löschen, deaktivieren oder verwalten. Je nachdem welchen Browser Sie
                verwenden, funktioniert dies auf unterschiedliche Art und Weise. Bitte
                beachten Sie aber, dass dann eventuell nicht mehr alle Funktionen wie
                gewohnt funktionieren.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wir haben ein berechtigtes Interesse daran, ein Website Baukastensystem zu
                verwenden, um unseren Online-Service zu optimieren und für Sie effizient und
                nutzeransprechend darzustellen. Die dafür entsprechende Rechtsgrundlage ist
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen). Wir setzen den
                Baukasten gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben.
            </p>
            <p>
                Soweit die Verarbeitung von Daten für den Betrieb der Webseite nicht
                unbedingt notwendig ist, werden die Daten nur auf Grundlage Ihrer
                Einwilligung verarbeitet. Dies betrifft insbesondere Aktivitäten des
                Trackings. Rechtsgrundlage ist insoweit Art. 6 Abs. 1 lit. a DSGVO.
            </p>
            <p>
                Mit dieser Datenschutzerklärung haben wir Ihnen die wichtigsten allgemeinen
                Informationen rund um die Datenverarbeitung nähergebracht. Wenn Sie sich
                diesbezüglich noch genauer informieren wollen, finden Sie weitere
                Informationen – sofern vorhanden – in dem folgenden Abschnitt bzw. in der
                Datenschutzerklärung des Anbieters.
            </p>
            <h2 id="web-analytics-einleitung" className="adsimple-112958647">
                Web Analytics Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Web Analytics Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Auswertung der Besucherinformationen zur Optimierung des
                    Webangebots.
                    <br />
                    📓 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte
                    der Zugriffe, Gerätedaten, Zugriffsdauer und Zeitpunkt,
                    Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Mehr
                    Details dazu finden Sie beim jeweils eingesetzten Web Analytics Tool.
                    <br />
                    📅 Speicherdauer: abhängig vom eingesetzten Web-Analytics-Tool
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Web Analytics?</h3>
            <p>
                Wir verwenden auf unserer Website Software zur Auswertung des Verhaltens der
                Website-Besucher, kurz Web Analytics oder Web-Analyse genannt. Dabei werden
                Daten gesammelt, die der jeweilige Analytic-Tool-Anbieter (auch Trackingtool
                genannt) speichert, verwaltet und verarbeitet. Mit Hilfe der Daten werden
                Analysen über das Nutzerverhalten auf unserer Website erstellt und uns als
                Websitebetreiber zur Verfügung gestellt. Zusätzlich bieten die meisten Tools
                verschiedene Testmöglichkeiten an. So können wir etwa testen, welche
                Angebote oder Inhalte bei unseren Besuchern am besten ankommen. Dafür zeigen
                wir Ihnen für einen begrenzten Zeitabschnitt zwei verschiedene Angebote.
                Nach dem Test (sogenannter A/B-Test) wissen wir, welches Produkt bzw.
                welcher Inhalt unsere Websitebesucher interessanter finden. Für solche
                Testverfahren, wie auch für andere Analytics-Verfahren, können auch
                Userprofile erstellt werden und die Daten in Cookies gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">Warum betreiben wir Web Analytics?</h3>
            <p>
                Mit unserer Website haben wir ein klares Ziel vor Augen: wir wollen für
                unsere Branche das beste Webangebot auf dem Markt liefern. Um dieses Ziel zu
                erreichen, wollen wir einerseits das beste und interessanteste Angebot
                bieten und andererseits darauf achten, dass Sie sich auf unserer Website
                rundum wohlfühlen. Mit Hilfe von Webanalyse-Tools können wir das Verhalten
                unserer Websitebesucher genauer unter die Lupe nehmen und dann entsprechend
                unser Webangebot für Sie und uns verbessern. So können wir beispielsweise
                erkennen wie alt unsere Besucher durchschnittlich sind, woher sie kommen,
                wann unsere Website am meisten besucht wird oder welche Inhalte oder
                Produkte besonders beliebt sind. All diese Informationen helfen uns die
                Website zu optimieren und somit bestens an Ihre Bedürfnisse, Interessen und
                Wünsche anzupassen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Welche Daten genau gespeichert werden, hängt natürlich von den verwendeten
                Analyse-Tools ab. Doch in der Regel wird zum Beispiel gespeichert, welche
                Inhalte Sie auf unserer Website ansehen, auf welche Buttons oder Links Sie
                klicken, wann Sie eine Seite aufrufen, welchen Browser sie verwenden, mit
                welchem Gerät (PC, Tablet, Smartphone usw.) Sie die Website besuchen oder
                welches Computersystem Sie verwenden. Wenn Sie damit einverstanden waren,
                dass auch Standortdaten erhoben werden dürfen, können auch diese durch den
                Webanalyse-Tool-Anbieter verarbeitet werden.
            </p>
            <p>
                Zudem wird auch Ihre IP-Adresse gespeichert. Gemäß der
                Datenschutz-Grundverordnung (DSGVO) sind IP-Adressen personenbezogene Daten.
                Ihre IP-Adresse wird allerdings in der Regel pseudonymisiert (also in
                unkenntlicher und gekürzter Form) gespeichert. Für den Zweck der Tests, der
                Webanalyse und der Weboptimierung werden grundsätzlich keine direkten Daten,
                wie etwa Ihr Name, Ihr Alter, Ihre Adresse oder Ihre E-Mail-Adresse
                gespeichert. All diese Daten werden, sofern sie erhoben werden,
                pseudonymisiert gespeichert. So können Sie als Person nicht identifiziert
                werden.
            </p>
            <p>
                Das folgende Beispiel zeigt schematisch die Funktionsweise von Google
                Analytics als Beispiel für client-basiertes Webtracking mit
                Java-Script-Code.
            </p>
            <p>
                <img
                role="img"
                src="https://www.adsimple.at/wp-content/uploads/2021/04/google-analytics-dataflow.svg"
                alt="Schematischer Datenfluss bei Google Analytics"
                width="100%"
                />
            </p>
            <p>
                Wie lange die jeweiligen Daten gespeichert werden, hängt immer vom Anbieter
                ab. Manche Cookies speichern Daten nur für ein paar Minuten bzw. bis Sie die
                Website wieder verlassen, andere Cookies können Daten über mehrere Jahre
                speichern.
            </p>
            <h3 className="adsimple-112958647">
                <span
                className="adsimple-112958647"
                data-sheets-value='{"1":2,"2":"Wo und wie lange werden Daten gespeichert?"}'
                data-sheets-userformat='{"2":769,"3":{"1":0},"11":4,"12":0}'
                >
                Dauer der Datenverarbeitung
                </span>
            </h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Generell verarbeiten wir
                personenbezogene Daten nur so lange wie es für die Bereitstellung unserer
                Dienstleistungen und Produkte unbedingt notwendig ist. Wenn es, wie zum
                Beispiel im Fall von Buchhaltung, gesetzlich vorgeschrieben ist, kann diese
                Speicherdauer auch überschritten werden.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert
                entweder über unser Cookie-Management-Tool oder über andere
                Opt-Out-Funktionen. Zum Beispiel können Sie auch die Datenerfassung durch
                Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
                deaktivieren oder löschen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von Web-Analytics setzt Ihre Einwilligung voraus, welche wir mit
                unserem Cookie Popup eingeholt haben. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Web-Analytics Tools vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse daran, das Verhalten der Websitebesucher zu analysieren und so
                unser Angebot technisch und wirtschaftlich zu verbessern. Mit Hilfe von
                Web-Analytics erkennen wir Fehler der Website, können Attacken
                identifizieren und die Wirtschaftlichkeit verbessern. Die Rechtsgrundlage
                dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen die Tools gleichwohl nur ein, soweit sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Da bei Web-Analytics-Tools Cookies zum Einsatz kommen, empfehlen wir Ihnen
                auch das Lesen unserer allgemeinen Datenschutzerklärung zu Cookies. Um zu
                erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet werden,
                sollten Sie die Datenschutzerklärungen der jeweiligen Tools durchlesen.
            </p>
            <p>
                Informationen zu speziellen Web-Analytics-Tools, erhalten Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h2 id="etracker-datenschutzerklaerung" className="adsimple-112958647">
                etracker Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        etracker Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Auswertung der Besucherinformationen zur Optimierung des
                    Webangebots.
                    <br />
                    📓 Verarbeitete Daten: unter anderem pseudonymisierte IP-Adresse,
                    technische Informationen zu Browser, Betriebssystem und Endgerät,
                    Verweildauer, Interaktionen auf der Website
                    <br />
                    📅 Speicherdauer: abhängig vom eingesetzten Web-Analytics-Tool
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist etracker?</h3>
            <p>
                Wir verwenden auf unserer Website das Analyse-Tracking-Tool etracker
                Analytics des deutschen Unternehmens etracker GmbH, Erste Brunnenstraße 1,
                D-20459 Hamburg. etracker Analytics ist eine Software, die Daten über Ihre
                Handlungen auf unserer Website sammelt und auswertet. Wir erhalten
                Analyse-Berichte wie Sie unsere Website verwenden und können so unser
                Angebot immer besser an Ihre Wünsche anpassen. In dieser
                Datenschutzerklärung gehen wir näher auf das Analyse-Tool ein und zeigen
                Ihnen vor allem, welche Daten wann, wie und wo gespeichert werden.
            </p>
            <p>
                Bei etracker Analytics handelt es sich um ein Analyse-Tool, das die
                Performance unserer Website und Online-Kampagnen misst und entsprechend auch
                analysiert. So sammelt das Softwareprogramm etwa Daten darüber, wie lange
                Sie auch unserer Website sind, wie viele User unsere Website besuchen und
                von wo Sie zu unserer Website gekommen sind. Wir erhalten auch genaue
                Auswertungen über das Besucherverhalten auf unserer Website. So können wir
                beispielsweise in Erfahrung bringen, welche Buttons Sie gerne klicken oder
                welche Unterseiten Sie mögen und welche Sie eher meiden. All diese
                Informationen sind anonym. Das bedeutet, dass wir durch diese Daten nicht
                Sie als Person identifizieren, sondern lediglich allgemeine
                Userinformationen und Statistiken erhalten.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir etracker auf unserer Website?
            </h3>
            <p>
                Wir nutzen das Software-Tool, um die Qualität unserer Website und unseres
                Angebots zu steigern. Unser Ziel ist es, Ihnen den bestmöglichen Service zu
                liefern. Wir wollen, dass Sie sich auf unserer Website wohl fühlen und genau
                das bekommen, was Sie erwarten. Dafür müssen wir natürlich unser Angebot so
                gut wie möglich an Ihre Wünsche und Anforderungen anpassen.
            </p>
            <p>
                Die Daten helfen uns auch, unsere Online-Marketing und Werbe-Maßnahmen
                günstiger und individueller durchzuführen. Denn wir wollen natürlich unser
                Angebot auch wirklich nur Menschen zeigen, die sich auch dafür
                interessieren.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von etracker gespeichert?
            </h3>
            <p>
                Damit das Tracking funktioniert muss ein JavaScript-Code in die Website
                eingebunden werden. etracker funktioniert auf einer Pixel-Technologie.
            </p>
            <p>
                Standardmäßig verwendet etracker keine Cookies oder Technologien für das
                Tracking auf einer Website, da dies im sogenannten Cookie-less Modus durch
                Privacy-by-Design umgesetzt wurde. In diesem Fall werden nur absolut
                notwendige Cookies gesetzt. Wenn Sie allerdings der Verwendung von Cookies
                aktiv zugestimmt haben, nutzt etracker auch Cookies.
            </p>
            <p>Folgende Daten werden beim Seitenaufruf gespeichert und verarbeitet:</p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">Ihre pseudonymisierte IP-Adresse</li>
                <li className="adsimple-112958647">
                Technische Informationen zu Ihrem Browser, Betriebssystem und Ihrem
                verwendeten Endgerät
                </li>
                <li className="adsimple-112958647">
                Ortsinformationen bis maximal Stadtebene
                </li>
                <li className="adsimple-112958647">
                die aufgerufene URL mit dazugehörigem Seitentitel und optionale
                Informationen zum Seiteninhalt
                </li>
                <li className="adsimple-112958647">
                Referrer-Website: das ist die Website, von der Sie auf unsere Website
                gekommen sind
                </li>
                <li className="adsimple-112958647">
                die Folgeseite: das ist die Website, wo Sie im Anschluss hinklicken
                </li>
                <li className="adsimple-112958647">
                wie lange Sie auf unserer Website bleiben (Verweildauer)
                </li>
                <li className="adsimple-112958647">
                Interaktionen auf der Website. Das können zum Beispiel Klicks auf der
                Website sein, eingegebene Suchbegriffe, heruntergeladene Dateien, Videos
                oder bestellte Artikel.
                </li>
            </ul>
            <p>
                Hier werden also Webseiten-Daten vom Webserver genutzt und Informationen,
                die der Webbrowser zum Abruf von Webseiten an den Webserver überträgt. Diese
                Informationen werden bei jedem einzelnen Seitenabruf übertragen.
            </p>
            <p>
                Anders als bei anderen Technologien werden bei etracker keine Informationen
                aus dem Speicher Ihres Endgeräts ausgelesen und auch keine Daten auf Ihrem
                Endgerät gespeichert. Die Daten werden von etracker für keine anderen Zwecke
                verwendet oder an Dritte weitergegeben.
            </p>
            <p>
                Die verwendeten Cookies erhalten keine Informationen, die Sie als Person
                identifizieren können. Daten wie etwa IP-Adresse, Gerät und Domaindaten
                werden bei der Speicherung verschlüsselt bzw. verkürzt. So ist die
                Identifizierung einzelner Personen weder für uns noch für etracker möglich.
            </p>
            <p>
                Wenn Sie der Verwendung von Cookies zugestimmt haben, können folgenden
                Cookies gesetzt werden:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> GS3_v
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>146480958112958647-9
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie wird vom etracker Optimizer Webservice gesetzt.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _et_coid
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                e9cc2b3efbf7807c6157e8b151baa2f3112958647-1
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie dient der Cookie-Erkennung und wird nur bei der Cookie-Aktivierung
                gesetzt.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach 3 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> pll_language
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>de
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie dient dazu, die voreingestellte Sprache zu speichern.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung: </strong>Bitte beachten
                Sie, dass die hier angeführte Liste lediglich eine Auswahl verwendeter
                Cookies darstellt und keinen Anspruch auf Vollständigkeit erheben kann.
                Welche Cookies im speziellen Fall gesetzt werden, ist von den jeweils
                eingesetzten Auswertungsmechanismen abhängig. Unter dem folgende Link,
                können Sie sich alle Cookies in einer Liste ansehen:{" "}
                <a
                className="adsimple-112958647"
                href="https://www.etracker.com/docs/integration-setup/einstellungen-accounts/etracker-cookies/verwendete-cookies-zaehlung/"
                >
                https://www.etracker.com/docs/integration-setup/einstellungen-accounts/etracker-cookies/verwendete-cookies-zaehlung/
                </a>
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Das Rechenzentrum (die Server) ist in Hamburg und auch die gesamte
                System-Administration finden in Hamburg statt. Somit werden alle Daten
                ausschließlich auf deutschen Servern gespeichert. Die Daten speichert
                etracker, bis der Vertrag mit uns als Kunde ausläuft. Nach einer kurzen Zeit
                nach Beendigung des Vertrags werden alle Daten endgültig gelöscht.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Sie können
                zudem auch jederzeit die Einwilligung zur Verarbeitung der Daten widerrufen.
            </p>
            <p>
                Falls Sie grundsätzlich Cookies deaktivieren, löschen oder verwalten wollen,
                finden Sie unter dem Abschnitt „Cookies“ die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von etracker setzt Ihre Einwilligung voraus, welche wir mit
                unserem Cookie Popup eingeholt haben. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Web-Analytics Tools vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse darin, das Verhalten der Websitebesucher zu analysieren und so
                unser Angebot technisch und wirtschaftlich zu verbessern. Mit Hilfe von
                etracker erkennen wir Fehler der Website, können Attacken identifizieren und
                die Wirtschaftlichkeit verbessern. Die Rechtsgrundlage dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen etracker gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Wir hoffen, wir konnten Ihnen die wichtigsten Informationen rund um die
                Datenverarbeitung von etracker näherbringen. Wenn Sie mehr über den
                Tracking-Dienst erfahren wollen, empfehlen wir Ihnen die
                Datenschutzerklärung des Unternehmens unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.etracker.com/datenschutz/?tid=112958647"
                >
                https://www.etracker.com/datenschutz/
                </a>
                .
            </p>
            <h2
                id="google-analytics-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Google Analytics Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Google Analytics Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Auswertung der Besucherinformationen zur Optimierung des
                    Webangebots.
                    <br />
                    📓 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte
                    der Zugriffe, Gerätedaten, Zugriffsdauer und Zeitpunkt,
                    Navigationsverhalten und Klickverhalten enthalten. Mehr Details dazu
                    finden Sie weiter unten in dieser Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: individuell einstellbar, standardmäßig speichert
                    Google Analytics 4 Daten für 14 Monate
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Google Analytics?</h3>
            <p>
                Wir verwenden auf unserer Website das Analyse-Tracking Tool Google Analytics
                in der Version Google Analytics 4 (GA4) des amerikanischen Unternehmens
                Google Inc. Für den europäischen Raum ist das Unternehmen Google Ireland
                Limited (Gordon House, Barrow Street Dublin 4, Irland) für alle
                Google-Dienste verantwortlich. Google Analytics sammelt Daten über Ihre
                Handlungen auf unserer Website. Durch die Kombination aus verschiedenen
                Technologien wie Cookies, Geräte-IDs und Anmeldeinformationen, können Sie
                als User aber über verschiedene Geräte hinweg identifiziert werden. Dadurch
                können Ihre Handlungen auch plattformübergreifend analysiert werden.
            </p>
            <p>
                Wenn Sie beispielsweise einen Link anklicken, wird dieses Ereignis in einem
                Cookie gespeichert und an Google Analytics versandt. Mithilfe der Berichte,
                die wir von Google Analytics erhalten, können wir unsere Website und unseren
                Service besser an Ihre Wünsche anpassen. Im Folgenden gehen wir näher auf
                das Tracking-Tool ein und informieren Sie vor allem darüber, welche Daten
                verarbeitet werden und wie Sie das verhindern können.
            </p>
            <p>
                Google Analytics ist ein Trackingtool, das der Datenverkehrsanalyse unserer
                Website dient. Basis dieser Messungen und Analysen ist eine pseudonyme
                Nutzeridentifikationsnummer. Diese Nummer beinhaltet keine personenbezogenen
                Daten wie Name oder Adresse, sondern dient dazu, Ereignisse einem Endgerät
                zuzuordnen. GA4 nutzt ein ereignisbasiertes Modell, das detaillierte
                Informationen zu Userinteraktionen wie etwa Seitenaufrufe, Klicks, Scrollen,
                Conversion-Ereignisse erfasst. Zudem wurden in GA4 auch verschiedene
                maschinelle Lernfunktionen eingebaut, um das Nutzerverhalten und gewissen
                Trends besser zu verstehen. GA4 setzt mit Hilfe maschineller Lernfunktionen
                auf Modellierungen. Das heißt auf Grundlage der erhobenen Daten können auch
                fehlende Daten hochgerechnet werden, um damit die Analyse zu optimieren und
                auch um Prognosen geben zu können.
            </p>
            <p>
                Damit Google Analytics grundsätzlich funktioniert, wird ein Tracking-Code in
                den Code unserer Website eingebaut. Wenn Sie unsere Website besuchen,
                zeichnet dieser Code verschiedene Ereignisse auf, die Sie auf unserer
                Website ausführen. Mit dem ereignisbasierten Datenmodell von GA4 können wir
                als Websitebetreiber spezifische Ereignisse definieren und verfolgen, um
                Analysen von Userinteraktionen zu erhalten. Somit können neben allgemeinen
                Informationen wie Klicks oder Seitenaufrufe auch spezielle Ereignisse, die
                für unser Geschäft wichtig sind, verfolgt werden. Solche speziellen
                Ereignisse können zum Beispiel das Absenden eines Kontaktformulars oder der
                Kauf eines Produkts sein.
            </p>
            <p>
                Sobald Sie unsere Website verlassen, werden diese Daten an die
                Google-Analytics-Server gesendet und dort gespeichert.
            </p>
            <p>
                Google verarbeitet die Daten und wir bekommen Berichte über Ihr
                Userverhalten. Dabei kann es sich unter anderem um folgende Berichte
                handeln:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                Zielgruppenberichte: Über Zielgruppenberichte lernen wir unsere User
                besser kennen und wissen genauer, wer sich für unser Service interessiert.
                </li>
                <li className="adsimple-112958647">
                Anzeigeberichte: Durch Anzeigeberichte können wir unsere Onlinewerbung
                leichter analysieren und verbessern.
                </li>
                <li className="adsimple-112958647">
                Akquisitionsberichte: Akquisitionsberichte geben uns hilfreiche
                Informationen darüber, wie wir mehr Menschen für unseren Service
                begeistern können.
                </li>
                <li className="adsimple-112958647">
                Verhaltensberichte: Hier erfahren wir, wie Sie mit unserer Website
                interagieren. Wir können nachvollziehen welchen Weg Sie auf unserer Seite
                zurücklegen und welche Links Sie anklicken.
                </li>
                <li className="adsimple-112958647">
                Conversionsberichte: Conversion nennt man einen Vorgang, bei dem Sie
                aufgrund einer Marketing-Botschaft eine gewünschte Handlung ausführen. Zum
                Beispiel, wenn Sie von einem reinen Websitebesucher zu einem Käufer oder
                Newsletter-Abonnent werden. Mithilfe dieser Berichte erfahren wir mehr
                darüber, wie unsere Marketing-Maßnahmen bei Ihnen ankommen. So wollen wir
                unsere Conversionrate steigern.
                </li>
                <li className="adsimple-112958647">
                Echtzeitberichte: Hier erfahren wir immer sofort, was gerade auf unserer
                Website passiert. Zum Beispiel sehen wir wie viele User gerade diesen Text
                lesen.
                </li>
            </ul>
            <p>
                Neben den oben genannten Analyseberichten bietet Google Analytics 4 unter
                anderem auch folgende Funktionen an:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                Ereignisbasiertes Datenmodell: Dieses Modell erfasst ganz spezifische
                Ereignisse, die auf unserer Website stattfinden können. Zum Beispiel das
                Abspielen eines Videos, der Kauf eines Produkts oder das Anmelden zu
                unserem Newsletter.
                </li>
                <li className="adsimple-112958647">
                Erweiterte Analysefunktionen: Mit diesen Funktionen können wir Ihr
                Verhalten auf unserer Website oder gewisse allgemeine Trends noch besser
                verstehen. So können wir etwa Usergruppen segmentieren, Vergleichsanalysen
                von Zielgruppen machen oder Ihren Weg bzw. Pfad auf unserer Website
                nachvollziehen.
                </li>
                <li className="adsimple-112958647">
                Vorhersagemodellierung: Auf Grundlage erhobener Daten können durch
                maschinelles Lernen fehlende Daten hochgerechnet werden, die zukünftige
                Ereignisse und Trends vorhersagen. Das kann uns helfen, bessere
                Marketingstrategien zu entwickeln.
                </li>
                <li className="adsimple-112958647">
                Cross-Plattform-Analyse: Die Erfassung und Analyse von Daten sind sowohl
                von Websites als auch von Apps möglich. Das bietet uns die Möglichkeit,
                das Userverhalten plattformübergreifend zu analysieren, sofern Sie
                natürlich der Datenverarbeitung eingewilligt haben.
                </li>
            </ul>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Google Analytics auf unserer Website?
            </h3>
            <p>
                Unser Ziel mit dieser Website ist klar: Wir wollen Ihnen den bestmöglichen
                Service bieten. Die Statistiken und Daten von Google Analytics helfen uns
                dieses Ziel zu erreichen.
            </p>
            <p>
                Die statistisch ausgewerteten Daten zeigen uns ein klares Bild von den
                Stärken und Schwächen unserer Website. Einerseits können wir unsere Seite so
                optimieren, dass sie von interessierten Menschen auf Google leichter
                gefunden wird. Andererseits helfen uns die Daten, Sie als Besucher besser zu
                verstehen. Wir wissen somit sehr genau, was wir an unserer Website
                verbessern müssen, um Ihnen das bestmögliche Service zu bieten. Die Daten
                dienen uns auch, unsere Werbe- und Marketing-Maßnahmen individueller und
                kostengünstiger durchzuführen. Schließlich macht es nur Sinn, unsere
                Produkte und Dienstleistungen Menschen zu zeigen, die sich dafür
                interessieren.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Google Analytics gespeichert?
            </h3>
            <p>
                Google Analytics erstellt mithilfe eines Tracking-Codes eine zufällige,
                eindeutige ID, die mit Ihrem Browser-Cookie verbunden ist. So erkennt Sie
                Google Analytics als neuen User und Ihnen wird eine User-ID zugeordnet. Wenn
                Sie das nächste Mal unsere Seite besuchen, werden Sie als „wiederkehrender“
                User erkannt. Alle gesammelten Daten werden gemeinsam mit dieser User-ID
                gespeichert. So ist es erst möglich pseudonyme Userprofile auszuwerten.
            </p>
            <p>
                Um mit Google Analytics unsere Website analysieren zu können, muss eine
                Property-ID in den Tracking-Code eingefügt werden. Die Daten werden dann in
                der entsprechenden Property gespeichert. Für jede neu angelegte Property ist
                die Google Analytics 4-Property standardmäßig. Je nach verwendeter Property
                werden Daten unterschiedlich lange gespeichert.
            </p>
            <p>
                Durch Kennzeichnungen wie Cookies, App-Instanz-IDs, User-IDs oder etwa
                benutzerdefinierte Ereignisparameter werden Ihre Interaktionen, sofern Sie
                eingewilligt haben, plattformübergreifend gemessen. Interaktionen sind alle
                Arten von Handlungen, die Sie auf unserer Website ausführen. Wenn Sie auch
                andere Google-Systeme (wie z.B. ein Google-Konto) nützen, können über Google
                Analytics generierte Daten mit Drittanbieter-Cookies verknüpft werden.
                Google gibt keine Google Analytics-Daten weiter, außer wir als
                Websitebetreiber genehmigen das. Zu Ausnahmen kann es kommen, wenn es
                gesetzlich erforderlich ist.
            </p>
            <p>
                Laut Google werden in Google Analytics 4 keine IP-Adressen protokolliert
                oder gespeichert. Google nutzt die IP-Adressdaten allerdings für die
                Ableitung von Standortdaten und löscht sie unmittelbar danach. Alle
                IP-Adressen, die von Usern in der EU erhoben werden, werden also gelöscht,
                bevor die Daten in einem Rechenzentrum oder auf einem Server gespeichert
                werden.
            </p>
            <p>
                Da bei Google Analytics 4 der Fokus auf ereignisbasierten Daten liegt,
                verwendet das Tool im Vergleich zu früheren Versionen (wie Google Universal
                Analytics) deutlich weniger Cookies. Dennoch gibt es einige spezifische
                Cookies, die von GA4 verwendet werden. Dazu zählen zum Beispiel:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _ga
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                2.1326744211.152112958647-5
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong>{" "}
                Standardmäßig verwendet analytics.js das Cookie _ga, um die User-ID zu
                speichern. Grundsätzlich dient es zur Unterscheidung der Webseitenbesucher.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 2 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _gid
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                2.1687193234.152112958647-1
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong>&nbsp;Das
                Cookie dient auch zur Unterscheidung der Webseitenbesucher
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 24
                Stunden
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong>{" "}
                _gat_gtag_UA_&lt;property-id&gt;
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> 1<br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Wird zum
                Senken der Anforderungsrate verwendet. Wenn Google Analytics über den Google
                Tag Manager bereitgestellt wird, erhält dieser Cookie den Namen _dc_gtm_
                &lt;property-id&gt;.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach 1 Minute
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung:</strong>&nbsp;Diese
                Aufzählung kann keinen Anspruch auf Vollständigkeit erheben, da Google die
                Wahl ihrer Cookies immer wieder auch verändert. Ziel von GA4 ist es auch,
                den Datenschutz zu verbessern. Daher bietet das Tool einige Möglichkeiten
                zur Kontrolle der Datenerfassung. So können wir beispielsweise die
                Speicherdauer selbst festlegen und auch die Datenerfassung steuern.
            </p>
            <p>
                Hier zeigen wir Ihnen einen Überblick über die wichtigsten Arten von Daten,
                die mit Google Analytics erhoben werden:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Heatmaps:</strong> Google legt
                sogenannte Heatmaps an. Über Heatmaps sieht man genau jene Bereiche, die Sie
                anklicken. So bekommen wir Informationen, wo Sie auf unserer Seite
                „unterwegs“ sind.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Sitzungsdauer:</strong> Als
                Sitzungsdauer bezeichnet Google die Zeit, die Sie auf unserer Seite
                verbringen, ohne die Seite zu verlassen. Wenn Sie 20 Minuten inaktiv waren,
                endet die Sitzung automatisch.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Absprungrate</strong> (engl.
                Bouncerate): Von einem Absprung ist die Rede, wenn Sie auf unserer Website
                nur eine Seite ansehen und dann unsere Website wieder verlassen.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Kontoerstellung:</strong> Wenn Sie
                auf unserer Website ein Konto erstellen bzw. eine Bestellung machen, erhebt
                Google Analytics diese Daten.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Standort:</strong> IP-Adressen werden
                in Google Analytics nicht protokolliert oder gespeichert. Allerdings werden
                kurz vor der Löschung der IP-Adresse Ableitungen für Standortdaten genutzt.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Technische Informationen:</strong> Zu
                den technischen Informationen zählen unter anderem Ihr Browsertyp, Ihr
                Internetanbieter oder Ihre Bildschirmauflösung.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Herkunftsquelle:</strong> Google
                Analytics beziehungsweise uns interessiert natürlich auch über welche
                Website oder welche Werbung Sie auf unsere Seite gekommen sind.
            </p>
            <p>
                Weitere Daten sind Kontaktdaten, etwaige Bewertungen, das Abspielen von
                Medien (z. B., wenn Sie ein Video über unsere Seite abspielen), das Teilen
                von Inhalten über Social Media oder das Hinzufügen zu Ihren Favoriten. Die
                Aufzählung hat keinen Vollständigkeitsanspruch und dient nur zu einer
                allgemeinen Orientierung der Datenspeicherung durch Google Analytics.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Google hat ihre Server auf der ganzen Welt verteilt. Hier können Sie genau
                nachlesen, wo sich die Google-Rechenzentren befinden:{" "}
                <a
                className="adsimple-112958647"
                href="https://www.google.com/about/datacenters/locations/?hl=de"
                >
                https://www.google.com/about/datacenters/locations/?hl=de
                </a>
            </p>
            <p>
                Ihre Daten werden auf verschiedenen physischen Datenträgern verteilt. Das
                hat den Vorteil, dass die Daten schneller abrufbar sind und vor Manipulation
                besser geschützt sind. In jedem Google-Rechenzentrum gibt es entsprechende
                Notfallprogramme für Ihre Daten. Wenn beispielsweise die Hardware bei Google
                ausfällt oder Naturkatastrophen Server lahmlegen, bleibt das Risiko einer
                Dienstunterbrechung bei Google dennoch gering.
            </p>
            <p>
                Die Aufbewahrungsdauer der Daten hängt von den verwendeten Properties ab.
                Die Speicherdauer wird stets für jede einzelne Property eigens festgelegt.
                Google Analytics bietet uns zur Kontrolle der Speicherdauer vier Optionen
                an:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                2 Monate: das ist die kürzeste Speicherdauer.
                </li>
                <li className="adsimple-112958647">
                14 Monate: standardmäßig bleiben die Daten bei GA4 für 14 Monate
                gespeichert.
                </li>
                <li className="adsimple-112958647">
                26 Monate: man kann die Daten auch 26 Monate lang speichern.
                </li>
                <li className="adsimple-112958647">
                Daten werden erst gelöscht, wenn wir sie manuell löschen
                </li>
            </ul>
            <p>
                Zusätzlich gibt es auch die Option, dass Daten erst dann gelöscht werden,
                wenn Sie innerhalb des von uns gewählten Zeitraums nicht mehr unsere Website
                besuchen. In diesem Fall wird die Aufbewahrungsdauer jedes Mal
                zurückgesetzt, wenn Sie unsere Website innerhalb des festgelegten Zeitraums
                wieder besuchen.
            </p>
            <p>
                Wenn der festgelegte Zeitraum abgelaufen ist, werden einmal im Monat die
                Daten gelöscht. Diese Aufbewahrungsdauer gilt für Ihre Daten, die mit
                Cookies, Usererkennung und Werbe-IDs (z.B. Cookies der DoubleClick-Domain)
                verknüpft sind. Berichtergebnisse basieren auf aggregierten Daten und werden
                unabhängig von Nutzerdaten gespeichert. Aggregierte Daten sind eine
                Zusammenschmelzung von Einzeldaten zu einer größeren Einheit.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Nach dem Datenschutzrecht der Europäischen Union haben Sie das Recht,
                Auskunft über Ihre Daten zu erhalten, sie zu aktualisieren, zu löschen oder
                einzuschränken. Mithilfe des Browser-Add-ons zur Deaktivierung von Google
                Analytics-JavaScript (analytics.js, gtag.js) verhindern Sie, dass Google
                Analytics 4 Ihre Daten verwendet. Das Browser-Add-on können Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://tools.google.com/dlpage/gaoptout?hl=de"
                >
                https://tools.google.com/dlpage/gaoptout?hl=de
                </a>
                runterladen und installieren. Beachten Sie bitte, dass durch dieses Add-on
                nur die Datenerhebung durch Google Analytics deaktiviert wird.
            </p>
            <p>
                Falls Sie grundsätzlich Cookies deaktivieren, löschen oder verwalten wollen,
                finden Sie unter dem Abschnitt „Cookies“ die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von Google Analytics setzt Ihre Einwilligung voraus, welche wir
                mit unserem Cookie Popup eingeholt haben. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Web-Analytics Tools vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse daran, das Verhalten der Websitebesucher zu analysieren und so
                unser Angebot technisch und wirtschaftlich zu verbessern. Mit Hilfe von
                Google Analytics erkennen wir Fehler der Website, können Attacken
                identifizieren und die Wirtschaftlichkeit verbessern. Die Rechtsgrundlage
                dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen Google Analytics gleichwohl nur ein, soweit Sie eine
                Einwilligung erteilt haben.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
                Terms), welche auf die Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
                .
            </p>
            <p>
                Wir hoffen, wir konnten Ihnen die wichtigsten Informationen rund um die
                Datenverarbeitung von Google Analytics näherbringen. Wenn Sie mehr über den
                Tracking-Dienst erfahren wollen, empfehlen wir diese beiden Links:{" "}
                <a
                className="adsimple-112958647"
                href="https://marketingplatform.google.com/about/analytics/terms/de/"
                target="_blank"
                rel="follow noopener"
                >
                https://marketingplatform.google.com/about/analytics/terms/de/
                </a>{" "}
                und{" "}
                <a
                className="adsimple-112958647"
                href="https://support.google.com/analytics/answer/6004245?hl=de"
                target="_blank"
                rel="follow noopener"
                >
                https://support.google.com/analytics/answer/6004245?hl=de
                </a>
                .
            </p>
            <p>
                Wenn Sie mehr über die Datenverarbeitung erfahren wollen, nutzen Sie die
                Google-Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de&tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://policies.google.com/privacy?hl=de
                </a>
                .
            </p>
            <h2
                id="google-analytics-berichte-zu-demografischen-merkmalen-und-interessen"
                className="adsimple-112958647"
            >
                Google Analytics Berichte zu demografischen Merkmalen und Interessen
            </h2>
            <p>
                Wir haben in Google Analytics die Funktionen für Werbeberichte
                eingeschaltet. Die Berichte zu demografischen Merkmalen und Interessen
                enthalten Angaben zu Alter, Geschlecht und Interessen. Damit können wir uns
                – ohne diese Daten einzelnen Personen zuordnen zu können – ein besseres Bild
                von unseren Nutzern machen. Mehr über die Werbefunktionen erfahren Sie
                auf&nbsp;
                <a
                className="adsimple-112958647"
                href="https://support.google.com/analytics/answer/3450482?hl=de_AT&utm_id=ad"
                >
                https://support.google.com/analytics/answer/3450482?hl=de_AT&amp;utm_id=ad
                </a>
                .
            </p>
            <p>
                Sie können die Nutzung der Aktivitäten und Informationen Ihres Google Kontos
                unter “Einstellungen für Werbung” auf{" "}
                <a
                className="adsimple-112958647"
                href="https://adssettings.google.com/authenticated"
                >
                https://adssettings.google.com/authenticated
                </a>{" "}
                per Checkbox beenden.
            </p>
            <h2
                id="google-analytics-im-einwilligungsmodus"
                className="adsimple-112958647"
            >
                Google Analytics im Einwilligungsmodus
            </h2>
            <p>
                Abhängig von Ihrer Einwilligung werden im sogenannten Einwilligungsmodus
                (bzw. „Consent Mode“) personenbezogene Daten von Ihnen durch Google
                Analytics verarbeitet. Sie können wählen, ob Sie Google-Analytics-Cookies
                zustimmen oder nicht. Damit wählen Sie auch, welche Daten Google Analytics
                von Ihnen verarbeitet darf. Diese erhobenen Daten werden hauptsächlich dafür
                verwendet, Messungen über das Userverhalten auf der Website durchzuführen,
                zielgerichtete Werbung auszuspielen und uns Web-Analyseberichte zu liefern.
                In der Regel willigen Sie der Datenverarbeitung durch Google über ein
                Cookie-Consent-Tool ein. Wenn Sie der Datenverarbeitung nicht einwilligen,
                werden nur aggregierte Daten erfasst und verarbeitet. Das bedeutet, Daten
                können einzelnen Usern nicht zugeordnet werden und es entsteht somit kein
                Userprofil von Ihnen. Sie können auch nur der statistischen Messung
                zustimmen. Dabei werden keine personenbezogenen Daten verarbeitet und
                folglich nicht für Werbungen oder Werbemesserfolge verwendet.
            </p>
            <h2 id="google-analytics-ip-anonymisierung" className="adsimple-112958647">
                Google Analytics IP-Anonymisierung
            </h2>
            <p>
                Wir haben auf dieser Webseite die IP-Adressen-Anonymisierung von Google
                Analytics implementiert.&nbsp;Diese Funktion wurde von Google entwickelt,
                damit diese Webseite die geltenden Datenschutzbestimmungen und Empfehlungen
                der lokalen Datenschutzbehörden einhalten kann, wenn diese eine Speicherung
                der vollständigen IP-Adresse untersagen. Die Anonymisierung bzw. Maskierung
                der IP findet statt, sobald die IP-Adressen im Google
                Analytics-Datenerfassungsnetzwerk eintreffen und bevor eine Speicherung oder
                Verarbeitung der Daten stattfindet.
            </p>
            <p>
                Mehr Informationen zur IP-Anonymisierung finden Sie auf&nbsp;
                <a
                className="adsimple-112958647"
                href="https://support.google.com/analytics/answer/2763052?hl=de"
                target="_blank"
                rel="noopener"
                >
                https://support.google.com/analytics/answer/2763052?hl=de
                </a>
                .
            </p>
            <h2 id="google-optimize-datenschutzerklaerung" className="adsimple-112958647">
                Google Optimize Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website Google Optimize, ein
                Website-Optimierungstool. Dienstanbieter ist das amerikanische Unternehmen
                Google Inc. Für den europäischen Raum ist das Unternehmen Google Ireland
                Limited (Gordon House, Barrow Street Dublin 4, Irland) für alle
                Google-Dienste verantwortlich.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
                Terms), welche auf die Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Google Optimize
                verarbeitet werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de"
                target="_blank"
                rel="follow noopener"
                >
                https://policies.google.com/privacy?hl=de
                </a>
                .
            </p>
            <h2
                id="meta-conversions-api-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Meta Conversions API Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Meta Conversions API Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Kundendaten, Daten zum
                    Nutzerverhalten, Informationen zu Ihrem Gerät und Ihre IP-Adresse.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in der Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: bis die Daten für Meta Zwecke nicht mehr nützlich
                    sind
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist eine Meta Conversions API?</h3>
            <p>
                Wir verwenden auf unserer Website Meta Conversions API, ein serverseitiges
                Event-Trackingtool. Dienstanbieter ist das amerikanische Unternehmen Meta
                Platforms Inc. Für den europäischen Raum ist das Unternehmen Meta Platforms
                Ireland Limited (4 Grand Canal Square, Grand Canal Harbour, Dublin 2,
                Irland) verantwortlich.
            </p>
            <p>
                Bei der Meta Conversions API handelt es sich um ein Tool bzw. um eine
                Funktion, die die Leistung unserer Werbekampagnen in Echtzeit messen kann.
                Die API ist eine Schnittstelle, die unsere Website mit Meta verbindet und
                dadurch bestimmte Aktionen auf unserer Website misst. Eine Conversion
                entsteht, wenn Sie als Besucher einer Website eine gewünschte Handlung
                ausführen. Das kann zum Beispiel ein Klick auf einen Button oder das
                Ausfüllen eines Anmeldeformulars sein. Diese Conversions-Tracking-Methode
                ist eine Alternative zu Meta-Pixel und will durch Präzision und
                Zuverlässigkeit die Conversions-Verfolgung optimieren. Die API sendet
                serverseitig von unserem Server Daten direkt an Meta. Dabei können auch
                personenbezogene Daten verarbeitet werden. In dieser Datenschutzerklärung
                gehen wir näher auf die Datenverarbeitung durch uns bzw. Meta ein.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir die Meta Conversions API auf unserer Website?
            </h3>
            <p>
                Wir nutzen die Meta Conversions API, um die Qualität unserer Website,
                unseres Angebots und unserer Werbekampagnen zu steigern. Unser Ziel ist es,
                Ihnen den bestmöglichen Service zu liefern. Wir wollen, dass Sie sich auf
                unserer Website wohl fühlen und genau das bekommen, was Sie erwarten. Dafür
                müssen wir natürlich unser Angebot so gut wie möglich an Ihre Wünsche und
                Anforderungen anpassen. Mit der Meta Conversions API können wir darauf sehr
                gut eingehen und Inhalte und Angebote individuell anpassen. Diese
                Flexibilität hilft uns, auf verschiedene Bedürfnisse Rücksicht zu nehmen und
                damit gleichzeitig unser Webangebot zu verbessern. Die Daten helfen uns
                auch, unsere Werbe-Maßnahmen günstiger und individueller durchzuführen. Denn
                wir wollen natürlich unser Angebot auch wirklich nur Menschen zeigen, die
                sich auch dafür interessieren.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch die Meta Conversions API gespeichert?
            </h3>
            <p>
                Mit Hilfe der Meta Conversions API können wir diverse Daten über Ereignisse
                auf unserer Website erfassen und Meta liefern. Welche Daten genau
                gespeichert und verarbeitet werden hängt von unseren individuellen
                Einstellungen und den spezifischen Ereignissen und Parametern ab. In der
                Regel werden Ereignisdaten, Benutzerdaten, Gerätedaten und der Zeitpunkt, an
                dem ein Ereignis (z. B. Buttonklick) stattgefunden hat, gespeichert und an
                Meta gesendet. Zu den Ereignisdaten zählen Aktionen wie etwa Anmeldung,
                Produktkauf, Seitenaufrufe oder Buttonklicks, die auf unserer Website
                durchgeführt werden können. Zu den Benutzerdaten können auch
                personenbezogene Daten wie IP-Adresse, Name, Anschrift oder E-Mail-Adresse
                zählen. Gerätedaten beziehen sich auf Ihren Gerätetyp, Betriebssystem,
                Browser und Bildschirmauflösung.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich speichert Meta Daten bis sie nicht mehr für die eigenen
                Dienste und Meta-Produkte benötigt werden. Meta hat auf der ganzen Welt
                Server verteilt, wo Daten gespeichert werden. Kundendaten werden allerdings,
                nachdem sie mit den eigenen Userdaten abgeglichen wurden, innerhalb von 48
                Stunden gelöscht.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht und die Möglichkeit auf Ihre personenbezogenen
                Daten zuzugreifen und Einspruch gegen die Nutzung und Verarbeitung dieser zu
                erheben. Sie können auch jederzeit bei einer staatlichen Aufsichtsbehörde
                eine Beschwerde einreichen. Die Datenspeicherung verhindern Sie
                grundsätzlich, indem Sie der Datenverarbeitung über das Consent Management
                Tool nicht zustimmen. Meta Conversions API arbeitet serverseitig und daher
                gestaltet sich das Löschen von Daten anders als bei clientseitigen Methoden.
                Dennoch können Sie die Datenschutz- und Sicherheitseinstellungen in Ihrem
                Browser überprüfen und, wenn möglich, Tracking-Ressourcen (Pixel, Cookies,
                Scripts) blockieren.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch Meta Conversions API
                verarbeitet und gespeichert werden können, gilt diese Einwilligung als
                Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>{" "}
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die Meta
                Conversions API gleichwohl nur ein, soweit Sie eine Einwilligung erteilt
                haben.
            </p>
            <p>
                Meta verarbeitet Daten von Ihnen u.a. auch in den USA. Meta Platforms ist
                aktiver Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte
                und sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Meta sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2
                und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC)
                sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Meta, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Meta Datenverarbeitungsbedingung, welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/legal/terms/dataprocessing"
                >
                https://www.facebook.com/legal/terms/dataprocessing
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Meta Conversions API
                verarbeitet werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/about/privacy?tid=112958647"
                >
                https://www.facebook.com/about/privacy
                </a>
                .
            </p>
            <h2 id="monsterinsights-datenschutzerklaerung" className="adsimple-112958647">
                MonsterInsights Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        MonsterInsights Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Auswertung der Besucherinformationen zur Optimierung des
                    Webangebots.
                    <br />
                    📓 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte
                    der Zugriffe, Gerätedaten, Zugriffsdauer und Zeitpunkt,
                    Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Mehr
                    Details dazu finden Sie weiter unten bzw. in der Google Analytics
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: abhängig von den verwendeten Google Analytics
                    Properties
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist MonsterInsights?</h3>
            <p>
                Wir nutzen auf unserer Website das „Google Analytics Plugin for WordPress“
                des amerikanischen Unternehmens MonsterInsights LCC (7732 Maywood Crest Dr,
                West Palm Beach, Florida, 33412, USA). Das Plugin wird meist einfach nur
                MonsterInsights genannt. Mit Hilfe des Plugins können Ihre Nutzerdaten bei
                Google Analytics gespeichert, verwaltet und verarbeitet werden. Etwa wenn
                Sie auf einen Link klicken, speichert Google Analytics diesen “Klick” über
                das eingebundene Plugin und bietet durch solche gesammelten Daten
                aufschlussreiche Webanalysen an. In dieser Datenschutzerklärung gehen wir
                näher auf MonsterInsights ein und informieren Sie welche Daten wo und wie
                gespeichert werden.
            </p>
            <p>
                MonsterInsights nutzt für seine Dienste die Google Analytics Reporting API,
                um Daten über unsere Website bzw. das Besucherverhalten zu sammeln. Diese
                Daten werden ausgewertet und erscheinen dann als Diagramme, Grafiken und
                Tabellen direkt auf unserem WordPress-Dashboard. Damit das Plugin
                funktioniert, wird ein Google-Analytics-Trackingcode in unsere
                WordPress-Seite eingebunden. Das Plugin bietet Funktionen wie etwa
                Seitenanalysen, Statistiken oder Werbeanzeigen-Verfolgung. Wir können also
                mit Hilfe des Plug-ins Tracking-Funktionen wie zum Beispiel Event-Tracking,
                eCommerce-Tracking oder Outbound-Link-Tracking ganz einfach und ohne
                Programmierkenntnisse für unsere Website einrichten. Alle wichtigen
                Statistiken sehen wir zusammengefasst an einem einzigen Ort direkt in
                unserem Dashboard.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir MonsterInsights?</h3>
            <p>
                MonsterInsights macht den Umgang mit Google Analytics für uns deutlich
                einfacher, da wir die wichtigsten Analysen gleich auf unserem Dashboard zu
                Gesicht bekommen und nicht immer zu Google Analytics wechseln müssen. Google
                Analytics bietet uns viele wichtige Daten über das Besucherverhalten auf
                unserer Website. Mit Hilfe dieser Daten können wir unsere Website bzw. unser
                Angebot besser an Ihre Wünsche anpassen. Die erhaltenen Statistiken nutzen
                wir, um unsere Website interessanter zu machen und etwaige Werbeanzeigen
                zielgerichtet einzusetzen.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch MonsterInsights bzw. Google Analytics gespeichert?
            </h3>
            <p>
                Durch die Installation des MonsterInsights-Plugins wird ein
                Google-Analytics-Trackingcode in unsere WordPress-Website eingebunden. Damit
                erstellt Google Analytics eine zufällige, eindeutige ID, die mit Ihrem
                Browser-Cookie verbunden ist. Auf diese Weise werden Sie als neuer Besucher
                unserer Website erkannt. Besuchen Sie uns wieder, werden Sie als sogenannter
                “wiederkehrender” User erkannt. Mit dieser User-ID werden dann alle
                gesammelten Daten gespeichert. So werden pseudonyme Userprofile erstellt und
                ausgewertet. Ihre Handlungen auf unserer Website werden in Cookies und
                App-Instanz-IDs gespeichert. Sofern Sie mit anderen Google-Diensten
                verknüpft sind, können die generierten Daten auch mit Drittanbieter-Cookies
                verbunden werden.
            </p>
            <p>
                Das gesamte Tracking wird von Google Analytics durchgeführt und gespeichert.
                MonsterInsights gibt alle Daten direkt zu Google Analytics weiter, um sie im
                Auftrag von MonsterInsights zu verarbeiten. Google gibt diese Daten nur dann
                weiter, wenn wir es erlauben oder es gesetzlich erforderlich ist.
                MonsterInsights verwendet keine eigenen Cookies, um Daten zu speichern,
                sondern der von MonsterInsights hinzugefügte Code lädt Google Analytics,
                welches Cookies hinzufügt.
            </p>
            <p>
                Es wird zum Beispiel erhoben, von welcher Website Sie zu uns gekommen sind,
                auf welche Buttons und Links Sie klicken, wie lange Sie auf einer bestimmten
                Seite bleiben und wann Sie die Website wieder verlassen. Weiters wird auch
                Ihre IP-Adresse in gekürzter Form dargestellt und gespeichert, damit keine
                eindeutige Zuordnung möglich ist. Es kann über die IP-Adresse auch ungefähr
                Ihr Standort bestimmt werden und zudem werden auch technische Informationen
                wie Gerätetyp, Browsertyp, Internetanbieter oder die Bildschirmauflösung
                gespeichert.
            </p>
            <p>
                Wenn Sie Näheres über die Datenspeicherung und Datenverarbeitung wissen
                wollen, empfehlen wir Ihnen unsere allgemeine Datenschutzerklärung zu Google
                Analytics.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                MonsterInsights speichert die erhobenen Daten nicht, sondern leitet Sie an
                Google Analytics weiter. Dort werden die Daten auf den Servern von Google
                gespeichert. Diese Server sind weltweit verteilt, aber die meisten befinden
                sich in den USA. Unter dem Link{" "}
                <a
                className="adsimple-112958647"
                href="https://www.google.com/about/datacenters/locations/?hl=de"
                target="_blank"
                rel="noopener"
                >
                https://www.google.com/about/datacenters/locations/?hl=de
                </a>{" "}
                sehen Sie genau an welchen Standorten die Rechenzentren zu finden sind.
                Standardmäßig werden Ihre Daten bei Google 26 Monate aufbewahrt, doch es
                gibt für Sie auch die Möglichkeit zwischen verschiedenen Aufbewahrungszeiten
                zu wählen. Sehen Sie sich auch dazu unsere Google Analytics
                Datenschutzerklärung an. Die Aufbewahrungsdauer gilt für Daten, die mit
                Cookies, Nutzungserkennung und Werbe-ID verknüpft sind. Webanalysen, die in
                Form von Berichten erscheinen, entstehen durch aggregierte Daten und werden
                unabhängig von Ihren Userdaten gespeichert.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Aktualisierung, Löschung und
                Einschränkung Ihrer Daten. Wenn Sie das Browser-Add-on{" "}
                <a
                className="adsimple-112958647"
                href="https://tools.google.com/dlpage/gaoptout?hl=de"
                >
                https://tools.google.com/dlpage/gaoptout?hl=de
                </a>
                herunterladen und installieren, können Sie durch die Deaktivierung von
                Google-Analytics-JavaScript verhindern, dass Google Analytics Ihre Daten
                benutzt.
            </p>
            <p>
                Falls Sie grundsätzlich Cookies deaktivieren, löschen oder verwalten wollen,
                finden Sie unter dem Abschnitt „Cookies“ die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von MonsterInsights setzt Ihre Einwilligung voraus, welche wir
                mit unserem Cookie Popup eingeholt haben. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Web-Analytics Tools vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse daran, dass Verhalten der Websitebesucher zu analysieren und so
                unser Angebot technisch und wirtschaftlich zu verbessern. Mit Hilfe von
                MonsterInsights erkennen wir Fehler der Website, können Attacken
                identifizieren und die Wirtschaftlichkeit verbessern. Die Rechtsgrundlage
                dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen MonsterInsights gleichwohl nur ein, soweit Sie eine
                Einwilligung erteilt haben.
            </p>
            <p>
                Google verarbeitet Daten u.a. auch in den USA. Wir weisen darauf hin, dass
                nach Meinung des Europäischen Gerichtshofs derzeit kein angemessenes
                Schutzniveau für den Datentransfer in die USA besteht. Dies kann mit
                verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Google
                von der EU-Kommission genehmigte Standardvertragsklauseln (= Art. 46. Abs. 2
                und 3 DSGVO). Diese Klauseln verpflichten Google, das EU-Datenschutzniveau
                bei der Verarbeitung relevanter Daten auch außerhalb der EU einzuhalten.
                Diese Klauseln basieren auf einem Durchführungsbeschluss der EU-Kommission.
                Sie finden den Beschluss sowie die Klauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Wenn Sie mehr über das WordPress-Plugin MonsterInsights erfahren wollen,
                empfehlen wir Ihnen die Website{" "}
                <a
                className="adsimple-112958647"
                href="https://www.monsterinsights.com/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.monsterinsights.com/
                </a>
                . Für nähere Informationen über die Datenverarbeitung durch Google Analytics
                empfehlen wir unsere Google Analytics Datenschutzerklärung, Googles
                Informationsseite unter
                <a
                className="adsimple-112958647"
                href="https://support.google.com/analytics/answer/6004245?hl=de"
                target="_blank"
                rel="follow noopener"
                >
                https://support.google.com/analytics/answer/6004245?hl=de
                </a>{" "}
                und die Website zu den Nutzungsbedingungen für Google Analytics unter{" "}
                <a
                className="adsimple-112958647"
                href="https://marketingplatform.google.com/about/analytics/terms/de/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://marketingplatform.google.com/about/analytics/terms/de/
                </a>
                .
            </p>
            <h2 id="optimizely-datenschutzerklaerung" className="adsimple-112958647">
                Optimizely Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Optimizely Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Auswertung der Besucherinformationen zur Optimierung des
                    Webangebots.
                    <br />
                    📓 Verarbeitete Daten: Technische Daten“, „Konversionsdaten“ und
                    „Personenbezogenen Daten”. Mehr Details dazu finden weiter unten und
                    in der Datenschutzerklärung von Optimizely.
                    <br />
                    📅 Speicherdauer: Grundsätzlich speichert Optimizely die Daten so
                    lange, wie es zur Erfüllung ihrer Pflichten notwendig ist.
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Optimizely?</h3>
            <p>
                Wir verwenden auf unserer Website Optimizely, eine Digital Experience
                Plattform. Dienstanbieter ist das amerikanisches Unternehmen Optimizely
                Inc., 119 5th Ave 7th floor, New York, NY 10003, USA. Der europäische
                Hauptfirmensitz liegt in Torsgaten 11, Box 7007, 10386, Stockholm, Schweden.
            </p>
            <p>
                Optimizely ist eine Software, die uns dabei hilft, unsere Website in
                verschiedenen Bereichen zu verbessern. Zum Beispiel können wir mit
                Optimizely unseren Besuchern verschiedene Versionen von unserer Website
                zeigen, um herauszufinden, welche Version am besten ankommt. Wenn wir das
                machen, sind das sogenannte A/B-Tests, die uns helfen, unser Webangebot zu
                optimieren. Zudem können wir mit Optimizely Besuchern, je nach Bedürfnissen
                und Interessen, unterschiedliche Inhalte präsentieren.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Optimizely auf unserer Website?
            </h3>
            <p>
                Wir wollen selbstverständlich Ihnen das bestmögliche Webangebot bieten. Mit
                Optimizely können wir am einfachsten herausfinden, wie das bestmögliche
                Webangebot überhaupt aussehen soll. Das Tool hilft uns dabei zu erkennen,
                was unsere Websitebesucher interessiert und was nicht. Zudem haben natürlich
                auch unsere Besucher sehr unterschiedliche Bedürfnisse und Interessen. Mit
                Optimizely können wir darauf sehr gut eingehen und Inhalte und Angebote
                individuell anpassen. Diese Flexibilität hilft uns, auf verschiedene
                Bedürfnisse unsere Websitebesucher Rücksicht zu nehmen und damit
                gleichzeitig unser Webangebot zu verbessern.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Optimizely verarbeitet?
            </h3>
            <p>
                Wenn Sie unsere Website besuchen und wir Optimizely aktiviert haben, können
                unterschiedliche Arten von Daten von Ihnen gespeichert werden. In der
                Datenschutzerklärung von Optimizely wird hier zwischen den Kategorien
                „Technische Daten“, „Konversionsdaten“ und „Personenbezogenen Daten“
                unterschieden.
            </p>
            <p>
                Zu den technischen Daten zählen etwa Ihr Browsertyp, das Betriebssystem, die
                Referrer-URL (Webadresse, von der Sie zu uns kamen) und die Uhrzeit, wann
                Sie unsere Website besucht haben. Konversationsdaten nennt Optimizely jene
                Informationen, die Ihr Verhalten auf unserer Website betreffen. Zum Beispiel
                wird festgehalten, welche Inhalte Sie sich ansehen, wie lange Sie auf einer
                bestimmten Seite bleiben oder welche Buttons Sie auf unserer Website
                klicken. Zu den personenbezogenen Daten zählen neben der IP-Adresse, jene
                Informationen, die Sie uns aktiv etwa über ein Kontaktformular mitteilen.
                Also in der Regel sind damit Name, E-Mail-Adresse und Telefonnummer gemeint.
                Optimizely kann aber auch noch mit Hilfe von Cookies, Serverprotokollen und
                ähnlichen Technologien weitere Informationen über Sie einholen. So können
                auch Standortinformationen, die von Ihrem mobilen Gerät bereitgestellt
                werden oder mit Ihrer IP-Adresse verknüpft sind, verarbeitet werden.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich speichert Optimizely die Daten so lange, wie es zur Erfüllung
                ihrer Pflichten notwendig ist. In der Datenschutzerklärung wird noch
                erwähnt, dass personenbezogene Daten mindestens für die Dauer der
                Geschäftsbeziehung zwischen uns und Optimizely aufbewahrt werden. Manche
                personenbezogenen Daten können aber auch noch länger gespeichert werden, um
                beispielsweise Beweise für einen möglichen Rechtsstreit zu haben. Nach
                Beendigung des Vertrags mit uns, werden personenbezogene Daten innerhalb von
                12 Monaten wieder gelöscht, wenn Optimizely nicht gesetzlich verpflichtet
                ist, Daten länger aufzubewahren. Optimizely hat weltweit Server und
                Niederlassungen. Daher können Daten auch weltweit übertragen und gespeichert
                werden. Das Unternehmen betont aber, dass personenbezogene Daten nur in
                Länder, die nach geltendem Recht ein angemessenes Datenschutzniveau bieten,
                übermittelt werden.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Sie können
                zudem auch jederzeit die Einwilligung zur Verarbeitung der Daten widerrufen.
            </p>
            <p>
                Falls Sie grundsätzlich Cookies deaktivieren, löschen oder verwalten wollen,
                finden Sie unter dem Abschnitt „Cookies“ die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Optimizely eingesetzt werden darf, ist die
                Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung.
                Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) die
                Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei
                der Erfassung durch Optimizely vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, Optimizely zu
                verwenden, um unser Online-Service zu optimieren und für Sie schön
                darzustellen. Die dafür entsprechende Rechtsgrundlage ist Art. 6 Abs. 1 lit.
                f DSGVO (Berechtigte Interessen). Wir setzen Optimizely gleichwohl nur ein,
                soweit Sie eine Einwilligung erteilt haben.
            </p>
            <p>
                Optimizely verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen
                darauf hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                Optimizely sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3
                DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind
                von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                diese Klauseln verpflichtet sich Optimizely, bei der Verarbeitung Ihrer
                relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn
                die Daten in den USA gespeichert, verarbeitet und verwaltet werden. Diese
                Klauseln basieren auf einem Durchführungsbeschluss der EU-Kommission. Sie
                finden den Beschluss und die entsprechenden Standardvertragsklauseln u.a.
                hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Datenverarbeitungsbedingung (Data Processing Addendum), welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.optimizely.com/trust-center/data-processing-agreement/"
                target="_blank"
                rel="follow noopener"
                >
                https://www.optimizely.com/trust-center/data-processing-agreement/
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Optimizely verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.optimizely.com/de/legal/datenschutz/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.optimizely.com/de/legal/datenschutz/
                </a>
                .
            </p>
            <h2 id="tiktok-pixel-datenschutzerklaerung" className="adsimple-112958647">
                TikTok Pixel Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        TikTok Pixel Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: es können Ihre IP-Adresse, Browserdaten, Datum
                    und Zeitpunkt Ihres Seitenaufrufs oder Informationen zu Buttonklicks
                    gespeichert werden.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in der Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: variiert je nach Einstellungen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist TikTok Pixel?</h3>
            <p>
                Auf unserer Website nutzen wir die Tracking-Software TikTok Pixel.
                Dienstanbieter ist das chinesische Unternehmen Beijing Bytedance Technology
                Ltd. Für den europäischen Raum ist das irische Unternehmen TikTok Technology
                Limited, 10 Earlsfort Terrace, Dublin, D02 T380, Irland, zuständig. TikTok
                ist speziell bei jungen Menschen eine beliebte Social-Media-Plattform, auf
                der Nutzer kurze Videoclips erstellen, teilen und ansehen können.
            </p>
            <p>
                Das TikTok Pixel ist ein Code-Schnipsel, den wir in unsere Website eingebaut
                haben, um das Verhalten auf der Website zu analysieren. Mit einem der
                TikTok-for-Business-Tools kann das Pixel uns helfen, den Traffic auf unserer
                Website zu messen, die Leistung von Werbekampagnen zu überwachen, unsere
                Kampagnen zu optimieren und neue Kunden zu gewinnen.
            </p>
            <p>
                In dieser Datenschutzerklärung informieren wir Sie darüber, welche Daten
                durch TikTok Pixel verarbeitet werden, wie lange die Daten gespeichert
                werden und wie Sie Ihre Datenschutzeinstellungen verwalten können.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir TikTok auf unserer Website?
            </h3>
            <p>
                Wir haben TikTok Pixel in unsere Website eingebaut, damit wir genauer in
                Erfahrung bringen, wie Sie unsere Website nutzen, was Sie interessiert und
                wo wir unser Service noch verbessern können. Zudem helfen uns diese
                Informationen auch, Werbekampagnen auf TikTok personalisierter
                durchzuführen. Schließlich wollen wir unser Angebot auch wirklich nur
                Menschen zeigen, die sich dafür interessieren.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von TikTok Pixel verarbeitet?
            </h3>
            <p>
                Damit das Tracking funktioniert muss ein JavaScript-Code in die Website
                eingebunden werden. Das Pixel sammelt verschiedene Daten über Ihr
                Userverhalten auf unserer Website und nutzt dafür auch Cookies. Dabei können
                auch personenbezogene Daten wie etwa Ihre IP-Adresse verarbeitet werden.
                Welche Daten genau verarbeitet werden, hängt in erster Linie von den
                individuellen Einstellungen ab und kann in diesem allgemeinen Textabschnitt
                nicht genau eruiert werden.
            </p>
            <p>
                TikTok unterscheidet zwischen folgenden Arten von Informationen, die über
                TikTok-Pixel gesammelt und verarbeitet werden:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Ad/Event-Informationen:</strong> Das
                sind Informationen über die Werbeanzeige, die ein User auf TikTok angeklickt
                hat.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Zeitstempel:</strong> Hier wird der
                Zeitpunkt festgelegt, an dem ein Pixel-Ereignis ausgelöst wurde. Wenn zum
                Beispiel ein bestimmter Button geklickt wurde, dann wird der Zeitpunkt des
                Klicks gespeichert.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">IP-Adresse:</strong> Die IP-Adresse
                zählt zu den personenbezogenen Daten und wird durch TikTok bestimmt, um
                Ihren geografischen Standort zu ermitteln.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">User Agent:</strong> Der User Agent
                wird verwendet, um das Gerätmodell, das Betriebssystem und Ihre
                Browserversion zu ermitteln.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Cookies:</strong> Mit Hilfe von
                Cookies werden Daten zur Leistungsmessung von Kampagnen oder direkt zur
                Websiteleistung gespeichert.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">
                Metadaten &amp; Buttonklicks:
                </strong>{" "}
                Dies umfasst verschiedene Seitenleistungsdaten wie zum Beispiel Ladezeiten
                und Buttonklicks (Name des Buttons, beschreibender Text und Attribute). Es
                wird also genau aufgezeichnet, wann sie welchen Button klicken und auch
                welche Unterseite Sie besuchen.
            </p>
            <p>
                Hier geben wir nur einen groben Überblick über die Arten von Daten, die
                durch TikTok-Pixel verarbeitet werden können. Zu beachten gilt aber, dass
                die Art der gesammelten Daten wesentlich von den individuellen Einstellungen
                des Pixels abhängen. Grundsätzlich werden die Daten zur Analyse von
                Websitetrends und zur Personalisierung von Werbung genutzt.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                TikTok bewahrt Ihre Daten so lange auf, wie es für die Bereitstellung der
                Plattform und für die anderen in der TikTok-Datenschutzerklärung genannten
                Zwecke erforderlich ist. Das Unternehmen bewahrt die Daten auch auf, wenn
                dies zur Erfüllung vertraglicher und rechtlicher Verpflichtungen
                erforderlich ist, wenn TikTok ein berechtigtes Geschäftsinteresse daran hat
                (z. B. zur Verbesserung und Entwicklung der Plattform und zur Verbesserung
                der Sicherheit und Stabilität unserer Dienste) und zur Geltendmachung oder
                Verteidigung von Rechtsansprüchen.
            </p>
            <p>
                Die Speicherdauer und Speicherorte der von TikTok erfassten Daten können
                stark variieren und unterliegen den Datenschutzrichtlinien von TikTok.
                TikTok kann auch Daten auf Servern in den USA und anderen Ländern speichern.
                Die Speicherdauer richtet sich in der Regel nach den jeweiligen gesetzlichen
                Anforderungen und den internen Richtlinien. Wie lange Daten genau
                gespeichert werden, konnten wir allerdings bis jetzt noch nicht in Erfahrung
                bringen. Sobald wir nähere Informationen haben, werden wir Sie darüber
                selbstverständlich in Kenntnis setzen.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Sie können
                zudem auch jederzeit die Einwilligung zur Verarbeitung der Daten widerrufen.
            </p>
            <p>
                Falls Sie grundsätzlich Cookies deaktivieren, löschen oder verwalten wollen,
                finden Sie unter dem Abschnitt „Cookies“ die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <p>
                Wenn Sie ein TikTok-Konto haben, können Sie direkt auf TikTok Ihre
                Datenschutzeinstellungen verwalten. So können Sie etwa in den Einstellungen
                Ihres TikTok-Kontos festlegen, welche Informationen geteilt werden dürfen
                und welche nicht.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch TikTok Pixel
                verarbeitet und gespeichert werden können, gilt diese Einwilligung als
                Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>{" "}
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen das eingebundene
                TikTok Pixel gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben.
                TikTok Pixel kann auch Cookies in Ihrem Browser setzen, um Daten zu
                speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies
                genau durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien
                des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                TikTok verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet TikTok
                sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich TikTok, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Weitere Informationen zur Datenschutzrichtlinie von TikTok und zur Erfassung
                von Daten durch TikTok Pixel finden Sie auf der TikTok-Website unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.tiktok.com/legal/page/eea/privacy-policy/en?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.tiktok.com/legal/page/eea/privacy-policy/en
                </a>
                &nbsp;sowie in den allgemeinen Informationen zu TikTok unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.tiktok.com/en/"
                target="_blank"
                rel="noopener"
                >
                https://www.tiktok.com/en/
                </a>
                .
            </p>
            <h2 id="e-mail-marketing-einleitung" className="adsimple-112958647">
                E-Mail-Marketing Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        E-Mail-Marketing Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Newsletter-Abonnenten
                    <br />
                    🤝 Zweck: Direktwerbung per E-Mail, Benachrichtigung über
                    systemrelevante Ereignisse
                    <br />
                    📓 Verarbeitete Daten: Eingegebene Daten bei der Registrierung jedoch
                    mindestens die E-Mail-Adresse. Mehr Details dazu finden Sie beim
                    jeweils eingesetzten E-Mail-Marketing-Tool.
                    <br />
                    📅 Speicherdauer: Dauer des Bestehens des Abonnements
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist E-Mail-Marketing?</h3>
            <p>
                Um Sie stets auf dem Laufenden zu halten, nutzen wir auch die Möglichkeit
                des E-Mail-Marketings. Dabei werden, sofern Sie dem Empfang unserer E-Mails
                bzw. Newsletter zugestimmt haben, auch Daten von Ihnen verarbeitet und
                gespeichert. E-Mail-Marketing ist ein Teilbereich des Online-Marketings.
                Dabei werden Neuigkeiten oder allgemeine Informationen über ein Unternehmen,
                Produkte oder Dienstleistungen per E-Mail an eine bestimmte Gruppe an
                Menschen, die sich dafür interessieren, gesendet.
            </p>
            <p>
                Wenn Sie an unserem E-Mail-Marketing (meist per Newsletter) teilnehmen
                wollen, müssen Sie sich im Normalfall einfach nur mit Ihrer E-Mail-Adresse
                anmelden. Dafür füllen Sie ein Online-Formular aus und senden es ab. Es kann
                aber auch vorkommen, dass wir Sie etwa um Ihre Anrede und Ihren Namen
                bitten, damit wir Sie auch persönlich anschreiben können.
            </p>
            <p>
                Grundsätzlich funktioniert das Anmelden zu Newslettern mit Hilfe des
                sogenannten „Double-Opt-In-Verfahrens“. Nachdem Sie sich für unseren
                Newsletter auf unserer Website angemeldet haben, bekommen Sie eine E-Mail,
                über die Sie die Newsletter-Anmeldung bestätigen. So wird sichergestellt,
                dass Ihnen die E-Mail-Adresse gehört und sich niemand mit einer fremden
                E-Mail-Adresse angemeldet hat. Wir oder ein von uns verwendetes
                Benachrichtigungs-Tool protokolliert jede einzelne Anmeldung. Dies ist
                nötig, damit wir den rechtlich korrekten Anmeldevorgang auch nachweisen
                können. Dabei wird in der Regel der Zeitpunkt der Anmeldung, der Zeitpunkt
                der Anmeldebestätigung und Ihre IP-Adresse gespeichert. Zusätzlich wird auch
                protokolliert, wenn Sie Änderungen Ihrer gespeicherten Daten vornehmen.
            </p>
            <h3 className="adsimple-112958647">Warum nutzen wir E-Mail-Marketing?</h3>
            <p>
                Wir wollen natürlich mit Ihnen in Kontakt bleiben und Ihnen stets die
                wichtigsten Neuigkeiten über unser Unternehmen präsentieren. Dafür nutzen
                wir unter anderem E-Mail-Marketing – oft auch nur “Newsletter” bezeichnet –
                als wesentlichen Bestandteil unseres Online-Marketings. Sofern Sie sich
                damit einverstanden erklären oder es gesetzlich erlaubt ist, schicken wir
                Ihnen Newsletter, System-E-Mails oder andere Benachrichtigungen per E-Mail.
                Wenn wir im folgenden Text den Begriff „Newsletter“ verwenden, meinen wir
                damit hauptsächlich regelmäßig versandte E-Mails. Natürlich wollen wir Sie
                mit unseren Newsletter in keiner Weise belästigen. Darum sind wir wirklich
                stets bemüht, nur relevante und interessante Inhalte zu bieten. So erfahren
                Sie etwa mehr über unser Unternehmen, unsere Leistungen oder Produkte. Da
                wir unsere Angebote auch immer verbessern, erfahren Sie über unseren
                Newsletter auch immer, wenn es Neuigkeiten gibt oder wir gerade spezielle,
                lukrative Aktionen anbieten. Sofern wir einen Dienstleister, der ein
                professionelles Versand-Tool anbietet, für unser E-Mail-Marketing
                beauftragen, machen wir das, um Ihnen schnelle und sichere Newsletter bieten
                zu können. Zweck unseres E-Mail-Marketings ist grundsätzlich, Sie über neue
                Angebote zu informieren und auch unseren unternehmerischen Zielen näher zu
                kommen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Wenn Sie über unsere Website Abonnent unseres Newsletters werden, bestätigen
                Sie per E-Mail die Mitgliedschaft in einer E-Mail-Liste. Neben IP-Adresse
                und E-Mail-Adresse können auch Ihre Anrede, Ihr Name, Ihre Adresse und Ihre
                Telefonnummer gespeichert werden. Allerdings nur, wenn Sie dieser
                Datenspeicherungen zustimmen. Die als solche markierten Daten sind
                notwendig, damit Sie an dem angebotenen Dienst teilnehmen können. Die Angabe
                ist freiwillig, die Nichtangabe führt jedoch dazu, dass Sie den Dienst nicht
                nutzen können. Zusätzlich können etwa auch Informationen zu Ihrem Gerät oder
                zu Ihren bevorzugten Inhalten auf unserer Website gespeichert werden. Mehr
                zur Speicherung von Daten, wenn Sie eine Website besuchen, finden Sie im
                Abschnitt “Automatische Datenspeicherung”. Ihre Einwilligungserklärung
                zeichnen wir auf, damit wir stets nachweisen können, dass dieser unseren
                Gesetzen entspricht.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Wenn Sie Ihre E-Mail-Adresse aus unserem E-Mail/Newsletter-Verteiler
                austragen, dürfen wir Ihre Adresse bis zu drei Jahren auf Grundlage unserer
                berechtigten Interessen speichern, damit wir Ihre damalige Einwilligung noch
                nachweisen können. Verarbeiten dürfen wir diese Daten nur, wenn wir uns
                gegen etwaige Ansprüche wehren müssen.
            </p>
            <p>
                Wenn Sie allerdings bestätigen, dass Sie uns die Einwilligung zur
                Newsletter-Anmeldung gegeben haben, können Sie jederzeit einen individuellen
                Löschantrag stellen. Widersprechen Sie der Einwilligung dauerhaft, behalten
                wir uns das Recht vor, Ihre E-Mail-Adresse in einer Sperrliste zu speichern.
                Solange Sie freiwillig unseren Newsletter abonniert haben, solange behalten
                wir selbstverständlich auch Ihre E-Mail-Adresse.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben jederzeit die Möglichkeit Ihre Newsletter-Anmeldung zu kündigen.
                Dafür müssen Sie lediglich Ihre Einwilligung zur Newsletter-Anmeldung
                widerrufen. Das dauert im Normalfall nur wenige Sekunden bzw. einen oder
                zwei Klicks. Meistens finden Sie direkt am Ende jeder E-Mail einen Link, um
                das Newsletter-Abonnement zu kündigen. Wenn der Link im Newsletter wirklich
                nicht zu finden ist, kontaktieren Sie uns bitte per Mail und wir werden Ihr
                Newsletter-Abo unverzüglich kündigen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Das Versenden unseres Newsletters erfolgt auf Grundlage Ihrer Einwilligung
                (Artikel 6 Abs. 1 lit. a DSGVO). Das heißt, wir dürfen Ihnen nur dann einen
                Newsletter schicken, wenn Sie sich zuvor aktiv dafür angemeldet haben.
                Gegebenenfalls können wir Ihnen auch Werbenachrichten senden, sofern Sie
                unser Kunde geworden sind und der Verwendung Ihrer E-Mailadresse für
                Direktwerbung nicht widersprochen haben.
            </p>
            <p>
                Informationen zu speziellen E-Mail-Marketing Diensten und wie diese
                personenbezogene Daten verarbeiten, erfahren Sie – sofern vorhanden – in den
                folgenden Abschnitten.
            </p>
            <h2 id="mailgun-datenschutzerklaerung" className="adsimple-112958647">
                Mailgun Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Mailgun Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Newsletter-Abonnenten
                    <br />
                    🤝 Zweck: Direktwerbung per E-Mail, Benachrichtigung über relevante
                    Ereignisse
                    <br />
                    📓 Verarbeitete Daten: Eingegebene Daten bei der Registrierung, jedoch
                    mindestens die E-Mail-Adresse.
                    <br />
                    📅 Speicherdauer: Dauer des Bestehens des Abonnements
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Mailgun?</h3>
            <p>
                Wir verwenden auf unserer Website Mailgun, ein E-Mail API Dienst für unser
                E-Mail-Marketing. Dienstanbieter ist das amerikanische Unternehmen Mailgun
                Technologies Inc., 112 E Pecan St #1135, San Antonio, TX 78205, USA.
            </p>
            <p>
                Mailgun wurde 2010 mit dem Ziel gegründet, Entwicklern und Unternehmen
                leistungsstarke APIs und Tools für das Senden, Empfangen und Verfolgen von
                E-Mails bereitzustellen. Seit der Gründung wächst das Unternehmen
                kontinuierlich weiter und bietet unter anderem Funktionen wie
                E-Mail-Sending, SMTP-Services, Mailverarbeitung, Echtzeitverfolgung,
                Spam-Filterung oder automatische Skalierung an. Im August 2020 erwarb Thoma
                Bravo die Mehrheitsbeteiligung an Mailgun. Mittlerweile zählt Mailgun zu
                einem der größten Anbieter, der weltweit Unternehmen bei der Umsetzung von
                effizienter E-Mail-Kommunikation unterstützt.
            </p>
            <p>
                Durch die Verwendung von Mailgun können personenbezogene Daten wie
                IP-Adresse, geografische Daten oder Kontaktdaten von Ihnen erhoben,
                gespeichert und verarbeitet werden. In dieser Datenschutzerklärung gehen wir
                auf die Datenverarbeitung durch Mailgun genauer ein, damit Sie bestens
                informiert sind.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Mailgun auf unserer Website?
            </h3>
            <p>
                Grundsätzlich nutzen wir einen E-Mail-Marketing-Dienst, damit wir mit Ihnen
                in Kontakt bleiben. Wir wollen Ihnen erzählen was es bei uns Neues gibt oder
                welche attraktiven Angebote wir gerade in unserem Programm haben. Für unsere
                Marketing-Maßnahmen suchen wir immer die einfachsten und besten Lösungen.
                Und aus diesem Grund haben wir uns auch für den Service von Mailgun
                entschieden. Obwohl die Software sehr einfach zu bedienen ist, bietet sie
                eine große Anzahl an hilfreichen Features.
            </p>
            <p>
                Durch die angebotenen Designvorlagen gestalten wir jeden Newsletter ganz
                individuell und dank des „Responsive Design“ werden unsere Inhalte auch auf
                Ihrem Smartphone (oder einem anderen mobilen Endgerät) leserlich und schön
                angezeigt.
            </p>
            <p>
                Der E-Mail-Marketing-Dienst bietet uns auch hilfreiche Analysemöglichkeiten.
                Das heißt, wenn wir einen Newsletter verschicken, erfahren wir
                beispielsweise ob und wann der Newsletter von Ihnen geöffnet wurde. Auch ob
                und auf welchen Link Sie im Newsletter klicken, wird von der Software
                erkannt und aufgezeichnet. Diese Informationen helfen enorm, unser Service
                an Ihre Wünsche und Anliegen anzupassen und zu optimieren. Schließlich
                wollen wir natürlich Ihnen die bestmögliche Dienstleistung bieten. Neben den
                oben bereits erwähnten Daten werden also auch solche Daten über Ihr
                Userverhalten gespeichert.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Mailgun verarbeitet?
            </h3>
            <p>
                Wenn Sie über unsere Website Abonnent unseres Newsletters werden, bestätigen
                Sie per E-Mail die Mitgliedschaft in einer E-Mail-Liste von Mailgun. Damit
                Mailgun auch nachweisen kann, dass Sie sich in den „Listenprovider“
                eingetragen haben, werden das Datum der Eintragung, die Uhrzeit und Ihre
                IP-Adresse gespeichert.
            </p>
            <p>
                Mit Hilfe von Mailgun können wir Ihnen immer aktuell und aus erster Hand
                mitteilen, was sich in unserem Unternehmen gerade so abspielt. Sie sollten
                aber wissen, dass beim Anmeldevorgang zum Newsletter alle Daten, die Sie
                eingeben (wie zum Beispiel Ihre E-Mailadresse oder Ihr Vor- und Nachname)
                auf unserem Server und bei Mailgun gespeichert und verwaltet werden. Dabei
                handelt es sich auch um personenbezogene Daten. Im Verlauf der Anmeldung
                willigen Sie auch ein, dass wir Ihnen den Newsletter senden können und es
                wird weiters auf diese Datenschutzerklärung hingewiesen. Weiters können auch
                Daten, wie etwa das Klickverhalten im Newsletter verarbeitet werden. Diese
                Informationen werden verwendet, um Ihnen E-Mails zu senden und bestimmte
                andere Mailgun-Funktionen (wie z.B. Auswertung der Newsletter) zu
                ermöglichen.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich werden die Daten bei Mailgun dann gelöscht, wenn sie für die
                eigenen Zwecke nicht mehr gebraucht werden. Es gibt natürlich Ausnahmen,
                besonders wenn gesetzliche Verpflichtungen ein längeres Aufbewahren der
                Daten vorschreiben. Webserverprotokolle, die Ihre IP-Adresse und technische
                Daten enthalten, werden von Mailgun auch dann gelöscht, wenn Sie sich von
                unserem Newsletter abmelden. Die persönlichen Daten werden laut Mailguns
                Datenschutzerklärung nach dem Antrag auf Löschung innerhalt von maximal 90
                Tagen gelöscht.
            </p>
            <p>
                Mailgun ist ein amerikanisches Unternehmen und die Daten werden folglich
                auch in den USA gespeichert und verarbeitet.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben jederzeit die Möglichkeit Ihre Newsletter-Anmeldung zu kündigen.
                Dafür müssen Sie lediglich Ihre Einwilligung zur Newsletter-Anmeldung
                widerrufen. Das dauert im Normalfall nur wenige Sekunden bzw. einen oder
                zwei Klicks. Meistens finden Sie direkt am Ende jeder E-Mail einen Link, um
                das Newsletter-Abonnement zu kündigen. Wenn der Link im Newsletter wirklich
                nicht zu finden ist, kontaktieren Sie uns bitte per Mail und wir werden Ihr
                Newsletter-Abo unverzüglich kündigen. Nach der Abmeldung werden die
                personenbezogenen Daten von unserem Server und von den Mailgun-Servern
                gelöscht. Sie haben ein Recht auf unentgeltliche Auskunft über Ihre
                gespeicherten Daten und gegebenenfalls auch ein Recht auf Löschung, Sperrung
                oder Berichtigung.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Mailgun eingesetzt werden darf, ist die
                Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung.
                Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) die
                Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei
                der Erfassung durch Mailgun vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, Mailgun zu
                verwenden, um unser Online-Service zu optimieren und für Sie schöne und
                informative Newsletter zu gestalten. Die dafür entsprechende Rechtsgrundlage
                ist Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen). Wenn eine
                Einwilligung nicht nötig ist, dann erfolgt der Newsletter-Versand auf
                Grundlage des{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                berechtigten Interesses am Direktmarketing (Artikel 6 Abs. 1 lit. f)
                </strong>
                , sofern dies rechtlich erlaubt ist. Ihren Registrierungsprozess zeichnen
                wir auf, damit wir stets nachweisen können, dass dieser unseren Gesetzen
                entspricht.
            </p>
            <p>
                Mailgun verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                Mailgun sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich Mailgun, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln und über die Daten, die
                durch die Verwendung von Mailgun verarbeitet werden, erfahren Sie in der
                Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.mailgun.com/de/rechtliches/datenschutzerklaerung/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.mailgun.com/de/rechtliches/datenschutzerklaerung/.
                </a>
            </p>
            <h2 id="manychat-datenschutzerklaerung" className="adsimple-112958647">
                ManyChat Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        ManyChat Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Website-Speicher und Zugänglichkeit im Internet
                    <br />
                    📓 Verarbeitete Daten: IP-Adresse, aber vor allem auch technische
                    Daten
                    <br />
                    📅 Speicherdauer: hängt von den individuellen Einstellungen ab
                    <br />
                    ⚖️ Rechtsgrundlagen:&nbsp; Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                    Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist ManyChat?</h3>
            <p>
                Wir verwenden auf unserer Website ManyChat, ein Dienst für unser Chat- und
                E-Mail-Marketing. Dienstanbieter ist das amerikanische Unternehmen ManyChat
                Inc., 535 Mission St, San Francisco, CA 94105, USA.
            </p>
            <p>
                Gegründet wurde das Unternehmen im Jahr 2015 von Mikael Yang und Dmitry
                Dumik. Ursprünglich haben die beiden im Marketing gearbeitet, aber früh
                haben sie erkannt, dass Chatbots für Unternehmen noch nicht ausreichend
                entwickelt wurden. Ziel war es, ein Plattform zu entwickeln, die es auch
                Menschen ohne besondere Programmierkenntnisse ermöglicht, Chatbots und ein
                E-Mail-Markeitng-System zu erstellen und einzusetzen. Mittlerweile ist
                ManyChat eine etablierte Marke am Markt und unterstützt neben uns eine
                Vielzahl an weitere Unternehmen bei der Optimierung der Kundenkommunikation.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir ManyChat auf unserer Website?
            </h3>
            <p>
                Grundsätzlich nutzen wir einen Chatbot, damit wir mit Ihnen in Kontakt
                bleiben und Direkt-Support anbieten. Wir wollen Ihnen erzählen was es bei
                uns Neues gibt oder welche attraktiven Angebote wir gerade in unserem
                Programm haben. Gleichzeit soll Ihnen bei Fragen zu unseren Dienstleistungen
                und Produkten so schnell wie möglich geholfen werden. Mit ManyChat ist genau
                das möglich. Für unsere Support-Maßnahmen suchen wir immer die schnellsten
                und besten Lösungen. Und aus diesem Grund haben wir uns auch für das Service
                von ManyChat entschieden. Wir können mit ManyChat automatisierte
                Konversationen in verschiedene Messaging-Plattformen einbauen und auch
                Echtzeit-Analysen wie Konversionsraten oder Userbeteiligungen durchführen.
                Diese Informationen helfen enorm, unser Service an Ihre Wünsche und Anliegen
                anzupassen und zu optimieren. Schließlich wollen wir natürlich Ihnen die
                bestmögliche Dienstleistung bieten.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von ManyChat verarbeitet?
            </h3>
            <p>
                Es werden von ManyChat verschiedene Arten von Daten gesammelt, darunter auch
                personenbezogene Daten. Darunter fallen Kundendaten wie ID, Name,
                E-Mail-Adresse sollten Sie diese in den Chatbot eingeben. Darüber hinaus
                werden Nutzungsinformationen wie Standort, IP-Adresse, Browsertyp,
                Browsereinstellungen sowie E-Mail-Leistungsdaten und Website-Cookies
                gespeichert und verarbeitet. Grundsätzlich werden alle Daten, die Sie uns
                via ManyChat zur Verfügung stellen gespeichert. Daher sollten Sie auf die
                Übermittlung sensibler persönlicher Daten via ManyChat verzichten. Das
                System wird am besten als News- und Supportdienstleistung genutzt.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Wie lange die Daten gespeichert werden, hängt von verschiedenen Faktoren ab.
                Also es hängt vor allem von der Art der gespeicherten Daten und den
                konkreten Einstellungen ab. Grundsätzlich werden die Daten bei ManyChat dann
                gelöscht, wenn sie für die eigenen Zwecke nicht mehr gebraucht werden bzw.
                wir die Vereinbarung gemäß den Nutzungsbedingungen mit ManyChat zu beenden.
                ManyChat kann auch gewisse Daten während einer gesetzlichen
                Aufbewahrungsfrist, etwa zur Beilegung von Streitigkeiten, nach Beendigung
                der Vereinbarung speichern.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben jederzeit die Möglichkeit Ihre Newsletter-Anmeldung zu kündigen.
                Dafür müssen Sie lediglich Ihre Einwilligung zur Newsletter-Anmeldung
                widerrufen. Das dauert im Normalfall nur wenige Sekunden bzw. einen oder
                zwei Klicks. Meistens finden Sie direkt am Ende jeder E-Mail einen Link, um
                das Newsletter-Abonnement zu kündigen. Wenn der Link im Newsletter wirklich
                nicht zu finden ist, kontaktieren Sie uns bitte per Mail und wir werden Ihr
                Newsletter-Abo unverzüglich kündigen. Nach der Abmeldung werden die
                personenbezogenen Daten von unserem Server und von den ManyChat-Servern
                gelöscht. Sie haben ein Recht auf unentgeltliche Auskunft über Ihre
                gespeicherten Daten und gegebenenfalls auch ein Recht auf Löschung, Sperrung
                oder Berichtigung.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass ManyChat eingesetzt werden darf, ist die
                Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung.
                Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) die
                Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei
                der Erfassung durch ManyChat vorkommen kann, dar.
                <br />
                Von unserer Seite besteht zudem ein berechtigtes Interesse, ManyChat zu
                verwenden, um unser Online-Service zu optimieren und für Sie einen
                hilfreichen Support anzubieten. Die dafür entsprechende Rechtsgrundlage ist
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen). Wenn eine Einwilligung
                nicht nötig ist, dann erfolgt der Newsletter-Versand auf Grundlage des
                berechtigten Interesses am Direktmarketing (Artikel 6 Abs. 1 lit. f), sofern
                dies rechtlich erlaubt ist. Ihren Registrierungsprozess zeichnen wir auf,
                damit wir stets nachweisen können, dass dieser unseren Gesetzen entspricht.
            </p>
            <p>
                ManyChat verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                ManyChat sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3
                DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind
                von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                diese Klauseln verpflichtet sich ManyChat, bei der Verarbeitung Ihrer
                relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn
                die Daten in den USA gespeichert, verarbeitet und verwaltet werden. Diese
                Klauseln basieren auf einem Durchführungsbeschluss der EU-Kommission. Sie
                finden den Beschluss und die entsprechenden Standardvertragsklauseln u.a.
                hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln und über die Daten, die
                durch die Verwendung von ManyChat verarbeitet werden, erfahren Sie in der
                Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://manychat.com/privacy.html?tid=112958647"
                >
                https://manychat.com/privacy.html
                </a>
                .
            </p>
            <h2 id="rapidmail-datenschutzerklaerung" className="adsimple-112958647">
                rapidmail Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        rapidmail Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Newsletter-Abonnenten
                    <br />
                    🤝 Zweck: Direktwerbung per E-Mail, Benachrichtigung über relevante
                    Ereignisse
                    <br />
                    📓 Verarbeitete Daten: Eingegebene Daten bei der Registrierung, jedoch
                    mindestens die E-Mail-Adresse.
                    <br />
                    📅 Speicherdauer: Dauer des Bestehens des Abonnements
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist rapidmail?</h3>
            <p>
                Wir verwenden auf unserer Website rapidmail, ein Dienst für unser
                E-Mail-Marketing. Dienstanbieter ist das deutsche Unternehmen rapidmail
                GmbH, Augustinerplatz 2, 79098 Freiburg, Deutschland.
            </p>
            <p>
                2008 wurde das Unternehmen in Freiburg von Sven Kummer gegründet, um
                einfaches Newsletter-Marketing für Unternehmen zu ermöglichen. Einige Jahre
                später veröffentlicht das Unternehmen die ersten rapidmail-Plugins, damit
                Onlineshops den E-Mail-Prozess und die Datenübertragung effizienter
                abwickeln können. Speziell nach dem Inkrafttreten der DSGVO im Jahr 2018
                legte das Unternehmen einen besonderen Wert auf Datenschutz, um ein zu 100%
                DSGVO-konformes Produkt anzubieten. 2019 knackt rapidmail die
                100.000-Kunden-Marke, bekommt ein weiteres Büro in Berlin und mit Steffen
                Müllers einen weiteren Geschäftsführer. 2021 hat rapidmail bereits über
                200.000 Kunden und Teil der Positive Group. Ebensfalls 2021 wird Keyed
                Datenschutz-Partner, damit sichergestellt wird, dass die rapidmail-Software
                auch bei jeder neuen rechtlichen Veränderung DSGVO-konform bleibt.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir rapidmail auf unserer Website?
            </h3>
            <p>
                Grundsätzlich nutzen wir einen Newsletter-Dienst, um mit Ihnen in Kontakt zu
                bleiben. Wir wollen Ihnen erzählen was es bei uns Neues gibt oder welche
                attraktiven Angebote wir gerade in unserem Programm haben. Für unsere
                Marketing-Maßnahmen suchen wir immer die einfachsten und besten Lösungen.
                Rapidmail bietet eine bedienungsfreundliche und DSGVO-konforme Software, die
                genau zu unseren Anforderungen passt. Darum haben wir uns auch für das
                Service von rapidmail entschieden. Obwohl die Software sehr einfach zu
                bedienen ist, bietet sie eine große Anzahl an hilfreichen Features. So
                können wir zum Beispiel unsere Newsletter in unserem Unternehmensdesign
                gestalten, unsere Kontakte einfach verwalten und über die Newsletter-Plugins
                kann das System auch in Shopsysteme eingebunden werden.
            </p>
            <p>
                Der E-Mail-Marketing-Dienste bietet uns auch hilfreiche
                Analysemöglichkeiten. Das heißt, wenn wir einen Newsletter verschicken,
                erfahren wir beispielsweise ob und wann der Newsletter von Ihnen geöffnet
                wurde. Auch ob und auf welchen Link Sie im Newsletter klicken, wird von der
                Software erkannt und aufgezeichnet. Diese Informationen helfen enorm, unser
                Service an Ihre Wünsche und Anliegen anzupassen und zu optimieren.
                Schließlich wollen wir natürlich Ihnen die bestmögliche Dienstleistung
                bieten.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von rapidmail verarbeitet?
            </h3>
            <p>
                Wenn Sie über unsere Website Abonnent unseres Newsletters werden, bestätigen
                Sie per E-Mail die Mitgliedschaft in einer E-Mail-Liste von rapidmail. Damit
                rapidmail auch nachweisen kann, dass Sie sich in den „Listenprovider“
                eingetragen haben, werden das Datum und die Urzeit der Eintragung und Ihre
                IP-Adresse gespeichert.
            </p>
            <p>
                Mit Hilfe von rapidmail können wir Ihnen immer aktuell und aus erster Hand
                mitteilen, was sich in unserem Unternehmen gerade so abspielt. Sie sollten
                aber wissen, dass beim Anmeldevorgang zum Newsletter alle Daten, die Sie
                eingeben (wie zum Beispiel Ihre E-Mailadresse oder Ihr Vor- und Nachname)
                bei rapidmail gespeichert und verwaltet werden. Dabei handelt es sich auch
                um personenbezogene Daten. Im Verlauf der Anmeldung willigen Sie auch ein,
                dass wir Ihnen den Newsletter senden können und es wird weiters auf diese
                Datenschutzerklärung hingewiesen. Weiters können auch Daten, wie etwa das
                Klickverhalten im Newsletter verarbeitet werden. Diese Informationen werden
                verwendet, um Ihnen E-Mails zu senden und bestimmte andere
                rapidmail-Funktionen (wie z.B. Auswertung der Newsletter) zu ermöglichen.
                Die Daten werden nicht an Dritte weitergegeben, außer es besteht eine
                gesetzliche Verpflichtung zur Weitergabe.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Ihre Daten werden von unseren und von den Servern von rapidmail dann
                gelöscht, &nbsp;wenn Sie Ihre Austragung aus dem Newsletter gespeichert
                haben bzw. wenn Sie den Newsletter abbestellt haben. Es gibt natürlich
                Ausnahmen, besonders wenn gesetzliche Verpflichtungen ein längeres
                Aufbewahren der Daten vorschreiben.
            </p>
            <p>
                Für die Datenspeicherung nutzt rapidmail ein deutsches Rechenzentrum mit
                höchsten Sicherheitsstandards. Somit sind Ihre Daten in sicheren Händen und
                werden ausschließlich auf Servern in Deutschland gespeichert und nicht an
                Dritte weitergegeben.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben jederzeit die Möglichkeit Ihre Newsletter-Anmeldung zu kündigen.
                Dafür müssen Sie lediglich Ihre Einwilligung zur Newsletter-Anmeldung
                widerrufen. Das dauert im Normalfall nur wenige Sekunden bzw. einen oder
                zwei Klicks. Meistens finden Sie direkt am Ende jeder E-Mail einen Link, um
                das Newsletter-Abonnement zu kündigen. Wenn der Link im Newsletter wirklich
                nicht zu finden ist, kontaktieren Sie uns bitte per Mail und wir werden Ihr
                Newsletter-Abo unverzüglich kündigen. Nach der Abmeldung werden die
                personenbezogenen Daten von unserem Server und von den rapidmail-Servern
                gelöscht. Sie haben ein Recht auf unentgeltliche Auskunft über Ihre
                gespeicherten Daten und gegebenenfalls auch ein Recht auf Löschung, Sperrung
                oder Berichtigung.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass rapidmail eingesetzt werden darf, ist die
                Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung.
                Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) die
                Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei
                der Erfassung durch rapidmail vorkommen kann, dar. Von unserer Seite besteht
                zudem ein berechtigtes Interesse, rapidmail zu verwenden, um unser
                Online-Service zu optimieren und für Sie schöne und informative Newsletter
                zu gestalten. Die dafür entsprechende Rechtsgrundlage ist Art. 6 Abs. 1 lit.
                f DSGVO (Berechtigte Interessen). Wenn eine Einwilligung nicht nötig ist,
                dann erfolgt der Newsletter-Versand auf Grundlage des{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                berechtigten Interesses am Direktmarketing (Artikel 6 Abs. 1 lit. f)
                </strong>
                , sofern dies rechtlich erlaubt ist. Ihren Registrierungsprozess zeichnen
                wir auf, damit wir stets nachweisen können, dass dieser unseren Gesetzen
                entspricht.
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von rapidmail verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.rapidmail.at/datenschutz?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.rapidmail.at/datenschutz
                </a>
                .
            </p>
            <h2 id="push-nachrichten-einleitung" className="adsimple-112958647">
                Push-Nachrichten Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Push-Nachrichten Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Push-Nachrichten Abonnenten
                    <br />
                    🤝 Zweck: Benachrichtigung über systemrelevante und interessante
                    Ereignisse
                    <br />
                    📓 Verarbeitete Daten: Eingegebene Daten bei der Registrierung,
                    meistens auch Standortdaten. Mehr Details dazu finden Sie beim jeweils
                    eingesetzten Push-Nachrichten-Tool.
                    <br />
                    📅 Speicherdauer: Daten meist so lange gespeichert, wie es für die
                    Bereitstellung der Dienste nötig ist.
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. b DSGVO (Vertrag)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Push-Nachrichten?</h3>
            <p>
                Wir nutzen auf unserer Website auch sogenannte
                Push-Benachrichtigungsdienste, mit denen wir unsere User stets auf dem
                Laufenden halten können. Das bedeutet, wenn Sie der Nutzung von solchen
                Push-Nachrichten zugestimmt haben, können wir Ihnen mit Hilfe eines
                Softwaretools kurze News schicken. Push-Nachrichten sind eine
                Textnachrichten-Form, die bei Ihnen direkt auf dem Smartphone oder auf
                anderen Geräten wie etwa Tablets oder PCs erscheinen, wenn Sie sich dafür
                angemeldet haben. Sie bekommen diese Nachrichten auch, wenn Sie sich nicht
                auf unserer Website befinden bzw. unser Angebot nicht aktiv nutzen. Dabei
                können auch Daten über Ihren Standort und Ihr Nutzungsverhalten gesammelt
                und gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir Push-Nachrichten?</h3>
            <p>
                Einerseits nutzen wir Push-Nachrichten, um unsere Leistungen, die wir mit
                Ihnen vertraglich vereinbart haben, auch vollständig erbringen zu können.
                Andererseits dienen die Nachrichten auch unserem Online-Marketing. Wir
                können Ihnen mit Hilfe dieser Nachrichten unser Service oder unsere Produkte
                näherbringen. Besonders wenn es Neuigkeiten in unserem Unternehmen gibt,
                können wir Sie darüber sofort informieren. Wir wollen die Vorlieben und die
                Gewohnheiten all unserer User so gut wie möglich kennenlernen, um unser
                Angebot laufend zu verbessern.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Damit Sie Push-Nachrichten bekommen können, müssen Sie auch bestätigen, dass
                Sie diese Nachrichten erhalten wollen. Die Daten, die während des Prozesses
                der Einwilligung angesammelt werden, werden auch gespeichert, verwaltet und
                verarbeitet. Das ist notwendig, damit bewiesen und erkannt werden kann, dass
                ein User dem Empfangen der Push-Nachrichten zugestimmt hat. Dafür wird ein
                sogenannter Device-Token oder Push-Token in Ihrem Browser gespeichert. Für
                gewöhnlich werden auch die Daten Ihres Standorts bzw. des Standorts Ihres
                verwendeten Endgeräts gespeichert.
            </p>
            <p>
                Damit wir auch stets interessante und wichtige Push-Nachrichten versenden,
                wird der Umgang mit den Nachrichten auch statistisch ausgewertet. So sehen
                wir dann zum Beispiel, ob und wann Sie die Nachricht öffnen. Mit Hilfe
                dieser Erkenntnisse können wir unsere Kommunikationsstrategie an Ihre
                Wünsche und Interessen anpassen. Obwohl diese gespeicherten Daten Ihnen
                zugeordnet werden können, wollen wir Sie als Einzelperson nicht überprüfen.
                Vielmehr interessieren uns die gesammelten Daten all unserer User, damit wir
                Optimierungen vornehmen können. Welche Daten genau gespeichert werden,
                erfahren Sie in den Datenschutzerklärungen der jeweiligen Dienstanbieter.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Wie lange die Daten verarbeitet und gespeichert werden, hängt in erster
                Linie von unserem verwendeten Tool ab. Weiter unten erfahren Sie mehr über
                die Datenverarbeitung der einzelnen Tools. In den Datenschutzerklärungen der
                Anbieter steht üblicherweise genau, welche Daten wie lange gespeichert und
                verarbeitet werden. Grundsätzlich werden personenbezogene Daten nur so lange
                verarbeitet, wie es für die Bereitstellung unserer Dienste nötig ist. Wenn
                Daten in Cookies gespeichert werden, variiert die Speicherdauer stark. Die
                Daten können gleich nach dem Verlassen einer Website wieder gelöscht werden,
                sie können aber auch über mehrere Jahre gespeichert bleiben. Daher sollten
                Sie sich jedes einzelnen Cookie im Detail ansehen, wenn Sie über die
                Datenspeicherung Genaueres wissen wollen. Meistens finden Sie in den
                Datenschutzerklärungen der einzelnen Anbieter auch aufschlussreiche
                Informationen über die einzelnen Cookies.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Es kann auch sein, dass die Push-Nachrichten notwendig sind, damit gewisse
                Pflichten, die in einem Vertrag stehen, erfüllt werden können. Zum Beispiel,
                damit wir Ihnen technische oder organisatorische Neuigkeiten mitteilen
                können. Dann lautet die Rechtsgrundlage Art. 6 Abs. 1 lit. b DSGVO.
            </p>
            <p>
                Wenn dies nicht der Fall ist, werden die Push-Nachrichten nur auf Grundlage
                Ihrer Einwilligung verschickt. Unsere Push-Nachrichten können insbesondere
                einen werbenden Inhalt haben. Die Push-Nachrichten können auch abhängig von
                Ihrem Standort, die Ihr Endgerät anzeigt, versendet werden. Auch die oben
                genannten analytischen Auswertungen basieren auf Grundlage Ihrer
                Einwilligung, solche Nachrichten empfangen zu wollen. Rechtsgrundlage ist
                insoweit Art. 6 Abs. 1 lit. a DSGVO. Sie können natürlich in den
                Einstellungen Ihre Einwilligung jederzeit widerrufen bzw. diverse
                Einstellungen ändern.
            </p>
            <h2 id="messenger-kommunikation-einleitung" className="adsimple-112958647">
                Messenger &amp; Kommunikation Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Messenger &amp; Kommunikation Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Kontaktanfragen und die allgemeine Kommunikation zwischen
                    uns und Ihnen
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Name, Adresse, E-Mailadresse,
                    Telefonnummer, allgemeine Inhaltsdaten, gegebenenfalls IP-Adresse
                    <br />
                    Mehr Details dazu finden Sie bei den jeweils eingesetzten Tools.
                    <br />
                    📅 Speicherdauer: abhängig von den verwendeten Messenger- &amp;
                    Kommunikationsfunktionen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen), Art. 6 Abs. 1 S. 1 lit.
                    b. DSGVO (vertragliche oder vorvertragliche Verpflichtungen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">
                Was sind Messenger- &amp; Kommunikationsfunktionen?
            </h3>
            <p>
                Wir bieten auf unserer Website verschiedene Möglichkeiten (etwa Messenger-
                und Chatfunktionen, Online- bzw. Kontaktformulare, E-Mail, Telefon), um mit
                uns zu kommunizieren. Dabei werden auch Ihre Daten, soweit es für die
                Beantwortung Ihrer Anfrage und unseren darauffolgenden Maßnahmen nötig ist,
                verarbeitet und gespeichert.
            </p>
            <p>
                Wir nutzen neben klassischen Kommunikationsmitteln wie E-Mail,
                Kontaktformularen oder Telefon auch Chats bzw. Messenger. Die derzeit am
                häufigsten verwendete Messenger-Funktion ist WhatsApp, aber es gibt
                natürlich speziell für Websites viele verschiedene Anbieter, die
                Messenger-Funktionen anbieten. Wenn Inhalte Ende zu Ende verschlüsselt sind,
                wird darauf in den einzelnen Datenschutztexten oder in der
                Datenschutzerklärung des jeweiligen Anbieters hingewiesen. Eine
                Ende-zu-Ende-Verschlüsselung bedeutet nichts anders, als dass Inhalte einer
                Nachricht selbst für den Anbieter nicht sichtbar sind. Allerdings können
                trotzdem Informationen zu Ihrem Gerät, Standorteinstellungen und andere
                technische Daten verarbeitet und gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">
                Warum nutzen wir Messenger- &amp; Kommunikationsfunktionen?
            </h3>
            <p>
                Kommunikationsmöglichkeiten mit Ihnen sind für uns von großer Bedeutung.
                Schließlich wollen wir mit Ihnen sprechen und alle möglichen Fragen zu
                unserem Service bestmöglich beantworten. Eine gut funktionierende
                Kommunikation ist bei uns ein wichtiger Teil unserer Dienstleistung. Mit den
                praktischen Messenger- &amp; Kommunikationsfunktionen können Sie jederzeit
                jene wählen, die Ihnen am liebsten sind. In Ausnahmefällen kann es aber auch
                vorkommen, dass wir bestimmte Fragen über Chat bzw. Messenger nicht
                beantworten. Das ist der Fall, wenn es etwa um interne vertragliche
                Angelegenheiten geht. Hier empfehlen wir andere Kommunikationsmöglichkeiten
                wie E-Mail oder Telefon.
            </p>
            <p>
                Wir gehen in der Regel davon aus, dass wir datenschutzrechtlich
                verantwortlich bleiben, auch wenn wir Dienste einer Social-Media-Plattform
                nutzen. Der Europäische Gerichtshof hat jedoch entschieden, dass in
                bestimmten Fällen der Betreiber der Social-Media-Plattform zusammen mit uns
                gemeinsam verantwortlich im Sinne des Art. 26 DSGVO sein kann. Soweit dies
                der Fall ist, weisen wir gesondert darauf hin und arbeiten auf Grundlage
                einer diesbezüglichen Vereinbarung. Das Wesentliche der Vereinbarung ist
                weiter unten bei der betroffenen Plattform wiedergegeben.
            </p>
            <p>
                Bitte beachten Sie, dass bei der Nutzung unserer eingebauten Elemente auch
                Daten von Ihnen außerhalb der Europäischen Union verarbeitet werden können,
                da viele Anbieter, beispielsweise Facebook-Messenger oder WhatsApp
                amerikanische Unternehmen sind. Dadurch können Sie möglicherweise Ihre
                Rechte in Bezug auf Ihre personenbezogenen Daten nicht mehr so leicht
                einfordern bzw. durchsetzen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Welche Daten genau gespeichert und verarbeitet werden, hängt vom jeweiligen
                Anbieter der Messenger- &amp; Kommunikationsfunktionen ab. Grundsätzlich
                handelt es sich um Daten wie etwa Name, Adresse, Telefonnummer,
                E-Mailadresse und Inhaltsdaten wie beispielsweise alle Informationen, die
                Sie in ein Kontaktformular eingeben. Meistens werden auch Informationen zu
                Ihrem Gerät und die IP-Adresse gespeichert. Daten, die über eine Messenger-
                &amp; Kommunikationsfunktion erhoben werden, werden auch auf den Servern der
                Anbieter gespeichert.
            </p>
            <p>
                Wenn Sie genau wissen wollen, welche Daten bei den jeweiligen Anbietern
                gespeichert und verarbeitet werden und wie Sie der Datenverarbeitung
                widersprechen können, sollten Sie die jeweilige Datenschutzerklärung des
                Unternehmens sorgfältig durchlesen.
            </p>
            <h3 className="adsimple-112958647">Wie lange werden Daten gespeichert?</h3>
            <p>
                Wie lange die Daten verarbeitet und gespeichert werden, hängt in erster
                Linie von unseren verwendeten Tools ab. Weiter unten erfahren Sie mehr über
                die Datenverarbeitung der einzelnen Tools. In den Datenschutzerklärungen der
                Anbieter steht üblicherweise genau, welche Daten wie lange gespeichert und
                verarbeitet werden. Grundsätzlich werden personenbezogene Daten nur so lange
                verarbeitet, wie es für die Bereitstellung unserer Dienste nötig ist. Wenn
                Daten in Cookies gespeichert werden, variiert die Speicherdauer stark. Die
                Daten können gleich nach dem Verlassen einer Website wieder gelöscht werden,
                sie können aber auch über mehrere Jahre gespeichert bleiben. Daher sollten
                Sie sich jedes einzelnen Cookie im Detail ansehen, wenn Sie über die
                Datenspeicherung Genaueres wissen wollen. Meistens finden Sie in den
                Datenschutzerklärungen der einzelnen Anbieter auch aufschlussreiche
                Informationen über die einzelnen Cookies.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert
                entweder über unser Cookie-Management-Tool oder über andere
                Opt-Out-Funktionen. Zum Beispiel können Sie auch die Datenerfassung durch
                Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
                deaktivieren oder löschen. Für weitere Informationen verweisen wir auf den
                Abschnitt zur Einwilligung.
            </p>
            <p>
                Da bei Messenger- &amp; Kommunikationsfunktionen Cookies zum Einsatz kommen
                können, empfehlen wir Ihnen auch unsere allgemeine Datenschutzerklärung über
                Cookies. Um zu erfahren, welche Daten von Ihnen genau gespeichert und
                verarbeitet werden, sollten Sie die Datenschutzerklärungen der jeweiligen
                Tools durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
                Messenger- &amp; Kommunikationsfunktionen verarbeitet und gespeichert werden
                können, gilt diese Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Wir bearbeiten Ihre Anfrage und verwalten Ihre Daten im Rahmen
                vertraglicher oder vorvertraglicher Beziehungen, um unsere vorvertraglichen
                und vertraglichen Pflichten zu erfüllen bzw. Anfragen zu beantworten.
                Grundlage dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 S. 1 lit. b. DSGVO
                </strong>
                . Grundsätzlich werden Ihre Daten bei Vorliegen einer Einwilligung auch auf
                Grundlage unseres berechtigten Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet.
            </p>
            <h2
                id="facebook-messenger-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Facebook Messenger Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Facebook Messenger Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Facebook Messenger-User
                    <br />
                    🤝 Zweck: Kommunikation
                    <br />
                    📓 Verarbeitete Daten: Kontaktdaten, Nachrichten, Medien
                    <br />
                    📅 Speicherdauer: nach Kontolöschung
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Facebook Messenger?</h3>
            <p>
                Wir verwenden auf unserer Website den Instant-Messaging-Dienst Facebook
                Messenger. Dienstanbieter ist das amerikanische Unternehmen Meta Platforms
                Inc. Für den europäischen Raum ist das Unternehmen Meta Platforms Ireland
                Limited (4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland)
                verantwortlich.
            </p>
            <p>
                Facebook Messenger ist eine von Facebook entwickelte
                Chat-Nachrichtenfunktion, mit der Sie Textnachrichten, Sprach- und
                Videoanrufe, Fotos und andere Mediendateien an andere Facebook-Nutzer senden
                und empfangen können.
                <br />
                Wenn Sie Facebook Messenger verwenden, werden auch personenbezogene Daten
                von Ihnen auf den Facebook-Servern verarbeitet. Dazu zählen neben Ihrer
                Telefonnummer und den Chatnachrichten unter anderem auch versendete Fotos,
                Videos, Profildaten, Ihre Adresse oder Ihr Standort.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Facebook Messenger?
            </h3>
            <p>
                Wir wollen mit Ihnen in Kontakt bleiben und das funktioniert am besten über
                Nachrichtendienste wie Facebook Messenger. Zum einen, weil der Dienst
                einwandfrei funktioniert, zum anderen, weil Facebook immer noch eine der
                bekanntesten Social-Media-Plattformen ist. Der Dienst ist praktisch und
                ermöglicht eine unkomplizierte und schnelle Kommunikation mit Ihnen.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch Facebook Messenger verarbeitet?
            </h3>
            <p>
                Durch die Verwendung von Facebook Messenger können verschiedene Arten von
                Daten, darunter auch personenbezogene Daten, verarbeitet werden. Dazu zählen
                Kontoinformationen wie Ihre Telefonnummer, Ihre Profilbild, Ihr Benutzername
                oder andere Informationen, die Sie Facebook im Zuge der Erstellung und
                Verwaltung Ihres Kontos zur Verfügung stellen. Natürlich speichert Facebook
                auch Inhalte Ihrer Nachrichten (Text, Fotos, Videos, Sprachnachrichten).
                Facebook speichert auch sogenannte Metadaten, wie zum Beispiel das Datum und
                die Uhrzeit, zu der eine Nachricht gesendet oder empfangen wurde. Facebook
                Messenger kann auch auf Ihre Kontakte zugreifen, um die Kommunikation mit
                Ihren Kontakten zu ermöglichen. Weiters werden auch technische Daten wie
                Gerätetyp, Betriebssystem oder Standortdaten gespeichert.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich speichert Facebook Daten bis sie nicht mehr für die eigenen
                Dienste und Facebook-Produkte benötigt werden. Facebook hat auf der ganzen
                Welt Server verteilt, wo seine Daten gespeichert werden. Kundendaten werden
                allerdings, nachdem sie mit den eigenen Userdaten abgeglichen wurden,
                innerhalb von 48 Stunden gelöscht.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Sie können
                zudem auch jederzeit die Einwilligung zur Verarbeitung der Daten widerrufen.
                Eine endgültige Löschung der Daten erfolgt nur, wenn Sie Ihr Facebook-Konto
                löschen.
            </p>
            <p>
                Folgen Sie diesen Schritten, um Ihr Facebook-Konto vollständig zu löschen:
            </p>
            <p>
                1) Melden Sie sich bei Facebook an und klicken Sie dann rechts oben auf
                „Einstellungen”.
            </p>
            <p>
                2) Anschließend klicken Sie in der linken Spalte auf „Deine
                Facebook-Informationen“.
            </p>
            <p>3) Nun klicken Sie “Deaktivierung und Löschung”.</p>
            <p>
                4) Wählen Sie jetzt „Konto löschen“ und klicken Sie dann auf „Weiter und
                Konto löschen“
            </p>
            <p>
                5) Geben Sie nun Ihr Passwort ein, klicken Sie auf „Weiter“ und dann auf
                „Konto löschen“
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von Facebook Messenger setzt Ihre Einwilligung voraus, welche
                wir mit unserem Consent-Tool (Popup) eingeholt haben. Diese Einwilligung
                stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Facebook Messenger vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse darin, unser Service zu verbessern. Mit Hilfe von Facebook
                Messenger können wir schneller und besser mit Ihnen kommunizieren. Die
                Rechtsgrundlage dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen Facebook Messenger gleichwohl nur ein, soweit Sie eine
                Einwilligung erteilt haben.
            </p>
            <p>
                Facebook verarbeitet Daten von Ihnen u.a. auch in den USA. Facebook bzw.
                Meta Platforms ist aktiver Teilnehmer des EU-US Data Privacy Frameworks,
                wodurch der korrekte und sichere Datentransfer personenbezogener Daten von
                EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Facebook sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Facebook, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Facebook Datenverarbeitungsbedingung, welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/legal/terms/dataprocessing"
                >
                https://www.facebook.com/legal/terms/dataprocessing
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Facebook verarbeitet
                werden, erfahren Sie in der Privacy Policy auf
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/about/privacy?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.facebook.com/about/privacy
                </a>
                .
            </p>
            <h2 id="helpspot-datenschutzerklaerung" className="adsimple-112958647">
                HelpSpot Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auch das Kommunikationstool HelpSpot. Dienstanbieter ist das
                amerikanische Unternehmen UserScape, Inc., 2600 South Rd Ste 44-175,
                Poughkeepsie, NY 12601, USA.
            </p>
            <h3 className="adsimple-112958647">Was ist HelpSpot?</h3>
            <p>
                Die von der Firma UserScape entwickelte Software ist ein hilfreiches Tool,
                um Ihre Anfragen und Anliegen besser zu verwalten. Dadurch wird unser
                gesamter Kundensupport verbessert und Sie erhalten schneller Lösungen und
                Antworten. Außerdem bietet die Software viele nützliche Funktionen wie
                automatische Antworten auf häufig gestellte Fragen, ein
                Berichterstattungs-System und eine Analyse der Support-Tickets.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir HelpSpot?</h3>
            <p>
                Ein Hauptgrund für die Verwendung von HelpSpot ist mit Sicherheit die
                zentrale Verwaltung aller Kundenanfragen. Dadurch, dass alle eingehenden
                Fragen über das Tool an einem Ort verwaltet werden können, bekommen Sie
                deutlich schneller und genauer Ihre Antworten. Gleichzeitig sind wir in der
                Bearbeitung von Kundenanfragen viel effektiver. Auch die automatisierten
                Prozesse helfen uns insofern weiter, als wir uns schneller auf komplexere
                Kundenanliegen kümmern können.
            </p>
            <h3 className="adsimple-112958647">
                Wie sicher ist der Datentransfer bei HelpSpot?
            </h3>
            <p>
                UserScape verarbeitet Daten von Ihnen u.a. auch in den USA. HelpSpot bzw.
                UserScape ist aktiver Teilnehmer des EU-US Data Privacy Frameworks, wodurch
                der korrekte und sichere Datentransfer personenbezogener Daten von
                EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von HelpSpot verarbeitet
                werden, erfahren Sie in der Privacy Policy auf
                <a
                className="adsimple-112958647"
                href="https://userscape.com/privacy?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://userscape.com/privacy
                </a>
                .
            </p>
            <h2 id="liveagent-datenschutzerklaerung" className="adsimple-112958647">
                LiveAgent Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für unsere Website auch die Help-Desk-Software LiveAgent.
                Dienstanbieter ist das slowakische Unternehmen Quality Unit, s. r. o.,
                Vajnorska 100/A, 831 04 Bratislava, Slowakei.
            </p>
            <h3 className="adsimple-112958647">Was ist LiveAgent?</h3>
            <p>
                Diese Kundenservice-Software vereinfacht und verbessert die Kommunikation
                mit Ihnen. Entwickelt wurde das Programm von den beiden Gründern Viktor
                Leman und Andrej Harsani im Jahr 2004. Das Tool bietet einen umfangreichen
                Kundensupport-Service mit Live-Chatfunktion, ein Ticketsystem und diverse
                Helpdesk-Funktionen. LiveAgent hat mittlerweile über 150 Millionen Nutzer
                und bedient mehr als 40.000 Unternehmen weltweit.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir LiveAgent?</h3>
            <p>
                Natürlich wollen wir mit Ihnen in Kommunikation bleiben und gleichzeitig
                unseren Kundenservice stets verbessern. Mit LiveAgent können wir beides
                realisieren. Mit Hilfe der Chatfunktion werden Ihre Fragen schnell und rasch
                beantwortet. Durch das Ticketsystem verbessert sich unser Workflow und
                steigert unsere Produktivität. Ein weiterer wichtiger Grund, warum wir uns
                bei der Wahl eines Help-Desk-Software für LiveAgent entschieden haben, ist
                der sichere und professionelle Umgang mit personenbezogenen Daten. Wie uns
                ist auch den Machern von LiveAgent Datenschutz ein großes Anliegen. So
                verwendet LiveAgent eine SSL-Verschlüsselung, um die Datenübertragung
                zwischen Ihnen und den Servern zu schützen. Auch alle dort gespeicherten
                Daten sind verschlüsselt und somit nicht einsehbar.
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von LiveAgent verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.liveagent.de/privacy-policy/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.liveagent.de/privacy-policy/
                </a>
                .
            </p>
            <h2
                id="signal-messenger-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Signal Messenger Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website den Messenger-Dienst Signal Messenger.
                Dienstanbieter ist das amerikanische Unternehmen Signal Messenger LLC, 650
                Castro Street, Suite 120-223 Mountain View, CA 94041, USA.
            </p>
            <h3 className="adsimple-112958647">Was ist Signal Messenger?</h3>
            <p>
                Bei dem Signal Messaging handelt es sich um eine Open-Source-Applikation,
                mit der wir eine sichere und private Kommunikation über Textnachrichten,
                Sprach- oder Videoanrufe führen können. Das Tool wurde im Jahr 2014 von
                Moxie Marlinspike und Stuart Anderson gegründet. Signal funktioniert auf
                iOS, Android und Desktop. Ein wichtiges Merkmal von Signal ist auch die
                Ende-zu-Ende-Verschlüsselung. Diese Verschlüsselung stellt sicher, dass
                Nachrichten oder Anrufe wirklich nur von den beteiligten Personen gelesen,
                gesehen oder gehört werden können. Auch die Entwickler von Signal können die
                Nachrichten nicht entschlüsseln.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir Signal Messenger?</h3>
            <p>
                Natürlich wollen wir mit Ihnen in Kommunikation bleiben. Als wir uns für
                einen Messenger entscheiden mussten, fiel unsere Wahl schnell auf Signal
                Messenger. Da uns die Sicherheit von Daten ein großes Anliegen ist, schätzen
                wir die Möglichkeit der verschlüsselten Kommunikation, die uns das Tool
                bietet, sehr. Zudem gibt es auch noch weitere Sicherheitseinstellungen wie
                etwa die automatische Datenlöschung oder die Zwei-Faktor-Authentifizierung.
            </p>
            <h3 className="adsimple-112958647">
                Wie sicher ist der Datentransfer bei Signal Messenger?
            </h3>
            <p>
                Signal verarbeitet Daten u.a. auch in den USA. Wir weisen darauf hin, dass
                nach Meinung des Europäischen Gerichtshofs derzeit kein angemessenes
                Schutzniveau für den Datentransfer in die USA besteht. Dies kann mit
                verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
                <br />
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Signal
                von der EU-Kommission genehmigte Standardvertragsklauseln (= Art. 46. Abs. 2
                und 3 DSGVO). Diese Klauseln verpflichten Signal, das EU-Datenschutzniveau
                bei der Verarbeitung relevanter Daten auch außerhalb der EU einzuhalten.
                Diese Klauseln basieren auf einem Durchführungsbeschluss der EU-Kommission.
                Sie finden den Beschluss sowie die Klauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Signal verarbeitet werden,
                erfahren Sie in der Privacy Policy auf
                <a
                className="adsimple-112958647"
                href="https://signal.org/legal/?tid=112958647"
                >
                https://signal.org/legal/
                </a>
                .
            </p>
            <h2 id="telegram-datenschutzerklaerung" className="adsimple-112958647">
                Telegram Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Telegram Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Telegram-User
                    <br />
                    🤝 Zweck: Kommunikation
                    <br />
                    📓 Verarbeitete Daten: Kontaktdaten, Nachrichten, Medien
                    <br />
                    📅 Speicherdauer: nach Kontolöschung oder Deaktivierung
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Telegram?</h3>
            <p>
                Wir nutzen auch den Instant-Messaging-Dienst Telegram. Dienstanbieter ist
                das internationale Unternehmen Telegram Messenger LLP, das unter einer
                Londoner Adresse (71-75 Shelton Street, Covent Garden, London,
                Großbritannien) geführt wird und in Russland entwickelt wurde.
            </p>
            <p>
                Gegründet wurde Telegram 2013 von Nikolai und Pawel Durow. Da sich das
                Telegram-Team als sogenannte digitale Nomaden verstehen, weiß man nie so
                genau, wo das Team arbeitet. Auch auf ein Impressum wird auf der
                Telegram-Website verzichtet.
                <br />
                Ähnlich wie bei anderen Messaging-Diensten, wie etwa WhatsApp, kann man über
                Telegram Nachrichten, Fotos und Videos und andere Dateien versenden und auch
                telefonieren. Dieser Nachrichtendienst erfreut sich in den letzten Jahren
                immer größerer Beliebtheit. 2022 zählte man bereits über 700 Millionen
                Nutzer.
                <br />
                Wenn Sie Telegram nutzen, werden auch personenbezogene Daten verarbeitet und
                auf den Telegram-Servern gespeichert. Dazu zählen neben den Chatnachrichten
                auch versendete Fotos, Videos und Profildaten, IP-Adresse und
                synchronisierte Kontakte. Telegram verschlüsselt Daten zwar zwischen Server
                und Ihrem Endgerät, kann aber eine Ende-zu-Ende-Verschlüsselung nur bei
                geheimen Chats bieten. Daten, die in der Cloud gespeichert werden, sind vom
                Unternehmen und auch von Drittanbietern einsehbar.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir Telegram?</h3>
            <p>
                Viele Menschen nutzen mittlerweile Telegram als Alternative zu anderen
                Nachrichtendiensten wie etwa WhatsApp. Wir wollen mit Ihnen in Kontakt
                bleiben und das funktioniert am besten über einen Instant-Messaging-Dienst,
                den viele unserer Kunden auch verwenden. Der Dienst funktioniert
                einwandfrei, ist praktisch und ermöglicht eine unkomplizierte Kommunikation
                mit Ihnen.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch Telegram verarbeitet?
            </h3>
            <p>
                Durch die Verwendung von Telegram können verschiedene Arten von Daten,
                darunter auch personenbezogene Daten, verarbeitet werden. Dazu zählen
                Kontoinformationen wie Ihre Telefonnummer, Ihre Profilbild, Ihr Benutzername
                oder andere Informationen, die Sie Telegram im Zuge der Erstellung und
                Verwaltung Ihres Kontos zur Verfügung stellen. Natürlich speichert Telegram
                auch Inhalte Ihrer Nachrichten (Text, Fotos, Videos, Sprachnachrichten).
                Telegram speichert auch sogenannte Metadaten, wie zum Beispiel das Datum und
                die Uhrzeit, zu der eine Nachricht gesendet oder empfangen wurde. Telegram
                kann auch auf Ihre Kontakte zugreifen, um die Kommunikation mit Ihren
                Kontakten zu ermöglichen. Weiters werden auch technische Daten wie
                Gerätetyp, Betriebssystem oder Standortdaten gespeichert.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich werden die Daten bei Telegram so lange gespeichert, wie es für
                die berechtigten Zwecke und zur Erfüllung der rechtlichen Pflichten
                notwendig ist. Wie lange die Daten genau gespeichert werden, kann an dieser
                Stelle nicht konkret beantwortet werden, da dies stark von der Art der Daten
                abhängt. Nach Angaben von Telegram werden die Daten bis zu 12 Monate
                gespeichert. Die Daten werden auf eigenen Telegram-Servern gespeichert, die
                auf der ganzen Welt verteilt sind. Die genauen Standorte dieser Server sind
                leider nicht bekannt.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Sie können
                zudem auch jederzeit die Einwilligung zur Verarbeitung der Daten widerrufen.
                Einzelne Nachrichten und auch ganze Chatverläufe können Sie direkt bei
                Telegram löschen. Weiters haben Sie in den Einstellungen auch die
                Möglichkeit Ihr Konto zu deaktivieren oder zu löschen. Vorerst wird dabei
                eine Kopie der Daten gelöscht und es kann einige Zeit dauern, bis die Daten
                auch auf den Telegramservern gelöscht werden.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von Telegram setzt Ihre Einwilligung voraus, welche wir mit
                unserem Consent-Tool (Popup) eingeholt haben. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Telegram vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse darin, unser Kommunikationsangebot zu verbessern. Mit Hilfe von
                Telegram können wir schneller und besser auf Ihre Anfragen reagieren, Ihnen
                wichtige Nachrichten mitteilen und somit unser Service auf ein nächstes
                Niveau heben. Die Rechtsgrundlage dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen Telegram aber nur ein, soweit Sie eine Einwilligung erteilt
                haben.
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Telegram verarbeitet
                werden, erfahren Sie in der Privacy Policy auf
                <a
                className="adsimple-112958647"
                href="https://telegram.org/privacy?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://telegram.org/privacy
                </a>
                .
            </p>
            <h2 id="whatsapp-datenschutzerklaerung" className="adsimple-112958647">
                WhatsApp Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        WhatsApp Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: WhatsApp-User
                    <br />
                    🤝 Zweck: Kommunikation
                    <br />
                    📓 Verarbeitete Daten: Kontaktdaten, Nachrichten, Medien
                    <br />
                    📅 Speicherdauer: nach Kontolöschung oder Deaktivierung
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist WhatsApp?</h3>
            <p>
                Wir verwenden auf unserer Website den Instant-Messaging-Dienst WhatsApp.
                Dienstanbieter ist das amerikanische Unternehmen WhatsApp Inc., ein
                Tochterunternehmen von Meta Platforms Inc. (bis Oktober 2021 Facebook Inc.).
                Für den europäischen Raum ist das Unternehmen WhatsApp Ireland Limited, 4
                Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland verantwortlich.
            </p>
            <p>
                Vermutlich müssen wir Ihnen WhatsApp nicht genauer vorstellen. Die
                Wahrscheinlichkeit, dass Sie selbst diesen bekannten Messaging-Dienst auf
                Ihrem Smartphone verwenden, ist relativ hoch. Seit vielen Jahren gibt es
                Stimmen, die WhatsApp bzw. das Mutterunternehmen Meta Platforms in Bezug auf
                den Umgang mit personenbezogenen Daten kritisieren. Die Hauptkritik bezog
                sich in den vergangenen Jahren auf das Zusammenfügen von WhatsApp-Userdaten
                mit Facebook. Daraufhin hat Facebook 2021 reagiert und die
                Nutzungsbedingungen angepasst. Facebook teilte darin mit, dass aktuell
                (Stand 2021) keine personenbezogenen Daten von WhatsApp-Usern mit Facebook
                geteilt werden.
                <br />
                Dennoch werden natürlich etliche personenbezogene Daten von Ihnen bei
                WhatsApp verarbeitet, sofern Sie WhatsApp nutzen und der Datenverarbeitung
                zugestimmt haben. Dazu zählen neben Ihrer Telefonnummer und den
                Chatnachrichten auch versendete Fotos, Videos und Profildaten. Fotos und
                Videos sollen allerdings nur kurz zwischengespeichert werden und alle
                Nachrichten und Telefonate sind mit einer Ende-zu-Ende-Verschlüsselung
                versehen. Sie sollten also auch von Meta selbst nicht einsehbar sein. Zudem
                werden auch Informationen aus Ihrem Adressbuch und weitere Metadaten bei
                WhatsApp gespeichert.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir WhatsApp?</h3>
            <p>
                Wir wollen mit Ihnen in Kontakt bleiben und das funktioniert am besten per
                WhatsApp. Zum einen, weil der Dienst einwandfrei funktioniert, zum anderen
                weil WhatsApp immer noch das meist verwendete Instant-Messaging-Tool
                weltweit ist. Der Dienst ist praktisch und ermöglicht eine unkomplizierte
                und schnelle Kommunikation mit Ihnen.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch WhatsApp verarbeitet?
            </h3>
            <p>
                Durch die Verwendung von WhatsApp können verschiedene Arten von Daten,
                darunter auch personenbezogene Daten, verarbeitet werden. Dazu zählen
                Kontoinformationen wie Ihre Telefonnummer, Ihre Profilbild, Ihr Benutzername
                oder andere Informationen, die Sie WhatsApp im Zuge der Erstellung und
                Verwaltung des WhatsApp Kontos zur Verfügung stellen. Natürlich speichert
                WhatsApp auch Inhalte Ihrer Nachrichten (Text, Fotos, Videos,
                Sprachnachrichten). WhatsApp speichert auch sogenannte Metadaten, wie zum
                Beispiel das Datum und die Uhrzeit, zu der eine Nachricht gesendet oder
                empfangen wurde. Auch Telefonnummern der beteiligten Personen und technische
                Daten wie Gerätetyp, Betriebssystem oder Standortdaten werden gespeichert.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich werden die Daten bei WhatsApp so lange gespeichert, wie es für
                die berechtigten Zwecke und zur Erfüllung der rechtlichen Pflichten
                notwendig ist. Wie lange die Daten genau gespeichert werden, kann an dieser
                Stelle nicht konkret beantwortet werden, da dies stark von der Art der Daten
                abhängt. In der Regel werden Nachrichten nur während der Zustellung in
                verschlüsselter Form bei WhatsApp gespeichert und sobald eine Nachricht
                zugestellt wurde, von den Servern gelöscht. Länger werden die Nachrichte nur
                am eigenen Endgerät gespeichert. Wenn Medien versendet werden, speichert
                WhatsApp diese Daten in verschlüsselter Form bis zu 30 Tage, um die
                Zustellung zu optimieren. Kontodaten werden gespeichert, so lange Sie ein
                aktives WhatsApps-Konto haben. Wenn Sie das Konto löschen oder deaktivieren,
                werden Ihre Kontodaten im Normalfall auch gelöscht. Jene Daten, die bei
                WhatsApp gespeichert werden, speichert das Unternehmen auf den eigenen
                Servern, die auf der gesamten Welt verteilt sind. Um die webbasierten
                WhatsApp-Dienste zu betreiben, werden Daten auch mit Hilfe von Cookies
                erhoben.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Sie können
                zudem auch jederzeit die Einwilligung zur Verarbeitung der Daten widerrufen.
            </p>
            <p>
                Wenn Sie nicht wollen, dass bei der Desktopversion Cookies gesetzt werden
                und Daten dadurch gespeichert werden, können Sie in Ihrem Browser das Setzen
                der Cookies auch verhindern. Denn in Ihrem Browser können Sie Cookies
                verwalten, deaktivieren oder löschen. Abhängig von Ihrem Browser
                funktioniert das immer etwas unterschiedlich. Näheres erfahren Sie in
                unserem Abschnitt über Cookies.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von WhatsApp setzt Ihre Einwilligung voraus, welche wir mit
                unserem Consent-Tool (Popup) eingeholt haben. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch WhatsApp vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse darin, unser Kommunikationsangebot zu verbessern. Mit Hilfe von
                WhatsApp können wir schneller und besser auf Ihre Anfragen reagieren, Ihnen
                wichtige Nachrichten mitteilen und somit unser Service auf ein nächstes
                Niveau heben. Die Rechtsgrundlage dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen WhatsApp gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                WhatsApp verarbeitet Daten von Ihnen u.a. auch in den USA. WhatsApp ist
                aktiver Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte
                und sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet WhatsApp sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich WhatsApp, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
                .
            </p>
            <p>
                Informationen zur Datenübermittlung bei WhatsApp, welche den
                Standardvertragsklauseln entsprechen, finden Sie unter
                <a
                className="adsimple-112958647"
                href="https://www.whatsapp.com/legal/business-data-transfer-addendum-20210927"
                target="_blank"
                rel="follow noopener"
                >
                https://www.whatsapp.com/legal/business-data-transfer-addendum-20210927
                </a>
            </p>
            <p>
                Wir hoffen, wir haben Ihnen die wichtigsten Informationen über die Nutzung
                und Datenverarbeitung durch WhatsApp nähergebracht. Mehr über die Daten, die
                durch die Verwendung von WhatsApp verarbeitet werden, erfahren Sie in der
                Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.whatsapp.com/privacy?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.whatsapp.com/privacy
                </a>
                .
            </p>
            <h2 id="zoho-desk-datenschutzerklaerung" className="adsimple-112958647">
                Zoho Desk Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Zoho Desk Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Kunden bzw. Websitebesucher
                    <br />
                    🤝 Zweck: Kundensupport und Kommunikation
                    <br />
                    📓 Verarbeitete Daten: Kontaktdaten, IP-Adresse, Analysedaten
                    <br />
                    📅 Speicherdauer: nach Kontokündigung maximal 6 Monate
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Zoho Desk?</h3>
            <p>
                Wir nutzen auch die Kundenservice-Software Zoho Desk. Der Dienstanbieter ist
                das indische Unternehmen Zoho Corporation, Estancia IT Park, Plot no. 140,
                151, GST Road, Vallancheri, Chengalpattu District, Tamil Nadu – 603202,
                Indien. Das Unternehmen hat auf der ganzen Welt Firmensitze. Der deutsche
                Firmensitz ist in Düsseldorf (Zoho Corporation GmbH, Trinkausstr. 7, 40213
                Düsseldorf, Deutschland).
            </p>
            <p>
                Gegründet wurde Zoho Desk im Jahr 2016 von dem indischen Milliardär und
                Geschäftsmann Sridhar Vembu, der mit seiner Firma neben Zoho Desk auch viele
                andere webbasierte Tools und Anwendungen entwickelt. Darunter finden sich
                Softwareprogramme für CRM-, Buchhaltungs-, E-Mail- und
                Projektmanagement-Systeme.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir Zoho Desk?</h3>
            <p>
                Die Helpdesk-Software Zoho Desk hilft uns, einen erstklassigen Kundensupport
                anzubieten. Zoho Desk bietet zudem auch Lösungen für ein effizientes
                Ticketmanagement und für die Automatisierung von Arbeitsabläufen. Mit Zoho
                Desk können Kundenanfragen auch über verschiedene Kanäle empfangen und
                anschließend beantwortet werden. Insgesamt unterstützt uns das Tool bei der
                Zusammenarbeit innerhalb unseres Teams und in der Kommunikation mit Ihnen.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch Zoho Desk verarbeitet?
            </h3>
            <p>
                Durch Zoho Desk können verschiedene Arten von Daten, darunter auch
                personenbezogene Daten, verarbeitet werden. Wenn Sie etwa das
                Kontaktformular nutzen oder eine Supportanfrage stellen, werden jene Daten,
                die Sie eingeben (z. B.: Name, E-Mail-Adresse und Telefonnummer) erfasst und
                gespeichert. Auch Informationen über Ihr konkretes Anliegen, das Datum, die
                Uhrzeit der Anfragen und Ihre IP-Adresse können gespeichert werden. Wenn Sie
                Supportlinks anklicken, die Chat-Funktion nutzen oder unsere Hilfeartikel
                lesen, werden diese Analyse-Daten zur Besucherinteraktion auch gespeichert.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich werden die Daten bei Zoho Desk so lange gespeichert, wie es
                für die berechtigten Zwecke und zur Erfüllung der rechtlichen Pflichten
                notwendig ist. Wie lange die Daten genau gespeichert werden, kann an dieser
                Stelle nicht konkret beantwortet werden, da dies stark von der Art der Daten
                abhängt. Sobald das Zoho-Benutzerkonto gekündigt wird, werden die Daten
                innerhalb von 6 Monaten aus der aktiven Datenbank gelöscht. Nach 3 Monaten
                werden sie auch aus den Backups gelöscht. Zoho Desk speichert die Daten auf
                ihren eigenen Servern, die an unterschiedlichen Orten stationiert sind. Zur
                Speicherung von Daten kann Zoho Desk auch Cookies und andere
                Tracking-Technologien verwenden.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Sie können
                zudem auch jederzeit die Einwilligung zur Verarbeitung der Daten widerrufen.
            </p>
            <p>
                Wenn Sie nicht wollen, dass Cookies gesetzt werden und Daten dadurch von
                Ihnen bzw. Ihrem Userverhalten gespeichert werden, können Sie in Ihrem
                Browser das Setzen der Cookies auch verhindern. Denn in Ihrem Browser können
                Sie Cookies verwalten, deaktivieren oder löschen. Abhängig von Ihrem Browser
                funktioniert das immer etwas unterschiedlich. Näheres erfahren Sie in
                unserem Abschnitt über Cookies.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von Zoho Desk setzt Ihre Einwilligung voraus, welche wir mit
                unserem Consent-Tool (Popup) eingeholt haben. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Zoho Desk vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse darin, unser Support-Angebot zu verbessern. Mit Hilfe von Zoho
                Desk können wir kanalübergreifend schneller und besser auf Ihre Anfragen
                reagieren und somit unser Service optimieren. Die Rechtsgrundlage dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen Zoho Desk gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Zoho Corporation verarbeitet Daten von Ihnen u.a. auch in den USA. Zoho
                Corporation ist aktiver Teilnehmer des EU-US Data Privacy Frameworks,
                wodurch der korrekte und sichere Datentransfer personenbezogener Daten von
                EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Zoho Corporation sogenannte Standardvertragsklauseln (= Art.
                46. Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual
                Clauses – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und
                sollen sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Zoho Corporation, bei der Verarbeitung Ihrer relevanten
                Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten
                in den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln
                basieren auf einem Durchführungsbeschluss der EU-Kommission. Sie finden den
                Beschluss und die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Zoho Corporation
                finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.zoho.com/blog/general/zoho-welcomes-the-new-sccs.html"
                target="_blank"
                rel="follow noopener"
                >
                https://www.zoho.com/blog/general/zoho-welcomes-the-new-sccs.html
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Zoho Desk verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.zoho.com/privacy.html?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.zoho.com/privacy.html
                </a>
                .
            </p>
            <h2 id="chatbots-einleitung" className="adsimple-112958647">
                Chatbots Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Chatbots Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Kontaktanfragen und die allgemeine Kommunikation zwischen
                    uns und Ihnen
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Name, Adresse, E-Mailadresse,
                    Telefonnummer, allgemeine Inhaltsdaten, gegebenenfalls IP-Adresse
                    <br />
                    Mehr Details dazu finden Sie bei den jeweils eingesetzten Tools.
                    <br />
                    📅 Speicherdauer: abhängig von den verwendeten Chatbots &amp;
                    Chatfunktionen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen), Art. 6 Abs. 1 S. 1 lit.
                    b. DSGVO (vertragliche oder vorvertragliche Verpflichtungen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Chatbots?</h3>
            <p>
                Sie können mit uns auch über Chatbots oder ähnliche Chatfunktionen
                kommunizieren. Ein Chat bietet die Möglichkeit, mit nur sehr geringer
                Zeitverzögerung miteinander zu schreiben oder zu sprechen. Ein Chatbot ist
                eine Software, die Ihre Frage versucht zu beantworten und Sie gegebenenfalls
                über Neuigkeiten informiert. Durch die Verwendung dieser
                Kommunikationsmittel können auch personenbezogene Daten von Ihnen
                verarbeitet und gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">Warum nutzen wir Chatbots?</h3>
            <p>
                Kommunikationsmöglichkeiten mit Ihnen sind uns wichtig. Schließlich wollen
                wir mit Ihnen sprechen und alle möglichen Fragen zu unserem Service
                bestmöglich beantworten. Eine gut funktionierende Kommunikation ist bei uns
                ein wichtiger Teil unserer Dienstleistung. Chatbots haben den großen
                Vorteil, dass wir häufig gestellte Fragen mit Hilfe dieser Software
                automatisiert beantworten können. Das erspart uns Zeit und Sie erhalten
                dennoch ausführliche und hilfreiche Antworten. Wenn der Chatbot nicht
                weiterhelfen kann, haben Sie natürlich jederzeit auch die Möglichkeit, mit
                uns persönlich in Kontakt zu treten.
            </p>
            <p>
                Bitte beachten Sie, dass bei der Nutzung unserer eingebauten Elemente auch
                Daten von Ihnen außerhalb der Europäischen Union verarbeitet werden können,
                da viele Anbieter amerikanische Unternehmen sind. Dadurch können Sie
                möglicherweise Ihre Rechte in Bezug auf Ihre personenbezogenen Daten nicht
                mehr so leicht einfordern bzw. durchsetzen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Es kann vorkommen, dass Sie die Chatdienste auch bei anderen
                Websites/Plattformen verwenden. In diesem Fall wird auch Ihre User-ID auf
                den Servern dieser Website gespeichert. Wir können weiters auch darüber
                informiert werden, welcher User zu welchem Zeitpunkt den Chat verwendet hat.
                Auch die Inhalte werden gespeichert. Welche Daten genau gespeichert werden
                hängt vom jeweiligen Dienst ab. In der Regel handelt es sich aber um
                Kontaktdaten wie E-Mail-Adresse oder Telefonnummer, IP-Adresse und diverse
                Nutzungsdaten.
            </p>
            <p>
                Wenn Sie eingewilligt haben, dass die Chatfunktion zur Anwendung kommen
                kann, wird auch diese Einwilligung samt einer möglichen Registrierung
                gespeichert bzw. protokolliert. Das machen wir, damit wir die Registrierung
                oder die Einwilligung auch vorweisen können, wenn dies gesetzlich verlangt
                wird.
            </p>
            <p>
                Der Anbieter einer Chat-Plattform kann auch erfahren, wann Sie chatten, und
                erhält auch technische Informationen über Ihr verwendetes Gerät. Welche
                Informationen genau gespeichert und verarbeitet werden, hängt auch von Ihren
                PC-Einstellungen ab. In vielen Fällen können etwa Daten zu Ihrem ungefähren
                Standort erhoben werden. Dies wird einerseits gemacht, um die Chatdienste zu
                optimieren und andererseits, um mehr Sicherheit zu gewährleisten. Weiters
                können die Informationen auch genutzt werden, um personalisierte Werbe- und
                Marketingmaßnahmen zu setzen.
            </p>
            <p>
                Wenn Sie eingewilligt haben, dass Ihnen ein Chatbot eine Nachrichten senden
                kann, können Sie natürlich diese Aktivierung auch jederzeit wieder
                deaktivieren. Der Chatbot dient hier auch als Hilfe und zeigt Ihnen wie Sie
                diese Funktion abbestellen können. All Ihre diesbezüglichen Daten werden im
                Anschluss aus dem Empfänger-Verzeichnis gelöscht.
            </p>
            <p>
                Die oben genannten Daten verwenden wir, um etwa Sie über den Chat persönlich
                ansprechen zu können, um Ihre Fragen und Anfragen beantworten zu können oder
                auch um Ihnen mögliche Inhalte zu senden. Außerdem können wir damit auch
                unsere Chat-Dienste grundsätzlich verbessern.
            </p>
            <h3 className="adsimple-112958647">Wie lange werden Daten gespeichert?</h3>
            <p>
                Wie lange die Daten verarbeitet und gespeichert werden, hängt in erster
                Linie von unseren verwendeten Tools ab. Weiter unten erfahren Sie mehr über
                die Datenverarbeitung der einzelnen Tools. In den Datenschutzerklärungen der
                Anbieter steht üblicherweise genau, welche Daten wie lange gespeichert und
                verarbeitet werden. Grundsätzlich werden personenbezogene Daten nur so lange
                verarbeitet, wie es für die Bereitstellung unserer Dienste nötig ist. Wenn
                Daten in Cookies gespeichert werden, variiert die Speicherdauer stark. Die
                Daten können gleich nach dem Verlassen einer Website wieder gelöscht werden,
                sie können aber auch über mehrere Jahre gespeichert bleiben. Daher sollten
                Sie sich jedes einzelnen Cookie im Detail ansehen, wenn Sie über die
                Datenspeicherung Genaueres wissen wollen. Meistens finden Sie in den
                Datenschutzerklärungen der einzelnen Anbieter auch aufschlussreiche
                Informationen über die einzelnen Cookies.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert
                entweder über unser Cookie-Management-Tool oder über andere
                Opt-Out-Funktionen. Zum Beispiel können Sie auch die Datenerfassung durch
                Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
                deaktivieren oder löschen.
            </p>
            <p>
                Da bei Chat-Diensten Cookies zum Einsatz kommen können, empfehlen wir Ihnen
                auch unsere allgemeine Datenschutzerklärung über Cookies. Um zu erfahren,
                welche Daten von Ihnen genau gespeichert und verarbeitet werden, sollten Sie
                die Datenschutzerklärungen der jeweiligen Tools durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wir fragen über ein Popup-Fenster um Ihre Erlaubnis, Daten von Ihnen im
                Rahmen der Chat-Dienste verarbeiten zu dürfen. Wenn Sie einwilligen, gilt
                diese Einwilligung auch als rechtliche Grundlage{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>{" "}
                zur Datenverarbeitung. Zudem bearbeiten wir Ihre Anfragen und verwalten Ihre
                Daten im Rahmen vertraglicher oder vorvertraglicher Beziehungen, um unsere
                vorvertraglichen und vertraglichen Pflichten zu erfüllen bzw. Anfragen zu
                beantworten. Grundlage dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 S. 1 lit. b. DSGVO
                </strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die Tools
                gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben.
            </p>
            <h2 id="chatchamp-datenschutzerklaerung" className="adsimple-112958647">
                Chatchamp Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auch die Assistenz- und Chatbot-Software Chatchamp.
                Dienstanbieter ist das deutsche Unternehmen chatchamp c/o Wayra,
                Kaufingerstraße 15, 80331 München. Mehr über die Daten, die durch die
                Verwendung von Chatchamp verarbeitet werden, erfahren Sie in der Privacy
                Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.chatchamp.com/privacy/"
                target="_blank"
                rel="noopener"
                >
                https://www.chatchamp.com/privacy/
                </a>
                .
            </p>
            <h2 id="livechat-datenschutzerklaerung" className="adsimple-112958647">
                LiveChat Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für unsere Website die Chat-Software LiveChat. Der Dienstanbieter
                ist das amerikanische Unternehmen LiveChat Inc., 101 Arch Street, 8th Floor,
                Boston MA 02110, USA.
            </p>
            <h3 className="adsimple-112958647">Was ist LiveChat?</h3>
            <p>
                Über dieses Tool können wir über eine Chat-Schnittstelle mit Ihnen
                kommunizieren. LiveChat kann sowohl auf Websites als auch auf mobilen
                Anwendungen eingesetzt werden und bietet Ihnen und uns eine userfreundliche
                Plattform für Marketing-Maßnahmen, Kundensupport und Vertrieb. Außerdem
                lassen sich viele andere Plattformen und Tools, wie etwa Projektmanagement-
                oder CRM-Systeme integrieren. Laut Angaben des Unternehmens wird auch großer
                Wert auf Sicherheit und Datenschutz gelegt.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir LiveChat?</h3>
            <p>
                Wir haben uns für LiveChat entschieden, weil uns der Schutz
                personenbezogener Daten am Herzen liegt. Über LiveChat können Sie uns sehr
                schnell und einfach Fragen stellen, Probleme lösen oder allgemeine
                Informationen zu unseren Dienstleistungen oder Produkten erhalten. Die
                Benutzeroberfläche ist einfach zu bedienen und das Support-Team steht uns
                bei Fragen schnell zur Seite steht.
            </p>
            <h3 className="adsimple-112958647">
                Wie sicher ist der Datentransfer bei LiveChat?
            </h3>
            <p>
                LiveChat verarbeitet Daten von Ihnen u.a. auch in den USA. LiveChat ist
                aktiver Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte
                und sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet LiveChat sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich LiveChat, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Weitere Informationen zu den Standardvertragsklauseln bei LiveChat finden
                Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.livechat.com/legal/gdpr-faq/"
                >
                https://www.livechat.com/legal/gdpr-faq/
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von LiveChat verarbeitet
                werden, erfahren Sie in der Privacy Policy auf
                <a
                className="adsimple-112958647"
                href="https://www.livechat.com/legal/privacy-policy/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.livechat.com/legal/privacy-policy/
                </a>
                .
            </p>
            <h2 id="social-media-einleitung" className="adsimple-112958647">
                Social Media Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Social Media Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Darstellung und Optimierung unserer Serviceleistung, Kontakt
                    zu Besuchern, Interessenten u.a., Werbung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Telefonnummern, E-Mail-Adressen,
                    Kontaktdaten, Daten zum Nutzerverhalten, Informationen zu Ihrem Gerät
                    und Ihre IP-Adresse.
                    <br />
                    Mehr Details dazu finden Sie beim jeweils eingesetzten
                    Social-Media-Tool.
                    <br />
                    📅 Speicherdauer: abhängig von den verwendeten
                    Social-Media-Plattformen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Social Media?</h3>
            <p>
                Zusätzlich zu unserer Website sind wir auch in diversen
                Social-Media-Plattformen aktiv. Dabei können Daten von Usern verarbeitet
                werden, damit wir gezielt User, die sich für uns interessieren, über die
                sozialen Netzwerke ansprechen können. Darüber hinaus können auch Elemente
                einer Social-Media-Plattform direkt in unsere Website eingebettet sein. Das
                ist etwa der Fall, wenn Sie einen sogenannten Social-Button auf unserer
                Website anklicken und direkt zu unserem Social-Media-Auftritt weitergeleitet
                werden. Als sogenannte Sozialen Medien oder Social Media werden Websites und
                Apps bezeichnet, über die angemeldete Mitglieder Inhalte produzieren,
                Inhalte offen oder in bestimmten Gruppen austauschen und sich mit anderen
                Mitgliedern vernetzen können.
            </p>
            <h3 className="adsimple-112958647">Warum nutzen wir Social Media?</h3>
            <p>
                Seit Jahren sind Social-Media-Plattformen der Ort, wo Menschen online
                kommunizieren und in Kontakt treten. Mit unseren Social-Media-Auftritten
                können wir unsere Produkte und Dienstleistungen Interessenten näherbringen.
                Die auf unserer Website eingebundenen Social-Media-Elemente helfen Ihnen,
                schnell und ohne Komplikationen zu unseren Social-Media-Inhalten wechseln
                können.
            </p>
            <p>
                Die Daten, die durch Ihre Nutzung eines Social-Media-Kanals gespeichert und
                verarbeitet werden, haben in erster Linie den Zweck, Webanalysen durchführen
                zu können. Ziel dieser Analysen ist es, genauere und personenbezogene
                Marketing- und Werbestrategien entwickeln zu können. Abhängig von Ihrem
                Verhalten auf einer Social-Media-Plattform, können mit Hilfe der
                ausgewerteten Daten, passende Rückschlüsse auf Ihre Interessen getroffen
                werden und sogenannte Userprofile erstellt werden. So ist es den Plattformen
                auch möglich, Ihnen maßgeschneiderte Werbeanzeigen zu präsentieren. Meistens
                werden für diesen Zweck Cookies in Ihrem Browser gesetzt, die Daten zu Ihrem
                Nutzungsverhalten speichern.
            </p>
            <p>
                Wir gehen in der Regel davon aus, dass wir datenschutzrechtlich
                verantwortlich bleiben, auch wenn wir Dienste einer Social-Media-Plattform
                nutzen. Der Europäische Gerichtshof hat jedoch entschieden, dass in
                bestimmten Fällen der Betreiber der Social-Media-Plattform zusammen mit uns
                gemeinsam verantwortlich im Sinne des Art. 26 DSGVO sein kann. Soweit dies
                der Fall ist, weisen wir gesondert darauf hin und arbeiten auf Grundlage
                einer diesbezüglichen Vereinbarung. Das Wesentliche der Vereinbarung ist
                dann weiter unten bei der betroffenen Plattform wiedergegeben.
            </p>
            <p>
                Bitte beachten Sie, dass bei der Nutzung der Social-Media-Plattformen oder
                unserer eingebauten Elemente auch Daten von Ihnen außerhalb der Europäischen
                Union verarbeitet werden können, da viele Social-Media-Kanäle,
                beispielsweise Facebook oder Twitter, amerikanische Unternehmen sind.
                Dadurch können Sie möglicherweise Ihre Rechte in Bezug auf Ihre
                personenbezogenen Daten nicht mehr so leicht einfordern bzw. durchsetzen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Welche Daten genau gespeichert und verarbeitet werden, hängt vom jeweiligen
                Anbieter der Social-Media-Plattform ab. Aber für gewöhnlich handelt es sich
                um Daten wie etwa Telefonnummern, E-Mailadressen, Daten, die Sie in ein
                Kontaktformular eingeben, Nutzerdaten wie zum Beispiel welche Buttons Sie
                klicken, wen Sie liken oder wem folgen, wann Sie welche Seiten besucht
                haben, Informationen zu Ihrem Gerät und Ihre IP-Adresse. Die meisten dieser
                Daten werden in Cookies gespeichert. Speziell wenn Sie selbst ein Profil bei
                dem besuchten Social-Media-Kanal haben und angemeldet sind, können Daten mit
                Ihrem Profil verknüpft werden.
            </p>
            <p>
                Alle Daten, die über eine Social-Media-Plattform erhoben werden, werden auch
                auf den Servern der Anbieter gespeichert. Somit haben auch nur die Anbieter
                Zugang zu den Daten und können Ihnen die passenden Auskünfte geben bzw.
                Änderungen vornehmen.
            </p>
            <p>
                Wenn Sie genau wissen wollen, welche Daten bei den Social-Media-Anbietern
                gespeichert und verarbeitet werden und wie sie der Datenverarbeitung
                widersprechen können, sollten Sie die jeweilige Datenschutzerklärung des
                Unternehmens sorgfältig durchlesen. Auch wenn Sie zur Datenspeicherung und
                Datenverarbeitung Fragen haben oder entsprechende Rechte geltend machen
                wollen, empfehlen wir Ihnen, sich direkt an den Anbieter wenden.
            </p>
            <h3 className="adsimple-112958647">
                <span
                className="adsimple-112958647"
                data-sheets-value='{"1":2,"2":"Wo und wie lange werden Daten gespeichert?"}'
                data-sheets-userformat='{"2":769,"3":{"1":0},"11":4,"12":0}'
                >
                Dauer der Datenverarbeitung
                </span>
            </h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Beispielsweise speichert die
                Social-Media-Plattform Facebook Daten, bis sie für den eigenen Zweck nicht
                mehr benötigt werden. Kundendaten, die mit den eigenen Userdaten abgeglichen
                werden, werden aber schon innerhalb von zwei Tagen gelöscht. Generell
                verarbeiten wir personenbezogene Daten nur so lange wie es für die
                Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig
                ist. Wenn es, wie zum Beispiel im Fall von Buchhaltung, gesetzlich
                vorgeschrieben ist, kann diese Speicherdauer auch überschritten werden.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern wie eingebettete
                Social-Media-Elemente zu widerrufen. Das funktioniert entweder über unser
                Cookie-Management-Tool oder über andere Opt-Out-Funktionen. Zum Beispiel
                können Sie auch die Datenerfassung durch Cookies verhindern, indem Sie in
                Ihrem Browser die Cookies verwalten, deaktivieren oder löschen.
            </p>
            <p>
                Da bei Social-Media-Tools Cookies zum Einsatz kommen können, empfehlen wir
                Ihnen auch unsere allgemeine Datenschutzerklärung über Cookies. Um zu
                erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet werden,
                sollten Sie die Datenschutzerklärungen der jeweiligen Tools durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
                Social-Media-Elemente verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten bei Vorliegen einer Einwilligung auch auf
                Grundlage unseres berechtigten Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>{" "}
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die Tools
                gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben. Die meisten
                Social-Media-Plattformen setzen auch Cookies in Ihrem Browser, um Daten zu
                speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies
                genau durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien
                des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                Informationen zu speziellen Social-Media-Plattformen erfahren Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h2 id="addthis-datenschutzerklaerung" className="adsimple-112958647">
                AddThis Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        AddThis Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Daten zum Nutzerverhalten,
                    Informationen zu Ihrem Gerät und Ihre IP-Adresse.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in der Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: die gesammelten Daten für 13 Monate ab der
                    Datenerhebung gespeichert
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist AddThis?</h3>
            <p>
                Wir verwenden auf unserer Website Plug-ins von AddThis der Firma Oracle
                America, Inc. (500 Oracle Parkway, Redwood Shores, CA 94065, USA). Mit
                diesen Plug-ins können Sie Inhalte unserer Website schnell und einfach mit
                anderen Menschen teilen. Wenn Sie eine Webseite mit einer AddThis-Funktion
                besuchen, können Daten von Ihnen an das Unternehmen AddThis übertragen,
                gespeichert und verarbeitet werden. Mit dieser Datenschutzerklärungen
                erfahren Sie warum wir AddThis verwenden, welche Daten verarbeitet werden
                und wie Sie diese Datenübertragung unterbinden können.
            </p>
            <p>
                AddThis entwickelt unter anderem Software-Tools, die auf Websites
                eingebunden werden, um Usern das Verbreiten von Inhalten auf verschiedenen
                Social-Media-Kanälen oder per E-Mail zu ermöglichen. Darüber hinaus bietet
                AddThis auch Funktionen, die der Websiteanalyse dienen. Die gesammelten
                Daten werden auch genutzt, um Internetusern interessensbezogene Werbung
                anzubieten. Das Service wird von mehr als 15 Millionen Websitebetreibern
                weltweit in Anspruch genommen.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir AddThis auf unserer Website?
            </h3>
            <p>
                Durch die Nutzung der AddThis-Buttons können Sie interessante Inhalte
                unserer Webseite in verschiedenen Social-Media-Kanälen wie Facebook,
                Twitter, Instagram oder Pinterest teilen. Wenn Sie unsere Inhalte gut
                finden, freut es uns natürlich, wenn Sie diese auch mit Ihrer
                Social-Community teilen. Und am einfachsten geht das über die
                AddThis-Buttons.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von AddThis gespeichert?
            </h3>
            <p>
                Wenn Sie Inhalte mit AddThis teilen und Sie mit dem jeweiligen
                Social-Media-Konto angemeldet sind, können Daten wie beispielsweise der
                Besuch auf unserer Website und das Teilen von Inhalten dem Userkonto des
                entsprechenden Social-Media-Kanals zugeordnet werden. AddThis verwendet
                Cookies, Pixel, HTTP-Header und Browser Identifier, um Daten zu Ihrem
                Besucherverhalten zu sammeln. Zudem werden manche dieser Daten nach einer
                Pseudonymisierung mit Dritten geteilt.
                <br />
                Hier eine beispielhafte Auflistung der möglicherweise verarbeiteten Daten:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                Eindeutige ID eines im Webbrowser platzierten Cookies
                </li>
                <li className="adsimple-112958647">Adresse der besuchten Webseite</li>
                <li className="adsimple-112958647">Zeitpunkt des Webseitenbesuches</li>
                <li className="adsimple-112958647">
                Suchanfragen über die ein Besucher zur Seite mit AddThis gelangt ist
                </li>
                <li className="adsimple-112958647">Verweildauer auf einer Webseite</li>
                <li className="adsimple-112958647">
                Die IP-Adresse des Computers oder mobilen Gerätes
                </li>
                <li className="adsimple-112958647">
                Mobile Werbe-IDs (Apple IDFA oder Google AAID)
                </li>
                <li className="adsimple-112958647">
                In HTTP-Headern oder anderen verwendeten Übertragungsprotokollen
                enthaltene Informationen
                </li>
                <li className="adsimple-112958647">
                Welches Programm auf dem Computer (Browser) oder welches Betriebssystem
                verwendet wurde (iOS)
                </li>
            </ul>
            <p>
                AddThis verwendet Cookies, die wir im Folgenden beispielhaft und
                auszugsweise auflisten. Mehr zu den AddThis-Cookies finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.oracle.com/legal/privacy/addthis-privacy-policy.html"
                target="_blank"
                rel="follow noopener"
                >
                https://www.oracle.com/legal/privacy/addthis-privacy-policy.html
                </a>
                .
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>bt2
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                8961a7f179d87qq69V69112958647-3
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck</strong>
                <strong className="adsimple-112958647 text-[#787c87]">: </strong>Dieses Cookie wird
                verwendet, um Teile der besuchten Website aufzuzeichnen, um andere Teile der
                Website zu empfehlen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 255
                Tagen
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>bku
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                ra/99nTmYN+fZWX7112958647-4
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie registriert anonymisierte Benutzerdaten wie Ihre IP-Adresse,
                geografischen Standort, besuchte Websites und auf welche Anzeigen Sie
                geklickt haben.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 179
                Tagen
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung: </strong>Bitte bedenken
                Sie, dass es sich hier um eine beispielhafte Liste handelt und wir keinen
                Anspruch auf Vollständigkeit erheben können.
            </p>
            <p>
                AddThis teilt gesammelte Informationen auch mit anderen Unternehmen. Nähere
                Details dazu finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.oracle.com/legal/privacy/addthis-privacy-policy.html"
                target="_blank"
                rel="follow noopener"
                >
                https://www.oracle.com/legal/privacy/addthis-privacy-policy.html
                </a>
                . AddThis verwendet die erhaltenen Daten auch, um Zielgruppen und
                Interessensprofile zu erstellen und um Usern im selben Werbenetzwerk
                interessensbezogene Werbung anzubieten.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                AddThis speichert die gesammelten Daten für 13 Monate ab der Datenerhebung.
                1% der Daten werden als „Musterdatensatz“ für maximal 24 Monate aufgehoben,
                damit die Geschäftsverbindung bewahrt bleibt. In diesem „Musterdatensatz“
                wird allerdings die direkte und indirekte Identifikation (wie Ihre
                IP-Adresse und Cookie-ID) gehasht. Das bedeutet, dass die persönlichen Daten
                ohne Zusatzinformationen nicht mehr mit Ihnen in Verbindung gebracht werden
                können. Da das Unternehmen AddThis ihren Hauptsitz in den USA hat, werden
                die gesammelte Daten auch auf amerikanischen Servern gespeichert.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Ihre personenbezogenen Daten zuzugreifen
                und sie auch zu löschen. Wenn Sie keine Werbung mehr sehen möchten, die auf
                von AddThis gesammelten Daten basiert, können Sie den Opt-out-Button auf{" "}
                <a
                className="adsimple-112958647"
                href="https://datacloudoptout.oracle.com/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://datacloudoptout.oracle.com/?tid=112958647
                </a>{" "}
                verwenden. Dabei wird ein Opt-out-Cookie gesetzt, das Sie nicht löschen
                dürfen, um diese Einstellung weiterhin zu behalten.
            </p>
            <p>
                Sie können Ihre Präferenzen für nutzungsbasierte Onlinewerbung auch über{" "}
                <a
                className="adsimple-112958647"
                href="https://www.youronlinechoices.com/at/"
                target="_blank"
                rel="follow noopener"
                >
                https://www.youronlinechoices.com/at/
                </a>
                &nbsp;im Präferenzmanagement festlegen.
            </p>
            <p>
                Eine Möglichkeit die Datenverarbeitung zu unterbinden bzw. nach Ihren
                Wünschen zu verwalten, bietet Ihr Browser. Je nach Browser funktioniert die
                Datenverarbeitung etwas anders. Unter dem Abschnitt „Cookies“ finden Sie die
                entsprechenden Links zu den jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
                Social-Media-Elemente verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die eingebundene
                Social-Media-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben. Die meisten Social-Media-Plattformen setzen auch Cookies in
                Ihrem Browser, um Daten zu speichern. Darum empfehlen wir Ihnen, unseren
                Datenschutztext über Cookies genau durchzulesen und die Datenschutzerklärung
                oder die Cookie-Richtlinien des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                AddThis verarbeitet Daten u.a. auch in den USA. Wir weisen darauf hin, dass
                nach Meinung des Europäischen Gerichtshofs derzeit kein angemessenes
                Schutzniveau für den Datentransfer in die USA besteht. Dies kann mit
                verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                AddThis von der EU-Kommission genehmigte Standardvertragsklauseln (= Art.
                46. Abs. 2 und 3 DSGVO). Diese Klauseln verpflichten AddThis, das
                EU-Datenschutzniveau bei der Verarbeitung relevanter Daten auch außerhalb
                der EU einzuhalten. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss sowie die Klauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Wenn Sie mehr über die Verarbeitung Ihrer Daten durch AddThis wissen
                möchten, finden Sie weitere Informationen unter
                <a
                className="adsimple-112958647"
                href="https://www.oracle.com/legal/privacy/?tid=[adsimpletextid"
                target="_blank"
                rel="follow noopener"
                >
                https://www.oracle.com/legal/privacy/
                </a>
                .
            </p>
            <h2 id="facebook-datenschutzerklaerung" className="adsimple-112958647">
                Facebook Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Facebook Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Kundendaten, Daten zum
                    Nutzerverhalten, Informationen zu Ihrem Gerät und Ihre IP-Adresse.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in der Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: bis die Daten für Facebooks Zwecke nicht mehr
                    nützlich sind
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Facebook-Tools?</h3>
            <p>
                Wir verwenden auf unserer Website ausgewählte Tools von Facebook. Facebook
                ist ein Social Media Network des Unternehmens Meta Platforms Inc. bzw. für
                den europäischen Raum des Unternehmens Meta Platforms Ireland Limited, 4
                Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland. Mithilfe dieser
                Tools können wir Ihnen und Menschen, die sich für unsere Produkte und
                Dienstleistungen interessieren, das bestmögliche Angebot bieten.
            </p>
            <p>
                Wenn über unsere eingebetteten Facebook-Elemente oder über unsere
                Facebook-Seite (Fanpage) Daten von Ihnen erhoben und weitergeleitet werden,
                sind sowohl wir als auch Facebook Irland Ltd. dafür verantwortlich. Für die
                weitere Verarbeitung dieser Daten trägt Facebook allein die Verantwortung.
                Unsere gemeinsamen Verpflichtungen wurden auch in einer öffentlich
                zugänglichen Vereinbarung unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/legal/controller_addendum"
                >
                https://www.facebook.com/legal/controller_addendum
                </a>
                verankert. Darin ist etwa festgehalten, dass wir Sie klar über den Einsatz
                der Facebook-Tools auf unserer Seite informieren müssen. Weiters sind wir
                auch dafür verantwortlich, dass die Tools datenschutzrechtlich sicher in
                unsere Website eingebunden sind. Facebook ist hingegen beispielsweise für
                die Datensicherheit der Facebook-Produkte verantwortlich. Bei etwaigen
                Fragen zur Datenerhebung und Datenverarbeitung durch Facebook können Sie
                sich direkt an das Unternehmen wenden. Wenn Sie die Frage an uns richten,
                sind wir dazu verpflichtet diese an Facebook weiterleiten.
            </p>
            <p>
                Im Folgenden geben wir einen Überblick über die verschiedenen Facebook
                Tools, welche Daten an Facebook gesendet werden und wie Sie diese Daten
                löschen können.
            </p>
            <p>
                Neben vielen anderen Produkten bietet Facebook auch die sogenannten
                “Facebook Business Tools” an.&nbsp;Das ist die offizielle Bezeichnung von
                Facebook. Da der Begriff aber kaum bekannt ist, haben wir uns dafür
                entschieden, sie lediglich Facebook-Tools zu nennen. Darunter finden sich
                unter anderem:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">Facebook-Pixel</li>
                <li className="adsimple-112958647">
                soziale Plug-ins (wie z.B der „Gefällt mir“- oder „Teilen“-Button)
                </li>
                <li className="adsimple-112958647">Facebook Login</li>
                <li className="adsimple-112958647">Account Kit</li>
                <li className="adsimple-112958647">APIs (Programmierschnittstelle)</li>
                <li className="adsimple-112958647">
                SDKs (Sammlung von Programmierwerkzeugen)
                </li>
                <li className="adsimple-112958647">Plattform-Integrationen</li>
                <li className="adsimple-112958647">Plugins</li>
                <li className="adsimple-112958647">Codes</li>
                <li className="adsimple-112958647">Spezifikationen</li>
                <li className="adsimple-112958647">Dokumentationen</li>
                <li className="adsimple-112958647">Technologien und Dienstleistungen</li>
            </ul>
            <p>
                Durch diese Tools erweitert Facebook Dienstleistungen und hat die
                Möglichkeit, Informationen über User-Aktivitäten außerhalb von Facebook zu
                erhalten.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Facebook-Tools auf unserer Website?
            </h3>
            <p>
                Wir wollen unsere Dienstleistungen und Produkte nur Menschen zeigen, die
                sich auch wirklich dafür interessieren. Mithilfe von Werbeanzeigen
                (Facebook-Ads) können wir genau diese Menschen erreichen. Damit den Usern
                passende Werbung gezeigt werden kann, benötigt Facebook allerdings
                Informationen über die Wünsche und Bedürfnisse der Menschen. So werden dem
                Unternehmen&nbsp;Informationen über das Userverhalten (und Kontaktdaten) auf
                unserer Webseite zur Verfügung gestellt. Dadurch sammelt Facebook bessere
                User-Daten und kann interessierten Menschen die passende Werbung über unsere
                Produkte bzw. Dienstleistungen anzeigen. Die Tools ermöglichen somit
                maßgeschneiderte Werbekampagnen auf Facebook.
            </p>
            <p>
                Daten über Ihr Verhalten auf unserer Webseite nennt Facebook „Event-Daten“.
                Diese werden auch für Messungs- und Analysedienste verwendet. Facebook kann
                so in unserem Auftrag „Kampagnenberichte“ über die Wirkung unserer
                Werbekampagnen erstellen. Weiters bekommen wir durch Analysen einen besseren
                Einblick, wie Sie unsere Dienstleistungen, Webseite oder Produkte verwenden.
                Dadurch optimieren wir mit einigen dieser Tools Ihre Nutzererfahrung auf
                unserer Webseite. Beispielsweise können Sie mit den sozialen Plug-ins
                Inhalte auf unserer Seite direkt auf Facebook teilen.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Facebook-Tools gespeichert?
            </h3>
            <p>
                Durch die Nutzung einzelner Facebook-Tools können personenbezogene Daten
                (Kundendaten) an Facebook gesendet werden. Abhängig von den benutzten Tools
                können Kundendaten wie Name, Adresse, Telefonnummer und IP-Adresse versandt
                werden.
            </p>
            <p>
                Facebook verwendet diese Informationen, um die Daten mit den Daten, die es
                selbst von Ihnen hat (sofern Sie Facebook-Mitglied sind) abzugleichen. Bevor
                Kundendaten an Facebook übermittelt werden, erfolgt ein sogenanntes
                „Hashing“. Das bedeutet, dass ein beliebig großer Datensatz in eine
                Zeichenkette transformiert wird. Dies dient auch der Verschlüsselung von
                Daten.
            </p>
            <p>
                Neben den Kontaktdaten werden auch „Event-Daten“ übermittelt. Unter
                „Event-Daten“ sind jene Informationen gemeint, die wir über Sie auf unserer
                Webseite erhalten. Zum Beispiel, welche Unterseiten Sie besuchen oder welche
                Produkte Sie bei uns kaufen. Facebook teilt die erhaltenen Informationen
                nicht mit Drittanbietern (wie beispielsweise Werbetreibende), außer das
                Unternehmen hat eine explizite Genehmigung oder ist rechtlich dazu
                verpflichtet. „Event-Daten“ können auch mit Kontaktdaten verbunden werden.
                Dadurch kann Facebook bessere personalisierte Werbung anbieten. Nach dem
                bereits erwähnten Abgleichungsprozess löscht Facebook die Kontaktdaten
                wieder.
            </p>
            <p>
                Um Werbeanzeigen optimiert ausliefern zu können, verwendet Facebook die
                Event-Daten nur, wenn diese mit anderen Daten (die auf andere Weise von
                Facebook erfasst wurden) zusammengefasst wurden. Diese Event-Daten nützt
                Facebook auch für Sicherheits-, Schutz-, Entwicklungs- und Forschungszwecke.
                Viele dieser Daten werden über Cookies zu Facebook übertragen. Cookies sind
                kleine Text-Dateien, die zum Speichern von Daten bzw. Informationen in
                Browsern verwendet werden. Je nach verwendeten Tools und abhängig davon, ob
                Sie Facebook-Mitglied sind, werden unterschiedlich viele Cookies in Ihrem
                Browser angelegt. In den Beschreibungen der einzelnen Facebook Tools gehen
                wir näher auf einzelne Facebook-Cookies ein. Allgemeine Informationen über
                die Verwendung von Facebook-Cookies erfahren Sie auch auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/policies/cookies?tid=112958647"
                >
                https://www.facebook.com/policies/cookies
                </a>
                .
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich speichert Facebook Daten bis sie nicht mehr für die eigenen
                Dienste und Facebook-Produkte benötigt werden. Facebook hat auf der ganzen
                Welt Server verteilt, wo seine Daten gespeichert werden. Kundendaten werden
                allerdings, nachdem sie mit den eigenen Userdaten abgeglichen wurden,
                innerhalb von 48 Stunden gelöscht.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Entsprechend der Datenschutz Grundverordnung haben Sie das Recht auf
                Auskunft, Berichtigung, Übertragbarkeit und Löschung Ihrer Daten.
            </p>
            <p>
                Eine komplette Löschung der Daten erfolgt nur, wenn Sie Ihr Facebook-Konto
                vollständig löschen. Und so funktioniert das Löschen Ihres Facebook-Kontos:
            </p>
            <p>1) Klicken Sie rechts bei Facebook auf Einstellungen.</p>
            <p>
                2) Anschließend klicken Sie in der linken Spalte auf „Deine
                Facebook-Informationen“.
            </p>
            <p>3) Nun klicken Sie “Deaktivierung und Löschung”.</p>
            <p>
                4) Wählen Sie jetzt „Konto löschen“ und klicken Sie dann auf „Weiter und
                Konto löschen“
            </p>
            <p>
                5) Geben Sie nun Ihr Passwort ein, klicken Sie auf „Weiter“ und dann auf
                „Konto löschen“
            </p>
            <p>
                Die Speicherung der Daten, die Facebook über unsere Seite erhält, erfolgt
                unter anderem über Cookies (z.B. bei sozialen Plugins). In Ihrem Browser
                können Sie einzelne oder alle Cookies deaktivieren, löschen oder verwalten.
                Je nach dem welchen Browser Sie verwenden, funktioniert dies auf
                unterschiedliche Art und Weise. Unter dem Abschnitt „Cookies“ finden Sie die
                entsprechenden Links zu den jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <p>
                Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser
                so einrichten, dass er Sie immer informiert, wenn ein Cookie gesetzt werden
                soll. So können Sie bei jedem einzelnen Cookie entscheiden, ob Sie es
                erlauben oder nicht.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
                Facebook-Tools verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die Tools
                gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben. Die meisten
                Social-Media-Plattformen setzen auch Cookies in Ihrem Browser, um Daten zu
                speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies
                genau durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien
                von Facebook anzusehen.
            </p>
            <p>
                Facebook verarbeitet Daten von Ihnen u.a. auch in den USA. Facebook bzw.
                Meta Platforms ist aktiver Teilnehmer des EU-US Data Privacy Frameworks,
                wodurch der korrekte und sichere Datentransfer personenbezogener Daten von
                EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Facebook sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Facebook, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Facebook Datenverarbeitungsbedingung, welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/legal/terms/dataprocessing"
                >
                https://www.facebook.com/legal/terms/dataprocessing
                </a>
                .
            </p>
            <p>
                Wir hoffen, wir haben Ihnen die wichtigsten Informationen über die Nutzung
                und Datenverarbeitung durch die Facebook-Tools nähergebracht. Wenn Sie mehr
                darüber erfahren wollen, wie Facebook Ihre Daten verwendet, empfehlen wir
                Ihnen die Datenrichtlinien auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/privacy/policy/?tid=112958647"
                >
                https://www.facebook.com/privacy/policy/
                </a>
                .
            </p>
            <h2 id="facebook-login-datenschutzerklaerung" className="adsimple-112958647">
                Facebook Login Datenschutzerklärung
            </h2>
            <p>
                Wir haben auf unserer Seite das praktische Facebook Login integriert. So
                können Sie sich bei uns ganz einfach mit Ihrem Facebook-Konto einloggen,
                ohne ein weiteres Benutzerkonto anlegen zu müssen. Wenn Sie sich
                entscheiden, Ihre Registrierung über das Facebook Login zu machen, werden
                Sie auf das Social Media Network Facebook weitergeleitet. Dort erfolgt die
                Anmeldung über Ihre Facebook Nutzerdaten. Durch dieses Login-Verfahren
                werden Daten über Sie bzw. Ihr Userverhalten gespeichert und an Facebook
                übermittelt.
            </p>
            <p>
                Um die Daten zu speichern, benutzt Facebook verschiedene Cookies. Im
                Folgenden zeigen wir Ihnen die wichtigsten Cookies, die in Ihrem Browser
                gesetzt werden bzw. schon bestehen, wenn Sie sich über das Facebook Login
                auf unserer Seite anmelden:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> fr
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                0jieyh4c2GnlufEJ9..Bde09j…1.0.Bde09j
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie wird verwendet, damit das soziale Plugin auf unserer Webseite
                bestmöglich funktioniert.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 3
                Monaten
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> datr
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                4Jh7XUA2112958647SEmPsSfzCOO4JFFl
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Facebook
                setzt das “datr”-Cookie, wenn ein Webbrowser auf facebook.com zugreift, und
                das Cookie hilft, Anmeldeaktivitäten zu identifizieren und die Benutzer zu
                schützen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 2
                Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _js_datr
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> deleted
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Session-Cookie setzt Facebook zu Trackingzwecken, auch wenn Sie kein
                Facebook-Konto haben oder ausgeloggt sind.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach
                Sitzungsende
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung:</strong> Die angeführten
                Cookies sind nur eine kleine Auswahl der Cookies, die Facebook zur Verfügung
                stehen. Weitere Cookies sind beispielsweise _ fbp, sb oder wd. Eine
                vollständige Aufzählung ist nicht möglich, da Facebook über eine Vielzahl an
                Cookies verfügt und diese variabel einsetzt.
            </p>
            <p>
                Der Facebook Login bietet Ihnen einerseits einen schnellen und einfachen
                Registrierungsprozess, andererseits haben wir so die Möglichkeit Daten mit
                Facebook zu teilen. Dadurch können wir unser Angebot und unsere
                Werbeaktionen besser an Ihre Interessen und Bedürfnisse anpassen. Daten, die
                wir auf diese Weise von Facebook erhalten, sind öffentliche Daten wie
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">Ihr Facebook-Name</li>
                <li className="adsimple-112958647">Ihr Profilbild</li>
                <li className="adsimple-112958647">eine hinterlegte E-Mail-Adresse</li>
                <li className="adsimple-112958647">Freundeslisten</li>
                <li className="adsimple-112958647">
                Buttons-Angaben (z.B. „Gefällt mir“-Button)
                </li>
                <li className="adsimple-112958647">Geburtstagsdatum</li>
                <li className="adsimple-112958647">Sprache</li>
                <li className="adsimple-112958647">Wohnort</li>
            </ul>
            <p>
                Im Gegenzug stellen wir Facebook Informationen über Ihre Aktivitäten auf
                unserer Webseite bereit. Das sind unter anderem Informationen über Ihr
                verwendetes Endgerät, welche Unterseiten Sie bei uns besuchen oder welche
                Produkte Sie bei uns erworben haben.
            </p>
            <p>
                Durch die Verwendung von Facebook Login willigen Sie der Datenverarbeitung
                ein. Sie können diese Vereinbarung jederzeit widerrufen. Wenn Sie mehr
                Informationen über die Datenverarbeitung durch Facebook erfahren wollen,
                empfehlen wir Ihnen die Facebook-Datenschutzerklärung unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/privacy/policy/?tid=112958647"
                >
                https://www.facebook.com/privacy/policy/
                </a>
                .
            </p>
            <p>
                Sofern Sie bei Facebook angemeldet sind, können Sie Ihre Einstellungen für
                Werbeanzeigen unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/adpreferences/advertisers/?entry_product=ad_settings_screen"
                >
                https://www.facebook.com/adpreferences/advertisers/?entry_product=ad_settings_screen
                </a>
                &nbsp;selbst verändern.
            </p>
            <h2
                id="facebook-soziale-plug-ins-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Facebook Soziale Plug-ins Datenschutzerklärung
            </h2>
            <p>
                Auf unserer Website sind sogenannte soziale Plug-ins des Unternehmens Meta
                Platforms Inc. eingebaut. Sie erkennen diese Buttons am klassischen
                Facebook-Logo, wie dem „Gefällt mir“-Button (die Hand mit erhobenem Daumen)
                oder an einer eindeutigen „Facebook Plug-in“-Kennzeichnung. Ein soziales
                Plug-in ist ein kleiner Teil von Facebook, der in unsere Seite integriert
                ist. Jedes Plug-in hat eine eigene Funktion. Die am meisten verwendeten
                Funktionen sind die bekannten “Gefällt mir”- und “Teilen”-Buttons.
            </p>
            <p>Folgende soziale Plug-ins werden von Facebook angeboten:</p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">“Speichern”-Button</li>
                <li className="adsimple-112958647">
                “Gefällt mir”-Button, Teilen, Senden und Zitat
                </li>
                <li className="adsimple-112958647">Seiten-Plug-in</li>
                <li className="adsimple-112958647">Kommentare</li>
                <li className="adsimple-112958647">Messenger-Plug-in</li>
                <li className="adsimple-112958647">
                Eingebettete Beiträge und Videoplayer
                </li>
                <li className="adsimple-112958647">Gruppen-Plug-in</li>
            </ul>
            <p>
                Auf{" "}
                <a
                className="adsimple-112958647"
                href="https://developers.facebook.com/docs/plugins"
                >
                https://developers.facebook.com/docs/plugins
                </a>
                &nbsp;erhalten Sie nähere Informationen, wie die einzelnen Plug-ins
                verwendet werden. Wir nützen die sozialen Plug-ins einerseits, um Ihnen ein
                besseres Usererlebnis auf unserer Seite zu bieten, andererseits weil
                Facebook dadurch unsere Werbeanzeigen optimieren kann.
            </p>
            <p>
                Sofern Sie ein Facebook-Konto haben oder{" "}
                <a className="adsimple-112958647" href="https://www.facebook.com/">
                https://www.facebook.com/
                </a>
                &nbsp;schon mal besucht haben, hat Facebook bereits mindestens ein Cookie in
                Ihrem Browser gesetzt. In diesem Fall sendet Ihr Browser über dieses Cookie
                Informationen an Facebook, sobald Sie unsere Seite besuchen bzw. mit
                sozialen Plug-ins (z.B. dem „Gefällt mir“-Button) interagieren.
            </p>
            <p>
                Die erhaltenen Informationen werden innerhalb von 90 Tagen wieder gelöscht
                bzw. anonymisiert. Laut Facebook gehören zu diesen Daten Ihre IP-Adresse,
                welche Webseite Sie besucht haben, das Datum, die Uhrzeit und weitere
                Informationen, die Ihren Browser betreffen.
            </p>
            <p>
                Um zu verhindern, dass Facebook während Ihres Besuches auf unserer Webseite
                viele Daten sammelt und mit den Facebook-Daten verbindet, müssen Sie sich
                während des Webseitenbesuchs von Facebook abmelden (ausloggen).
            </p>
            <p>
                Falls Sie bei Facebook nicht angemeldet sind oder kein Facebook-Konto
                besitzen, sendet Ihr Browser weniger Informationen an Facebook, weil Sie
                weniger Facebook-Cookies haben. Dennoch können Daten wie beispielsweise Ihre
                IP-Adresse oder welche Webseite Sie besuchen an Facebook übertragen werden.
                Wir möchten noch ausdrücklich darauf hinweisen, dass wir über die genauen
                Inhalte der Daten nicht exakt Bescheid wissen. Wir versuchen aber Sie nach
                unserem aktuellen Kenntnisstand so gut als möglich über die
                Datenverarbeitung aufzuklären. Wie Facebook die Daten nutzt, können Sie auch
                in den Datenrichtline des Unternehmens unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/about/privacy/update"
                >
                https://www.facebook.com/about/privacy/update
                </a>
                &nbsp;nachlesen.
            </p>
            <p>
                Folgende Cookies werden in Ihrem Browser mindestens gesetzt, wenn Sie eine
                Webseite mit sozialen Plug-ins von Facebook besuchen:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> dpr
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> keine Angabe
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie wird verwendet, damit die sozialen Plug-ins auf unserer Webseite
                funktionieren.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach
                Sitzungsende
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> fr
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                0jieyh4112958647c2GnlufEJ9..Bde09j…1.0.Bde09j
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong>&nbsp;Auch
                das Cookie ist nötig, dass die Plug-ins einwandfrei funktionieren.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum::</strong>&nbsp;nach 3
                Monaten
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung:</strong> Diese Cookies
                wurden nach einem Test gesetzt, auch wenn Sie nicht Facebook-Mitglied sind.
            </p>
            <p>
                Sofern Sie bei Facebook angemeldet sind, können Sie Ihre Einstellungen für
                Werbeanzeigen unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/adpreferences/advertisers/"
                >
                https://www.facebook.com/adpreferences/advertisers/
                </a>
                selbst verändern. Falls Sie kein Facebook-User sind, können Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.youronlinechoices.com/de/praferenzmanagement/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.youronlinechoices.com/de/praferenzmanagement/?tid=112958647
                </a>{" "}
                grundsätzlich Ihre nutzungsbasierte Online-Werbung verwalten. Dort haben Sie
                die Möglichkeit, Anbieter zu deaktivieren bzw. zu aktivieren.
            </p>
            <p>
                Wenn Sie mehr über den Datenschutz von Facebook erfahren wollen, empfehlen
                wir Ihnen die eigenen Datenrichtlinien des Unternehmens auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/privacy/policy/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.facebook.com/privacy/policy/
                </a>
                .
            </p>
            <h2 id="instagram-datenschutzerklaerung" className="adsimple-112958647">
                Instagram Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Instagram Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Daten zum Nutzerverhalten,
                    Informationen zu Ihrem Gerät und Ihre IP-Adresse.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in der Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: bis Instagram die Daten für ihre Zwecke nicht mehr
                    benötigt
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Instagram?</h3>
            <p>
                Wir haben auf unserer Webseite Funktionen von Instagram eingebaut. Instagram
                ist eine Social Media Plattform des Unternehmens Instagram LLC, 1601 Willow
                Rd, Menlo Park CA 94025, USA. Instagram ist seit 2012 ein Tochterunternehmen
                von Meta Platforms Inc. und gehört zu den Facebook-Produkten. Das Einbetten
                von Instagram-Inhalten auf unserer Webseite nennt man Embedding. Dadurch
                können wir Ihnen Inhalte wie Buttons, Fotos oder Videos von Instagram direkt
                auf unserer Webseite zeigen. Wenn Sie Webseiten unserer Webpräsenz aufrufen,
                die eine Instagram-Funktion integriert haben, werden Daten an Instagram
                übermittelt, gespeichert und verarbeitet. Instagram verwendet dieselben
                Systeme und Technologien wie Facebook. Ihre Daten werden somit über alle
                Facebook-Firmen hinweg verarbeitet.
            </p>
            <p>
                Im Folgenden wollen wir Ihnen einen genaueren Einblick geben, warum
                Instagram Daten sammelt, um welche Daten es sich handelt und wie Sie die
                Datenverarbeitung weitgehend kontrollieren können. Da Instagram zu Meta
                Platforms Inc. gehört, beziehen wir unsere Informationen einerseits von den
                Instagram-Richtlinien, andererseits allerdings auch von den
                Meta-Datenschutzrichtlinien selbst.
            </p>
            <p>
                Instagram ist eines der bekanntesten Social Media Netzwerken weltweit.
                Instagram kombiniert die Vorteile eines Blogs mit den Vorteilen von
                audiovisuellen Plattformen wie YouTube oder Vimeo. Sie können auf „Insta“
                (wie viele der User die Plattform salopp nennen) Fotos und kurze Videos
                hochladen, mit verschiedenen Filtern bearbeiten und auch in anderen sozialen
                Netzwerken verbreiten. Und wenn Sie selbst nicht aktiv sein wollen, können
                Sie auch nur anderen interessante Users folgen.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Instagram auf unserer Website?
            </h3>
            <p>
                Instagram ist jene Social Media Plattform, die in den letzten Jahren so
                richtig durch die Decke ging. Und natürlich haben auch wir auf diesen Boom
                reagiert. Wir wollen, dass Sie sich auf unserer Webseite so wohl wie möglich
                fühlen. Darum ist für uns eine abwechslungsreiche Aufbereitung unserer
                Inhalte selbstverständlich. Durch die eingebetteten Instagram-Funktionen
                können wir unseren Content mit hilfreichen, lustigen oder spannenden
                Inhalten aus der Instagram-Welt bereichern. Da Instagram eine
                Tochtergesellschaft von Facebook ist, können uns die erhobenen Daten auch
                für personalisierte Werbung auf Facebook dienlich sein. So bekommen unsere
                Werbeanzeigen nur Menschen, die sich wirklich für unsere Produkte oder
                Dienstleistungen interessieren.
            </p>
            <p>
                Instagram nützt die gesammelten Daten auch&nbsp;zu Messungs- und
                Analysezwecken. Wir bekommen zusammengefasste Statistiken und so mehr
                Einblick über Ihre Wünsche und Interessen. Wichtig ist zu erwähnen, dass
                diese Berichte Sie nicht persönlich identifizieren.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Instagram gespeichert?
            </h3>
            <p>
                Wenn Sie auf eine unserer Seiten stoßen, die Instagram-Funktionen (wie
                Instagrambilder oder Plug-ins) eingebaut haben, setzt sich Ihr Browser
                automatisch mit den Servern von Instagram in Verbindung. Dabei werden Daten
                an Instagram versandt, gespeichert und verarbeitet. Und zwar unabhängig, ob
                Sie ein Instagram-Konto haben oder nicht. Dazu zählen Informationen über
                unserer Webseite, über Ihren Computer, über getätigte Käufe, über
                Werbeanzeigen, die Sie sehen und wie Sie unser Angebot nutzen. Weiters
                werden auch Datum und Uhrzeit Ihrer Interaktion mit Instagram gespeichert.
                Wenn Sie ein Instagram-Konto haben bzw. eingeloggt sind, speichert Instagram
                deutlich mehr Daten über Sie.
            </p>
            <p>
                Facebook unterscheidet zwischen Kundendaten und Eventdaten. Wir gehen davon
                aus, dass dies bei Instagram genau so der Fall ist. Kundendaten sind zum
                Beispiel Name, Adresse, Telefonnummer und IP-Adresse. Diese Kundendaten
                werden erst an Instagram übermittelt werden, wenn Sie zuvor „gehasht“
                wurden. Hashing meint, ein Datensatz wird in eine Zeichenkette verwandelt.
                Dadurch kann man die Kontaktdaten verschlüsseln. Zudem werden auch die oben
                genannten „Event-Daten“ übermittelt. Unter „Event-Daten“ versteht Facebook –
                und folglich auch Instagram – Daten über Ihr Userverhalten. Es kann auch
                vorkommen, dass Kontaktdaten mit Event-Daten kombiniert werden. Die
                erhobenen Kontaktdaten werden mit den Daten, die Instagram bereits von Ihnen
                hat, abgeglichen.
            </p>
            <p>
                Über kleine Text-Dateien (Cookies), die meist in Ihrem Browser gesetzt
                werden, werden die gesammelten Daten an Facebook übermittelt. Je nach
                verwendeten Instagram-Funktionen und ob Sie selbst ein Instagram-Konto
                haben, werden unterschiedlich viele Daten gespeichert.
            </p>
            <p>
                Wir gehen davon aus, dass bei Instagram die Datenverarbeitung gleich
                funktioniert wie bei Facebook. Das bedeutet: wenn Sie ein Instagram-Konto
                haben oder{" "}
                <a
                className="adsimple-112958647"
                href="https://www.instagram.com/?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                www.instagram.com
                </a>
                besucht haben, hat Instagram zumindest ein Cookie gesetzt. Wenn das der Fall
                ist, sendet Ihr Browser über das Cookie Infos an Instagram, sobald Sie mit
                einer Instagram-Funktion in Berührung kommen. Spätestens nach 90 Tagen (nach
                Abgleichung) werden diese Daten wieder gelöscht bzw. anonymisiert. Obwohl
                wir uns intensiv mit der Datenverarbeitung von Instagram beschäftigt haben,
                können wir nicht ganz genau sagen, welche Daten Instagram exakt sammelt und
                speichert.
            </p>
            <p>
                Im Folgenden zeigen wir Ihnen Cookies, die in Ihrem Browser mindestens
                gesetzt werden, wenn Sie auf eine Instagram-Funktion (wie z.B. Button oder
                ein Insta-Bild) klicken. Bei unserem Test gehen wir davon aus, dass Sie kein
                Instagram-Konto haben. Wenn Sie bei Instagram eingeloggt sind, werden
                natürlich deutlich mehr Cookies in Ihrem Browser gesetzt.
            </p>
            <p>Diese Cookies wurden bei unserem Test verwendet:</p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>csrftoken
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>“”
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:&nbsp;</strong>
                Dieses Cookie wird mit hoher Wahrscheinlichkeit aus Sicherheitsgründen
                gesetzt, um Fälschungen von Anfragen zu verhindern. Genauer konnten wir das
                allerdings nicht in Erfahrung bringen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>mid
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>“”
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Instagram
                setzt dieses Cookie, um die eigenen Dienstleistungen und Angebote in und
                außerhalb von Instagram zu optimieren. Das Cookie legt eine eindeutige
                User-ID fest.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach Ende der
                Sitzung
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> fbsr_112958647124024
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>keine Angaben
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:&nbsp;</strong>
                Dieses Cookie speichert die Log-in-Anfrage für User der Instagram-App.
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                </strong>
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach Ende der
                Sitzung
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> rur
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>ATN
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dabei
                handelt es sich um ein Instagram-Cookie, das die Funktionalität auf
                Instagram gewährleistet.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach Ende der
                Sitzung
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> urlgen
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>“{"{"}”194.96.75.33”:
                1901{"}"}:1iEtYv:Y833k2_UjKvXgYe112958647”
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie dient den Marketingzwecken von Instagram.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach Ende der
                Sitzung
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung:</strong> Wir können hier
                keinen Vollständigkeitsanspruch erheben. Welche Cookies im individuellen
                Fall gesetzt werden, hängt von den eingebetteten Funktionen und Ihrer
                Verwendung von Instagram ab.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Instagram teilt die erhaltenen Informationen zwischen den
                Facebook-Unternehmen mit externen Partnern und mit Personen, mit denen Sie
                sich weltweit verbinden. Die Datenverarbeitung erfolgt unter Einhaltung der
                eigenen Datenrichtlinie. Ihre Daten sind, unter anderem aus
                Sicherheitsgründen, auf den Facebook-Servern auf der ganzen Welt verteilt.
                Die meisten dieser Server stehen in den USA.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Dank der Datenschutz Grundverordnung haben Sie das Recht auf Auskunft,
                Übertragbarkeit, Berichtigung und Löschung Ihrer Daten. In den
                Instagram-Einstellungen können Sie Ihre Daten verwalten. Wenn Sie Ihre Daten
                auf Instagram völlig löschen wollen, müssen Sie Ihr Instagram-Konto
                dauerhaft löschen.
            </p>
            <p>Und so funktioniert die Löschung des Instagram-Kontos:</p>
            <p>
                Öffnen Sie zuerst die Instagram-App. Auf Ihrer Profilseite gehen Sie nach
                unten und klicken Sie auf „Hilfebereich“. Jetzt kommen Sie auf die Webseite
                des Unternehmens. Klicken Sie auf der Webseite auf „Verwalten des Kontos“
                und dann auf „Dein Konto löschen“.
            </p>
            <p>
                Wenn Sie Ihr Konto ganz löschen, löscht Instagram Posts wie beispielsweise
                Ihre Fotos und Status-Updates. Informationen, die andere Personen über Sie
                geteilt haben, gehören nicht zu Ihrem Konto und werden folglich nicht
                gelöscht.
            </p>
            <p>
                Wie bereits oben erwähnt, speichert Instagram Ihre Daten in erster Linie
                über Cookies. Diese Cookies können Sie in Ihrem Browser verwalten,
                deaktivieren oder löschen. Abhängig von Ihrem Browser funktioniert die
                Verwaltung immer ein bisschen anders. Unter dem Abschnitt „Cookies“ finden
                Sie die entsprechenden Links zu den jeweiligen Anleitungen der bekanntesten
                Browser.
            </p>
            <p>
                Sie können auch grundsätzlich Ihren Browser so einrichten, dass Sie immer
                informiert werden, wenn ein Cookie gesetzt werden soll. Dann können Sie
                immer individuell entscheiden, ob Sie das Cookie zulassen wollen oder nicht.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
                Social-Media-Elemente verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die eingebundene
                Social-Media-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben. Die meisten Social-Media-Plattformen setzen auch Cookies in
                Ihrem Browser, um Daten zu speichern. Darum empfehlen wir Ihnen, unseren
                Datenschutztext über Cookies genau durchzulesen und die Datenschutzerklärung
                oder die Cookie-Richtlinien des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                Instagram verarbeitet Daten von Ihnen u.a. auch in den USA. Instagram bzw.
                Meta Platforms ist aktiver Teilnehmer des EU-US Data Privacy Frameworks,
                wodurch der korrekte und sichere Datentransfer personenbezogener Daten von
                EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Instagram sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Instagram, bei der Verarbeitung Ihrer relevanten Daten,
                das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den
                USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren
                auf einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss
                und die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Wir haben versucht, Ihnen die wichtigsten Informationen über die
                Datenverarbeitung durch Instagram näherzubringen. Auf{" "}
                <a
                className="adsimple-112958647"
                href="https://privacycenter.instagram.com/policy/"
                target="_blank"
                rel="follow noopener"
                >
                https://privacycenter.instagram.com/policy/
                </a>
                &nbsp;können Sie sich noch näher mit den Datenrichtlinien von Instagram
                auseinandersetzen.
            </p>
            <h2
                id="instagram-lookalike-audience-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Instagram Lookalike Audience Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auch das Werbetool Instagram Lookalike Audience. Dienstanbieter
                ist das amerikanische Unternehmen Meta Platforms Inc. Für den europäischen
                Raum ist das Unternehmen Meta Platforms Ireland Limited (4 Grand Canal
                Square, Grand Canal Harbour, Dublin 2, Irland) verantwortlich.
            </p>
            <p>
                Instagram bzw. Meta verarbeitet Daten von Ihnen u.a. auch in den USA.
                Facebook bzw. Meta Platforms ist aktiver Teilnehmer des EU-US Data Privacy
                Frameworks, wodurch der korrekte und sichere Datentransfer personenbezogener
                Daten von EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu
                finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Meta Platforms sogenannte Standardvertragsklauseln (= Art.
                46. Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual
                Clauses – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und
                sollen sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Meta Platforms, bei der Verarbeitung Ihrer relevanten
                Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten
                in den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln
                basieren auf einem Durchführungsbeschluss der EU-Kommission. Sie finden den
                Beschluss und die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Instagram bzw. Meta Datenverarbeitungsbedingungen, welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/legal/terms/dataprocessing"
                >
                https://www.facebook.com/legal/terms/dataprocessing
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Instagram Lookalike
                Audience verarbeitet werden, erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://privacycenter.instagram.com/policy/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://privacycenter.instagram.com/policy/
                </a>
                .
            </p>
            <h2 id="pinterest-datenschutzerklaerung" className="adsimple-112958647">
                Pinterest Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Pinterest Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Daten zum Nutzerverhalten,
                    Informationen zu Ihrem Gerät, Ihre IP-Adresse und Suchbegriffe.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in der Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: bis Pinterest die Daten für ihre Zwecke nicht mehr
                    benötigt
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Pinterest?</h3>
            <p>
                Wir verwenden auf unserer Seite Buttons und Widgets des Social Media
                Netzwerks Pinterest, der Firma Pinterest Inc., 808 Brannan Street, San
                Francisco, CA 94103, USA. Für den europäischen Raum ist das irische
                Unternehmen Pinterest Europe Ltd. (Palmerston House, 2nd Floor, Fenian
                Street, Dublin 2, Irland) für alle datenschutzrelevanten Aspekte zuständig.
            </p>
            <p>
                Pinterest ist ein soziales Netzwerk, das sich auf grafische Darstellungen
                bzw. Fotografien spezialisiert hat. Der Name setzt sich aus den beiden
                Wörtern „pin“ und „interest“ zusammen. Nutzer können sich über Pinterest
                über verschiedene Hobbies und Interessen austauschen und sich offen oder in
                definierten Gruppen die jeweiligen Profile mit Bildern ansehen.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir Pinterest?</h3>
            <p>
                Pinterest gibt es mittlerweile schon einige Jahre und immer noch zählt diese
                Social-Media-Plattform zu den meist besuchten und geschätzten Plattformen.
                Speziell für unsere Branche eignet sich Pinterest, weil die Plattform in
                erster Linie für schöne und interessante Bilder bekannt ist. Darum sind
                natürlich auch wir auf Pinterest vertreten und wollen unsere Inhalte auch
                abseits unserer Website entsprechend in Szene setzen. Die erhobenen Daten
                können auch für Werbezwecke verwendet werden, damit wir Werbebotschaften
                genau jenen Menschen zeigen können, die sich für unsere Dienstleistungen
                bzw. Produkte interessieren.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Pinterest verarbeitet?
            </h3>
            <p>
                Es können sogenannte Protokolldaten gespeichert werden. Dazu zählen
                Informationen zu Ihrem Browser, IP-Adresse, die Adresse unserer Website und
                die darauf vorgenommenen Aktivitäten (zum Beispiel, wenn Sie den Merken-
                oder Pin-Button klicken), Suchverläufe, Datum und Uhrzeit der Anfrage und
                Cookie- und Gerätedaten. Wenn Sie mit einer eingebetteten Pinterest-Funktion
                interagieren, können auch Cookies, die diverse Daten speichern, in Ihrem
                Browser gesetzt werden. Meist werden die oben genannten Protokolldaten,
                voreingestellte Spracheinstellungen und Clickstream-Daten in Cookies
                gespeichert. Unter Clickstream-Daten versteht Pinterest Informationen zu
                Ihrem Websiteverhalten.
            </p>
            <p>
                Wenn Sie selbst ein Pinterest-Konto haben und eingeloggt sind, können die
                Daten, die über unsere Seite erhoben werden, zu Ihrem Konto hinzugefügt
                werden und für Werbezwecke verwendet werden. Wenn Sie mit unseren
                eingebundenen Pinterest-Funktionen interagieren, werden Sie in der Regel auf
                die Pinterest-Seite weitergeleitet. Hier sehen Sie eine beispielhafte
                Auswahl an Cookies, die dann in Ihrem Browser gesetzt werden.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _auth
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> 0<br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Das Cookie
                dient der Authentifizierung. Darin kann beispielsweise ein Wert wie Ihr
                “Benutzername” gespeichert werden.&nbsp;
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                </strong>
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _pinterest_referrer
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> 1<br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Das Cookie
                speichert, dass Sie über unsere Website zu Pinterest gelangten. Es wird also
                die URL unserer Website gespeichert.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach
                Sitzungsende
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _pinterest_sess
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> …9HRHZvVE0rQlUxdG89
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Das Cookie
                dient der Anmeldung bei Pinterest und enthält Nutzer-IDs,
                Authentifizierungs-Token und Zeitstempel.
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                </strong>
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _routing_id
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>
                “8d850ddd-4fb8-499c-961c-77efae9d4065112958647-8”
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Das Cookie
                beinhaltet einen zugewiesenen Wert, der zur Identifizierung eines bestimmten
                Routing-Ziels verwendet wird.
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                </strong>
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Tag
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> cm_sub
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> denied
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie speichert eine Benutzer-ID und den Zeitstempel.
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                </strong>
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> csrftoken
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                9e49145c82a93d34fd933b0fd8446165112958647-1
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie wird mit hoher Wahrscheinlichkeit aus Sicherheitsgründen gesetzt, um
                Fälschungen von Anfragen zu verhindern. Genauer konnten wir das allerdings
                nicht in Erfahrung bringen.
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                </strong>
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong>{" "}
                sessionFunnelEventLogged
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> 1<br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Zu diesem
                Cookie konnten wir noch keine näheren Informationen in Erfahrung bringen.
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                </strong>
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Tag
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Pinterest speichert grundsätzlich die erhobenen Daten so lange, bis diese
                für die Zwecke des Unternehmens nicht mehr gebraucht werden. Sobald die
                Datenaufbewahrung nicht mehr notwendig ist, um etwa auch rechtlichen
                Vorschriften gerecht zu werden, werden die Daten entweder gelöscht oder
                anonymisiert, damit Sie als Person nicht mehr identifiziert werden können.
                Die Daten können auch auf amerikanischen Servern gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern wie Pinterest zu widerrufen. Das
                funktioniert entweder über unser Cookie-Management-Tool oder über andere
                Opt-Out-Funktionen. Zum Beispiel können Sie auch die Datenerfassung durch
                Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
                deaktivieren oder löschen.
            </p>
            <p>
                Da bei eingebetteten Pinterest-Elementen Cookies zum Einsatz kommen können,
                empfehlen wir Ihnen auch unsere allgemeine Datenschutzerklärung über
                Cookies. Um zu erfahren, welche Daten von Ihnen genau gespeichert und
                verarbeitet werden, sollten Sie die Datenschutzerklärungen der jeweiligen
                Tools durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
                Social-Media-Elemente verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen das Tool
                gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben. Die meisten
                Social-Media-Plattformen setzen auch Cookies in Ihrem Browser, um Daten zu
                speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies
                genau durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien
                des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                Pinterest verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen
                darauf hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                Pinterest sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3
                DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind
                von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                diese Klauseln verpflichtet sich Pinterest, bei der Verarbeitung Ihrer
                relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn
                die Daten in den USA gespeichert, verarbeitet und verwaltet werden. Diese
                Klauseln basieren auf einem Durchführungsbeschluss der EU-Kommission. Sie
                finden den Beschluss und die entsprechenden Standardvertragsklauseln u.a.
                hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de.
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Pinterest finden Sie
                unter{" "}
                <a
                className="adsimple-112958647"
                href="https://policy.pinterest.com/de/privacy-policy#section-residents-of-the-eea"
                target="_blank"
                rel="follow noopener"
                >
                https://policy.pinterest.com/de/privacy-policy#section-residents-of-the-eea
                </a>
                .
            </p>
            <p>
                Wir haben versucht, Ihnen die wichtigsten Informationen über die
                Datenverarbeitung durch Pinterest näherzubringen. Auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policy.pinterest.com/de/privacy-policy"
                >
                https://policy.pinterest.com/de/privacy-policy
                </a>{" "}
                können Sie sich noch näher mit den Datenrichtlinien von Pinterest
                auseinandersetzen.
            </p>
            <h2 id="snapchat-datenschutzerklaerung" className="adsimple-112958647">
                Snapchat Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Snapchat Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Daten zum Nutzerverhalten,
                    Informationen zu Ihrem Gerät und Ihre IP-Adresse.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in der Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: ist abhängig von der Art der Daten
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Snapchat?</h3>
            <p>
                Wir nutzen für unsere Website auch Integrationen des Messaging- und
                Social-Media-Dienstes Snapchat. Dienstanbieter ist das amerikanische
                Unternehmen Snap Inc., 2772 Donald Douglas Loop N, Santa Monica (HQ), CA,
                USA.
            </p>
            <p>
                Mit Snapchat können Nutzer sogenannte „Snaps“, also kurze Bilder oder Videos
                erstellen und mit Freunden bzw. Followers teilen. Snapchat ist vor allem bei
                jüngeren Menschen ein beliebtes Kommunikations-Tool. Diese „Snaps“ werden im
                Gegensatz zu anderen Social-Media-Tools nach einer begrenzten Zeit wieder
                gelöscht. Je nach Vorlieben des Nutzers kann diese Zeit zwischen ein paar
                Sekunden und bis zu 24 Stunden eingestellt werden. Zudem bietet Snapchat
                auch Funktionen wie Gruppenchats, Videoanrufe und einen Discover-Bereich für
                Medienunternehmen.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Snapchat auf unserer Website?
            </h3>
            <p>
                Wir haben Funktionen von Snapchat auf unserer Website bereitgestellt, damit
                wir auch auf Snapchat-Inhalte hinweisen können und Sie auch die Möglichkeit
                haben uns auf Snapchat zu folgen. Somit können wir auch über unsere
                Website-Präsenz hinaus mit Ihnen in Kontakt bleiben. Mit der Integration von
                Snapchat-Inhalten bieten wir auch all unseren Besuchern, die nicht auf
                Snapchat sind, die Möglichkeit einen Einblick in die Snapchat-Welt zu
                bekommen. Wir sehen also die Integration als Teil unseres Gesamtangebots auf
                unserer Website.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Snapchat verarbeitet?
            </h3>
            <p>
                Wenn Sie Snapchat-Inhalte über unsere Website ansehen oder mit ihnen
                interagieren, kann Snapchat Informationen über Ihr Nutzungsverhalten und Ihr
                Gerät sammeln. Dies kann Daten wie Ihre IP-Adresse, den Browsertyp, das
                Betriebssystem, den Standort, Spracheinstellungen und weitere technische
                Informationen umfassen. Snapchat kann auch Cookies und ähnliche Technologien
                verwenden, um Informationen zu sammeln und Ihr Nutzererlebnis zu
                personalisieren.
            </p>
            <p>
                Wenn Sie selbst einen Snapchat-Konto haben bzw. anlegen, können auch noch
                weitere Informationen gesammelt und verarbeitet werden. In diesem Fall geben
                Sie freiwillig Daten wie beispielsweise Ihren Namen, Usernamen,
                E-Mail-Adresse, Telefonnummer und Geburtsdatum preis. Wenn Sie innerhalb der
                App etwas kaufen, müssen Sie auch Zahlungsdaten angeben. All diese
                Informationen werden bei Snapchat verarbeitet, sofern Sie diese Daten zur
                Verfügung stellen. Wenn Sie mit Ihrem Account den Service aktiv nutzen,
                werden auch alle Informationen, die über Snapchat gesendet werden,
                verarbeitet. Zu diesen Informationen zählen etwa Chats, Gespräche, Bilder
                und Videos.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Snapchat speichert unterschiedliche Daten unterschiedlich lange und die
                Snapchat-Server sind weltweit in verschiedenen Regionen verteilt. Das heißt,
                Ihre Daten können beispielsweise auch in den USA verarbeitet werden. Wie
                bereits oben erwähnt, kann die Speicherdauer der „Snaps“ in den
                Einstellungen zum Teil selbst gewählt werden. Die meisten Nachrichten, die
                im Tool versendet werden, werden von den Servern automatisch gelöscht,
                sobald sie empfangen wurden oder abgelaufen sind. Es gibt aber auch Daten,
                die deutlich länger gespeichert werden. Dazu zählen Konto-Informationen wie
                Name, Handynummer oder E-Mail-Adresse. Die Speicherdauer von Standortdaten
                hängt davon ab, wie genau sie sind und welches der Snapchat-Services genau
                verwendet wird.
            </p>
            <p>
                Unter{" "}
                <a
                className="adsimple-112958647"
                href="https://help.snapchat.com/hc/de/articles/7012334940948"
                >
                https://help.snapchat.com/hc/de/articles/7012334940948
                </a>
                finden Sie einen ganz guten Überblick über die Speicherdauer verschiedener
                Snapchat-Daten.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Wenn Sie ein Snapchat-Konto haben, können Sie direkt auf Snapchat Ihre
                Datenschutzeinstellungen verwalten und die Speicherdauer diverser Inhalte
                selbst bestimmen. So können Sie etwa in den Einstellungen Ihres
                Snapchat-Kontos festlegen, ob „Snaps“ nach ein paar Sekunden wieder gelöscht
                werden oder erst nach 24 Stunden. Zudem können Sie auch direkt
                Verantwortliche von Snapchat bitte, Ihre personenbezogenen Daten zu löschen.
                In der Datenschutzerklärung auf Snapchat wird aber darauf hingewiesen, dass
                zwar die meisten Daten gelöscht werden, allerdings aus rechtlichen Gründen
                der Fall auftreten kann, dass die Datenlöschung ausgesetzt werden muss bzw.
                manche Daten weiterhin gespeichert bleiben.
            </p>
            <p>
                Darüber hinaus können Sie Cookies, die Snapchat eventuell setzt, in Ihrem
                Webbrowser verwalten und deaktivieren, um die Datenerfassung zu begrenzen.
                Das ist auch ohne Snapchat-Konto möglich. Bitte beachten Sie jedoch, dass
                dies die Funktionalität unserer Website beeinträchtigen kann.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch Snapchat verarbeitet
                und gespeichert werden können, gilt diese Einwilligung als Rechtsgrundlage
                der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>{" "}
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die eingebundene
                Snapchat-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung erteilt
                haben. Snapchat kann auch Cookies in Ihrem Browser setzen, um Daten zu
                speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies
                genau durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien
                des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                Snap verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Snap
                sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich Snap, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Snap finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://snap.com/en-US/terms/standard-contractual-clauses"
                target="_blank"
                rel="follow noopener"
                >
                https://snap.com/en-US/terms/standard-contractual-clauses
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Snapchat verarbeitet
                werden, erfahren Sie in der Privacy Policy auf
                <a
                className="adsimple-112958647"
                href="https://snap.com/de-DE/privacy/privacy-policy?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://snap.com/de-DE/privacy/privacy-policy
                </a>
                .
            </p>
            <h2 id="tiktok-datenschutzerklaerung" className="adsimple-112958647">
                TikTok Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        TikTok Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: es können etwa Ihre IP-Adresse, Browserdaten,
                    Datum und Zeitpunkt Ihres Seitenaufrufs gespeichert werden
                    <br />
                    Mehr Details dazu finden Sie weiter unten in der Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: variiert je nach Einstellungen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist TikTok?</h3>
            <p>
                Auf unserer Website nutzen wir die TikTok-Integration. Dienstanbieter ist
                das chinesische Unternehmen Beijing Bytedance Technology Ltd. Für den
                europäischen Raum ist das irische Unternehmen TikTok Technology Limited, 10
                Earlsfort Terrace, Dublin, D02 T380, Irland, zuständig. TikTok ist speziell
                bei jungen Menschen eine beliebte Social-Media-Plattform, auf der Nutzer
                kurze Videoclips erstellen, teilen und ansehen können.
            </p>
            <p>
                In dieser Datenschutzerklärung informieren wir Sie darüber, welche Daten
                durch TikTok verarbeitet werden, wie lange die Daten gespeichert werden und
                wie Sie Ihre Datenschutzeinstellungen verwalten können.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir TikTok auf unserer Website?
            </h3>
            <p>
                Wir haben TikTok in unsere Website eingebaut, damit Sie sich, wenn Sie Lust
                haben, TikTok-Videos ansehen können und gegebenenfalls mit den Videos
                interagieren können. TikTok ist besonders für lustige und kreative Inhalte
                bekannt und natürlich wollen wir Ihnen solche Inhalte nicht vorenthalten.
                Schließlich sehen wir uns auch selbst gerne das ein oder andere kreative
                TikTok-Video an.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von TikTok verarbeitet?
            </h3>
            <p>
                Wenn Sie TikTok-Videos auf unserer Website ansehen oder mit ihnen
                interagieren, kann TikTok Informationen über Ihr Nutzungsverhalten und Ihr
                Gerät sammeln. Dies kann Daten wie Ihre IP-Adresse, den Browsertyp, das
                Betriebssystem, den Standort und weitere technische Informationen umfassen.
                TikTok kann auch Cookies und ähnliche Technologien verwenden, um
                Informationen zu sammeln und Ihr Nutzererlebnis zu personalisieren.
            </p>
            <p>
                Wenn Sie selbst einen TikTok-Account haben, können auch noch weitere
                Informationen gesammelt und verarbeitet werden. Dazu zählen etwa
                Nutzerinformationen (wie Name, Geburtsdatum oder Ihre E-Mail-Adresse) und
                Daten über Ihre Kommunikation mit anderen TikTok-Nutzern.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Die Speicherdauer und Speicherorte der von TikTok erfassten Daten können
                stark variieren und unterliegen den Datenschutzrichtlinien von TikTok.
                TikTok kann auch Daten auf Servern in den USA und anderen Ländern speichern.
                Die Speicherdauer richtet sich in der Regel nach den jeweiligen gesetzlichen
                Anforderungen und den internen Richtlinien. Wie lange Daten genau
                gespeichert werden, konnten wir allerdings bis jetzt noch nicht in Erfahrung
                bringen. Sobald wir nähere Informationen haben, werden wir Sie darüber
                selbstverständlich in Kenntnis setzen.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Wenn Sie ein TikTok-Konto haben, können Sie direkt auf TikTok Ihre
                Datenschutzeinstellungen verwalten. So können Sie etwa in den Einstellungen
                Ihres TikTok-Kontos festlegen, welche Informationen geteilt werden dürfen
                und welche nicht. Darüber hinaus können Sie Cookies in Ihrem Webbrowser
                verwalten und deaktivieren, um die Datenerfassung zu begrenzen. Das ist
                natürlich auch ohne TikTok-Konto möglich. Bitte beachten Sie jedoch, dass
                dies die Funktionalität unserer Website und Ihr TikTok-Erlebnis beeinflussen
                kann.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch TikTok verarbeitet
                und gespeichert werden können, gilt diese Einwilligung als Rechtsgrundlage
                der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>{" "}
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die eingebundene
                Social-Media-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben. TikTok kann auch Cookies in Ihrem Browser setzen, um Daten zu
                speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies
                genau durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien
                des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                TikTok verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet TikTok
                sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich TikTok, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Weitere Informationen zur Datenschutzrichtlinie von TikTok und zur Erfassung
                von Daten durch TikTok finden Sie auf der TikTok-Website unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.tiktok.com/legal/page/eea/privacy-policy/en?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.tiktok.com/legal/page/eea/privacy-policy/en
                </a>
                &nbsp;sowie in den allgemeinen Informationen zu TikTok unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.tiktok.com/en/"
                target="_blank"
                rel="noopener"
                >
                https://www.tiktok.com/en/
                </a>
                .
            </p>
            <h2
                id="x-frueher-twitter-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                X (früher: Twitter) Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        X (früher: Twitter) Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Daten zum Nutzerverhalten,
                    Informationen zu Ihrem Gerät und Ihre IP-Adresse.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in der Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: erhobene Daten von anderen Websites löscht X nach
                    spätestens 30 Tagen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist X?</h3>
            <p>
                Auf unserer Website haben wir Funktionen von X eingebaut. Dabei handelt es
                sich zum Beispiel um eingebettete Tweets, Timelines, Buttons oder Hashtags.
                X ist ein Kurznachrichtendienst und eine Social-Media-Plattform des
                amerikanischen Unternehmens X Corp., 1355 Market Street, Suite 900 San
                Francisco, CA 94103, USA. Für den europäischen Raum ist das Unternehmen
                Twitter International Unlimited Company (One Cumberland Place, Fenian
                Street, Dublin 2, D02 AX07, Irland) für das Verarbeiten personenbezogener
                Daten verantwortlich.
            </p>
            <p>
                Nach unserer Kenntnis werden im Europäischen Wirtschaftsraum und in der
                Schweiz durch das bloße Einbinden von X-Funktionen noch keine
                personenbezogenen Daten oder Daten zu Ihrer Webaktivitäten an X übertragen.
                Erst wenn Sie mit den X-Funktionen interagieren, wie zum Beispiel auf einen
                Button klicken, können Daten an X gesendet, dort gespeichert und verarbeitet
                werden. Auf diese Datenverarbeitung haben wir keinen Einfluss und tragen
                keine Verantwortung. Im Rahmen dieser Datenschutzerklärung wollen wir Ihnen
                einen Überblick geben, welche Daten X speichert, was X mit diesen Daten
                macht und wie Sie sich vor der Datenübertragung weitgehend schützen können.
            </p>
            <p>
                Für die einen ist X ein Nachrichtendienst, für andere eine
                Social-Media-Plattform und wieder andere sprechen von einem
                Microblogging-Dienst. All diese Bezeichnungen haben ihre Berechtigung und
                meinen mehr oder weniger dasselbe.
            </p>
            <p>
                Sowohl Privatpersonen als auch Unternehmen nützen X, um mit interessierten
                Personen über Kurznachrichten zu kommunizieren. Pro Nachricht erlaubt X nur
                280 Zeichen. Diese Nachrichten werden „Tweets“ genannt. Anders als
                beispielsweise bei Facebook fokussiert sich der Dienst nicht auf den Ausbau
                eines Netzwerks für “Freunde”, sondern will als weltweite und offene
                Nachrichten-Plattform verstanden werden. Bei X kann man auch ein anonymes
                Konto führen und Tweets können einerseits vom Unternehmen, andererseits von
                den Usern selbst gelöscht werden.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir X auf unserer Website?
            </h3>
            <p>
                Wie viele andere Webseiten und Unternehmen versuchen wir unsere Services und
                Dienstleistungen über verschiedene Kanäle anzubieten und mit unseren Kunden
                zu kommunizieren. Speziell X, (vielen wohl noch besser als Twitter bekannt)
                ist uns als nützlicher „kleiner“ Nachrichtendienst ans Herz gewachsen. Immer
                wieder tweeten oder retweeten wir spannende, lustige oder interessante
                Inhalte. Uns ist klar, dass Sie nicht jedem Kanal extra folgen können.
                Schließlich haben Sie auch noch etwas anderes zu tun. Darum haben wir auf
                unserer Webseite auch X-Funktionen eingebunden. Sie können unsere
                X-Aktivität „vor Ort“ miterleben oder über einen direkten Link zu unserer
                X-Seite kommen. Durch die Einbindung wollen wir unser Service und die
                Nutzerfreundlichkeit auf unserer Webseite stärken.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden von X gespeichert?</h3>
            <p>
                Auf manchen unserer Unterseiten finden Sie die eingebauten X-Funktionen.
                Wenn Sie mit den X-Inhalten interagieren, wie zum Beispiel auf einen Button
                klicken, kann X Daten erfassen und speichern. Und zwar auch dann, wenn Sie
                selbst kein X-Konto haben. X nennt diese Daten “Log-Daten”. Dazu zählen
                demografische Daten, Browser-Cookie-IDs, die ID Ihres Smartphones, gehashte
                E-Mail-Adressen, und Informationen, welche Seiten Sie bei X besucht haben
                und welche Handlungen Sie ausgeführt haben. X speichert natürlich mehr
                Daten, wenn Sie ein X-Konto haben und angemeldet sind. Bisher passierte
                diese Speicherung über Cookies. Cookies sind kleine Text-Dateien, die meist
                in Ihrem Browser gesetzt werden und unterschiedliche Information an X
                übermitteln.
            </p>
            <p>
                Welche Cookies gesetzt werden, wenn Sie nicht bei X angemeldet sind, aber
                eine Webseite mit eingebauten X-Funktionen besuchen, zeigen wir Ihnen jetzt.
                Bitte betrachten Sie diese Aufzählung als Beispiel. Einen Anspruch auf
                Vollständigkeit können wir hier auf keinen Fall gewährleisten, da sich die
                Wahl der Cookies stets verändert und von Ihren individuellen Handlungen mit
                den X-Inhalten abhängt.
            </p>
            <p>Diese Cookies wurden bei unserem Test verwendet:</p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> personalization_id
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                “v1_cSJIsogU51SeE112958647”
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie speichert Informationen darüber, wie Sie die Webseite nutzen und über
                welche Werbung Sie möglicherweise zu X gekommen sind.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 2 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>lang
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>de
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie speichert Ihre voreingestellte bzw. bevorzugte Sprache.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:&nbsp;</strong>nach
                Sitzungsende
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>guest_id
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                112958647v1%3A157132626
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie wird gesetzt, um Sie als Gast zu identifizieren.
                <strong className="adsimple-112958647 text-[#787c87]">&nbsp;</strong>
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach 2 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>fm
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>0<br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Zu diesem
                Cookie konnten wir leider den Verwendungszweck nicht in Erfahrung bringen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:&nbsp;</strong>nach
                Sitzungsende
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>external_referer
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                1129586472beTA0sf5lkMrlGt
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie sammelt anonyme Daten, wie zum Beispiel wie oft Sie X besuchen und
                wie lange Sie X besuchen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>Nach 6 Tagen
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>eu_cn
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>1<br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie speichert Useraktivität und dient diversen Werbezwecken von X.{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                Ablaufdatum:{" "}
                </strong>
                Nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>ct0
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                c1179f07163a365d2ed7aad84c99d966
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Zu diesem
                Cookie haben wir leider keine Informationen gefunden.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach 6 Stunden
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>_twitter_sess
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                53D%253D–dd0248112958647-
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Mit diesem
                Cookie können Sie Funktionen innerhalb der X-Webseite nutzen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach
                Sitzungsende
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung:</strong> X arbeitet auch
                mit Drittanbietern zusammen. Darum haben wir bei unserem Test auch die drei
                Google-Analytics-Cookies _ga, _gat, _gid erkannt.
            </p>
            <p>
                X verwendet die erhobenen Daten einerseits, um das Userverhalten besser zu
                verstehen und somit seine eigenen Dienste und Werbeangebote zu verbessern,
                andererseits dienen die Daten auch internen Sicherheitsmaßnahmen.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Wenn X Daten von anderen Websites erhebt, werden diese nach maximal 30 Tagen
                gelöscht, zusammengefasst oder auf andere Weise verdeckt. Die X-Server
                liegen auf verschiedenen Serverzentren in den Vereinigten Staaten. Demnach
                ist davon auszugehen, dass die erhobenen Daten in Amerika gesammelt und
                gespeichert werden. Nach unserer Recherche konnten wir nicht eindeutig
                feststellen, ob X auch eigene Server in Europa hat. Grundsätzlich kann X die
                erhobenen Daten speichern, bis sie dem Unternehmen nicht mehr dienlich sind,
                Sie die Daten löschen oder eine gesetzliche Löschfrist besteht.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                X betont in seinen Datenschutzrichtlinien immer wieder, dass es keine Daten
                von externen Webseitenbesuchen speichert, wenn Sie bzw. Ihr Browser sich im
                europäischen Wirtschaftsraum oder in der Schweiz befinden. Falls Sie
                allerdings mit X direkt interagieren, speichert X selbstverständlich auch
                Daten von Ihnen.
            </p>
            <p>
                Wenn Sie ein X-Konto besitzen, können Sie Ihre Daten verwalten, indem Sie
                unter dem „Profil“-Button auf „Mehr“ klicken. Anschließend klicken Sie auf
                „Einstellungen und Datenschutz“. Hier können Sie die Datenverarbeitung
                individuell verwalten.
            </p>
            <p>
                Wenn Sie kein X-Konto besitzen, können Sie auf{" "}
                <a className="adsimple-112958647" href="https://twitter.com/">
                twitter.com
                </a>
                &nbsp;gehen und dann auf „Individualisierung“ klicken. Unter dem Punkt
                „Individualisierung und Daten“ können Sie Ihre erhobenen Daten verwalten.
            </p>
            <p>
                Die meisten Daten werden, wie oben bereits erwähnt, über Cookies gespeichert
                und die können Sie in Ihrem Browser verwalten, deaktivieren oder löschen.
                Bitte beachten Sie, dass Sie die Cookies nur in dem von Ihnen gewählten
                Browser “bearbeiten”. Das heißt: verwenden Sie in Zukunft einen anderen
                Browser, müssen Sie dort Ihre Cookies erneut nach Ihren Wünschen verwalten.
                Unter dem Abschnitt „Cookies“ finden Sie die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <p>
                Ihren Browser können Sie auch so verwalten, dass Sie bei jedem einzelnen
                Cookie informiert werden. Dann können Sie immer individuell entscheiden, ob
                Sie ein Cookie zulassen oder nicht.
            </p>
            <p>
                X verwendet die Daten auch für personalisierte Werbung in- und außerhalb von
                X. In den Einstellungen können Sie unter „Individualisierung und Daten“ die
                personalisierte Werbung abschalten. Wenn Sie X auf einem Browser nutzen,
                können Sie die personalisierte Werbung unter{" "}
                <a
                className="adsimple-112958647"
                href="https://optout.aboutads.info/?c=2&lang=EN"
                >
                https://optout.aboutads.info/?c=2&amp;lang=EN
                </a>
                deaktivieren.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
                Social-Media-Elemente verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die eingebundene
                Social-Media-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben. Die meisten Social-Media-Plattformen setzen auch Cookies in
                Ihrem Browser, um Daten zu speichern. Darum empfehlen wir Ihnen, unseren
                Datenschutztext über Cookies genau durchzulesen und die Datenschutzerklärung
                oder die Cookie-Richtlinien des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                X verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf hin,
                dass nach Meinung des Europäischen Gerichtshofs derzeit kein angemessenes
                Schutzniveau für den Datentransfer in die USA besteht. Dies kann mit
                verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet X
                sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich X, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei X finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://gdpr.twitter.com/en/controller-to-controller-transfers.html"
                target="_blank"
                rel="follow noopener"
                >
                https://gdpr.twitter.com/en/controller-to-controller-transfers.html
                </a>
                .
            </p>
            <p>
                Wir hoffen, wir haben Ihnen einen grundsätzlichen Überblick über die
                Datenverarbeitung durch X gegeben. Wir erhalten keinen Daten von X und
                tragen auch keine Verantwortung darüber, was X mit Ihren Daten macht. Falls
                Sie noch weitere Fragen zu diesem Thema haben, empfehlen wir Ihnen die
                X-Datenschutzerklärung unter{" "}
                <a
                className="adsimple-112958647"
                href="https://twitter.com/de/privacy?tid=112958647"
                >
                https://twitter.com/de/privacy
                </a>
                .
            </p>
            <h2
                id="blogs-und-publikationsmedien-einleitung"
                className="adsimple-112958647"
            >
                Blogs und Publikationsmedien Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Blogs und Publikationsmedien Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Darstellung und Optimierung unserer Serviceleistung sowie
                    Kommunikation zwischen Websitebesuchern, Sicherheitsmaßnahmen und
                    Verwaltung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Kontaktdaten, IP-Adresse und
                    veröffentlichte Inhalte.
                    <br />
                    Mehr Details dazu finden Sie bei den eingesetzten Tools.
                    <br />
                    📅 Speicherdauer: abhängig von den verwendeten Tools
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen), Art. 6 Abs. 1 S. 1 lit.
                    b. DSGVO (Vertrag)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Blogs und Publikationsmedien?</h3>
            <p>
                Wir nutzen auf unsere Website Blogs oder auch andere Kommunikationsmittel,
                mit denen wir einerseits mit Ihnen und andererseits Sie auch mit uns
                kommunizieren können. Dabei können auch Daten von Ihnen bei uns gespeichert
                und verarbeitet werden. Das kann notwendig sein, damit wir Inhalte
                entsprechend darstellen können, die Kommunikation funktioniert und die
                Sicherheit erhöht wird. In unserem Datenschutztext gehen wir allgemein
                darauf ein, welche Daten von Ihnen verarbeitet werden können. Exakte Angaben
                zur Datenverarbeitung hängen stets auch von den verwendeten Tools und
                Funktionen ab. In den Datenschutzhinweisen der einzelnen Anbieter finden Sie
                genaue Informationen über die Datenverarbeitung.
            </p>
            <h3 className="adsimple-112958647">
                Warum nutzen wir Blogs und Publikationsmedien?
            </h3>
            <p>
                Unser größtes Anliegen mit unserer Website ist Ihnen interessante und
                spannende Inhalte zu bieten und gleichzeitig sind uns auch Ihre Meinungen
                und Inhalte wichtig. Darum wollen wir einen guten interaktiven Austausch
                zwischen uns und Ihnen schaffen. Mit diversen Blogs und
                Publikationsmöglichkeiten können wir genau das erreichen. Sie können
                beispielsweise Kommentare zu unseren Inhalten verfassen, andere Kommentare
                kommentieren oder auch in manchen Fällen selbst Beiträge verfassen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Welche Daten genau verarbeitet werden, hängt stets von den von uns
                verwendeten Kommunikationsfunktionen ab. Sehr oft werden IP-Adresse,
                Benutzername und der veröffentlichte Inhalt gespeichert. Das geschieht in
                erster Linie, um einen Sicherheitsschutz zu gewährleisten, Spam vorzubeugen
                und um gegen widerrechtliche Inhalte vorgehen zu können. Für die
                Datenspeicherung können auch Cookies verwendet werden. Das sind kleine
                Text-Dateien, die mit Informationen in Ihrem Browser abgespeichert werden.
                Näheres zu den erhobenen und gespeicherten Daten finden Sie in unseren
                einzelnen Abschnitten und in der Datenschutzerklärung des jeweiligen
                Anbieters.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Beispielsweise speichern
                Beitrags- und Kommentarfunktionen Daten, bis Sie die Datenspeicherung
                widerrufen. Generell werden personenbezogene Daten nur so lange, wie es für
                die Bereitstellung unserer Dienstleistungen unbedingt notwendig ist,
                gespeichert.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern von Kommunikations-Tools zu
                widerrufen. Das funktioniert entweder über unser Cookie-Management-Tool oder
                über andere Opt-Out-Funktionen. Zum Beispiel können Sie auch die
                Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die
                Cookies verwalten, deaktivieren oder löschen.
            </p>
            <p>
                Da bei Publikationsmedien auch Cookies zum Einsatz kommen können, empfehlen
                wir Ihnen auch unsere allgemeine Datenschutzerklärung über Cookies. Um zu
                erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet werden,
                sollten Sie die Datenschutzerklärungen der jeweiligen Tools durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wir setzen die Kommunikationsmittel hauptsächlich auf Grundlage unserer
                berechtigten Interessen (Art. 6 Abs. 1 lit. f DSGVO) an einer schnellen und
                guten Kommunikation mit Ihnen oder anderen Kunden, Geschäftspartnern und
                Besuchern ein. Soweit die Nutzung der Abwicklung von vertraglichen
                Beziehungen oder deren Anbahnung dient, ist Rechtsgrundlage ferner Art. 6
                Abs. 1 S. 1 lit. b. DSGVO.
            </p>
            <p>
                Bestimmte Verarbeitungen, insbesondere der Einsatz von Cookies sowie die
                Nutzung von Kommentar- oder Nachrichtenfunktionen bedürfen Ihrer
                Einwilligung. Wenn und soweit Sie eingewilligt haben, dass Daten von Ihnen
                durch eingebundene Publikationsmedien verarbeitet und gespeichert werden
                können, gilt diese Einwilligung als Rechtsgrundlage der Datenverarbeitung
                (Art. 6 Abs. 1 lit. a DSGVO).&nbsp;Die meisten von uns verwendeten
                Kommunikationsfunktionen setzen Cookies in Ihrem Browser, um Daten zu
                speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies
                genau durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien
                des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                Informationen zu speziellen Tools erfahren Sie – sofern vorhanden – in den
                folgenden Abschnitten.
            </p>
            <h2
                id="blogbeitraege-und-kommentarfunktionen-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Blogbeiträge und Kommentarfunktionen Datenschutzerklärung
            </h2>
            <p>
                Es gibt verschiedenen Online-Kommunikationsmittel, die wir auf unsere
                Website verwenden können. So nutzen wir beispielweise Blogbeiträge und
                Kommentarfunktionen. So haben Sie die Möglichkeit, Inhalte auch zu
                kommentieren bzw. Beiträge zu verfassen. Wenn Sie diese Funktion nutzen,
                kann aus Sicherheitsgründen etwa Ihre IP-Adresse gespeichert werden. So
                schützen wir uns vor widerrechtlichen Inhalten wie beispielsweise
                Beleidigungen, unerlaubte Werbung oder verbotene politische Propaganda. Um
                zu erkennen, ob es sich bei Kommentaren um Spam handelt, können wir auch auf
                Grundlage unseres berechtigten Interesses User-Angaben speichern und
                verarbeiten. Falls wir eine Umfrage starten, speichern wir auch für die
                Dauer der Umfrage Ihre IP-Adresse, damit wir sicher gehen können, dass alle
                Beteiligten auch wirklich nur einmal abstimmen. Es können zum Zweck der
                Speicherung auch Cookies zum Einsatz kommen. Alle Daten, die wir von Ihnen
                speichern (etwa Inhalte oder Informationen zu Ihrer Person), bleiben bis zu
                Ihrem Widerspruch gespeichert.
            </p>
            <h2 id="blogger-com-datenschutzerklaerung" className="adsimple-112958647">
                Blogger.com Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auf unserer Website auch die Hosting- und Bloggerplattform
                Blogger.com. Dienstanbieter ist das amerikanische Unternehmen Google Inc.
                Für den europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon
                House, Barrow Street Dublin 4, Irland) für alle Google-Dienste
                verantwortlich.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Google verarbeitet werden,
                erfahren Sie in der Privacy Policy auf
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de?tid=112958647"
                target="_blank"
                rel="noopener"
                >
                https://policies.google.com/privacy?hl=de
                </a>
                .
            </p>
            <h2 id="kommentar-abos-datenschutzerklaerung" className="adsimple-112958647">
                Kommentar-Abos Datenschutzerklärung
            </h2>
            <p>
                Sie können auch Kommentare, die auf Ihren Beitrag folgen, abonnieren. In
                diesem Fall erhalten Sie stets eine Nachricht, wenn ein Folgekommentar
                veröffentlicht wird. Zuerst bekommen Sie eine Bestätigungsmail, um zu
                überprüfen, ob Ihnen auch die angegebene E-Mail-Adresse gehört. Mit der
                Abgabe der Bestätigung willigen Sie auch in die Datenverarbeitung ein.
                Dieses Abo können Sie (wie beispielsweise bei einem Newsletter) jederzeit
                abbestellen und ihre Einwilligung widerrufen. Die Rechtmäßigkeit der
                Verarbeitung bis zu diesem Zeitpunkt bleibt unberührt. Solange Sie
                Abonnement der Kommentare sind, speichern wir Ihren Anmeldezeitpunkt und
                Ihre IP-Adresse, damit wir Ihre Einwilligung auch gegebenenfalls nachweisen
                können. Nach Ihrer Abo-Kündigung können wir Ihre E-Mail-Adresse, auf der
                rechtlichen Grundlage unseres berechtigten Interesses eines
                Einwilligungsnachweises, bis zu drei Jahren aufbewahren. Wenn Sie allerdings
                die ehemalige Einwilligung zum Abo bestätigen und eine Löschung Ihrer Daten
                beantragen, werden die Daten sofort aus unserem System gelöscht.
            </p>
            <h2 id="online-marketing-einleitung" className="adsimple-112958647">
                Online-Marketing Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Online-Marketing Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Auswertung der Besucherinformationen zur Optimierung des
                    Webangebots.
                    <br />
                    📓 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte
                    der Zugriffe, Gerätedaten, Zugriffsdauer und Zeitpunkt,
                    Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Auch
                    personenbezogene Daten wie Name oder E-Mail-Adresse können verarbeitet
                    werden. Mehr Details dazu finden Sie beim jeweils eingesetzten
                    Online-Marketing-Tool.
                    <br />
                    📅 Speicherdauer: abhängig von den eingesetzten Online-Marketing-Tools
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit.f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Online-Marketing?</h3>
            <p>
                Unter Online-Marketing bezeichnet man alle Maßnahmen, die online
                durchgeführt werden, um Marketingziele wie etwa die Steigerung der
                Markenbekanntheit oder einen Geschäftsabschluss zu erreichen. Weiters zielen
                unserer Online-Marketing-Maßnahmen darauf ab, Menschen auf unsere Website
                aufmerksam zu machen. Um unser Angebot vielen interessierten Menschen zeigen
                zu können, betreiben wir also Online-Marketing. Meistens handelt es sich
                dabei um Onlinewerbung, Content-Marketing oder Suchmaschinenoptimierung.
                Damit wir Online-Marketing effizient und zielgerecht einsetzen können,
                werden auch personenbezogene Daten gespeichert und verarbeitet. Die Daten
                helfen uns einerseits unsere Inhalte nur wirklich jenen Personen zu zeigen,
                die sich dafür auch interessieren und andererseits können wir den
                Werbeerfolg unserer Online-Marketing-Maßnahmen messen.
            </p>
            <h3 className="adsimple-112958647">
                Warum nutzen wir Online-Marketing-Tools?
            </h3>
            <p>
                Wir wollen jedem Menschen, der sich für unser Angebot interessiert, unsere
                Website zeigen. Uns ist bewusst, dass dies ohne bewusst gesetzte Maßnahmen
                nicht möglich ist. Darum machen wir Online-Marketing. Es gibt verschiedene
                Tools, die uns die Arbeit an unseren Online-Marketing-Maßnahmen erleichtern
                und zusätzlich über Daten stets Verbesserungsvorschläge liefern. So können
                wir unsere Kampagnen genauer an unsere Zielgruppe richten. Zweck dieser
                eingesetzten Online-Marketing-Tools ist also letztlich die Optimierung
                unseres Angebots.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Damit unser Online-Marketing funktioniert und der Erfolg der Maßnahmen
                gemessen werden kann, werden Userprofile erstellt und Daten beispielsweise
                in Cookies (das sind kleine Text-Dateien) gespeichert. Mit Hilfe dieser
                Daten können wir nicht nur Werbung in klassischer Hinsicht schalten, sondern
                auch direkt auf unserer Website, unsere Inhalte so darstellen, wie es Ihnen
                am liebsten ist. Dafür gibt es verschiedene Drittanbieter-Tools, die diese
                Funktionen anbieten und entsprechend auch Daten von Ihnen sammeln und
                speichern. In den benannten Cookies wird zum Beispiel gespeichert, welche
                Webseiten Sie auf unserer Website besucht haben, wie lange Sie diese Seiten
                angesehen haben, welche Links oder Buttons Sie klicken oder von welcher
                Website sie zu uns gekommen sind. Zusätzlich können auch technische
                Informationen gespeichert werden. Etwa Ihre IP-Adresse, welchen Browser Sie
                nutzen, von welchem Endgerät Sie unsere Website besuchen oder die Uhrzeit,
                wann Sie unserer Website aufgerufen haben und wann Sie sie wieder verlassen
                haben. Wenn Sie eingewilligt haben, dass wir auch Ihren Standort bestimmen
                dürfen, können wir auch diesen speichern und verarbeiten.
            </p>
            <p>
                Ihre IP-Adresse wird in pseudonymisierter Form (also gekürzt) gespeichert.
                Eindeutige Daten, die Sie als Person direkt identifizieren, wie etwa Name,
                Adresse oder E-Mail-Adresse, werden im Rahmen der Werbe- und
                Online-Marketing-Verfahren auch nur in pseudonymisierter Form gespeichert.
                Wir können Sie also nicht als Person identifizieren, sondern wir haben nur
                die pseudonymisierten, gespeicherten Informationen in den Userprofilen
                gespeichert.
            </p>
            <p>
                Die Cookies können unter Umständen auch auf anderen Websites, die mit
                denselben Werbetools arbeiten, eingesetzt, analysiert und für Werbezwecke
                verwendet werden. Die Daten können dann auch auf den Servern der
                Werbetools-Anbieter gespeichert werden.
            </p>
            <p>
                In Ausnahmefällen können auch eindeutige Daten (Namen, Mail-Adresse usw.) in
                den Userprofilen gespeichert werden. Zu dieser Speicherung kommt es etwa,
                wenn Sie Mitglied eines Social-Media-Kanals sind, dass wir für unsere
                Online-Marketing-Maßnahmen nutzen und das Netzwerk bereits früher
                eingegangene Daten mit dem Userprofil verbindet.
            </p>
            <p>
                Bei allen von uns verwendeten Werbetools, die Daten von Ihnen auf deren
                Servern speichert, erhalten wir immer nur zusammengefasste Informationen und
                nie Daten, die Sie als Einzelperson erkennbar machen. Die Daten zeigen
                lediglich, wie gut gesetzte Werbemaßnahmen funktionierten. Zum Beispiel
                sehen wir, welche Maßnahmen Sie oder andere User dazu bewogen haben, auf
                unsere Website zu kommen und dort eine Dienstleistung oder ein Produkt zu
                erwerben. Anhand der Analysen können wir unser Werbeangebot in Zukunft
                verbessern und noch genauer an die Bedürfnisse und Wünsche interessierter
                Personen anpassen.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Generell verarbeiten wir
                personenbezogene Daten nur so lange wie es für die Bereitstellung unserer
                Dienstleistungen und Produkte unbedingt notwendig ist. Daten, die in Cookies
                gespeichert werden, werden unterschiedlich lange gespeichert.&nbsp;Manche
                Cookies werden bereits nach dem Verlassen der Website wieder gelöscht,
                anderen können über einige Jahre in Ihrem Browser gespeichert sein. In den
                jeweiligen Datenschutzerklärungen der einzelnen Anbieter erhalten Sie in der
                Regel genaue Informationen über die einzelnen Cookies, die der Anbieter
                verwendet.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert
                entweder über unser Cookie-Management-Tool oder über andere
                Opt-Out-Funktionen. Zum Beispiel können Sie auch die Datenerfassung durch
                Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
                deaktivieren oder löschen. Die Rechtmäßigkeit der Verarbeitung bis zum
                Widerruf bleibt unberührt.
            </p>
            <p>
                Da bei Online-Marketing-Tools in der Regel Cookies zum Einsatz kommen
                können, empfehlen wir Ihnen auch unsere allgemeine Datenschutzerklärung über
                Cookies. Um zu erfahren, welche Daten von Ihnen genau gespeichert und
                verarbeitet werden, sollten Sie die Datenschutzerklärungen der jeweiligen
                Tools durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Drittanbieter eingesetzt werden dürfen,
                ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese
                Einwilligung. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Online-Marketing-Tools vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse,
                Online-Marketing-Maßnahmen in anonymisierter Form zu messen, um mithilfe der
                gewonnenen Daten unser Angebot und unsere Maßnahmen zu optimieren. Die dafür
                entsprechende Rechtsgrundlage ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen die Tools gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Informationen zu speziellen Online-Marketing-Tools erhalten Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h2
                id="facebook-custom-audiences-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Facebook Custom Audiences Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website Facebook Custom Audiences, ein
                serverseitiges Event-Trackingtool. Dienstanbieter ist das amerikanische
                Unternehmen Meta Platforms Inc. Für den europäischen Raum ist das
                Unternehmen Meta Platforms Ireland Limited (4 Grand Canal Square, Grand
                Canal Harbour, Dublin 2, Irland) verantwortlich.
            </p>
            <p>
                Facebook verarbeitet Daten von Ihnen u.a. auch in den USA. Facebook bzw.
                Meta Platforms ist aktiver Teilnehmer des EU-US Data Privacy Frameworks,
                wodurch der korrekte und sichere Datentransfer personenbezogener Daten von
                EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Facebook sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Facebook, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Facebook Datenverarbeitungsbedingung, welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/legal/terms/dataprocessing"
                >
                https://www.facebook.com/legal/terms/dataprocessing
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Facebook Custom Audiences
                verarbeitet werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/about/privacy"
                target="_blank"
                rel="noopener"
                >
                https://www.facebook.com/about/privacy
                </a>
                <u>.&nbsp;</u>
            </p>
            <h2 id="google-admob-datenschutzerklaerung" className="adsimple-112958647">
                Google AdMob Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website Google AdMob, ein Tool für mobile Werbung.
                Dienstanbieter ist das amerikanische Unternehmen Google Inc. Für den
                europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon House,
                Barrow Street Dublin 4, Irland) für alle Google-Dienste verantwortlich.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Datenverarbeitungsbedingungen für Google Werbeprodukte (Google Ads
                Controller-Controller Data Protection Terms), welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Google AdMob verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de?tid=112958647"
                target="_blank"
                rel="noopener"
                >
                https://policies.google.com/privacy?hl=de
                </a>
                .
            </p>
            <h2
                id="google-marketing-platform-frueher-doubleclick-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Google Marketing Platform (früher: DoubleClick) Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website Google-Marketing-Platform-Produkte.
                Darunter befinden sich diverse Marketingtools wie etwa Data Studio, Surveys,
                Campaign Manager 360, Display &amp; Video 360 oder Search Ads 360.
                Dienstanbieter ist das amerikanische Unternehmen Google Inc. Für den
                europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon House,
                Barrow Street Dublin 4, Irland) für alle Google-Dienste verantwortlich.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
                Terms), welche auf die Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von
                Google-Marketing-Platform-Produkte verarbeitet werden, erfahren Sie in der
                Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://policies.google.com/privacy?hl=de
                </a>
                .
            </p>
            <h2 id="hubspot-datenschutzerklaerung" className="adsimple-112958647">
                HubSpot Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website HubSpot, ein Tool für digitales Marketing.
                Dienstanbieter ist das amerikanische Unternehmen HubSpot, Inc., 25 First
                Street, 2nd Floor Cambridge, MA, USA. Das Unternehmen hat unter anderem auch
                in Irland einen Firmensitz mit der Adresse 1 Sir John Rogerson’s Quay,
                Dublin 2, Irland.
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von HubSpot verarbeitet
                werden, erfahren Sie in der Privacy Policy auf
                <a
                className="adsimple-112958647"
                href="https://legal.hubspot.com/de/privacy-policy?tid=112958647"
                target="_blank"
                rel="noopener"
                >
                https://legal.hubspot.com/de/privacy-policy
                </a>
                <u>. </u>
            </p>
            <h2
                id="datenspeicherung-durch-hubspot-in-den-usa"
                className="adsimple-112958647"
            >
                Datenspeicherung durch HubSpot in den USA
            </h2>
            <p>
                HubSpot verarbeitet Daten von Ihnen auch in den USA. HubSpot ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet HubSpot sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich HubSpot, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Datenverarbeitungsbedingung (Data Processing Agreement), welche den
                Standardvertragsklauseln entspricht, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://legal.hubspot.com/dpa"
                target="_blank"
                rel="follow noopener"
                >
                https://legal.hubspot.com/dpa
                </a>
                .
            </p>
            <h2
                id="datenspeicherung-durch-hubspot-in-der-eu"
                className="adsimple-112958647"
            >
                Datenspeicherung durch HubSpot in der EU
            </h2>
            <p>
                HubSpot speichert und verarbeitet Ihre Daten innerhalb der Europäischen
                Union (EU). Die Daten werden in einem Rechenzentrum in Deutschland gehostet.
                Zudem gibt es auch noch einen Backup-Standort in Irland. Damit stellt
                HubSpot sicher, dass Ihre personenbezogenen Daten gemäß den Vorgaben der
                Datenschutz-Grundverordnung (DSGVO) verarbeitet werden.
            </p>
            <p>
                Weitere Informationen zur Datenverarbeitung durch HubSpot finden Sie unter:{" "}
                <a
                className="adsimple-112958647"
                href="https://legal.hubspot.com/dpa"
                target="_blank"
                rel="follow noopener"
                >
                https://legal.hubspot.com/dpa
                </a>
                .
            </p>
            <h2
                id="linkedin-insight-tag-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                LinkedIn Insight-Tag Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        LinkedIn Insight-Tag Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Auswertung der Besucherinformationen zur Optimierung des
                    Webangebots.
                    <br />
                    📓 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte
                    der Zugriffe, Gerätedaten, Zugriffsdauer und Zeitpunkt,
                    Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Mehr
                    Details dazu finden weiter unten und in der Datenschutzerklärung von
                    LinkedIn.
                    <br />
                    📅 Speicherdauer: direkte Kennungen durch LinkedIn Insight-Tag werden
                    innerhalb von sieben Tagen entfernt
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist LinkedIn Insight-Tag?</h3>
            <p>
                Wir nutzen auf unserer Website das Conversion-Tracking-Tool LinkedIn
                Insight-Tag. Dienstanbieter ist das amerikanische Unternehmen LinkedIn
                Corporation, 2029 Stierlin Court, Mountain View, CA 94043, USA. Für die
                datenschutzrelevanten Aspekte im Europäischen Wirtschaftsraum (EWR), der EU
                und der Schweiz ist das Unternehmen LinkedIn Ireland Unlimited (Wilton
                Place, Dublin 2, Irland) verantwortlich.
            </p>
            <p>
                Durch die Einbettung des Tracking-Tools können Daten an LinkedIn versandt,
                gespeichert und dort verarbeitet werden. In dieser Datenschutzerklärung
                wollen wir Sie informieren, um welche Daten es sich handelt, wie das
                Netzwerk diese Daten verwendet und wie Sie die Datenspeicherung verwalten
                bzw. unterbinden können.
            </p>
            <p>
                LinkedIn ist das größte soziale Netzwerk für Geschäftskontakte. Anders als
                beispielsweise bei Facebook konzentriert sich das Unternehmen ausschließlich
                auf den Aufbau geschäftlicher Kontakte. Unternehmen können auf der Plattform
                Dienstleistungen und Produkte vorstellen und Geschäftsbeziehungen knüpfen.
                Viele Menschen verwenden LinkedIn auch für die Jobsuche oder um selbst
                geeignete Mitarbeiter oder Mitarbeiterinnen für die eigene Firma zu finden.
                Allein in Deutschland zählt das Netzwerk über 11 Millionen Mitglieder. In
                Österreich sind es etwa 1,3 Millionen.
            </p>
            <p>
                Bei dem Conversion-Tracking-Tool von LinkedIn handelt es sich um einen
                kleinen JavaScript-Code, den wir in unsere Website eingebunden haben. Diese
                Funktion hilft uns, unser Werbeangebot besser an Ihre Interessen und
                Bedürfnisse anzupassen. Im folgenden Artikel wollen wir genauer darauf
                eingehen, warum wir LinkedIn Insight-Tag benutzen, welche Daten dabei
                gespeichert werden und wie Sie diese Datenspeicherung verhindern.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir LinkedIn Insight-Tag auf unserer Website?
            </h3>
            <p>
                Wir setzen LinkedIn Insight-Tag ein, um auf unser Angebot aufmerksam zu
                machen. Ziel ist es, dass unsere Werbekampagnen wirklich auch nur jene
                Menschen erreichen, die sich für unsere Angebote interessieren. Mit dem
                LinkedIn Insight-Tag können wir detaillierte Informationen über Ihr
                Websiteverhalten sammeln, sofern Sie auch ein LinkedIn-Mitglied sind. So
                sehen wir auch welche Keywords, Anzeigen, Anzeigengruppen und Kampagnen auf
                LinkedIn zu den gewünschten Kundenaktionen führen.&nbsp;Wir sehen wie viele
                Kunden mit unseren Anzeigen auf einem Gerät interagieren und dann eine
                Conversion durchführen. Durch diese Daten können wir
                unseren&nbsp;Kosten-Nutzen-Faktor berechnen,&nbsp;den Erfolg einzelner
                Werbemaßnahmen messen und folglich unsere Online-Marketing-Maßnahmen
                optimieren.&nbsp;Wir können weiters mithilfe der gewonnenen Daten unsere
                Webseite für Sie interessanter gestalten und unser Werbeangebot noch
                individueller an Ihre Bedürfnisse anpassen.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von LinkedIn Insight-Tag gespeichert?
            </h3>
            <p>
                Wie bereits oben erwähnt, haben wir ein Conversion-Tracking-Tag oder
                Code-Snippet auf unserer Website eingebunden, um gewisse User-Aktionen
                besser analysieren zu können. Wenn Sie nun eine unserer LinkedIn-Anzeigen
                anklicken, kann auf Ihrem Computer (meist im Browser) oder Mobilgerät ein
                Cookie gespeichert werden. Grundsätzlich verarbeitet LinkedIn Daten mit
                einer Kombination aus Cookies und serverseitigen Funktionen.
            </p>
            <p>
                Sobald Sie eine Aktion auf der Webseite abschließen, erkennt LinkedIn das
                Cookie und speichert Ihre Handlung als sogenannte Conversion. Solange Sie
                auf unserer Webseite surfen, erkennen wir und LinkedIn, dass Sie über unsere
                LinkedIn-Anzeige zu uns gefunden haben. Das Cookie wird ausgelesen und mit
                den Conversion-Daten zurück an LinkedIn gesendet. Es ist auch möglich, dass
                noch weitere Cookies zur Messung von Conversions verwendet werden.
            </p>
            <p>
                Neben Ihrer IP-Adresse werden dabei auch URL, Referrer-URL, Geräte und
                Browsereigenschaften und der Zeitstempel gespeichert. Die IP-Adresse zählt
                zu den personenbezogenen Daten und wird bei LinkedIn gekürzt oder gehasht.
            </p>
            <p>
                Sie fragen sich vielleicht, was Conversions eigentlich sind. Eine Conversion
                entsteht, wenn Sie von einem rein interessierten Webseitenbesucher zu einem
                handelnden Besucher werden. Dies passiert immer dann, wenn Sie auf unsere
                Anzeige klicken und im Anschluss eine andere Aktion ausführen, wie zum
                Beispiel unsere Webseite besuchen oder ein Produkt erwerben.&nbsp;Mit dem
                Conversion-Tracking-Tool von LinkedIn erfassen wir, was nach einem Klick
                eines Users auf unsere LinkedIn-Anzeige geschieht. Zum Beispiel können wir
                so sehen, ob Produkte gekauft werden, Dienstleistungen in Anspruch genommen
                werden oder ob Sie sich beispielsweise für unseren Newsletter angemeldet
                haben.
            </p>
            <p>
                Zudem können auch noch demografische Daten, die Sie in Ihrem LinkedIn-Profil
                angegeben haben, verarbeitet werden. Das können Informationen zu Ihrem
                Beruf, zur geografischen Lage, zu Ihrer Branche bzw. zu Ihrem Unternehmen
                sein.
            </p>
            <p>
                Wir bekommen von LinkedIn einen Bericht mit statistischen Auswertungen. So
                erfahren wir etwa die Gesamtanzahl der User, die unsere Anzeige angeklickt
                haben und wir sehen, welche Werbemaßnahmen gut ankamen.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich behaltet LinkedIn Ihre personenbezogenen Daten so lange, wie
                es das Unternehmen als nötig betrachtet, um die eigenen Dienste anzubieten.
                LinkedIn löscht aber Ihre personenbezogenen Daten, wenn Sie Ihr Konto
                löschen. In manchen Ausnahmefällen behaltet LinkedIn selbst nach Ihrer
                Kontolöschung einige Daten in zusammengefasster und anonymisierter Form.
            </p>
            <p>
                Direkte Kennungen durch LinkedIn Insight-Tag werden innerhalb von sieben
                Tagen entfernt, um die Daten zu pseudonymisieren. Die daraus entstandenen
                pseudonymisierten Daten werden innerhalb von 180 Tagen gelöscht.
            </p>
            <p>
                Die Daten werden auf verschiedenen Servern in Amerika und vermutlich auch in
                Europa gespeichert.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Ihre personenbezogenen Daten zuzugreifen
                und sie auch zu löschen.
            </p>
            <p>
                Sie haben die Möglichkeit am Conversion-Tracking von LinkedIn nicht
                teilzunehmen. Wenn Sie das Cookie des Google Conversion-Trackings über Ihren
                Browser deaktivieren bzw. der Datenverarbeitung über den Consent Manager
                (Pop-up) nicht einwilligen, blockieren Sie das Conversion-Tracking. In
                diesem Fall werden Sie in der Statistik des Tracking-Tools nicht
                berücksichtigt. Sie können die Cookie-Einstellungen in Ihrem Browser
                jederzeit verändern. Bei jedem Browser funktioniert dies etwas anders. Unter
                dem Abschnitt „Cookies“ finden Sie die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <p>
                In Ihrem LinkedIn-Konto können Sie auch Ihre Daten verwalten, ändern und
                löschen. Zudem können Sie von LinkedIn auch eine Kopie Ihrer
                personenbezogenen Daten anfordern.
            </p>
            <p>So greifen Sie auf die Kontodaten in Ihrem LinkedIn-Profil zu:</p>
            <p>
                Klicken Sie in LinkedIn auf Ihr Profilsymbol und wählen Sie die Rubrik
                „Einstellungen und Datenschutz“. Klicken Sie nun auf „Datenschutz“ und dann
                im Abschnitt „So verwendet LinkedIn Ihre Daten auf „Ändern“. In nur kurzer
                Zeit können Sie ausgewählte Daten zu Ihrer Web-Aktivität und Ihrem
                Kontoverlauf herunterladen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass LinkedIn Insight-Tag eingesetzt werden
                darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese
                Einwilligung. Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO
                (Einwilligung) die Rechtsgrundlage für die Verarbeitung personenbezogener
                Daten, wie sie bei der Erfassung durch den LinkedIn Insight-Tag vorkommen
                kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, den LinkedIn
                Insight-Tag zu verwenden, um unser Online-Service und unsere
                Marketingmaßnahmen zu optimieren. Die dafür entsprechende Rechtsgrundlage
                ist Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen). Wir setzen den
                LinkedIn Insight-Tag gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                LinkedIn verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                LinkedIn sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3
                DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind
                von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                diese Klauseln verpflichtet sich LinkedIn, bei der Verarbeitung Ihrer
                relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn
                die Daten in den USA gespeichert, verarbeitet und verwaltet werden. Diese
                Klauseln basieren auf einem Durchführungsbeschluss der EU-Kommission. Sie
                finden den Beschluss und die entsprechenden Standardvertragsklauseln u.a.
                hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei LinkedIn finden Sie
                unter{" "}
                <a
                className="adsimple-112958647"
                href="https://de.linkedin.com/legal/l/dpa"
                target="_blank"
                rel="follow noopener"
                >
                https://de.linkedin.com/legal/l/dpa
                </a>{" "}
                oder{" "}
                <a
                className="adsimple-112958647"
                href="https://www.linkedin.com/legal/l/eu-sccs"
                target="_blank"
                rel="follow noopener"
                >
                https://www.linkedin.com/legal/l/eu-sccs
                </a>
            </p>
            <p>
                Näheres über LinkedIn Insight-Tag erfahren Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.linkedin.com/help/linkedin/answer/a427660"
                target="_blank"
                rel="follow noopener"
                >
                https://www.linkedin.com/help/linkedin/answer/a427660
                </a>
                . Mehr über die Daten, die durch die Verwendung von LinkedIn Insight-Tag
                verarbeitet werden, erfahren Sie auch in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://de.linkedin.com/legal/privacy-policy"
                target="_blank"
                rel="follow noopener"
                >
                https://de.linkedin.com/legal/privacy-policy
                </a>
                .
            </p>
            <h2
                id="microsoft-advertising-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Microsoft Advertising Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Microsoft Advertising Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: wirtschaftlicher Erfolg und die Optimierung unserer
                    Serviceleistung.
                    <br />
                    📓 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte
                    der Zugriffe, Gerätedaten, Zugriffsdauer und Zeitpunkt,
                    Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Auch
                    personenbezogene Daten wie Name oder E-Mail-Adresse können verarbeitet
                    werden.
                    <br />
                    📅 Speicherdauer: Microsoft speichert die Daten, bis sie für die
                    Erfüllung der Zwecke nicht mehr gebraucht werden
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit.f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Microsoft Advertising?</h3>
            <p>
                Für unsere Online-Marketing-Maßnahmen nutzen wir auch das Werbeprogramm
                Microsoft Advertising des Unternehmens Microsoft Corporation, One Microsoft
                Way, Redmond, WA 98052-6399, USA. Mit Hilfe von Microsoft Advertising wollen
                wir viele Menschen auf die hohe Qualität unserer Produkte und/oder
                Dienstleistungen aufmerksam machen. Dafür verwenden wir eine Technologie
                (Conversion-Tracking-Tool) von Microsoft auf unserer Website, die auch Daten
                von Ihnen speichert. In dieser Datenschutzerklärung gehen wir näher auf
                dieses Service ein, zeigen Ihnen welche Daten gespeichert, verwaltet und
                verarbeitet werden und wie Sie diese Datenspeicherung verhindern können.
            </p>
            <p>
                Vielleicht kennen Sie Microsoft Advertising eher unter dem ehemaligen Namen
                „Bing Ads“. Dabei handelt es sich um ein Werbeprogramm von Microsoft, das
                auf einem Pay-per-Click-System basiert. Das bedeutet Werbetreibende können
                Werbeanzeigen über die Suchmaschinen Bing und Yahoo! schalten und bezahlen
                erst, wenn ein User auf die Anzeige klickt.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Microsoft Advertising?
            </h3>
            <p>
                Wir sind von unseren Angeboten überzeugt und wollen diese natürlich einer
                breiten Öffentlichkeit präsentieren. Mit Microsoft Advertising können wir
                unsere Produkte oder Dienstleistungen genau jenen Menschen näherbringen, die
                sich auch wirklich dafür interessieren. Wir wollen unsere Produkte nicht nur
                auf der berühmten Suchmaschine Google präsentieren, sondern auch auf Bing
                und Yahoo! Mit Microsoft Advertising haben wir zudem die Möglichkeit
                Anzeigen im sogenannten „Microsoft Audience Network“ zu schalten. So können
                wir beispielsweise auch in LinkedIn Werbeanzeigen schalten. Durch das
                Conversion-Tracking erfahren wir zum Beispiel über welche Anzeige Sie zu uns
                gefunden haben, welche Unterseiten Ihnen besonders gefallen und welche
                Aktionen Sie auf unserer Website ausführen. Durch diese Daten können wir
                unsere Website, unsere Werbeanzeigen und unsere Angebote wesentlich besser
                an Ihre Bedürfnisse anpassen.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Microsoft Advertising gespeichert?
            </h3>
            <p>
                Wir haben in unsere Website ein Conversion-Tracking Tag (also ein kleines
                Code-Snippet) von Microsoft Advertising eingebunden. Dabei handelt es sich
                um das sogenannte Universal-Event Tracking (UET)-Tag. Wenn Sie über eine
                Microsoftwerbung auf unsere Website kommen, können wir mit Hilfe dieses
                Trackingtools mehr über Ihr Userverhalten auf unserer Website erfahren. So
                erfahren wir etwa über welches Keyword bzw. welche Anzeige Sie zu uns
                gekommen sind, was Sie auf unserer Website anklicken, wie viele Menschen
                über Microsoft Ads unsere Website besuchen und wie lange Sie auf unserer
                Website bleiben. All diese Daten beziehen sich auf das Userverhalten und
                nicht auf personenbezogene Daten. Wir erhalten also nur Daten bzw.
                Auswertungen zu Ihrem Webverhalten, aber keine personenbezogenen
                Informationen. Microsoft nutzt die Daten, um das eigene Werbeangebot und
                weitere Dienste zu optimieren. Wenn Sie selbst ein Microsoft-Konto haben,
                können die erhobenen Daten mit Ihrem Konto verknüpft werden. So kann es auch
                sein, dass Microsoft Ihre IP-Adresse erkennt und speichert. Um all diese
                Daten zu Ihrem Userverhalten zu speichern wird in Ihrem Browser, nachdem Sie
                über eine Microsoft-Anzeige zu unserer Website gekommen sind, folgendes
                Cookie gesetzt:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>MUIDB
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                08A53CA3313F6255044C307E353F61CD
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie wird durch unser eingebettetes Microsoft-Tag (UET-Tag) eingestellt
                und dient der Synchronisierung über verschiedene Microsoft-Websites. Dadurch
                können Nutzer über verschiedene Domains hinweg erkannt werden.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach einem Jahr
            </p>
            <p>
                Wenn Sie etwa über eine Bing-Anzeige zu unserer Website gelangen, können
                allerdings noch andere Cookies in Ihrem Browser gesetzt werden. Hier zeigen
                wir Ihnen eine Auswahl weiterer Cookies:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>ABDEF
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                V=0&amp;ABDV=0&amp;MRNB=1594294373452&amp;MRB=0112958647-7
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Zu diesem
                Cookie konnten wir keine genaueren Informationen in Erfahrung bringen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>SRCHD
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>AF=NOFORM
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie ist für die Funktionalität des Trackings bzw. der Website
                verantwortlich.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>SRCHHPGUSR
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>
                WTS=63729889193&amp;HV=1594294374&amp;CW=1920&amp;CH=937&amp;DPR=1&amp;UTC=120&amp;DM=0
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie verfolgt und speichert Ihr Nutzerverhalten auf unserer Website und
                die Interaktion der Bing-Map-Schnittstelle.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>SRCHUID
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                V=2&amp;GUID=157B20CCF36A43F3A4AE9790346EB7A7&amp;dmnchg=1
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie verfolgt und speichert Ihr Nutzerverhalten auf unserer Website und
                die Interaktion der Bing-Map-API.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>_EDGE_S
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                mkt=de-at&amp;SID=2EE7002D956A61511D280F2F9474607112958647-2
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Cookie sammelt und speichert Ihr Userverhalten über mehrere Websites hinweg.
                Ziel des Targetings ist es, die Werbemaßnahmen besser an die Interessen
                unserer Zielgruppe anzupassen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach Ende der
                Browsersitzung
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name: </strong>_SS
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                SID=2EE7002D956A61511D280F2F94746077112958647-9
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck</strong>: Dieses
                Cookie dient unter anderem dazu, zu erkennen, wie Sie als User auf unsere
                Website zugegriffen haben. Also über welche Werbeanzeige Sie zu unserer
                Website geleitet wurden.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach einem Jahr
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Wie Microsoft die erhobenen Userdaten weiter verwendet, haben wir keinen
                Einfluss. Microsoft hat weltweit eigene Server in Betrieb. Die meisten
                befinden sich in den Vereinigten Staaten und darum können Ihre Daten auch
                auf den amerikanischen Servern gespeichert, verwaltet und verarbeitet
                werden. Microsoft speichert Daten (besonders personenbezogenen Daten) so
                lange wie es zur Erbringung der eigenen Dienstleistungen bzw. Produkte oder
                für rechtliche Zwecke notwendig ist. Microsoft erwähnt zudem noch, dass die
                tatsächliche Aufbewahrungsdauer stark variiert und vom jeweiligen Produkt
                abhängt.
            </p>
            <p>
                Bei Suchanfragen über Bing löscht Microsoft Ihre gespeicherten Suchanfragen
                nach 6 Monaten, indem das Unternehmen Ihre IP-Adresse löscht. Cookie-IDs,
                die etwa über das Cookie MUID erzeugt werden, werden nach 18 Monaten
                unkenntlich gemacht.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit die Möglichkeit nicht an dem Conversion-Tracking von
                Microsoft Ads teilzunehmen. Falls Sie nicht wollen, dass Ihnen
                interessensbezogene Werbeanzeigen von Microsoft Advertising angezeigt
                werden, können Sie über{" "}
                <a
                className="adsimple-112958647"
                href="https://account.microsoft.com/privacy/ad-settings/signedout"
                >
                https://account.microsoft.com/privacy/ad-settings/signedout
                </a>
                diese Funktion ausschalten. Zudem können Sie auch in Ihrem Browser alle
                Cookies deaktivieren, verwalten oder löschen. Bei jedem Browser funktioniert
                das ein wenig anders. Unter dem Abschnitt „Cookies“ finden Sie die
                entsprechenden Links zu den jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Microsoft Advertising eingesetzt werden
                darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese
                Einwilligung. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Microsoft Advertising vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, Microsoft
                Advertising zu verwenden, um unser Online-Service und unsere
                Marketingmaßnahmen zu optimieren. Die dafür entsprechende Rechtsgrundlage
                ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen das Microsoft Advertising gleichwohl nur ein, soweit Sie eine
                Einwilligung erteilt haben.
            </p>
            <p>
                Microsoft verarbeitet Daten von Ihnen u.a. auch in den USA. Microsoft ist
                aktiver Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte
                und sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Microsoft sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Microsoft, bei der Verarbeitung Ihrer relevanten Daten,
                das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den
                USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren
                auf einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss
                und die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Microsoft finden Sie
                unter{" "}
                <a
                className="adsimple-112958647"
                href="https://learn.microsoft.com/en-us/compliance/regulatory/offering-eu-model-clauses"
                >
                https://learn.microsoft.com/en-us/compliance/regulatory/offering-eu-model-clauses
                </a>
            </p>
            <p>
                Wir hoffen Ihnen einen Überblick über die Datenverarbeitung durch das
                Conversion-Tracking von Microsoft Ads geboten zu haben. Es ist natürlich
                immer möglich, dass sich die Datenschutzrichtlinien bei Microsoft ändern.
                Für mehr Informationen und um immer am Laufenden zu bleiben, empfehlen wir
                Ihnen auch die Datenschutzbestimmungen von Microsoft unter{" "}
                <a
                className="adsimple-112958647"
                href="https://privacy.microsoft.com/de-de/privacystatement?tid=112958647"
                target="_blank"
                rel="noopener"
                >
                https://privacy.microsoft.com/de-de/privacystatement
                </a>
                .
            </p>
            <h2
                id="microsoft-advertising-similar-audiences-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Microsoft Advertising Similar Audiences Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auch das Werbetool Microsoft Advertising Similar Audiences.
                Dienstanbieter ist das amerikanische Unternehmen Microsoft Corporation, One
                Microsoft Way, Redmond, WA 98052-6399, USA. Für den europäischen Raum ist
                das Unternehmen Microsoft Ireland Operations Limited, South County Business
                Park, Dublin D18 P521, Irland, verantwortlich.
            </p>
            <p>
                Microsoft verarbeitet Daten von Ihnen u.a. auch in den USA. Microsoft ist
                aktiver Teilnehmer des EU‑US Data Privacy Frameworks, wodurch der korrekte
                und sichere Datentransfer personenbezogener Daten von EU‑Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie unter:{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
            </p>
            <p>
                Zudem verwendet Microsoft sogenannte Standardvertragsklauseln (= Art. 46
                Abs. 2 und 3 DSGVO). Diese von der EU‑Kommission bereitgestellten
                Mustervorlagen stellen sicher, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn sie in Drittländer (wie
                beispielsweise in die USA) übermittelt und dort gespeichert werden. Durch
                das EU‑US Data Privacy Framework und die Standardvertragsklauseln
                verpflichtet sich Microsoft, bei der Verarbeitung Ihrer relevanten Daten das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Den entsprechenden
                Durchführungsbeschluss und die Standardvertragsklauseln finden Sie u.a.
                unter:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Microsoft Advertising
                verarbeitet werden, erfahren unter:{" "}
                <a
                className="adsimple-112958647"
                href="https://www.microsoft.com/de-de/privacy/privacystatement?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                privacy.microsoft.com/de-de/privacystatement
                </a>
                .
            </p>
            <h2 id="monetizemore-datenschutzerklaerung" className="adsimple-112958647">
                MonetizeMore Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website MonetizeMore, ein Tool für
                Werbeoptimierungen. Dienstanbieter ist das kanadische Unternehmen
                MonetizeMore, 101-15317 Thrift Avenue White Rock, BC, Canada V4B 2L4.
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von MonetizeMore verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.monetizemore.com/privacy-policy/"
                target="_blank"
                rel="noopener"
                >
                https://www.monetizemore.com/privacy-policy/
                </a>
                .
            </p>
            <h2
                id="paypal-marketing-solutions-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                PayPal Marketing Solutions Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        PayPal Marketing Solutions Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa IP-Adresse und Anmelde- und
                    Kontaktdaten, Identifizierungs- und Unterschriftsdaten,
                    Zahlungsinformationen usw. Mehr Details dazu finden Sie weiter unten
                    in dieser Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: Grundsätzlich werden die Daten so lange gespeichert,
                    wie es zur Erfüllung der Pflichten und im Rahmen des Zwecks notwendig
                    ist.
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist PayPal Marketing Solutions?</h3>
            <p>
                Wir nutzen auf unserer Website das Verkaufs-Optimierungstool PayPal
                Marketing Solutions. Dienstanbieter ist das amerikanische Unternehmen PayPal
                Inc. Für den europäischen Raum ist das Unternehmen PayPal Europe (S.à r.l.
                et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg) verantwortlich.
            </p>
            <p>
                Mit PayPal Marketing Solutions können wir gezielte Marketingkampagnen
                durchführen, um unsere Dienstleistungen oder Produkte besser zu vermarkten.
                Gegründet wurde das Unternehmen 1998 und mittlerweile zählt es mit über 325
                Millionen aktiven Kunden zu den bekanntesten und größten
                Online-Zahlungsdienstleistern weltweit. PayPal Marketing Solutions ist neben
                der Zahlungsdienstleistung ein zusätzlicher Service, den das Unternehmen
                anbietet.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir PayPal Marketing Solutions für unsere Website?
            </h3>
            <p>
                Es gibt verschiedene Gründe, warum wir PayPal Marketing Solutions nutzen und
                auf unserer Website anbieten. Wir wollen Ihnen auf unserer Website den
                bestmöglichen Service und die beste Nutzererfahrung (User Experience, UX)
                bieten. Für uns bedeutet das auch, dass Sie nur Inhalte und Werbeanzeigen zu
                sehen bekommen, die Sie auch wirklich interessieren. Durch PayPal Marketing
                Solutions können wir Werbeanzeigen und weiteren Content exakt an Ihre
                Wünsche und Interessen anpassen. Damit versorgen wir Sie mit guten Inhalten
                und erreichen leichter und schneller unsere Unternehmensziele.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von PayPal Marketing Solutions verarbeitet?
            </h3>
            <p>
                PayPal unterscheidet in ihrer Datenschutzerklärung verschiedene Kategorien
                personenbezogener Daten, die durch die Nutzung des Dienstes verarbeitet
                werden können. Dazu zählen Anmelde- und Kontaktdaten, Identifizierungs- und
                Unterschriftsdaten, Zahlungsinformationen, Informationen zu importierten
                Kontakten, Daten aus Ihrem Kontoprofil, Gerätedaten wie etwa Ihre
                IP-Adresse, Standortdaten und sogenannte abgeleitete Daten. Darunter werden
                Informationen verstanden, die durch Transaktionen oder andere Daten
                abgeleitet werden können. Das können etwa Kaufgewohnheiten,
                Verhaltensmuster, Kreditwürdigkeit oder persönliche Vorlieben sein.
            </p>
            <p>
                Dann gibt es auch noch personenbezogene Daten, die von Dritten (wie
                Identitätsprüfern, Betrugserkennungsanbieter oder Ihre Bank) erhoben werden.
                Zu diesen Daten zählen Informationen von Auskunfteien, Transaktionsdaten,
                Informationen zu den gesetzlichen Vorschriften, technische Nutzungsdaten,
                Standortdaten und auch wieder abgeleitete Daten.
            </p>
            <p>
                PayPal und auch deren Partner verwenden auch Trackingtechnologien wie
                Cookies, Pixel-Tags, Web-Beacons und Widgets, um Sie als Benutzer zu
                erkennen, Inhalte anzupassen und um Analysen für interessensbezogene Werbung
                durchzuführen.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich speichert PayPal die Daten so lange, wie es zur Erfüllung
                ihrer Pflichten und im Rahmen des Zwecks notwendig ist. Personenbezogene
                Daten, die für die Kundenbeziehung notwendig sind, werden bis 10 Jahre nach
                Beendigung der Beziehung aufbewahrt. Wenn PayPal einer rechtlichen
                Verpflichtung unterliegt, beträgt die Aufbewahrungsdauer der
                personenbezogenen Daten dem jeweils geltenden Recht (z.B. Insolvenzrecht).
                PayPal speichert personenbezogene Daten auch dann so lange wie nötig, wenn
                die Aufbewahrung in Hinblick auf Rechtsstreitigkeiten empfehlenswert ist.
            </p>
            <p>
                Da PayPal ein global agierendes Unternehmen ist, hat der Dienst auch
                weltweit Rechenzentren, in denen Ihre Daten gespeichert werden können. Das
                heißt, Ihre Daten können auch außerhalb Ihres Landes und auch außerhalb des
                Geltungsbereiches der DSGVO auf PayPal-Servern gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Sie können
                zudem auch jederzeit die Einwilligung zur Verarbeitung der Daten widerrufen.
            </p>
            <p>
                Falls Sie grundsätzlich Cookies deaktivieren, löschen oder verwalten wollen,
                finden Sie unter dem Abschnitt „Cookies“ die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von PayPal Marketing Solutions setzt Ihre Einwilligung voraus,
                welche wir mit unserem Cookie Popup eingeholt haben. Diese Einwilligung
                stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch PayPal Marketing Solutions vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse daran, dass Verhalten der Websitebesucher zu analysieren und so
                unser Angebot technisch und wirtschaftlich zu verbessern. Die
                Rechtsgrundlage dafür ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen PayPal Marketing Solutions gleichwohl nur ein, soweit Sie eine
                Einwilligung erteilt haben.
            </p>
            <p>
                PayPal verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet PayPal
                sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich PayPal, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln und über die Daten, die
                durch die Verwendung von PayPal Marketing Solutions verarbeitet werden,
                erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.paypal.com/webapps/mpp/ua/privacy-full?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.paypal.com/webapps/mpp/ua/privacy-full
                </a>
                .
            </p>
            <h2 id="snap-pixel-datenschutzerklaerung" className="adsimple-112958647">
                Snap Pixel Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website Snap Pixel, ein Tool für
                Conversion-Tracking für Werbetreibende. Dienstanbieter ist das amerikanische
                Unternehmen Snap Inc., 2772 Donald Douglas Loop N, Santa Monica (HQ), CA,
                USA.
            </p>
            <p>
                Snap verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Snap
                sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich Snap, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Snap finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://snap.com/en-US/terms/standard-contractual-clauses"
                >
                https://snap.com/en-US/terms/standard-contractual-clauses
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Snap Pixel verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://snap.com/de-DE/privacy/privacy-policy"
                >
                https://snap.com/de-DE/privacy/privacy-policy
                </a>
                .
            </p>
            <h2 id="content-delivery-networks-einleitung" className="adsimple-112958647">
                Content Delivery Networks Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Content Delivery Networks Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung (um die Website
                    schneller laden zu können)
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Ihre IP-Adresse
                    <br />
                    Mehr Details dazu finden Sie weiter unten und den einzelnen
                    Datenschutztexten.
                    <br />
                    📅 Speicherdauer: meisten werden die Daten solange gespeichert, bis
                    sie zur Erfüllung der Dienstleistung nicht mehr benötigt werden
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist ein Content Delivery Network?</h3>
            <p>
                Wir nutzen auf unserer Website ein sogenanntes Content Delivery Network.
                Meistens wird ein solchen Netzwerk nur CDN genannt. Ein CDN hilft uns,
                unsere Website, unabhängig von Ihrem Standort, schnell und problemlos zu
                laden. Dabei werden auch personenbezogene Daten von Ihnen auf den Servern
                des eingesetzten CDN-Anbieters gespeichert, verwaltet und verarbeitet.
                Nachfolgend gehen wir allgemein näher auf den Dienst und dessen
                Datenverarbeitung ein. Genaue Informationen über den Umgang mit Ihren Daten
                finden Sie in der jeweiligen Datenschutzerklärung des Anbieters.
            </p>
            <p>
                Jedes Content Delivery Network (CDN) ist ein Netzwerk regional verteilter
                Server, die alle über das Internet miteinander verbunden sind. Über dieses
                Netzwerk können Inhalte von Websites (speziell auch sehr große Dateien) auch
                bei großen Lastspitzen schnell und reibungslos ausgeliefert werden. Das CDN
                legt dafür eine Kopie unserer Website auf Ihren Servern an. Da diese Server
                weltweit verteilt sind, kann die Website schnell ausgeliefert werden. Die
                Datenübertragung zu Ihrem Browser wird folglich durch das CDN deutlich
                verkürzt.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir ein Content Delivery Network für unsere Website?
            </h3>
            <p>
                Eine schnell ladende Website ist Teil unserer Dienstleistung. Wir wissen
                natürlich, wie nervig es ist, wenn eine Website im Schneckentempo lädt.
                Meist verliert man sogar die Geduld und sucht das Weite, bevor die Website
                vollständig geladen ist. Das wollen wir natürlich vermeiden. Daher gehört
                eine schnell ladende Website ganz selbstverständlich zu unserem
                Websiteangebot. Mit einem Content Delivery Network wird in Ihrem Browser
                unsere Website deutlich schneller geladen. Besonders hilfreich ist der
                Einsatz des CDNs wenn Sie im Ausland sind, weil die Website von einem Server
                in Ihrer Nähe ausgeliefert wird.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Wenn Sie eine Website bzw. die Inhalte einer Website anfordern und diese in
                einem CDN zwischengespeichert sind, leitet das CDN die Anforderung an den
                von Ihnen am nächsten gelegenen Server und dieser liefert die Inhalte aus.
                Content Delivery Networks sind so aufgebaut, dass JavaScript-Bibliotheken
                heruntergeladen werden können und auf npm- und Github-Servern gehostet
                werden. Alternativ können bei den meisten CDNs auch WordPress-Plugins
                geladen werden, wenn diese auf{" "}
                <a
                className="adsimple-112958647"
                href="https://wordpress.org/"
                target="_blank"
                rel="noopener"
                >
                WordPress.org
                </a>{" "}
                gehostet werden. Ihr Browser kann personenbezogene Daten an das von uns
                eingesetzte Content Delivery Network senden. Dabei handelt es sich etwa um
                Daten wie IP-Adresse, Browsertyp, Browserversion, welche Webseite geladen
                wird oder Uhrzeit und Datum des Seitenbesuchs. Diese Daten werden vom CDN
                gesammelt und auch gespeichert. Ob zur Datenspeicherung Cookies verwendet
                werden, hängt von dem eingesetzten Network ab. Bitte lesen Sie sich dafür
                die Datenschutztexte des jeweiligen Dienstes durch.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Falls Sie diese Datenübertragung vollkommen unterbinden wollen, können Sie
                einen JavaScript-Blocker (siehe beispielsweise{" "}
                <a
                className="adsimple-112958647"
                href="https://noscript.net/"
                target="_blank"
                rel="noopener"
                >
                https://noscript.net/
                </a>
                ) auf Ihrem PC installieren. Natürlich kann dann unsere Website nicht mehr
                das gewohnte Service (wie beispielsweise eine schnelle Ladegeschwindigkeit)
                bieten.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass ein Content Delivery Network eingesetzt
                werden darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung
                diese Einwilligung. Diese Einwilligung stellt laut{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch ein Content Delivery Network vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, ein Content
                Delivery Network zu verwenden, um unser Online-Service zu optimieren und
                sicherer zu machen. Die dafür entsprechende Rechtsgrundlage ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen das Tool gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Informationen zu speziellen Content Delivery Network erhalten Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h2 id="cloudflare-datenschutzerklaerung" className="adsimple-112958647">
                Cloudflare Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Cloudflare Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung (um die Website
                    schneller laden zu können)
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa IP-Adresse, Kontakt- und
                    Protokollinfos, Sicherheitsfingerabdrücke und Leistungsdaten für
                    Websites
                    <br />
                    Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: meisten werden die Daten für weniger als 24 Stunden
                    gespeichert
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Cloudflare?</h3>
            <p>
                Wir verwenden auf dieser Website Cloudflare der Firma Cloudflare, Inc. (101
                Townsend St., San Francisco, CA 94107, USA), um unsere Webseite schneller
                und sicherer zu machen. Dabei verwendet Cloudflare Cookies und verarbeitet
                User-Daten. Cloudflare, Inc. ist eine amerikanische Firma, die ein Content
                Delivery Network und diverse Sicherheitsdienste anbietet. Diese Dienste
                befinden sich zwischen dem User und unserem Hosting-Anbieter. Was das alles
                genau bedeutet, versuchen wir im Folgenden genauer zu erläutern.
            </p>
            <p>
                Ein Content Delivery Network (CDN), wie es die Firma Cloudflare
                bereitstellt, ist nichts anderes als ein Netzwerk aus verbundenen Servern.
                Cloudflare hat auf der ganzen Welt solche Server verteilt, um Webseiten
                schneller auf Ihren Bildschirm zu bringen. Ganz einfach gesagt, legt
                Cloudflare Kopien unserer Webseite an und platziert sie auf ihren eigenen
                Servern. Wenn Sie jetzt unsere Webseite besuchen, stellt ein System der
                Lastenverteilung sicher, dass die größten Teile unserer Webseite von jenem
                Server ausgeliefert werden, der Ihnen unsere Webseite am schnellsten
                anzeigen kann. Die Strecke der Datenübertragung zu Ihrem Browser wird durch
                ein CDN deutlich verkürzt. Somit wird Ihnen der Content unserer Webseite
                durch Cloudflare nicht nur von unserem Hosting-Server geliefert, sondern von
                Servern aus der ganzen Welt. Besonders hilfreich wird der Einsatz von
                Cloudflare für User aus dem Ausland, da hier die Seite von einem Server in
                der Nähe ausgeliefert werden kann. Neben dem schnellen Ausliefern von
                Webseiten bietet Cloudflare auch diverse Sicherheitsdienste, wie den
                DDoS-Schutz oder die Web Application Firewall an.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Cloudflare auf unserer Website?
            </h3>
            <p>
                Natürlich wollen wir Ihnen mit unserer Webseite das bestmögliche Service
                bieten. Cloudflare hilft uns dabei, unsere Webseite schneller und sicherer
                zu machen. Cloudflare bietet uns sowohl Web-Optimierungen als auch
                Sicherheitsdienste, wie DDoS-Schutz und Web-Firewall, an. Dazu gehören auch
                ein{" "}
                <a
                className="adsimple-112958647"
                href="https://de.wikipedia.org/wiki/Reverse_Proxy"
                target="_blank"
                rel="noopener noreferrer"
                >
                Reverse-Proxy
                </a>
                und das Content-Verteilungsnetzwerk (CDN). Cloudflare blockiert Bedrohungen
                und begrenzt missbräuchliche Bots und Crawler, die unsere Bandbreite und
                Serverressourcen verschwenden. Durch das Speichern unserer Webseite auf
                lokalen Datenzentren und das Blockieren von Spam-Software ermöglicht
                Cloudflare, unsere Bandbreitnutzung etwa um 60% zu reduzieren. Das
                Bereitstellen von Inhalten über ein Datenzentrum in Ihrer Nähe und einiger
                dort durchgeführten Web-Optimierungen reduziert die durchschnittliche
                Ladezeit einer Webseite etwa um die Hälfte. Durch die Einstellung „I´m Under
                Attack Mode“ („Ich werde angegriffen“-Modus) können laut Cloudflare weitere
                Angriffe abgeschwächt werden, indem eine JavaScript-Rechenaufgabe angezeigt
                wird, die man lösen muss, bevor ein User auf eine Webseite zugreifen kann.
                Insgesamt wird dadurch unsere Webseite deutlich leistungsstärker und weniger
                anfällig auf Spam oder andere Angriffe.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Cloudflare verarbeitet?
            </h3>
            <p>
                Cloudflare leitet im Allgemeinen nur jene Daten weiter, die von
                Webseitenbetreibern gesteuert werden. Die Inhalte werden also nicht von
                Cloudflare bestimmt, sondern immer vom Websitebetreiber selbst. Zudem
                erfasst Cloudflare unter Umständen bestimmte Informationen zur Nutzung
                unserer Website und verarbeitet Daten, die von uns versendet werden oder für
                die Cloudflare entsprechende Anweisungen erhalten hat. In den meisten Fällen
                erhält Cloudflare Daten wie IP-Adresse, Kontakt- und Protokollinfos,
                Sicherheitsfingerabdrücke und Leistungsdaten für Websites. Protokolldaten
                helfen Cloudflare beispielsweise dabei, neue Bedrohungen zu erkennen. So
                kann Cloudflare einen hohen Sicherheitsschutz für unsere Webseite
                gewährleisten. Cloudflare verarbeitet diese Daten im Rahmen der Services
                unter Einhaltung der geltenden Gesetze. Dazu zählt natürlich auch die
                Datenschutzgrundverordnung (DSGVO). Cloudflare arbeitet auch mit
                Drittanbietern zusammen. Diese dürfen personenbezogene Daten nur unter
                Anweisung der Firma Cloudflare und in Übereinstimmung mit den
                Datenschutzrichtlinien und anderer Vertraulichkeits- und
                Sicherheitsmaßnahmen verarbeiten. Ohne explizite Einwilligung von uns gibt
                Cloudflare keine personenbezogenen Daten weiter.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Cloudflare speichert Ihre Informationen hauptsächlich in den USA und im
                Europäischen Wirtschaftsraum. Cloudflare kann die oben beschriebenen
                Informationen aus der ganzen Welt übertragen und darauf zugreifen. Im
                Allgemeinen speichert Cloudflare Daten auf User-Ebene für Domains in den
                Versionen Free, Pro und Business für weniger als 24 Stunden. Für Enterprise
                Domains, die Cloudflare Logs (früher Enterprise LogShare oder ELS) aktiviert
                haben, können die Daten bis zu 7 Tage gespeichert werden. Wenn allerdings
                IP-Adressen bei Cloudflare Sicherheitswarnungen auslösen, kann es zu
                Ausnahmen der oben angeführten Speicherungsdauer kommen.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Cloudflare bewahrt Daten-Protokolle nur solange wie nötig auf und diese
                Daten werden auch in den meisten Fällen innerhalb von 24 Stunden wieder
                gelöscht. Cloudflare speichert auch keine personenbezogenen Daten, wie
                beispielsweise Ihre IP-Adresse. Es gibt allerdings Informationen, die
                Cloudflare als Teil seiner permanenten Protokolle auf unbestimmte Zeit
                speichert, um so die Gesamtleistung von Cloudflare Resolver zu verbessern
                und etwaige Sicherheitsrisiken zu erkennen. Welche permanenten Protokolle
                genau gespeichert werden, können Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.cloudflare.com/application/privacypolicy/"
                >
                https://www.cloudflare.com/application/privacypolicy/
                </a>
                nachlesen. Alle Daten, die Cloudflare sammelt (temporär oder permanent),
                werden von allen personenbezogenen Daten bereinigt. Alle permanenten
                Protokolle werden zudem von Cloudflare anonymisiert.
            </p>
            <p>
                Cloudflare geht in ihrer Datenschutzerklärung darauf ein, dass sie für die
                Inhalte, die sie erhalten nicht verantwortlich sind. Wenn Sie beispielsweise
                bei Cloudflare anfragen, ob sie Ihre Inhalte aktualisieren oder löschen
                können, verweist Cloudflare grundsätzlich auf uns als Webseitenbetreiber.
                Sie können auch die gesamte Erfassung und Verarbeitung Ihrer Daten durch
                Cloudflare komplett unterbinden, indem Sie die Ausführung von Script-Code in
                Ihrem Browser deaktivieren oder einen Script-Blocker in Ihren Browser
                einbinden.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Cloudflare eingesetzt werden darf, ist die
                Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung.
                Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Cloudflare vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, Cloudflare zu
                verwenden, um unser Online-Service zu optimieren und sicherer zu machen. Die
                dafür entsprechende Rechtsgrundlage ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen Cloudflare gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Cloudflare verarbeitet Daten von Ihnen u.a. auch in den USA. Cloudflare ist
                aktiver Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte
                und sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Cloudflare sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Cloudflare, bei der Verarbeitung Ihrer relevanten Daten,
                das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den
                USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren
                auf einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss
                und die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
                .
            </p>
            <p>
                Mehr über die Standardvertragsklauseln und Daten, die durch die Verwendung
                von Cloudflare verarbeitet werden, erfahren Sie in der Datenschutzerklärung
                auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.cloudflare.com/de-de/privacypolicy/?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                https://www.cloudflare.com/de-de/privacypolicy/
                </a>
                .
            </p>
            <h2 id="jquery-cdn-datenschutzerklaerung" className="adsimple-112958647">
                jQuery CDN Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        jQuery CDN Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung (um die Website
                    schneller laden zu können)
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Ihre IP-Adresse
                    <br />
                    Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: meisten werden die Daten solange gespeichert, bis
                    sie zur Erfüllung der Dienstleistung nicht mehr benötigt werden
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist jQuery?</h3>
            <p>
                Um Ihnen unsere Website bzw.jQuery-Bibliothek auf unterschiedlichen Geräten
                schnell und problemlos auszuliefern, nutzen wir Dienste von jQuery CDN des
                Unternehmens OpenJS Foundation. jQuery wird über das Content Delivery
                Network (CDN) des amerikanischen Software-Unternehmens Fastly, Inc. (475
                Brannan St, Suite 300 San Francisco, CA 94107, USA) verteilt. Durch diesen
                Dienst werden personenbezogene Daten von Ihnen gespeichert, verwaltet und
                verarbeitet. In dieser Datenschutzerklärung gehen wir näher darauf ein,
                welche Daten von Ihnen durch die Verwendung von jQuery CDN verarbeitet
                werden.
            </p>
            <p>
                Ein Content Delivery Network (CDN) ist ein Netzwerk regional verteilter
                Server, die über das Internet miteinander verbunden sind. Durch dieses
                Netzwerk können Inhalte, speziell sehr große Dateien, auch bei großen
                Lastspitzen schnell ausgeliefert werden. jQuery legt eine Kopie unserer
                Website auf ihren Servern an. So kann unsere Website, schnellstmöglich
                ausgeliefert werden. Das heißt, die Datenübertragung zu Ihrem Browser wird
                durch ein CDN verkürzt.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir jQuery auf unserer Website?
            </h3>
            <p>
                Selbstverständlich wollen wir Ihnen mit unserer Website einen umfassenden
                und gut funktionierenden Service bieten. Dazu zählt auch eine schnelle
                Website. Mit jQuery kann unsere Website bei Ihnen viel schneller geladen
                werden. Besonders hilfreich wird der Einsatz von jQuery CDN für User aus dem
                Ausland, da hier die Seite von einem Server in der Nähe ausgeliefert werden
                kann.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch jQuery verarbeitet?
            </h3>
            <p>
                jQuery nutzt JavaScript-Bibliotheken, um unsere Website-Inhalte zügig
                ausliefern zu können. Dafür lädt ein CDN-Server die nötigen Dateien. Sobald
                eine Verbindung zum CDN-Server aufgebaut ist, wird Ihre IP-Adresse erfasst
                und gespeichert. Das geschieht nur, wenn diese Daten nicht schon durch einen
                vergangenen Websitebesuch in Ihrem Browser gespeichert sind.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                jQuery bzw. Fastly hat Server in verschiedenen Ländern verteilt und Ihre
                Daten können somit sowohl in Amerika als auch im Europäischen
                Wirtschaftsraum gespeichert werden. Fastly bewahrt personenbezogene Daten,
                die in unserem Auftrag verarbeitet werden, so lange auf, wie es für die
                Erbringung angebotener Dienstleistungen erforderlich ist, wie es für die
                Erfüllung rechtlicher Verpflichtungen, die Beilegung von Streitigkeiten und
                die Durchsetzung der Vereinbarungen notwendig ist.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben immer das Recht auf Auskunft, Berichtigung und Löschung Ihrer
                personenbezogenen Daten. Bei Fragen können Sie auch jederzeit
                Verantwortliche von jQuery kontaktieren.
            </p>
            <p>
                Wenn Sie nicht wollen, dass es zu einer Datenübertragung kommt, haben Sie
                immer auch die Möglichkeit Java-Scriptblocker wie beispielsweise{" "}
                <a
                className="adsimple-112958647"
                href="https://www.ghostery.com/"
                target="_blank"
                rel="follow noopener"
                >
                https://www.ghostery.com/
                </a>{" "}
                oder{" "}
                <a
                className="adsimple-112958647"
                href="https://noscript.net/"
                target="_blank"
                rel="follow noopener noreferrer"
                >
                noscript.net
                </a>{" "}
                zu installieren. Sie können aber auch einfach in Ihrem Browser die
                Ausführung von JavaScript-Codes deaktivieren. Wenn Sie sich für die
                Deaktivierung von JavaScript-Codes entscheiden, verändern sich auch die
                gewohnten Funktionen. So wird beispielsweise eine Website nicht mehr so
                schnell geladen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass jQuery CDN eingesetzt werden darf, ist die
                Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung.
                Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch jQuery CDN vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, jQuery CDN zu
                verwenden, um unser Online-Service zu optimieren und sicherer zu machen. Die
                dafür entsprechende Rechtsgrundlage ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen das Tool gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Fastly verarbeitet Daten von Ihnen u.a. auch in den USA. Fastly ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Fastly sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Fastly, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
                .
            </p>
            <p>
                Die Fastly Datenverarbeitungsbedingung (Data Protection Terms), welche den
                Standardvertragsklauseln entspricht, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.fastly.com/data-processing/"
                target="_blank"
                rel="follow noopener"
                >
                https://www.fastly.com/data-processing/
                </a>
                .
            </p>
            <p>
                Mehr Informationen zum Datenschutz bei Fastly finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.fastly.com/privacy/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.fastly.com/privacy/
                </a>{" "}
                und zu jQuery unter{" "}
                <a
                className="adsimple-112958647"
                href="https://images.prismic.io/openjsf/ba00b254-685f-4e54-b1ca-17984b0f3e55_OpenJS-Foundation-Privacy-Policy-2019-11-15.pdf"
                target="_blank"
                rel="follow noopener"
                >
                https://images.prismic.io/openjsf/ba00b254-685f-4e54-b1ca-17984b0f3e55_OpenJS-Foundation-Privacy-Policy-2019-11-15.pdf
                </a>
                .
            </p>
            <h2
                id="jsdelivr-com-cdn-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                jsdelivr.com-CDN Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        jsdelivr.com-CDN Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung (um die Website
                    schneller laden zu können)
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Ihre IP-Adresse, Browsertyp,
                    Browserversion, welche Webseite geladen wird oder Uhrzeit und Datum
                    des Seitenbesuchs
                    <br />
                    Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: meisten werden die Daten solange gespeichert, bis
                    sie zur Erfüllung der Dienstleistung nicht mehr benötigt werden
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist jsdelivr.com-CDN?</h3>
            <p>
                Damit wir Ihnen unsere einzelnen Webseiten schnell und auf allen
                unterschiedlichen Geräten einwandfrei ausliefern können, verwenden wir die
                Open-Source-Dienste von{" "}
                <a
                className="adsimple-112958647"
                href="https://www.jsdelivr.com/"
                target="_blank"
                rel="follow noopener noreferrer"
                >
                jsdelivr.com
                </a>{" "}
                des polnischen Software-Unternehmens ProspectOne, Królewska 65A/1, 30-081,
                Kraków, Polen. Dabei handelt es sich um ein Content Delivery Network (CDN).
                Das ist ein Netzwerk regional verteilter Server, die über das Internet
                verbunden sind. Dadurch können Inhalte, speziell große Dateien, auch bei
                großen Lastspitzen schnell und optimal ausgeliefert werden.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir jsdelivr.com-CDN?</h3>
            <p>
                Selbstverständlich wollen wir Ihnen mit unserer Website einen umfassenden
                und gut funktionierenden Service bieten. Dazu zählt auch eine schnelle
                Website. Mit jsdelivr.com-CDN kann unsere Website bei Ihnen viel schneller
                geladen werden. Besonders hilfreich wird der Einsatz von jsdelivr.com-CDN
                für User aus dem Ausland, da hier die Seite von einem Server in der Nähe
                ausgeliefert werden kann.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch jsdelivr.com-CDN verarbeitet?
            </h3>
            <p>
                jsDelivr ist so aufgebaut, dass JavaScript-Bibliotheken heruntergeladen
                werden können, die auf npm- und Github-Servern gehostet werden. Es können
                aber auch WordPress-Plugins geladen werden, sofern diese auf{" "}
                <a
                className="adsimple-112958647"
                href="https://wordpress.org/"
                target="_blank"
                rel="follow noopener noreferrer"
                >
                WordPress.org
                </a>{" "}
                gehostet werden. Um diesen Dienst bereitstellen zu können, kann Ihr Browser
                personenbezogene Daten an{" "}
                <a
                className="adsimple-112958647"
                href="https://www.jsdelivr.com/?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                jsdelivr.com
                </a>
                senden. jsDelivr kann somit Userdaten wie IP-Adresse, Browsertyp,
                Browserversion, welche Webseite geladen wird oder Uhrzeit und Datum des
                Seitenbesuchs sammeln und speichern. In der Datenschutzerklärung von{" "}
                <a
                className="adsimple-112958647"
                href="https://www.jsdelivr.com/"
                target="_blank"
                rel="follow noopener noreferrer"
                >
                jsdelivr.com
                </a>{" "}
                wird ausdrücklich darauf hingewiesen, dass das Unternehmen keine Cookies
                oder andere Tracking-Services verwendet.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                jsDelivr hat Server in verschiedenen Ländern verteilt und Ihre Daten können
                auch außerhalb des Europäischen Wirtschaftsraums gespeichert werden.
                jsDelivr bewahrt personenbezogene Daten, die in unserem Auftrag verarbeitet
                werden, so lange auf, wie es für die Erbringung angebotener Dienstleistungen
                erforderlich ist, wie es für die Erfüllung rechtlichen Verpflichtungen, die
                Beilegung von Streitigkeiten und die Durchsetzung der Vereinbarungen
                notwendig ist.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben immer das Recht auf Auskunft, Berichtigung und Löschung Ihrer
                personenbezogenen Daten. Bei Fragen können Sie auch jederzeit
                Verantwortliche von jsdelivr.com-CDN kontaktieren.
            </p>
            <p>
                Wenn Sie diese Datenübertragung unterbinden wollen, können Sie einen
                JavaScript-Blocker (siehe beispielsweise{" "}
                <a
                className="adsimple-112958647"
                href="https://noscript.net/"
                target="_blank"
                rel="noopener noreferrer"
                >
                https://noscript.net/
                </a>
                ) installieren. Bitte beachten Sie aber, dass dadurch die Website nicht mehr
                das gewohnte Service (wie etwa schnelle Ladegeschwindigkeit) bieten kann.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass jsdelivr.com-CDN eingesetzt werden darf,
                ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese
                Einwilligung. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch jsdelivr.com-CDN vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, jsdelivr.com-CDN
                zu verwenden, um unser Online-Service zu optimieren und sicherer zu machen.
                Die dafür entsprechende Rechtsgrundlage ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen das Tool gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Nähere Informationen zur Datenverarbeitung durch den Softwaredienst jsDelivr
                finden Sie in der Datenschutzerklärung des Unternehmens unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.jsdelivr.com/terms/privacy-policy-jsdelivr-net"
                >
                https://www.jsdelivr.com/terms/privacy-policy-jsdelivr-net
                </a>
                .
            </p>
            <h2
                id="cookie-consent-management-platform-einleitung"
                className="adsimple-112958647"
            >
                Cookie Consent Management Platform Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Cookie Consent Management Platform Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Website Besucher
                    <br />
                    🤝 Zweck: Einholung und Verwaltung der Zustimmung zu bestimmten
                    Cookies und somit dem Einsatz bestimmter Tools
                    <br />
                    📓 Verarbeitete Daten: Daten zur Verwaltung der eingestellten
                    Cookie-Einstellungen wie IP-Adresse, Zeitpunkt der Zustimmung, Art der
                    Zustimmung, einzelne Zustimmungen. Mehr Details dazu finden Sie beim
                    jeweils eingesetzten Tool.
                    <br />
                    📅 Speicherdauer: Hängt vom eingesetzten Tool ab, man muss sich auf
                    Zeiträume von mehreren Jahren einstellen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit.f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">
                Was ist eine Cookie Consent Manangement Platform?
            </h3>
            <p>
                Wir verwenden auf unserer Website eine Consent Management Platform (CMP)
                Software, die uns und Ihnen den korrekten und sicheren Umgang mit
                verwendeten Skripten und Cookies erleichtert. Die Software erstellt
                automatisch ein Cookie-Popup, scannt und kontrolliert alle Skripts und
                Cookies, bietet eine datenschutzrechtlich notwendige Cookie-Einwilligung für
                Sie und hilft uns und Ihnen den Überblick über alle Cookies zu behalten. Bei
                den meisten Cookie Consent Management Tools werden alle vorhandenen Cookies
                identifiziert und kategorisiert. Sie als Websitebesucher entscheiden dann
                selbst, ob und welche Skripte und Cookies Sie zulassen oder nicht zulassen.
                Die folgende Grafik stellt die Beziehung zwischen Browser, Webserver und CMP
                dar.
            </p>
            <p>
                <img
                role="img"
                src="https://www.adsimple.at/wp-content/uploads/2021/03/consent-management-platform-overview.svg"
                alt="Consent Management Platform Überblick"
                width="100%"
                />
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir ein Cookie-Management-Tool?
            </h3>
            <p>
                Unser Ziel ist es, Ihnen im Bereich Datenschutz die bestmögliche Transparenz
                zu bieten. Zudem sind wir dazu auch rechtlich verpflichtet. Wir wollen Sie
                über alle Tools und alle Cookies, die Daten von Ihnen speichern und
                verarbeiten können, so gut wie möglich aufklären. Es ist auch Ihr Recht,
                selbst zu entscheiden, welche Cookies Sie akzeptieren und welche nicht. Um
                Ihnen dieses Recht einzuräumen, müssen wir zuerst genau wissen, welche
                Cookies überhaupt auf unserer Website gelandet sind. Dank eines
                Cookie-Management-Tools, welches die Website regelmäßig nach allen
                vorhandenen Cookies scannt, wissen wir über alle Cookies Bescheid und können
                Ihnen DSGVO-konform Auskunft darüber geben. Über das Einwilligungssystem
                können Sie dann Cookies akzeptieren oder ablehnen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Im Rahmen unseres Cookie-Management-Tools können Sie jedes einzelnen Cookies
                selbst verwalten und haben die vollständige Kontrolle über die Speicherung
                und Verarbeitung Ihrer Daten. Die Erklärung Ihrer Einwilligung wird
                gespeichert, damit wir Sie nicht bei jedem neuen Besuch unserer Website
                abfragen müssen und wir Ihre Einwilligung, wenn gesetzlich nötig, auch
                nachweisen können. Gespeichert wird dies entweder in einem Opt-in-Cookie
                oder auf einem Server. Je nach Anbieter des Cookie-Management-Tools variiert
                Speicherdauer Ihrer Cookie-Einwilligung. Meist werden diese Daten (etwa
                pseudonyme User-ID, Einwilligungs-Zeitpunkt, Detailangaben zu den
                Cookie-Kategorien oder Tools, Browser, Gerätinformationen) bis zu zwei
                Jahren gespeichert.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Generell verarbeiten wir
                personenbezogene Daten nur so lange wie es für die Bereitstellung unserer
                Dienstleistungen und Produkte unbedingt notwendig ist. Daten, die in Cookies
                gespeichert werden, werden unterschiedlich lange gespeichert. Manche Cookies
                werden bereits nach dem Verlassen der Website wieder gelöscht, andere können
                über einige Jahre in Ihrem Browser gespeichert sein. Die genaue Dauer der
                Datenverarbeitung hängt vom verwendeten Tool ab, meistens sollten Sie sich
                auf eine Speicherdauer von mehreren Jahren einstellen. In den jeweiligen
                Datenschutzerklärungen der einzelnen Anbieter erhalten Sie in der Regel
                genaue Informationen über die Dauer der Datenverarbeitung.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies zu widerrufen. Das funktioniert entweder über unser
                Cookie-Management-Tool oder über andere Opt-Out-Funktionen. Zum Beispiel
                können Sie auch die Datenerfassung durch Cookies verhindern, indem Sie in
                Ihrem Browser die Cookies verwalten, deaktivieren oder löschen.
            </p>
            <p>
                Informationen zu speziellen Cookie-Management-Tools, erfahren Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie Cookies zustimmen, werden über diese Cookies personenbezogene Daten
                von Ihnen verarbeitet und gespeichert. Falls wir durch Ihre{" "}
                <strong className="adsimple-112958647 text-[#787c87]">Einwilligung</strong> (Artikel 6 Abs.
                1 lit. a DSGVO) Cookies verwenden dürfen, ist diese Einwilligung auch
                gleichzeitig die Rechtsgrundlage für die Verwendung von Cookies bzw. die
                Verarbeitung Ihrer Daten. Um die Einwilligung zu Cookies verwalten zu können
                und Ihnen die Einwilligung ermöglichen zu können, kommt eine
                Cookie-Consent-Management-Platform-Software zum Einsatz. Der Einsatz dieser
                Software ermöglicht uns, die Website auf effiziente Weise rechtskonform zu
                betreiben, was ein{" "}
                <strong className="adsimple-112958647 text-[#787c87]">berechtigtes Interesse</strong>{" "}
                (Artikel 6 Abs. 1 lit. f DSGVO) darstellt.
            </p>
            <h2
                id="adsimple-consent-manager-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                AdSimple Consent Manager Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        AdSimple Consent Manager Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Website Besucher
                    <br />
                    🤝 Zweck: Einholung der Zustimmung zu bestimmten Cookies und somit dem
                    Einsatz bestimmter Tools
                    <br />
                    📓 Verarbeitete Daten: Daten zur Verwaltung der eingestellten
                    Cookie-Einstellungen wie IP-Adresse, Zeitpunkt der Zustimmung, Art der
                    Zustimmung, einzelne Zustimmungen. Mehr Details dazu finden Sie weiter
                    unter in dieser Datenschutzerklärung
                    <br />
                    📅 Speicherdauer: das verwendete Cookie läuft nach einem Jahr ab
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit.f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist der AdSimple Consent Manager?</h3>
            <p>
                Wir verwenden auf unserer Website den AdSimple Consent Manager des
                Softwareentwicklungs- und Online-Marketing Unternehmens AdSimple GmbH,
                Fabriksgasse 20, 2230 Gänserndorf. Der AdSimple Consent Manager bietet uns
                unter anderem die Möglichkeit, Ihnen einen umfangreichen und
                datenschutzkonformen Cookie-Hinweis zu liefern, damit Sie selbst entscheiden
                können, welche Cookies Sie zulassen und welche nicht. Durch die Verwendung
                dieser Software werden Daten von Ihnen an AdSimple gesendet und gespeichert.
                In dieser Datenschutzerklärung informieren wir Sie, warum wir den AdSimple
                Consent Manager verwenden, welche Daten übertragen und gespeichert werden
                und wie Sie diese Datenübertragung verhindern können.
            </p>
            <p>
                Der AdSimple Consent Manager ist eine Software, die unsere Website scannt
                und alle vorhandenen Cookies identifiziert und kategorisiert. Zudem werden
                Sie als Websitebesucher über ein Cookie Hinweis Script über die Verwendung
                von Cookies informiert und entscheiden selbst welche Cookies Sie zulassen
                und welche nicht.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir den AdSimple Consent Manager auf unserer Website?
            </h3>
            <p>
                Wir wollen Ihnen maximale Transparenz im Bereich Datenschutz bieten. Um das
                zu gewährleisten, müssen wir zuerst genau wissen, welche Cookies im Laufe
                der Zeit auf unserer Website gelandet sind. Dadurch, dass der Consent
                Manager von AdSimple regelmäßig unsere Website scannt und alle Cookies
                ausfindig macht, haben wir die volle Kontrolle über diese Cookies und können
                so DSGVO-konform handeln. Wir können Sie dadurch über die Nutzung der
                Cookies auf unserer Website genau informieren. Weiters bekommen Sie stets
                einen aktuellen und datenschutzkonformen Cookie-Hinweis und entscheiden per
                Checkbox-System selbst, welche Cookies Sie akzeptieren bzw. blockieren.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von dem AdSimple Consent Manager gespeichert?
            </h3>
            <p>
                Wenn Sie Cookies auf unserer Website zustimmen, wird folgendes Cookie von
                dem AdSimple Consent Manager gesetzt:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong>&nbsp;acm_status
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>
                “:true,”statistik”:true,”marketing”:true,”socialmedia”:true,”einstellungen”:true
                {"}"}
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> In diesem
                Cookie wird Ihr Zustimmungsstatus, gespeichert. Dadurch kann unsere Website
                auch bei zukünftigen Besuchen den aktuellen Status lesen und befolgen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach einem
                Jahr
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Alle Daten, die durch den AdSimple Consent Manager erhoben werden, werden
                ausschließlich innerhalb der Europäischen Union übertragen und gespeichert.
                Die erhobenen Daten werden auf den Servern von AdSimple bei der Hetzner GmbH
                in Deutschland gespeichert. Zugriff auf diese Daten hat ausschließlich die
                AdSimple GmbH und die Hetzner GmbH.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Ihre personenbezogenen Daten zuzugreifen
                und sie auch zu löschen. Die Datenerfassung und Speicherung können Sie
                beispielsweise verhindern, indem Sie über das Cookie-Hinweis-Script die
                Verwendung von Cookies ablehnen. Eine weitere Möglichkeit die
                Datenverarbeitung zu unterbinden bzw. nach Ihren Wünschen zu verwalten,
                bietet Ihr Browser. Je nach Browser funktioniert die Cookie-Verwaltung etwas
                anders. Unter dem Abschnitt „Cookies“ finden Sie die entsprechenden Links zu
                den jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie Cookies zustimmen, werden über diese Cookies personenbezogene Daten
                von Ihnen verarbeitet und gespeichert. Falls wir durch Ihre{" "}
                <strong className="adsimple-112958647 text-[#787c87]">Einwilligung</strong> (Artikel 6 Abs.
                1 lit. a DSGVO) Cookies verwenden dürfen, ist diese Einwilligung auch
                gleichzeitig die Rechtsgrundlage für die Verwendung von Cookies bzw. die
                Verarbeitung Ihrer Daten. Um die Einwilligung zu Cookies verwalten zu können
                und Ihnen die Einwilligung ermöglichen zu können, kommt der AdSimple Consent
                Manager zum Einsatz. Der Einsatz dieser Software ermöglicht uns, die Website
                auf effiziente Weise rechtskonform zu betreiben, was ein{" "}
                <strong className="adsimple-112958647 text-[#787c87]">berechtigtes Interesse</strong>{" "}
                (Artikel 6 Abs. 1 lit. f DSGVO) darstellt.
            </p>
            <p>
                Wir hoffen, wir haben Ihnen einen guten Überblick über den Datenverkehr und
                die Datenverarbeitung durch den AdSimple Consent Manager geliefert. Wenn Sie
                mehr über dieses Tool erfahren wollen, empfehlen wir Ihnen die
                Beschreibungsseite auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.adsimple.at/consent-manager/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.adsimple.at/consent-manager/
                </a>
                .
            </p>
            <h2 id="consentmanager-datenschutzerklaerung" className="adsimple-112958647">
                consentmanager Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website consentmanager, eine Cookie-Banner-Lösung
                des Händlerbunds. Dienstanbieter ist das deutsche Unternehmen Händlerbund
                Management AG, Torgauer Str. 233, ArcusPark / Haus B, 04347 Leipzig,
                Deutschland.
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von consentmanager verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <u>
                <a
                    className="adsimple-112958647"
                    href="https://www.haendlerbund.de/de/datenschutzerklaerung"
                    target="_blank"
                    rel="noopener"
                >
                    https://www.haendlerbund.de/de/datenschutzerklaerung
                </a>
                .{" "}
                </u>
            </p>
            <h2 id="cookiebot-datenschutzerklaerung" className="adsimple-112958647">
                Cookiebot Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Cookiebot Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Website Besucher
                    <br />
                    🤝 Zweck: Einholung der Zustimmung zu bestimmten Cookies und somit dem
                    Einsatz bestimmter Tools
                    <br />
                    📓 Verarbeitete Daten:&nbsp; Daten zur Verwaltung der eingestellten
                    Cookie-Einstellungen wie IP-Adresse, Zeitpunkt der Zustimmung, Art der
                    Zustimmung, einzelne Zustimmungen. Mehr Details dazu finden Sie beim
                    jeweils eingesetzten Tool.
                    <br />
                    📅 Speicherdauer: die Daten werden nach einem Jahr gelöscht
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit.f DSGVO (berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Cookiebot?</h3>
            <p>
                Wir verwenden auf unserer Website Funktionen des Anbieters Cookiebot. Hinter
                Cookiebot steht das Unternehmen Cybot A/S, Havnegade 39, 1058 Kopenhagen,
                DK. Cookiebot bietet uns unter anderem die Möglichkeit, Ihnen einen
                umfangreichen Cookie-Hinweis (auch Cookie-Banner oder Cookie-Notice genannt)
                zu liefern. Durch die Verwendung dieser Funktion können Daten von Ihnen an
                Cookiebot bzw. Cybot gesendet, gespeichert und verarbeitet werden. In dieser
                Datenschutzerklärung informieren wir Sie warum wir Cookiebot nutzen, welche
                Daten übertragen werden und wie Sie diese Datenübertragung verhindern
                können.
            </p>
            <p>
                Cookiebot ist ein Software-Produkt des Unternehmens Cybot. Die Software
                erstellt automatisch einen DSGVO-konformen Cookie-Hinweis für unserer
                Websitebesucher. Zudem scannt, kontrolliert und wertet die Technologie
                hinter Cookiebot alle Cookies und Tracking-Maßnahmen auf unserer Website.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Cookiebot auf unserer Website?
            </h3>
            <p>
                Datenschutz nehmen wir sehr ernst. Wir wollen Ihnen ganz genau zeigen, was
                auf unserer Website vor sich geht und welche Ihrer Daten gespeichert werden.
                Cookiebot hilft uns einen guten Überblick über all unsere Cookies (Erst- und
                Drittanbieter-Cookies) zu erhalten. So können wir Sie über die Nutzung von
                Cookies auf unserer Website exakt und transparent informieren. Sie bekommen
                stets einen aktuellen und datenschutzkonformen Cookie-Hinweis und
                entscheiden selbst, welche Cookies Sie zulassen und welche nicht.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Cookiebot gespeichert?
            </h3>
            <p>
                Wenn Sie Cookies zulassen, werden folgende Daten an Cybot übertragen,
                gespeichert und verarbeitet.
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                IP-Adresse (in anonymisierter Form, die letzten 3 Ziffern werden auf 0
                gesetzt)
                </li>
                <li className="adsimple-112958647">
                Datum und Uhrzeit Ihres Einverständnisses
                </li>
                <li className="adsimple-112958647">unsere Website-URL</li>
                <li className="adsimple-112958647">technische Browserdaten</li>
                <li className="adsimple-112958647">verschlüsselter, anonymer Key</li>
                <li className="adsimple-112958647">
                die Cookies, die Sie zugelassen haben (als Zustimmungsnachweis)
                </li>
            </ul>
            <p>
                Folgenden Cookies werden von Cookiebot gesetzt, wenn Sie der Verwendung von
                Cookies zugestimmt haben:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong>&nbsp;CookieConsent
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>&nbsp;{"{"}
                stamp:’P7to4eNgIHvJvDerjKneBsmJQd9112958647-2
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong>&nbsp;In
                diesem Cookie wird Ihr Zustimmungsstatus, gespeichert. Dadurch kann unsere
                Website auch bei zukünftigen Besuchen den aktuellen Status lesen und
                befolgen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach einem
                Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong>
                &nbsp;CookieConsentBulkTicket
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>
                &nbsp;kDSPWpA%2fjhljZKClPqsncfR8SveTnNWhys5NojaxdFYBPjZ2PaDnUw%3d%3112958647-6
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong>
                &nbsp;Dieses Cookie wird gesetzt, wenn Sie alle Cookies erlauben und somit
                eine “Sammelzustimmung” aktiviert haben. Das Cookie speichert dann eine
                eigene, zufällige und eindeutige ID.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:&nbsp;</strong>nach einem
                Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung: </strong>Bitte bedenken
                Sie, dass es sich hier um eine beispielhafte Liste handelt und wir keinen
                Anspruch auf Vollständigkeit erheben können. In der Cookie-Erklärung
                unter&nbsp;
                <a
                className="adsimple-112958647"
                href="https://www.cookiebot.com/de/cookie-declaration/"
                target="_blank"
                rel="follow noopener noreferrer"
                >
                https://www.cookiebot.com/de/cookie-declaration/
                </a>
                &nbsp;sehen Sie, welche weiteren Cookies eingesetzt werden können.
            </p>
            <p>
                Laut der Datenschutzerklärung von Cybot verkauft das Unternehmen
                personenbezogene Daten nicht weiter. Cybot gibt allerdings Daten an
                vertrauensvolle Dritt- oder Subunternehmen weiter, die dem Unternehmen
                helfen, die eigenen betriebswirtschaftlichen Ziele zu erreichen. Daten
                werden auch dann weitergegeben, wenn dies rechtlich erforderlich ist.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Alle erhobenen Daten werden ausschließlich innerhalb der Europäischen Union
                übertragen, gespeichert und weitergeleitet. Die Daten werden in einem
                Azure-Rechenzentrum (Cloud-Anbieter ist Microsoft) gespeichert. Auf{" "}
                <a
                className="adsimple-112958647"
                href="https://azure.microsoft.com/de-de/explore/global-infrastructure/geographies/"
                target="_blank"
                rel="follow noopener"
                >
                https://azure.microsoft.com/de-de/explore/global-infrastructure/geographies/
                </a>{" "}
                erfahren Sie mehr über alle „Azure-Regionen“. Alle User Daten werden von
                Cookiebot nach 12 Monaten ab der Registrierung (Cookie-Zustimmung) bzw.
                unmittelbar nach Kündigung des Cookiebot-Services gelöscht.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Ihre personenbezogenen Daten zuzugreifen
                und sie auch zu löschen. Die Datenerfassung und Speicherung können Sie
                beispielsweise verhindern, indem Sie über den Cookie-Hinweis die Verwendung
                von Cookies ablehnen. Eine weitere Möglichkeit die Datenverarbeitung zu
                unterbinden bzw. nach Ihren Wünschen zu verwalten, bietet Ihr Browser. Je
                nach Browser funktioniert die Cookie-Verwaltung etwas anders. Unter dem
                Abschnitt „Cookies“ finden Sie die entsprechenden Links zu den jeweiligen
                Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie Cookies zustimmen, werden über diese Cookies personenbezogene Daten
                von Ihnen verarbeitet und gespeichert. Falls wir durch Ihre{" "}
                <strong className="adsimple-112958647 text-[#787c87]">Einwilligung</strong> (Artikel 6 Abs.
                1 lit. a DSGVO) Cookies verwenden dürfen, ist diese Einwilligung auch
                gleichzeitig die Rechtsgrundlage für die Verwendung von Cookies bzw. die
                Verarbeitung Ihrer Daten. Um die Einwilligung zu Cookies verwalten zu können
                und Ihnen die Einwilligung ermöglichen zu können, kommt der Cookiebot zum
                Einsatz. Der Einsatz dieser Software ermöglicht uns, die Website auf
                effiziente Weise rechtskonform zu betreiben, was ein{" "}
                <strong className="adsimple-112958647 text-[#787c87]">berechtigtes Interesse</strong>{" "}
                (Artikel 6 Abs. 1 lit. f DSGVO) darstellt.
            </p>
            <p>
                Wenn Sie mehr über die Datenschutzrichtlinien von „Cookiebot“ bzw. dem
                dahinterstehenden Unternehmen Cybot erfahren wollen, empfehlen wir Ihnen die
                Datenschutzrichtlinien unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.cookiebot.com/de/privacy-policy/?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                https://www.cookiebot.com/de/privacy-policy/
                </a>{" "}
                durchzulesen.
            </p>
            <p>&nbsp;</p>
            <h2 id="security-anti-spam" className="adsimple-112958647">
                Security &amp; Anti-Spam
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Security &amp; Anti-Spam Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Cybersicherheit
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Ihre IP-Adresse, Name oder
                    technische Daten wie etwa Browserversion
                    <br />
                    Mehr Details dazu finden Sie weiter unten und den einzelnen
                    Datenschutztexten.
                    <br />
                    📅 Speicherdauer: meisten werden die Daten solange gespeichert, bis
                    sie zur Erfüllung der Dienstleistung nicht mehr benötigt werden
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">
                Was ist eine Security- &amp; Anti-Spam-Software?
            </h3>
            <p>
                Mit sogenannten Security- &amp; Anti-Spam-Softwares können Sie sich und wir
                uns vor diversen Spam- oder Phishing-Mails und möglichen anderen
                Cyberattacken schützen. Unter Spam versteht man Werbemails aus einem
                Massenversand, die man selbst nicht verlangte. Solche Mails werden auch
                Datenmüll genannt und können auch Kosten verursachen. Phishing-Mails sind
                wiederum Nachrichten, die darauf abzielen, über gefälschte Nachrichten oder
                Websites Vertrauen aufzubauen, um an persönliche Daten zu gelangen. Eine
                Anti-Spam-Software schützt in der Regel vor unerwünschten Spam-Nachrichten
                oder bösartigen Mails, die etwa Viren in unser System einschleusen könnten.
                Wir nutzen auch allgemeine Firewall- und Sicherheitssysteme, die unsere
                Computer vor unerwünschten Netzwerkangriffen schützen.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Security- &amp; Anti-Spam-Software?
            </h3>
            <p>
                Wir legen auf unserer Website besonders großen Wert auf Sicherheit.
                Schließlich geht es nicht nur um unsere, sondern vor allem auch um Ihre
                Sicherheit. Leider gehören mittlerweile in der Welt der IT und des Internets
                Cyberbedrohungen schon zum Alltag. Oft versuchen Hacker mit Hilfe einer
                Cyberattacke personenbezogene Daten aus einem IT-System zu stehlen. Und
                daher ist ein gutes Abwehrsystem absolut notwendig. Ein Sicherheitssystem
                überwacht alle ein- und ausgehenden Verbindungen zu unserem Netzwerk bzw.
                Computer. Damit wir noch größere Sicherheit vor Cyberangriffen erreichen,
                nutzen wir neben den standardisierten Sicherheitssystemen auf unserem
                Computer auch noch weitere externe Security-Dienste. Unerlaubter Verkehr von
                Daten wird dadurch besser unterbunden und so schützen wir uns vor
                Cyberkriminalität.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch Security- &amp; Anti-Spam-Softwares verarbeitet?
            </h3>
            <p>
                Welche Daten genau erhoben und gespeichert werden hängt natürlich vom
                jeweiligen Dienst ab. Wir sind allerdings stets bemüht nur Programme zu
                verwenden, die sehr sparsam Daten erheben bzw. nur Daten speichern, die für
                die Erfüllung der angebotenen Leistung nötig sind. Grundsätzlich kann der
                Dienst Daten wie beispielsweise Name, Adresse, IP-Adresse, E-Mail-Adresse
                und technische Daten wie Browsertyp oder Browserversion speichern. Auch
                können etwaige Leistungs- und Protokolldaten erhoben werden, um mögliche
                eingehende Bedrohungen rechtzeitig zu erkennen. Diese Daten werden im Rahmen
                der Services und unter Einhaltung der geltenden Gesetze verarbeitet. Dazu
                zählt auch bei US-amerikanischen Anbietern (über die
                Standardvertragsklauseln) die DSGVO. Diese Security-Dienste arbeiten in
                einigen Fällen auch mit Drittanbietern zusammen, die unter Anweisung und in
                Übereinstimmung mit den Datenschutzrichtlinien und weiteren
                Sicherheitsmaßnahmen Daten speichern und/oder verarbeiten können. Die
                Datenspeicherung erfolgt meist über Cookies.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Beispielsweise speichern
                Security-Programme Daten bis Sie oder wir die Datenspeicherung widerrufen.
                Generell werden personenbezogene Daten nur so lange, wie es für die
                Bereitstellung der Dienstleistungen unbedingt notwendig ist, gespeichert. In
                vielen Fällen fehlen uns leider von den Anbietern präzise Informationen über
                die Länge der Speicherung.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern von Security-Software zu
                widerrufen. Das funktioniert entweder über unser Cookie-Management-Tool oder
                über andere Opt-Out-Funktionen. Zum Beispiel können Sie auch die
                Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die
                Cookies verwalten, deaktivieren oder löschen.
            </p>
            <p>
                Da bei solchen Sicherheitsdiensten auch Cookies zum Einsatz kommen können,
                empfehlen wir Ihnen unsere allgemeine Datenschutzerklärung über Cookies. Um
                zu erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet
                werden, sollten Sie die Datenschutzerklärungen der jeweiligen Tools
                durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wir setzen die Sicherheitsdienste hauptsächlich auf Grundlage unserer
                berechtigten Interessen (Art. 6 Abs. 1 lit. f DSGVO) an einem guten
                Sicherheitssystem gegen diverse Cyberangriffe ein.
            </p>
            <p>
                Bestimmte Verarbeitungen, insbesondere der Einsatz von Cookies sowie die
                Nutzung von Sicherheitsfunktionen bedürfen Ihrer Einwilligung. Wenn Sie
                eingewilligt haben, dass Daten von Ihnen durch eingebundene Security-Dienste
                verarbeitet und gespeichert werden können, gilt diese Einwilligung als
                Rechtsgrundlage der Datenverarbeitung (Art. 6 Abs. 1 lit. a DSGVO). Die
                meisten von uns verwendeten Dienste setzen Cookies in Ihrem Browser, um
                Daten zu speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext über
                Cookies genau durchzulesen und die Datenschutzerklärung oder die
                Cookie-Richtlinien des jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                Informationen zu speziellen Tools erfahren Sie – sofern vorhanden – in den
                folgenden Abschnitten.
            </p>
            <h2
                id="google-recaptcha-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Google reCAPTCHA Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Google reCAPTCHA Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung und Schutz vor
                    Cyberangriffen
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa IP-Adresse,
                    Browserinformationen, Ihr Betriebssystem, eingeschränkte Standorts-
                    und Nutzungsdaten
                    <br />
                    Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: abhängig von den gespeicherten Daten
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist reCAPTCHA?</h3>
            <p>
                Unser oberstes Ziel ist es, unsere Webseite für Sie und für uns bestmöglich
                zu sichern und zu schützen. Um das zu gewährleisten, verwenden wir Google
                reCAPTCHA der Firma Google Inc. Für den europäischen Raum ist das
                Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4,
                Irland) für alle Google-Dienste verantwortlich. Mit reCAPTCHA können wir
                feststellen, ob Sie auch wirklich ein Mensch aus Fleisch und Blut sind und
                kein Roboter oder eine andere Spam-Software. Unter Spam verstehen wir jede,
                auf elektronischen Weg, unerwünschte Information, die uns ungefragter Weise
                zukommt. Bei den klassischen CAPTCHAS mussten Sie zur Überprüfung meist
                Text- oder Bildrätsel lösen. Mit reCAPTCHA von Google müssen wir Sie meist
                nicht mit solchen Rätseln belästigen. Hier reicht es in den meisten Fällen,
                wenn Sie einfach ein Häkchen setzen und so bestätigen, dass Sie kein Bot
                sind. Mit der neuen Invisible reCAPTCHA Version müssen Sie nicht mal mehr
                ein Häkchen setzen. Wie das genau funktioniert und vor allem welche Daten
                dafür verwendet werden, erfahren Sie im Verlauf dieser Datenschutzerklärung.
            </p>
            <p>
                reCAPTCHA ist ein freier Captcha-Dienst von Google, der Webseiten vor
                Spam-Software und den Missbrauch durch nicht-menschliche Besucher schützt.
                Am häufigsten wird dieser Dienst verwendet, wenn Sie Formulare im Internet
                ausfüllen. Ein Captcha-Dienst ist eine Art automatischer Turing-Test, der
                sicherstellen soll, dass eine Handlung im Internet von einem Menschen und
                nicht von einem Bot vorgenommen wird. Im klassischen Turing-Test (benannt
                nach dem Informatiker Alan Turing) stellt ein Mensch die Unterscheidung
                zwischen Bot und Mensch fest. Bei Captchas übernimmt das auch der Computer
                bzw. ein Softwareprogramm. Klassische Captchas arbeiten mit kleinen
                Aufgaben, die für Menschen leicht zu lösen sind, doch für Maschinen
                erhebliche Schwierigkeiten aufweisen. Bei reCAPTCHA müssen Sie aktiv keine
                Rätsel mehr lösen. Das Tool verwendet moderne Risikotechniken, um Menschen
                von Bots zu unterscheiden. Hier müssen Sie nur noch das Textfeld „Ich bin
                kein Roboter“ ankreuzen bzw. bei Invisible reCAPTCHA ist selbst das nicht
                mehr nötig. Bei reCAPTCHA wird ein JavaScript-Element in den Quelltext
                eingebunden und dann läuft das Tool im Hintergrund und analysiert Ihr
                Benutzerverhalten. Aus diesen Useraktionen berechnet die Software einen
                sogenannten Captcha-Score. Google berechnet mit diesem Score schon vor der
                Captcha-Eingabe wie hoch die Wahrscheinlichkeit ist, dass Sie ein Mensch
                sind. reCAPTCHA bzw. Captchas im Allgemeinen kommen immer dann zum Einsatz,
                wenn Bots gewisse Aktionen (wie z.B. Registrierungen, Umfragen usw.)
                manipulieren oder missbrauchen könnten.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir reCAPTCHA auf unserer Website?
            </h3>
            <p>
                Wir wollen nur Menschen aus Fleisch und Blut auf unserer Seite begrüßen.
                Bots oder Spam-Software unterschiedlichster Art dürfen getrost zuhause
                bleiben. Darum setzen wir alle Hebel in Bewegung, uns zu schützen und die
                bestmögliche Benutzerfreundlichkeit für Sie anzubieten. Aus diesem Grund
                verwenden wir Google reCAPTCHA der Firma Google. So können wir uns ziemlich
                sicher sein, dass wir eine „botfreie“ Webseite bleiben. Durch die Verwendung
                von reCAPTCHA werden Daten an Google übermittelt, um festzustellen, ob Sie
                auch wirklich ein Mensch sind. reCAPTCHA dient also der Sicherheit unserer
                Webseite und in weiterer Folge damit auch Ihrer Sicherheit. Zum Beispiel
                könnte es ohne reCAPTCHA passieren, dass bei einer Registrierung ein Bot
                möglichst viele E-Mail-Adressen registriert, um im Anschluss Foren oder
                Blogs mit unerwünschten Werbeinhalten „zuzuspamen“. Mit reCAPTCHA können wir
                solche Botangriffe vermeiden.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von reCAPTCHA gespeichert?
            </h3>
            <p>
                reCAPTCHA sammelt personenbezogene Daten von Usern, um festzustellen, ob die
                Handlungen auf unserer Webseite auch wirklich von Menschen stammen. Es kann
                also die IP-Adresse und andere Daten, die Google für den reCAPTCHA-Dienst
                benötigt, an Google versendet werden. IP-Adressen werden innerhalb der
                Mitgliedstaaten der EU oder anderer Vertragsstaaten des Abkommens über den
                Europäischen Wirtschaftsraum fast immer zuvor gekürzt, bevor die Daten auf
                einem Server in den USA landen. Die IP-Adresse wird nicht mit anderen Daten
                von Google kombiniert, sofern Sie nicht während der Verwendung von reCAPTCHA
                mit Ihrem Google-Konto angemeldet sind. Zuerst prüft der
                reCAPTCHA-Algorithmus, ob auf Ihrem Browser schon Google-Cookies von anderen
                Google-Diensten (YouTube. Gmail usw.) platziert sind. Anschließend setzt
                reCAPTCHA ein zusätzliches Cookie in Ihrem Browser und erfasst einen
                Schnappschuss Ihres Browserfensters.
            </p>
            <p>
                Die folgende Liste von gesammelten Browser- und Userdaten, hat nicht den
                Anspruch auf Vollständigkeit. Vielmehr sind es Beispiele von Daten, die nach
                unserer Erkenntnis, von Google verarbeitet werden.
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                Referrer URL (die Adresse der Seite von der der Besucher kommt)
                </li>
                <li className="adsimple-112958647">IP-Adresse (z.B. 256.123.123.1)</li>
                <li className="adsimple-112958647">
                Infos über das Betriebssystem&nbsp;(die Software, die den Betrieb Ihres
                Computers ermöglicht. Bekannte Betriebssysteme sind Windows, Mac OS X oder
                Linux)
                </li>
                <li className="adsimple-112958647">
                Cookies&nbsp;(kleine Textdateien, die Daten in Ihrem Browser speichern)
                </li>
                <li className="adsimple-112958647">
                Maus- und Keyboardverhalten&nbsp;(jede Aktion, die Sie mit der Maus oder
                der Tastatur ausführen wird gespeichert)
                </li>
                <li className="adsimple-112958647">
                Datum und Spracheinstellungen&nbsp;(welche Sprache bzw. welches Datum Sie
                auf Ihrem PC voreingestellt haben wird gespeichert)
                </li>
                <li className="adsimple-112958647">
                Alle Javascript-Objekte&nbsp;(JavaScript ist eine Programmiersprache, die
                Webseiten ermöglicht, sich an den User anzupassen. JavaScript-Objekte
                können alle möglichen Daten unter einem Namen sammeln)
                </li>
                <li className="adsimple-112958647">
                Bildschirmauflösung&nbsp;(zeigt an aus wie vielen Pixeln die
                Bilddarstellung besteht)
                </li>
            </ul>
            <p>
                Unumstritten ist, dass Google diese Daten verwendet und analysiert noch
                bevor Sie auf das Häkchen „Ich bin kein Roboter“ klicken. Bei der Invisible
                reCAPTCHA-Version fällt sogar das Ankreuzen weg und der ganze
                Erkennungsprozess läuft im Hintergrund ab. Wie viel und welche Daten Google
                genau speichert, erfährt man von Google nicht im Detail.
            </p>
            <p>
                Folgende Cookies werden von reCAPTCHA verwendet: Hierbei beziehen wir uns
                auf die reCAPTCHA Demo-Version von Google unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.google.com/recaptcha/api2/demo"
                target="_blank"
                rel="noopener noreferrer"
                >
                https://www.google.com/recaptcha/api2/demo
                </a>
                . All diese Cookies benötigen zu Trackingzwecken eine eindeutige Kennung.
                Hier ist eine Liste an Cookies, die Google reCAPTCHA auf der Demo-Version
                gesetzt hat:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> IDE
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>
                &nbsp;WqTUmlnmv_qXyi_DGNPLESKnRNrpgXoy1K-pAZtAkMbHI-112958647-8
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie wird von der Firma DoubleClick (gehört auch Google) gesetzt, um die
                Aktionen eines Users auf der Webseite im Umgang mit Werbeanzeigen zu
                registrieren und zu melden. So kann die Werbewirksamkeit gemessen und
                entsprechende Optimierungsmaßnahmen getroffen werden. IDE wird in Browsern
                unter der Domain doubleclick.net gespeichert.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> 1P_JAR
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>&nbsp;2019-5-14-12
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie sammelt Statistiken zur Webseite-Nutzung und misst Conversions. Eine
                Conversion entsteht z.B., wenn ein User zu einem Käufer wird. Das Cookie
                wird auch verwendet, um Usern relevante Werbeanzeigen einzublenden. Weiters
                kann man mit dem Cookie vermeiden, dass ein User dieselbe Anzeige mehr als
                einmal zu Gesicht bekommt.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem
                Monat
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> ANID
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>
                &nbsp;U7j1v3dZa1129586470xgZFmiqWppRWKOr
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Viele
                Infos konnten wir über dieses Cookie nicht in Erfahrung bringen. In der
                Datenschutzerklärung von Google wird das Cookie im Zusammenhang mit
                „Werbecookies“ wie z. B. “DSID”, “FLC”, “AID”, “TAID” erwähnt. ANID wird
                unter Domain google.com gespeichert.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 9 Monaten
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> CONSENT
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:&nbsp;</strong>
                YES+AT.de+20150628-20-0
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Das Cookie
                speichert den Status der Zustimmung eines Users zur Nutzung
                unterschiedlicher Services von Google. CONSENT dient auch der Sicherheit, um
                User zu überprüfen, Betrügereien von Anmeldeinformationen zu verhindern und
                Userdaten vor unbefugten Angriffen zu schützen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 19 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> NID
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                0WmuWqy112958647zILzqV_nmt3sDXwPeM5Q
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> NID wird
                von Google verwendet, um Werbeanzeigen an Ihre Google-Suche anzupassen. Mit
                Hilfe des Cookies „erinnert“ sich Google an Ihre meist eingegebenen
                Suchanfragen oder Ihre frühere Interaktion mit Anzeigen. So bekommen Sie
                immer maßgeschneiderte Werbeanzeigen. Das Cookie enthält eine einzigartige
                ID, um persönliche Einstellungen des Users für Werbezwecke zu sammeln.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 6 Monaten
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> DV
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                gEAABBCjJMXcI0dSAAAANbqc112958647-4
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Sobald Sie
                das „Ich bin kein Roboter“-Häkchen angekreuzt haben, wird dieses Cookie
                gesetzt. Das Cookie wird von Google Analytics für personalisierte Werbung
                verwendet. DV sammelt Informationen in anonymisierter Form und wird weiters
                benutzt, um User-Unterscheidungen zu treffen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 10 Minuten
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung:&nbsp;</strong>Diese
                Aufzählung kann keinen Anspruch auf Vollständigkeit erheben, da Google
                erfahrungsgemäß die Wahl ihrer Cookies immer wieder auch verändert.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Durch das Einfügen von reCAPTCHA werden Daten von Ihnen auf den
                Google-Server übertragen. Wo genau diese Daten gespeichert werden, stellt
                Google, selbst nach wiederholtem Nachfragen, nicht klar dar. Ohne eine
                Bestätigung von Google erhalten zu haben, ist davon auszugehen, dass Daten
                wie Mausinteraktion, Verweildauer auf der Webseite oder Spracheinstellungen
                auf den europäischen oder amerikanischen Google-Servern gespeichert werden.
                Die IP-Adresse, die Ihr Browser an Google übermittelt, wird grundsätzlich
                nicht mit anderen Google-Daten aus weiteren Google-Diensten zusammengeführt.
                Wenn Sie allerdings während der Nutzung des reCAPTCHA-Plug-ins bei Ihrem
                Google-Konto angemeldet sind, werden die Daten zusammengeführt.
                <strong className="adsimple-112958647 text-[#787c87]">&nbsp;</strong>Dafür gelten die
                abweichenden Datenschutzbestimmungen der Firma Google.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Wenn Sie wollen, dass über Sie und über Ihr Verhalten keine Daten an Google
                übermittelt werden, müssen Sie sich, bevor Sie unsere Webseite besuchen bzw.
                die reCAPTCHA-Software verwenden, bei Google vollkommen ausloggen und alle
                Google-Cookies löschen.&nbsp;Grundsätzlich werden die Daten sobald Sie
                unsere Seite aufrufen automatisch an Google übermittelt. Um diese Daten
                wieder zu löschen, müssen Sie den Google-Support auf&nbsp;{" "}
                <a
                className="adsimple-112958647"
                href="https://support.google.com/?hl=de&tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                https://support.google.com/?hl=de&amp;tid=112958647
                </a>{" "}
                kontaktieren.
            </p>
            <p>
                Wenn Sie also unsere Webseite verwenden, erklären Sie sich einverstanden,
                dass Google LLC und deren Vertreter automatisch Daten erheben, bearbeiten
                und nutzen.
            </p>
            <p>
                Bitte beachten Sie, dass bei der Verwendung dieses Tools Daten von Ihnen
                auch außerhalb der EU gespeichert und verarbeitet werden können. Die meisten
                Drittstaaten (darunter auch die USA) gelten nach derzeitigem europäischen
                Datenschutzrecht als nicht sicher. Daten an unsichere Drittstaaten dürfen
                also nicht einfach übertragen, dort gespeichert und verarbeitet werden,
                sofern es keine passenden Garantien (wie etwa EU-Standardvertragsklauseln)
                zwischen uns und dem außereuropäischen Dienstleister gibt.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Google reCAPTCHA eingesetzt werden darf,
                ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese
                Einwilligung. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Google reCAPTCHA vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, Google reCAPTCHA
                zu verwenden, um unser Online-Service zu optimieren und sicherer zu machen.
                Die dafür entsprechende Rechtsgrundlage ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen Google reCAPTCHA gleichwohl nur ein, soweit Sie eine
                Einwilligung erteilt haben.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
                Terms), welche auf die Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
                .
            </p>
            <p>
                Etwas mehr über reCAPTCHA erfahren Sie auf der Webentwickler-Seite von
                Google auf{" "}
                <a
                className="adsimple-112958647"
                href="https://developers.google.com/recaptcha/"
                target="_blank"
                rel="noopener noreferrer"
                >
                https://developers.google.com/recaptcha/
                </a>
                . Google geht hier zwar auf die technische Entwicklung der reCAPTCHA näher
                ein, doch genaue Informationen über Datenspeicherung und
                datenschutzrelevanten Themen sucht man auch dort vergeblich. Eine gute
                Übersicht über die grundsätzliche Verwendung von Daten bei Google finden Sie
                in der hauseigenen Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?tid=112958647"
                >
                https://policies.google.com/privacy
                </a>
                .
            </p>
            <h2 id="cloud-dienste" className="adsimple-112958647">
                Cloud-Dienste
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Cloud-Dienste Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Wir als Websitebetreiber und Sie als Websitebesucher
                    <br />
                    🤝 Zweck: Sicherheit und Datenspeicherung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Ihre IP-Adresse, Name oder
                    technische Daten wie etwa Browserversion
                    <br />
                    Mehr Details dazu finden Sie weiter unten und den einzelnen
                    Datenschutztexten bzw. in den Datenschutzerklärungen der Anbieter
                    <br />
                    📅 Speicherdauer: meisten werden die Daten solange gespeichert, bis
                    sie zur Erfüllung der Dienstleistung nicht mehr benötigt werden
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Cloud-Dienste?</h3>
            <p>
                Cloud-Dienste stellen uns als Websitebetreiber Speicherplatz und
                Rechenleistung über das Internet zur Verfügung. Über das Internet können
                Daten an ein externes System übertragen, verarbeitet und gespeichert werden.
                Die Verwaltung dieser Daten übernimmt der entsprechende Cloud-Anbieter. Je
                nach Anforderung kann eine einzelne Person oder auch ein Unternehmen die
                Speicherplatzgröße oder Rechenleistung wählen. Zugegriffen wird auf
                Cloud-Speicher über eine API oder über Speicherprotokolle. API steht für
                Application Programming Interface und gemeint ist damit eine
                Programmierschnittstelle, die Software- mit Hardwarekomponenten verbindet.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir Cloud-Dienste?</h3>
            <p>
                Wir nutzen Cloud-Dienste aus mehreren Gründen. Ein Cloud-Dienst bietet uns
                die Möglichkeit unsere Daten sicher zu speichern. Zudem haben wir von
                verschiedenen Orten und Geräten Zugriff auf die Daten und verfügen damit
                über mehr Flexibilität und erleichtern unsere Arbeitsprozesse. Ein
                Cloud-Speicher erspart uns auch Kosten, weil wir keine eigene Infrastruktur
                für Datenspeicherung und Datensicherheit errichten und verwalten müssen.
                Durch die zentrale Speicherung unserer Daten in der Cloud können wir auch
                unsere Anwendungsfelder erweitern und unsere Informationen deutlich besser
                verwalten.
            </p>
            <p>
                Wir als Websitebetreiber bzw. als Unternehmen setzen Cloud-Dienste also in
                erster Linie für unsere eigenen Zwecke ein. Zum Beispiel nutzen wir die
                Dienste, um unseren Kalender zu verwalten, um Dokumente oder andere wichtige
                Informationen in der Cloud zu speichern. Dabei können allerdings auch
                personenbezogene Daten von Ihnen gespeichert werden. Dies ist beispielsweise
                dann der Fall, wenn Sie uns Ihre Kontaktdaten (etwa Name und E-Mail-Adresse)
                zu Verfügung stellen und wir unsere Kundendaten bei einem Cloud-Anbieter
                speichern. Folglich können Daten, die wir von Ihnen verarbeiten auch auf
                externen Servern abgelegt und verarbeitet werden. Wenn wir auf unserer
                Website bestimmte Formulare oder Inhalte von Cloud-Diensten anbieten, können
                auch Cookies für Webanalysen und Werbezwecke gesetzt werden. Weiters merken
                sich solche Cookies Ihre Einstellungen (wie z. B. die verwendete Sprache),
                damit Sie beim nächsten Besuch auf unserer Website Ihre gewohnte Webumgebung
                vorfinden.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch Cloud-Dienste verarbeitet?
            </h3>
            <p>
                Viele von uns in der Cloud gespeicherten Daten haben keinen Personenbezug,
                einige Daten zählen jedoch, nach Definition der DSGVO, zu personenbezogenen
                Daten. Häufig handelt es sich um Kundendaten wie Name, Adresse, IP-Adresse
                oder Telefonnummer oder um technische Gerätinformationen. In der Cloud
                können des Weiteren auch Videos, Bilder und Audiodateien gespeichert werden.
                Wie die Daten genau erhoben und gespeichert werden, hängt vom jeweiligen
                Dienst ab. Wir versuchen nur Dienste zu nutzen, die sehr vertrauenswürdig
                und professionell mit den Daten umgehen. Grundsätzlich haben die Dienste,
                wie etwa Amazon Drive, Zugriff auf die gespeicherten Dateien, um ihren
                eigenen Service entsprechend anbieten zu können. Dafür benötigen die Dienste
                allerdings Genehmigungen wie beispielsweise das Recht Dateien wegen
                Sicherheitsaspekten zu kopieren. Diese Daten werden im Rahmen der Services
                und unter Einhaltung der geltenden Gesetze verarbeitet und verwaltet. Dazu
                zählt auch bei US-amerikanischen Anbietern (über die
                Standardvertragsklauseln) die DSGVO. Diese Cloud-Dienste arbeiten in einigen
                Fällen auch mit Drittanbietern zusammen, die unter Anweisung und in
                Übereinstimmung mit den Datenschutzrichtlinien und weiteren
                Sicherheitsmaßnahmen Daten verarbeiten können. Wir möchten an dieser Stelle
                nochmals betonen, dass sich alle bekannten Cloud-Dienste (wie Amazon Drive,
                Google Drive oder Microsoft Onedrive) das Recht einholen, Zugriff auf
                gespeicherte Inhalte zu haben, um ihr eigenes Service entsprechend anbieten
                und optimieren zu können.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Im Allgemeinen speichern
                Cloud-Dienste Daten, bis Sie oder wir die Datenspeicherung widerrufen bzw.
                die Daten wieder löschen. Generell werden personenbezogene Daten nur so
                lange gespeichert, wie es für die Bereitstellung der Dienstleistungen
                unbedingt notwendig ist. Ein endgültiges Datenlöschen aus der Cloud kann
                allerdings einige Monate dauern. Das ist der Fall, weil die Daten meist
                nicht nur auf einem Server gespeichert sind, sondern auf verschiedenen
                Servern aufgeteilt werden.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Datenspeicherung in einer Cloud zu widerrufen. Falls Cookies verwendet
                werden, haben Sie auch hier ein Widerrufsrecht. Das funktioniert entweder
                über unser Cookie-Management-Tool oder über andere Opt-Out-Funktionen. Zum
                Beispiel können Sie auch die Datenerfassung durch Cookies verhindern, indem
                Sie in Ihrem Browser die Cookies verwalten, deaktivieren oder löschen. Wir
                empfehlen Ihnen auch unsere allgemeine Datenschutzerklärung über Cookies. Um
                zu erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet
                werden, sollten Sie die Datenschutzerklärungen der jeweiligen Cloud-Anbieter
                durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wir setzen Cloud-Dienste hauptsächlich auf Grundlage unserer berechtigten
                Interessen (Art. 6 Abs. 1 lit. f DSGVO) an einem guten Sicherheits- und
                Speichersystem ein.
            </p>
            <p>
                Bestimmte Verarbeitungen, insbesondere der Einsatz von Cookies sowie die
                Nutzung von Speicherfunktionen bedürfen Ihrer Einwilligung. Wenn Sie
                eingewilligt haben, dass Daten von Ihnen bei Cloud-Diensten verarbeitet und
                gespeichert werden können, gilt diese Einwilligung als Rechtsgrundlage der
                Datenverarbeitung (Art. 6 Abs. 1 lit. a DSGVO).&nbsp;Die meisten von uns
                verwendeten Dienste setzen Cookies in Ihrem Browser, um Daten zu speichern.
                Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies genau
                durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien des
                jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                Informationen zu speziellen Tools erfahren Sie – sofern vorhanden – in den
                folgenden Abschnitten.
            </p>
            <h2 id="google-cloud-datenschutzerklaerung" className="adsimple-112958647">
                Google Cloud Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden für unserer Website Google Cloud, einen Online-Speicherdienst
                für Dateien, Fotos und Videos. Dienstanbieter ist das amerikanische
                Unternehmen Google Inc. Für den europäischen Raum ist das Unternehmen Google
                Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland) für alle
                Google-Dienste verantwortlich.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Google hält einen Vertrag über die Auftragsverarbeitung gemäß Art. 28 DSGVO
                bereit, der als datenschutzrechtliche Grundlage für unsere Kundenbeziehung
                zu Google fungiert. Dieser verweist inhaltlich auf die
                EU-Standardvertragsklauseln. Hier finden Sie die
                Auftragsverarbeitungsbedingungen:{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Google Cloud verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de?tid=112958647"
                >
                https://policies.google.com/privacy?hl=de
                </a>
                .
            </p>
            <h2 id="zahlungsanbieter-einleitung" className="adsimple-112958647">
                Zahlungsanbieter Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Zahlungsanbieter Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Ermöglichung und Optimierung des Zahlungsvorgangs auf
                    unserer Website
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Name, Adresse, Bankdaten
                    (Kontonummer, Kreditkartennummer, Passwörter, TANs usw.), IP-Adresse
                    und Vertragsdaten
                    <br />
                    Mehr Details dazu finden Sie beim jeweils eingesetzten
                    Zahlungsanbieter-Tool.
                    <br />
                    📅 Speicherdauer: abhängig vom verwendeten Zahlungsanbieter
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. b DSGVO (Erfüllung eines
                    Vertrags)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist ein Zahlungsanbieter?</h3>
            <p>
                Wir verwenden auf unserer Website Online-Zahlungssysteme, die uns und Ihnen
                ein sicheres und reibungsloses Bezahlverfahren ermöglichen. Dabei können
                unter anderem auch personenbezogene Daten an den jeweiligen Zahlungsanbieter
                gesendet, gespeichert und dort verarbeitet werden. Bei Zahlungsanbietern
                handelt es sich um Online-Zahlungssysteme, die es Ihnen ermöglichen eine
                Bestellung über Online-Banking durchzuführen. Dabei wird die
                Zahlungsabwicklung durch den von Ihnen gewählten Zahlungsanbieter
                durchgeführt. Wir erhalten anschließend eine Information über die getätigte
                Zahlung. Diese Methode kann jeder User nutzen, der ein aktives
                Online-Banking-Konto mit PIN und TAN hat. Es gibt kaum noch Banken, die
                solche Zahlungsmethoden nicht anbieten bzw. akzeptieren.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Zahlungsanbieter auf unserer Website?
            </h3>
            <p>
                Wir wollen natürlich mit unserer Website und unserem eingebundenen
                Onlineshop den bestmögliche Service bieten, damit Sie sich auf unserer Seite
                wohl fühlen und unsere Angebote nutzen. Wir wissen, dass Ihre Zeit kostbar
                ist und speziell Zahlungsabwicklungen schnell und reibungslos funktionieren
                müssen. Aus diesen Gründen bieten wir Ihnen diverse Zahlungsanbieter an. Sie
                können Ihren bevorzugten Zahlungsanbieter wählen und so in gewohnter Manier
                bezahlen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Welche Daten genau verarbeitet werden, hängt natürlich von dem jeweiligen
                Zahlungsanbieter ab. Doch grundsätzlich werden Daten wie Name, Adresse,
                Bankdaten (Kontonummer, Kreditkartennummer, Passwörter, TANs usw.)
                gespeichert. Dabei handelt es sich um notwendige Daten, um überhaupt eine
                Transaktion durchführen zu können. Zudem können auch etwaige Vertragsdaten
                und Userdaten, wie zum Beispiel wann Sie unsere Website besuchen, für welche
                Inhalte Sie sich interessieren oder welche Unterseiten Sie anklicken,
                gespeichert werden. Auch Ihre IP-Adresse und Informationen zu Ihrem
                verwendeten Computer werden von den meisten Zahlungsanbietern gespeichert.
            </p>
            <p>
                Die Daten werden in der Regel auf den Servern der Zahlungsanbietern
                gespeichert und verarbeitet. Wir als Websitebetreiber erhalten diese Daten
                nicht. Wir werden nur darüber informiert, ob die Zahlung funktioniert hat
                oder nicht. Für Identitäts- und Bonitätsprüfungen kann es vorkommen, dass
                Zahlungsanbieter Daten an die entsprechende Stelle weiterleiten. Für alle
                Zahlungsgeschäfte gelten immer die Geschäfts- und Datenschutzgrundlagen des
                jeweiligen Anbieters. Schauen Sie sich daher bitte immer auch die
                Allgemeinen Geschäftsbedingen und die Datenschutzerklärung des
                Zahlungsanbieters an. Sie haben auch jederzeit das Recht beispielsweise
                Daten löschen oder korrigieren zu lassen. Bitte setzen Sie sich bezüglich
                Ihrer Rechte (Widerrufsrecht, Auskunftsrecht und Betroffenheitsrecht) mit
                dem jeweiligen Dienstanbieter in Verbindung.
            </p>
            <h3 className="adsimple-112958647">
                <span
                className="adsimple-112958647"
                data-sheets-value='{"1":2,"2":"Wo und wie lange werden Daten gespeichert?"}'
                data-sheets-userformat='{"2":769,"3":{"1":0},"11":4,"12":0}'
                >
                Dauer der Datenverarbeitung
                </span>
            </h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten sofern
                wir weitere Informationen dazu haben. Generell verarbeiten wir
                personenbezogene Daten nur so lange wie es für die Bereitstellung unserer
                Dienstleistungen und Produkte unbedingt notwendig ist. Wenn es wie zum
                Beispiel im Fall von Buchhaltung gesetzlich vorgeschrieben ist, kann diese
                Speicherdauer auch überschritten werden. So bewahren wir zu einem Vertrag
                gehörige Buchungsbelege (Rechnungen, Vertragsurkunden, Kontoauszüge u.a.) 10
                Jahre (§ 147 AO) sowie sonstige relevante Geschäftsunterlagen 6 Jahre (§ 247
                HGB) nach Anfallen auf.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben immer das Recht auf Auskunft, Berichtigung und Löschung Ihrer
                personenbezogenen Daten. Bei Fragen können Sie auch jederzeit
                Verantwortliche des verwendeten Zahlungsanbieter kontaktieren. Kontaktdaten
                finden Sie entweder in unserer spezifischen Datenschutzerklärung oder auf
                der Website des entsprechenden Zahlungsanbieters.
            </p>
            <p>
                Cookies, die Zahlungsanbieter für ihre Funktionen verwenden, können Sie in
                Ihrem Browser löschen, deaktivieren oder verwalten. Je nachdem welchen
                Browser Sie verwenden, funktioniert dies auf unterschiedliche Art und Weise.
                Bitte beachten Sie aber, dass dann eventuell der Zahlungsvorgang nicht mehr
                funktioniert.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wir bieten also zur Abwicklung von vertraglichen bzw. rechtlichen
                Beziehungen{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. b DSGVO)</strong>
                <strong className="adsimple-112958647 text-[#787c87]">&nbsp;</strong>neben den
                herkömmlichen Bank-/Kreditinstitutionen auch andere Zahlungsdienstleister
                an. In den Datenschutzerklärungen der einzelnen Zahlungsanbietern (wie zum
                Beispiel{" "}
                <span
                className="adsimple-112958647"
                data-sheets-value='{"1":2,"2":"Amazon Payments"}'
                data-sheets-userformat='{"2":513,"3":{"1":0},"12":0}'
                >
                Amazon Payments
                </span>
                ,{" "}
                <span
                className="adsimple-112958647"
                data-sheets-value='{"1":2,"2":"Apple Pay"}'
                data-sheets-userformat='{"2":513,"3":{"1":0},"12":0}'
                >
                Apple Pay
                </span>
                oder{" "}
                <span
                className="adsimple-112958647"
                data-sheets-value='{"1":2,"2":"Discover"}'
                data-sheets-userformat='{"2":513,"3":{"1":0},"12":0}'
                >
                Discover
                </span>
                ) wird Ihnen ein genauer Überblick über die Datenverarbeitung und
                Datenspeicherung geboten. Zudem können Sie sich bei Fragen zu
                datenschutzrelevanten Themen stets an die Verantwortlichen richten.
            </p>
            <p>
                Informationen zu den speziellen Zahlungsanbietern erfahren Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h2
                id="american-express-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                American Express Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auf unserer Website American Express, ein weltweit agierender
                Finanzdienstleister. Dienstanbieter ist das amerikanische Unternehmen
                American Express Company. Für den europäischen Raum ist das Unternehmen
                American Express Europe S.A. (Avenida Partenón 12-14, 28042, Madrid,
                Spanien) zuständig.
            </p>
            <p>
                American Express verarbeitet Daten von Ihnen u.a. auch in den USA. Wir
                weisen darauf hin, dass nach Meinung des Europäischen Gerichtshofs derzeit
                kein angemessenes Schutzniveau für den Datentransfer in die USA besteht.
                Dies kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit
                der Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                American Express sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und
                3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind
                von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                diese Klauseln verpflichtet sich American Express, bei der Verarbeitung
                Ihrer relevanten Daten, das europäische Datenschutzniveau einzuhalten,
                selbst wenn die Daten in den USA gespeichert, verarbeitet und verwaltet
                werden. Diese Klauseln basieren auf einem Durchführungsbeschluss der
                EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von American Express
                verarbeitet werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.americanexpress.com/de-de/firma/legal/datenschutz-center/online-datenschutzerklarung/"
                target="_blank"
                rel="follow noopener"
                >
                https://www.americanexpress.com/de-de/firma/legal/datenschutz-center/online-datenschutzerklarung/
                </a>
                .
            </p>
            <h2
                id="eps-ueberweisung-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                eps-Überweisung Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auf unserer Website eps-Überweisung, einen Dienst für
                Online-Bezahlverfahren. Dienstanbieter ist das österreichische Unternehmen
                Stuzza GmbH, Frankgasse 10/8, 1090 Wien, Österreich.
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von eps-Überweisung
                verarbeitet werden, erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://eservice.psa.at/de/datenschutzerklaerung.html"
                target="_blank"
                rel="follow noopener"
                >
                https://eservice.psa.at/de/datenschutzerklaerung.html
                </a>
                .
            </p>
            <h2 id="google-pay-datenschutzerklaerung" className="adsimple-112958647">
                Google Pay Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auf unserer Website den Online-Zahlungsanbieter Google Pay.
                Dienstanbieter ist das amerikanische Unternehmen Google Inc. Für den
                europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon House,
                Barrow Street Dublin 4, Irland) für alle Google-Dienste verantwortlich.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Datenverarbeitungsbedingungen für Google Werbeprodukte (Google Ads
                Controller-Controller Data Protection Terms), welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/adscontrollerterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/adscontrollerterms/
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Google Pay verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <u>
                <a
                    className="adsimple-112958647"
                    href="https://policies.google.com/privacy?tid=112958647"
                >
                    https://policies.google.com/privacy
                </a>
                .
                </u>
            </p>
            <h2 id="klarna-checkout-datenschutzerklaerung" className="adsimple-112958647">
                Klarna Checkout Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Klarna Checkout Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung des Zahlungsvorgangs auf unserer Website
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Name, Adresse, Bankdaten
                    (Kontonummer, Kreditkartennummer, Passwörter, TANs usw.), IP-Adresse
                    und Vertragsdaten
                    <br />
                    Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: Daten werden gespeichert, solange Klarna sie für den
                    Verarbeitungszweck benötigt.
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. c DSGVO (Rechtliche
                    Verpflichtung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Klarna Checkout?</h3>
            <p>
                Wir verwenden auf unserer Website das Online-Zahlungssystem Klarna Checkout
                des schwedischen Unternehmens Klarna Bank AB. Die Klarna-Bank hat ihren
                Hauptfirmensitz in Sveavägen 46, 111 34 Stockholm, Schweden. Wenn Sie sich
                für diesen Dienst entscheiden, werden unter anderem personenbezogene Daten
                an Klarna gesendet, gespeichert und verarbeitet. In dieser
                Datenschutzerklärung möchten wir Ihnen einen Überblick über die
                Datenverarbeitung durch Klarna geben.
            </p>
            <p>
                Klarna Checkout ist ein Zahlungssystem für Bestellungen in einem Onlineshop.
                Dabei wählt der Nutzer die Zahlungsart und Klarna Checkout übernimmt den
                gesamten Zahlungsprozess. Nachdem ein Nutzer einmal eine Zahlung über das
                Checkout-System durchgeführt hat und die entsprechenden Daten angegeben hat,
                können zukünftige Online-Einkäufe noch schneller und einfacher durchgeführt
                werden. Das Klarna-System erkennt dann bereits nach Eingabe der
                E-Mail-Adresse und Postleitzahl den bestehenden Kunden.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Klarna Checkout für unsere Website?
            </h3>
            <p>
                Unser Ziel mit unserer Website und unserem eingebundenen Onlineshop ist es,
                Ihnen den bestmögliche Service zu bieten. Dazu zählt neben dem
                Gesamterlebnis auf der Website und neben unseren Angeboten auch eine
                reibungslose, schnelle und sichere Zahlungsabwicklung Ihrer Bestellungen. Um
                das zu gewährleisten, nutzen wir das Zahlungssystem Klarna Checkout.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Klarna Checkout gespeichert?
            </h3>
            <p>
                Sobald Sie sich für den Zahlungsdienst Klarna entscheiden und über die
                Zahlungsmethode Klarna Checkout bezahlen, übermitteln Sie auch
                personenbezogene Daten an das Unternehmen. Auf der Klarna Checkout-Seite
                werden technische Daten wie Browsertyp, Betriebssystem, unsere
                Internetadresse, Datum und Uhrzeit, Spracheinstellungen,
                Zeitzoneneinstellungen und IP-Adresse von Ihnen erhoben und an die Server
                von Klarna übermittelt und dort gespeichert. Diese Daten werden auch dann
                gespeichert, wenn Sie noch keine Bestellung abgeschlossen haben.
            </p>
            <p>
                Wenn Sie ein Produkt oder eine Dienstleistung über unseren Shop bestellen,
                müssen Sie in die vorgegebenen Felder Daten zu Ihrer Person eingeben. Diese
                Daten werden durch Klarna für die Zahlungsabwicklung verarbeitet. Dabei
                können zur Bonitäts- und Identitätsprüfung speziell folgende
                personenbezogenen Daten (sowie allgemeine Produktinformationen) durch Klarna
                gespeichert und verarbeitet werden:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">
                Kontaktinformationen: Namen, Geburtsdatum, nationale Ausweisnummer, Titel,
                Rechnungs- und Lieferadresse, E-Mail-Adresse, Telefonnummer, Nationalität
                oder Gehalt.
                </li>
                <li className="adsimple-112958647">
                Zahlungsinformationen wie Kreditkartendaten oder Ihre Kontonummer
                </li>
                <li className="adsimple-112958647">
                Produktinformationen wie Sendungsnummer, Art des Artikels und Preis des
                Produkts
                </li>
            </ul>
            <p>
                Zudem gibt es auch noch Daten, die optional erhoben werden können, sofern
                Sie sich dazu bewusst entscheiden. Das sind etwa politische, religiöse oder
                weltanschauliche Überzeugungen oder diverse Gesundheitsdaten.
            </p>
            <p>
                Klarna kann auch selbst oder über Dritte (wie beispielsweise über uns oder
                über öffentliche Datenbanken) neben den oben genannten Daten auch Daten zu
                den Waren oder Dienstleistungen, die Sie kaufen oder bestellen erheben. Das
                kann zum Beispiel die Sendungsnummer oder die Art des bestellten Artikels
                sein, aber auch Auskünfte über Ihre Bonität, über Ihr Einkommen oder
                Kreditgewährungen. Klarna kann Ihre personenbezogenen Daten auch
                Dienstleister wie etwa Softwareanbieter, Datenspeicheranbieter oder uns als
                Händler weitergeben.
            </p>
            <p>
                Wenn Daten automatisch in ein Formular eingetragen werden, dann sind immer
                Cookies im Spiel. Wenn Sie diese Funktion nicht nutzen wollen, können Sie
                jederzeit diese Cookies deaktivieren. Weiter unten im Text finden Sie eine
                Anleitung, wie Sie Cookies in Ihrem Browser grundsätzlich löschen,
                deaktivieren oder verwalten. Unsere Tests haben ergeben, dass von Klarna
                direkt keine Cookies gesetzt werden. Wenn Sie die Zahlungsmethode “Klarna
                Sofort” wählen und auf “Bestellen” klicken, werden Sie auf die
                Sofort-Website weitergeleitet. Nach der erfolgreichen Zahlung kommen Sie auf
                unsere Dankesseite. Dort wird von sofort.com folgendes Cookie gesetzt:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name</strong>: SOFUEB
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert: </strong>
                e8cipp378mdscn9e17kajlfhv7112958647-4
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie speichert Ihre Session-ID.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach Beenden
                der Browsersitzung
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Klarna ist bemüht Ihre Daten nur innerhalb der EU bzw. des Europäischen
                Wirtschaftsraums (EWR) zu speichern. Es kann aber auch vorkommen, dass Daten
                außerhalb des EU/EWR übertragen werden. Wenn das passiert, stellt Klarna
                sicher, dass der Datenschutz im Einklang mit der DSGVO steht und das
                Drittland in einer Angemessenheitsentscheidung der Europäischen Union steht.
                Die Daten werden immer gespeichert, solange Klarna sie für den
                Verarbeitungszweck benötigt.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie können Ihre Einwilligung, dass Klarna personenbezogene Daten verarbeitet
                jederzeit widerrufen. Sie haben auch immer das Recht auf Auskunft,
                Berichtigung und Löschung Ihrer personenbezogenen Daten. Dafür müssen Sie
                lediglich das Unternehmen bzw. das Datenschutzteam des Unternehmens per
                E-Mail an{" "}
                <a className="adsimple-112958647" href="mailto:datenschutz@klarna.de">
                datenschutz@klarna.de
                </a>{" "}
                kontaktieren. Über die Klarna-Website{" "}
                <a
                className="adsimple-112958647"
                href="https://www.klarna.com/at/meine-datenschutzanfrage-formular/?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                „Meine Datenschutzanfrage“
                </a>
                &nbsp;können Sie ebenfalls mit Klarna direkt in Kontakt treten.
            </p>
            <p>
                Cookies, die Klarna für ihre Funktionen möglicherweise verwendet, können Sie
                in Ihrem Browser löschen, deaktivieren oder verwalten. Je nachdem welchen
                Browser Sie verwenden, funktioniert dies auf unterschiedliche Art und Weise.
                Unter dem Abschnitt „Cookies“ finden Sie die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wir bieten also zur Abwicklung von vertraglichen bzw. rechtlichen
                Beziehungen{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. b DSGVO)</strong>
                <strong className="adsimple-112958647 text-[#787c87]">&nbsp;</strong>neben den
                herkömmlichen Bank-/Kreditinstitutionen auch den Zahlungsdienstleister
                Klarna Checkout an.
            </p>
            <p>
                Wir hoffen Ihnen einen guten Überblick über die Datenverarbeitung durch
                Klarna geboten zu haben. Wenn Sie mehr über den Umgang mit Ihren Daten
                erfahren wollen, empfehlen wir Ihnen die Klarna-Datenschutzerklärung unter{" "}
                <a
                className="adsimple-112958647"
                href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/de_at/privacy?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                https://cdn.klarna.com/1.0/shared/content/legal/terms/0/de_at/privacy
                </a>
                .
            </p>
            <p>&nbsp;</p>
            <h2 id="paypal-datenschutzerklaerung" className="adsimple-112958647">
                PayPal Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        PayPal Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung des Zahlungsvorgangs auf unserer Website
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Name, Adresse, Bankdaten
                    (Kontonummer, Kreditkartennummer, Passwörter, TANs usw.), IP-Adresse
                    und Vertragsdaten können verarbeitet werden.
                    <br />
                    Mehr Details dazu finden Sie weiter unter in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: Daten werden grundsätzlich gespeichert, bis die
                    Zusammenarbeit mit PayPal aufgelöst wird
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. b DSGVO (Vertragsabwicklung),
                    Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist PayPal?</h3>
            <p>
                Wir nutzen auf unserer Website den Online-Bezahldienst PayPal.
                Dienstanbieter ist das amerikanische Unternehmen PayPal Inc. Für den
                europäischen Raum ist das Unternehmen PayPal Europe (S.à r.l. et Cie,
                S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg) verantwortlich.
            </p>
            <p>
                Mit PayPal können alle Benutzer Geld auf elektronischen Weg senden und auch
                empfangen. Gegründet wurde das Unternehmen 1998 und mittlerweile zählt es
                mit über 325 Millionen aktiven Kunden zu den bekanntesten und größten
                Online-Zahlungsdienstleistern weltweit.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir PayPal für unsere Website?
            </h3>
            <p>
                Es gibt verschiedene Gründe, warum wir PayPal nutzen und auf unserer Website
                anbieten. Da PayPal zu den bekanntesten Online-Zahlungsanbietern zählt,
                nutzen und vertrauen auch viele unserer Websitebesucher diesem Dienst.
                PayPal bietet auch hohe Sicherheitsstandards für digitale Geldtransfers. Der
                Service nutzt verschiedene Verschlüsselungsmethoden, um Ihre
                personenbezogenen Daten bestmöglich zu schützen. Wir schätzen auch die
                einfache Bedienbarkeit von PayPal und die Möglichkeit der internationalen
                Zahlungen in verschiedenen Währungen. In der Regel gehen die Transaktionen
                sehr schnell über die Bühne, was sowohl für uns als auch für Sie als Kunden
                ein weiterer Vorteil ist.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von PayPal verarbeitet?
            </h3>
            <p>
                PayPal unterscheidet in ihrer Datenschutzerklärung verschiedene Kategorien
                personenbezogener Daten, die durch die Nutzung des Dienstes verarbeitet
                werden können. Dazu zählen Anmelde- und Kontaktdaten, Identifizierungs- und
                Unterschriftsdaten, Zahlungsinformationen, Informationen zu importierten
                Kontakten, Daten aus Ihrem Kontoprofil, Gerätedaten wie etwa Ihre
                IP-Adresse, Standortdaten und sogenannte abgeleitete Daten. Darunter werden
                Informationen verstanden, die durch Transaktionen oder andere Daten
                abgeleitet werden können. Das können etwa Kaufgewohnheiten,
                Verhaltensmuster, Kreditwürdigkeit oder persönliche Vorlieben sein.
            </p>
            <p>
                Dann gibt es auch noch personenbezogene Daten, die von Dritten (wie
                Identitätsprüfern, Betrugserkennungsanbieter oder Ihre Bank) erhoben werden.
                Zu diesen Daten zählen Informationen von Auskunfteien, Transaktionsdaten,
                Informationen zu den gesetzlichen Vorschriften, technische Nutzungsdaten,
                Standortdaten und auch wieder abgeleitete Daten.
            </p>
            <p>
                PayPal und auch deren Partner verwenden auch Trackingtechnologien wie
                Cookies, Pixel-Tags, Web-Beacons und Widgets, um Sie als Benutzer zu
                erkennen, Inhalte anzupassen und um Analysen für interessensbezogene Werbung
                durchzuführen.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich speichert PayPal die Daten so lange, wie es zur Erfüllung
                ihrer Pflichten und im Rahmen des Zwecks notwendig ist. Personenbezogene
                Daten, die für die Kundenbeziehung notwendig sind, werden bis 10 Jahre nach
                Beendigung der Beziehung aufbewahrt. Wenn PayPal einer rechtlichen
                Verpflichtung unterliegt, beträgt die Aufbewahrungsdauer der
                personenbezogenen Daten dem jeweils geltenden Recht (z.B. Insolvenzrecht).
                PayPal speichert personenbezogene Daten auch dann so lange wie nötig, wenn
                die Aufbewahrung in Hinblick auf Rechtsstreitigkeiten empfehlenswert ist.
            </p>
            <p>
                Da PayPal ein global agierendes Unternehmen ist, hat der Dienst auch
                weltweit Rechenzentren, in denen Ihre Daten gespeichert werden können. Das
                heißt, Ihre Daten können auch außerhalb Ihres Landes und auch außerhalb des
                Geltungsbereiches der DSGVO auf PayPal-Servern gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Sie können
                zudem auch jederzeit die Einwilligung zur Verarbeitung der Daten widerrufen.
            </p>
            <p>
                Falls Sie grundsätzlich Cookies deaktivieren, löschen oder verwalten wollen,
                finden Sie unter dem Abschnitt „Cookies“ die entsprechenden Links zu den
                jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Es besteht von unserer Seite ein berechtigtes Interesse daran, mit PayPal
                einen externen Zahlungsdienst einzubinden und so unser Angebot attraktiver
                zu machen und technisch und wirtschaftlich zu verbessern.&nbsp; Die
                Rechtsgrundlage dafür ist Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                Interessen). Wir weisen darauf hin, dass Sie PayPal nur nutzen können, wenn
                Sie ein Vertragsverhältnis mit PayPal eingehen. Hier kann es notwendig
                werden, weitere datenschutzrechtliche und vertragliche Erklärungen (z.B.
                eine Einwilligung) abzugeben.
            </p>
            <p>
                PayPal verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet PayPal
                sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich PayPal, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln und über die Daten, die
                durch die Verwendung von PayPal verarbeitet werden, erfahren Sie in der
                Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.paypal.com/webapps/mpp/ua/privacy-full?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.paypal.com/webapps/mpp/ua/privacy-full
                </a>
                .
            </p>
            <h2 id="shop-pay-datenschutzerklaerung" className="adsimple-112958647">
                Shop Pay Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auf unserer Website Shop Pay, einen Dienst für
                Online-Zahlungslösungen. Dienstanbieter ist das amerikanische Unternehmen
                Shopify Inc. Für den europäischen Raum ist das Unternehmen Shopify
                International Limited (Victoria Buildings, 2. Etage, 1-2 Haddington Road,
                Dublin 4, D04 XN32, Irland) verantwortlich.
            </p>
            <p>
                Wir weisen darauf hin, dass nach Meinung des Europäischen Gerichtshofs
                derzeit kein angemessenes Schutzniveau für den Datentransfer in die USA
                besteht. Die Datenverarbeitung geschieht im Wesentlichen durch Shop Pay.
                Dies kann dazu führen, dass gegebenenfalls Daten nicht anonymisiert
                verarbeitet und gespeichert werden. Ferner können gegebenenfalls
                US-amerikanische staatliche Behörden Zugriff auf einzelne Daten nehmen. Es
                kann ferner vorkommen, dass diese Daten mit Daten aus möglichen anderen
                Diensten von Shop Pay, bei denen Sie ein Nutzerkonto haben, verknüpft
                werden.
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Shop Pay verarbeitet
                werden, erfahren Sie in der Privacy Policy auf
                <u>
                <a
                    className="adsimple-112958647"
                    href="https://www.shopify.de/legal/datenschutz"
                >
                    https://www.shopify.de/legal/datenschutz
                </a>
                .
                </u>
            </p>
            <h2 id="visa-datenschutzerklaerung" className="adsimple-112958647">
                Visa Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auf unserer Website Visa, einen weltweit agierenden
                Zahlungsanbieter. Dienstanbieter ist das amerikanische Unternehmen Visa Inc.
                Für den europäischen Raum ist das Unternehmen Visa Europe Services Inc. (1
                Sheldon Square, London W2 6TT, Großbritannien) zuständig.
            </p>
            <p>
                Visa verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Visa
                sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich Visa, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Visa finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.visa.de/nutzungsbedingungen/visa-globale-datenschutzmitteilung/mitteilung-zu-zustandigkeitsfragen-fur-den-ewr.html"
                target="_blank"
                rel="follow noopener"
                >
                https://www.visa.de/nutzungsbedingungen/visa-globale-datenschutzmitteilung/mitteilung-zu-zustandigkeitsfragen-fur-den-ewr.html
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Visa verarbeitet werden,
                erfahren Sie in der Privacy Policy auf{" "}
                <u>
                <a
                    className="adsimple-112958647"
                    href="https://www.visa.de/nutzungsbedingungen/visa-privacy-center.html"
                >
                    https://www.visa.de/nutzungsbedingungen/visa-privacy-center.html
                </a>
                .
                </u>
            </p>
            <h2 id="externe-onlineplattformen-einleitung" className="adsimple-112958647">
                Externe Onlineplattformen Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Externe Onlineplattformen Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website bzw. Besucher der externen
                    Onlineplattformen
                    <br />
                    🤝 Zweck: Darstellung und Optimierung unserer Serviceleistung, Kontakt
                    zu Besuchern, Interessenten
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Telefonnummern, E-Mail-Adressen,
                    Kontaktdaten, Daten zum Nutzerverhalten, Informationen zu Ihrem Gerät
                    und Ihre IP-Adresse.
                    <br />
                    Mehr Details dazu finden Sie bei der jeweils eingesetzten Plattform.
                    <br />
                    📅 Speicherdauer: abhängig von den verwendeten Plattformen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind externe Onlineplattformen?</h3>
            <p>
                Um unsere Leistungen oder Produkte auch außerhalb unserer Website anbieten
                zu können, nutzen wir auch externe Plattformen. Dabei handelt es sich meist
                um Online-Marktplätze wie etwa Amazon oder eBay. Neben unserer
                Verantwortlichkeit des Datenschutzes gelten auch die Datenschutzbestimmungen
                der von uns verwendeten externen Plattformen. Dies ist speziell dann der
                Fall, wenn über die Plattform unsere Produkte erworben werden. Also wenn es
                einen Zahlungsvorgang gibt. Weiters nützen die meisten Plattformen Ihre
                Daten auch, um die eigenen Marketingmaßnahmen zu optimieren. Beispielsweise
                kann die Plattform, mit Hilfe erhobener Daten, Werbeanzeigen genau an die
                Interessen der Kunden und Websitebesucher zuschneiden.
            </p>
            <h3 className="adsimple-112958647">
                Warum nutzen wir externe Onlineplattformen?
            </h3>
            <p>
                Neben unserer Website wollen wir unser Angebot auch auf anderen Plattformen
                anbieten, um mehr Kunden unser Angebot näher zu bringen. Externe
                Online-Marktplätze wie etwa Amazon, Ebay oder auch Digistore24 bieten große
                Verkaufswebsites, die unsere Produkte Menschen anbieten, die unter Umständen
                nicht unsere Website kennen. Es kann auch vorkommen, dass eingebaute
                Elemente auf unserer Seite zu einer externen Onlineplattform leiten. Daten,
                die von der verwendeten Onlineplattform verarbeitet und gespeichert werden,
                dienen dem Unternehmen einerseits den Zahlungsvorgang zu protokollieren,
                andererseits aber auch um Webanalysen durchführen zu können.
            </p>
            <p>
                Ziel dieser Analysen ist es, genauere und personenbezogene Marketing- und
                Werbestrategien entwickeln zu können. Abhängig von Ihrem Verhalten auf einer
                Plattform, können mit Hilfe der ausgewerteten Daten, passende Rückschlüsse
                auf Ihre Interessen getroffen werden und sogenannte Userprofile erstellt
                werden. So ist es den Plattformen auch möglich, Ihnen maßgeschneiderte
                Werbeanzeigen bzw. Produkte zu präsentieren. Meistens werden für diesen
                Zweck Cookies in Ihrem Browser gesetzt, die Daten zu Ihrem Nutzungsverhalten
                speichern.
            </p>
            <p>
                Bitte beachten Sie, dass bei der Nutzung der Plattformen oder unserer
                eingebauten Elemente auch Daten von Ihnen außerhalb der Europäischen Union
                verarbeitet werden können, da Onlineplattformen, beispielsweise Amazon oder
                eBay, amerikanische Unternehmen sind. Dadurch können Sie möglicherweise Ihre
                Rechte in Bezug auf Ihre personenbezogenen Daten nicht mehr so leicht
                einfordern bzw. durchsetzen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Welche Daten genau gespeichert und verarbeitet werden, hängt von der
                jeweiligen externen Plattform ab. Aber für gewöhnlich handelt es sich um
                Daten wie etwa Telefonnummern, E-Mailadressen, Daten, die Sie in ein
                Kontaktformular eingeben, Nutzerdaten wie zum Beispiel welche Buttons Sie
                klicken, wann Sie welche Seiten besucht haben, Informationen zu Ihrem Gerät
                und Ihre IP-Adresse. Sehr häufig werden die meisten dieser Daten in Cookies
                gespeichert. Wenn Sie bei einer externen Plattform ein eigenes Profil haben
                und dort auch angemeldet sind, können Daten mit dem Profil verknüpft werden.
                Die erhobenen Daten werden auf den Servern der verwendeten Plattformen
                gespeichert und dort verarbeitet. Wie eine externe Plattform Daten genau
                speichert, verwaltet und verarbeitet, erfahren Sie in der jeweiligen
                Datenschutzerklärung. Falls Sie zur Datenspeicherung und Datenverarbeitung
                Fragen haben oder entsprechende Rechte geltend machen wollen, empfehlen wir
                Ihnen, sich direkt an die Plattform zu wenden.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Beispielsweise speichert Amazon
                Daten, bis sie für den eigenen Zweck nicht mehr benötigt werden. Generell
                verarbeiten wir personenbezogene Daten nur so lange wie es für die
                Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig
                ist.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies zu widerrufen. Das funktioniert entweder über unser
                Cookie-Management-Tool oder über Opt-Out-Funktionen bei der jeweiligen
                externen Plattform. Weiters können Sie auch die Datenerfassung durch Cookies
                verhindern, indem Sie in Ihrem Browser die Cookies verwalten, deaktivieren
                oder löschen.
            </p>
            <p>
                Da Cookies zum Einsatz kommen können, empfehlen wir Ihnen auch unsere
                allgemeine Datenschutzerklärung über Cookies. Um zu erfahren, welche Daten
                von Ihnen genau gespeichert und verarbeitet werden, sollten Sie die
                Datenschutzerklärungen der jeweiligen externen Plattformen durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch externe Plattformen
                verarbeitet und gespeichert werden können, gilt diese{" "}
                <strong className="adsimple-112958647 text-[#787c87]">Einwilligung</strong> als
                Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten bei Vorliegen einer Einwilligung auch auf
                Grundlage eines{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO)
                </strong>{" "}
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Falls wir eingebundene
                Elemente externer Plattformen auf unser Website haben, setzen wir diese
                gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben.
            </p>
            <p>
                Informationen zu speziellen externen Plattformen erfahren Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h2 id="shopify-datenschutzerklaerung" className="adsimple-112958647">
                shopify Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen den Online-Marktplatz shopify. Dienstanbieter ist das
                amerikanische Unternehmen Shopify International Limited, Victoria Buildings,
                2. Etage, 1-2 Haddington Road, Dublin 4, D04 XN32, Irland.
            </p>
            <p>
                shopify verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                shopify sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich shopify, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln und über die Daten, die
                durch die Verwendung von shopify verarbeitet werden, erfahren Sie in der
                Privacy Policy auf
                <a
                className="adsimple-112958647"
                href="https://www.shopify.de/legal/datenschutz"
                >
                {" "}
                https://www.shopify.de/legal/datenschutz
                </a>{" "}
                bzw.{" "}
                <a
                className="adsimple-112958647"
                href="https://help.shopify.com/en/manual/your-account/privacy/GDPR/gdpr-faq#will-shopify-sign-standard-contractual-clauses"
                target="_blank"
                rel="follow noopener"
                >
                https://help.shopify.com/en/manual/your-account/privacy/GDPR/gdpr-faq#will-shopify-sign-standard-contractual-clauses
                </a>
                .
            </p>
            <h2 id="audio-video-einleitung" className="adsimple-112958647">
                Audio &amp; Video Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Audio &amp; Video Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Kontaktdaten, Daten zum
                    Nutzerverhalten, Informationen zu Ihrem Gerät und Ihre IP-Adresse
                    können gespeichert werden.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in den entsprechenden
                    Datenschutztexten.
                    <br />
                    📅 Speicherdauer: Daten bleiben grundsätzlich gespeichert, solange sie
                    für den Dienstzweck nötig sind
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Audio- und Videoelemente?</h3>
            <p>
                Wir haben auf unsere Website Audio- bzw. Videoelemente eingebunden, damit
                Sie sich direkt über unsere Website etwa Videos ansehen oder Musik/Podcasts
                anhören können. Die Inhalte werden von Dienstanbietern zur Verfügung
                gestellt. Alle Inhalte werden also auch von den entsprechenden Servern der
                Anbieter bezogen.
            </p>
            <p>
                Es handelt sich dabei um eingebundene Funktionselemente von Plattformen wie
                etwa YouTube, Vimeo oder Spotify. Die Nutzung dieser Portale ist in der
                Regel kostenlos, es können aber auch kostenpflichtige Inhalte veröffentlicht
                werden. Mit Hilfe dieser eingebundenen Elemente könne Sie sich über unsere
                Website die jeweiligen Inhalte anhören oder ansehen.
            </p>
            <p>
                Wenn Sie Audio- oder Videoelemente auf unsere Website verwenden, können auch
                personenbezogene Daten von Ihnen an die Dienstanbieter übermittelt,
                verarbeitet und gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Audio- &amp; Videoelemente auf unserer Website?
            </h3>
            <p>
                Natürlich wollen wir Ihnen auf unserer Website das beste Angebot liefern.
                Und uns ist bewusst, dass Inhalte nicht mehr bloß in Text und statischem
                Bild vermittelt werden. Statt Ihnen einfach nur einen Link zu einem Video zu
                geben, bieten wir Ihnen direkt auf unserer Website Audio- und Videoformate,
                die unterhaltend oder informativ und im Idealfall sogar beides sind. Das
                erweitert unser Service und erleichtert Ihnen den Zugang zu interessanten
                Inhalten. Somit bieten wir neben unseren Texten und Bildern auch Video
                und/oder Audio-Inhalte an.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch Audio- &amp; Videoelemente gespeichert?
            </h3>
            <p>
                Wenn Sie eine Seite auf unserer Website aufrufen, die beispielsweise ein
                eingebettetes Video hat, verbindet sich Ihr Server mit dem Server des
                Dienstanbieters. Dabei werden auch Daten von Ihnen an den Drittanbieter
                übertragen und dort gespeichert. Manche Daten werden ganz unabhängig davon,
                ob Sie bei dem Drittanbieter ein Konto haben oder nicht, gesammelt und
                gespeichert. Dazu zählen meist Ihre IP-Adresse, Browsertyp, Betriebssystem,
                und weitere allgemeine Informationen zu Ihrem Endgerät. Weiters werden von
                den meisten Anbietern auch Informationen über Ihre Webaktivität eingeholt.
                Dazu zählen etwa Sitzungsdauer, Absprungrate, auf welchen Button Sie
                geklickt haben oder über welche Website Sie den Dienst nutzen. All diese
                Informationen werden meist über Cookies oder Pixel-Tags (auch Web Beacon
                genannt) gespeichert. Pseudonymisierte Daten werden meist in Cookies in
                Ihrem Browser gespeichert. Welche Daten genau gespeichert und verarbeitet
                werden, erfahren Sie stets in der Datenschutzerklärung des jeweiligen
                Anbieters.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Wie lange die Daten auf den Servern der Drittanbieter genau gespeichert
                werden, erfahren Sie entweder weiter unten im Datenschutztext des jeweiligen
                Tools oder in der Datenschutzerklärung des Anbieters. Grundsätzlich werden
                personenbezogene Daten immer nur so lange verarbeitet, wie es für die
                Bereitstellung unserer Dienstleistungen oder Produkte unbedingt nötig wird.
                Dies gilt in der Regel auch für Drittanbieter. Meist können Sie davon
                ausgehen, dass gewisse Daten über mehrere Jahre auf den Servern der
                Drittanbieter gespeichert werden. Daten können speziell in Cookies
                unterschiedlich lange gespeichert werden. Manche Cookies werden bereits nach
                dem Verlassen der Website wieder gelöscht, anderen können über einige Jahre
                in Ihrem Browser gespeichert sein.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert
                entweder über unser Cookie-Management-Tool oder über andere
                Opt-Out-Funktionen. Zum Beispiel können Sie auch die Datenerfassung durch
                Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
                deaktivieren oder löschen. Die Rechtmäßigkeit der Verarbeitung bis zum
                Widerruf bleibt unberührt.
            </p>
            <p>
                Da durch die eingebundenen Audio- und Video-Funktionen auf unserer Seite
                meist auch Cookies verwendet werden, sollte Sie sich auch unsere allgemeine
                Datenschutzerklärung über Cookies durchlesen. In den Datenschutzerklärungen
                der jeweiligen Drittanbieter erfahren Sie genaueres über den Umgang und die
                Speicherung Ihrer Daten.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene Audio-
                und Video-Elemente verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die eingebundenen
                Audio- und Video-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <h2 id="vimeo-datenschutzerklaerung" className="adsimple-112958647">
                Vimeo Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Vimeo Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Kontaktdaten, Daten zum
                    Nutzerverhalten, Informationen zu Ihrem Gerät und Ihre IP-Adresse
                    können gespeichert werden.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: Daten bleiben grundsätzlich gespeichert, solange sie
                    für den Dienstzweck nötig sind
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Vimeo?</h3>
            <p>
                Wir verwenden auf unserer Website auch Videos der Firma Vimeo. Betrieben
                wird das Videoportal durch Vimeo LLC, 555 West 18th Street, New York, New
                York 10011, USA. Mit Hilfe eines Plug-ins können wir Ihnen so interessantes
                Videomaterial direkt auf unserer Website anzeigen. Dabei können gewissen
                Daten von Ihnen an Vimeo übertragen werden. In dieser Datenschutzerklärung
                zeigen wir Ihnen, um welche Daten es sich handelt, warum wir Vimeo verwenden
                und wie Sie Ihre Daten bzw. die Datenübertragung verwalten oder unterbinden
                können.
            </p>
            <p>
                Vimeo ist eine Videoplattform, die 2004 gegründet wurde und seit 2007 das
                Streamen von Videos in HD-Qualität ermöglicht. Seit 2015 kann auch in 4k
                Ultra HD gestreamt werden. Die Nutzung des Portals ist kostenlos, es kann
                allerdings auch kostenpflichtiger Content veröffentlicht werden. Im
                Vergleich zum Marktführer YouTube, legt Vimeo vorrangig Wert auf
                hochwertigen Content in guter Qualität. So bietet das Portal einerseits
                viele künstlerische Inhalte wie Musikvideos und Kurzfilme, andererseits aber
                auch wissenswerte Dokumentationen zu den unterschiedlichsten Themen.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Vimeo auf unserer Website?
            </h3>
            <p>
                Ziel unserer Webpräsenz ist es, Ihnen den bestmöglichen Content zu liefern.
                Und zwar so einfach zugänglich wie möglich. Erst wenn wir das geschafft
                haben, sind wir mit unserem Service zufrieden. Der Videodienst Vimeo
                unterstützt uns dieses Ziel zu erreichen. Vimeo bietet uns die Möglichkeit,
                Ihnen qualitativ hochwertige Inhalte direkt auf unserer Website zu
                präsentieren. Statt Ihnen nur einen Link zu einem interessanten Video zu
                geben, können Sie so das Video gleich bei uns ansehen. Das erweitert unser
                Service und erleichtert Ihnen den Zugang zu interessanten Inhalten. Somit
                bieten wir neben unseren Texten und Bildern auch Video-Content an.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden auf Vimeo gespeichert?
            </h3>
            <p>
                Wenn Sie auf unserer Website eine Seite aufrufen, die ein Vimeo-Video
                eingebettet hat, verbindet sich Ihr Browser mit den Servern von Vimeo. Dabei
                kommt es zu einer Datenübertragung. Diese Daten werden auf den Vimeo-Servern
                gesammelt, gespeichert und verarbeitet. Unabhängig davon, ob Sie ein
                Vimeo-Konto haben oder nicht, sammelt Vimeo Daten über Sie. Dazu zählen Ihre
                IP-Adresse, technische Infos über Ihren Browsertyp, Ihr Betriebssystem oder
                ganz grundlegende Geräteinformationen. Weiters speichert Vimeo Informationen
                über welche Webseite Sie den Vimeo-Dienst nutzen und welche Handlungen
                (Webaktivitäten) Sie auf unserer Webseite ausführen. Zu diesen
                Webaktivitäten zählen beispielsweise Sitzungsdauer, Absprungrate oder auf
                welchen Button Sie auf unserer Webseite mit eingebauter Vimeo-Funktion
                geklickt haben. Diese Handlungen kann Vimeo mit Hilfe von Cookies und
                ähnlichen Technologien verfolgen und speichern.
            </p>
            <p>
                Falls Sie als registriertes Mitglied bei Vimeo eingeloggt sind, können
                meistens mehr Daten erhoben werden, da möglicherweise mehr Cookies bereits
                in Ihrem Browser gesetzt wurden. Zudem werden Ihre Handlungen auf unsere
                Webseite direkt mit Ihrem Vimeo-Account verknüpft. Um dies zu verhindern
                müssen Sie sich, während des “Surfens” auf unserer Webseite, von Vimeo
                ausloggen.
            </p>
            <p>
                Nachfolgend zeigen wir Ihnen Cookies, die von Vimeo gesetzt werden, wenn Sie
                auf einer Webseite mit integrierter Vimeo-Funktion, sind. Diese Liste erhebt
                keinen Anspruch auf Vollständigkeit und geht davon aus, dass Sie keinen
                Vimeo-Account haben.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong>&nbsp;player
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>&nbsp;“”
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie speichert Ihre Einstellungen, bevor Sie ein eingebettetes Vimeo-Video
                abspielen. Dadurch bekommen Sie beim nächsten Mal, wenn Sie ein Vimeo-Video
                ansehen, wieder Ihre bevorzugten Einstellungen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach einem
                Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name</strong>:&nbsp;vuid
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:&nbsp;</strong>
                pl1046149876.614422590112958647-4
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:&nbsp;</strong>
                </strong>
                Dieses Cookie sammelt Informationen über Ihre Handlungen auf Webseiten, die
                ein Vimeo-Video eingebettet haben.
                <strong className="adsimple-112958647 text-[#787c87]">
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:&nbsp;</strong>
                </strong>
                nach 2 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung:</strong> Diese beiden
                Cookies werden immer gesetzt, sobald Sie sich auf einer Webseite mit einem
                eingebetteten Vimeo-Video befinden. Wenn Sie das Video ansehen und auf die
                Schaltfläche klicken, um beispielsweise das Video zu “teilen” oder zu
                “liken”, werden weitere Cookies gesetzt. Dabei handelt es sich auch um
                Drittanbieter-Cookies wie&nbsp; _ga oder _gat_UA-76641-8 von Google
                Analytics oder _fbp von Facebook. Welche Cookies hier genau gesetzt werden,
                hängt von Ihrer Interaktion mit dem Video ab.
            </p>
            <p>
                Die folgende Liste zeigt einen Ausschnitt möglicher Cookies, die gesetzt
                werden, wenn Sie mit dem Vimeo-Video interagieren:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _abexps
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> %5B%5D
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:&nbsp;</strong>
                Dieses Vimeo-Cookie hilft Vimeo, sich an die von Ihnen getroffenen
                Einstellungen zu erinnern. Dabei kann es sich zum Beispiel um eine
                voreingestellte Sprache, um eine Region oder einen Benutzernamen handeln. Im
                Allgemeinen speichert das Cookie Daten darüber, wie Sie Vimeo verwenden.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> continuous_play_v3
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> 1<br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:&nbsp;</strong>Bei
                diesem Cookie handelt es sich um ein Erstanbieter-Cookie von Vimeo. Das
                Cookie sammelt Informationen wie Sie das Vimeo-Service verwenden.
                Beispielsweise speichert das Cookie, wann Sie ein Video pausieren bzw.
                wieder abspielen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem Jahr
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _ga
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                GA1.2.1522249635.1578401280112958647-7
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:&nbsp;</strong>
                Dieses Cookie ist ein Drittanbieter-Cookie von Google. Standardmäßig
                verwendet analytics.js das Cookie _ga, um die User-ID zu speichern.
                Grundsätzlich dient es zur Unterscheidung der Websitebesucher.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 2 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _gcl_au
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                1.1.770887836.1578401279112958647-3
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck: </strong>Dieses
                Drittanbieter-Cookie von Google AdSense wird verwendet, um die Effizienz von
                Werbeanzeigen auf Websites zu verbessern.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 3
                Monaten
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> _fbp
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                fb.1.1578401280585.310434968
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Das ist
                ein Facebook-Cookie. Dieses Cookie wird verwendet, um Werbeanzeigen bzw.
                Werbeprodukte von Facebook oder anderen Werbetreibenden einzublenden.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 3
                Monaten
            </p>
            <p>
                Vimeo nutzt diese Daten unter anderem, um das eigene Service zu verbessern,
                um mit Ihnen in Kommunikation zu treten und um eigene zielgerichtete
                Werbemaßnahmen zu setzen. Vimeo betont auf seiner Website, dass bei
                eingebetteten Videos nur Erstanbieter-Cookies (also Cookies von Vimeo
                selbst) verwendet werden, solange man mit dem Video nicht interagiert.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Vimeo hat den Hauptsitz in White Plains im Bundesstaat New York (USA). Die
                Dienste werden aber weltweit angeboten. Dabei verwendet das Unternehmen
                Computersysteme, Datenbanken und Server in den USA und auch in anderen
                Ländern. Ihre Daten können somit auch auf Servern in Amerika gespeichert und
                verarbeitet werden. Die Daten bleiben bei Vimeo so lange gespeichert, bis
                das Unternehmen keinen wirtschaftlichen Grund mehr für die Speicherung hat.
                Dann werden die Daten gelöscht oder anonymisiert.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Sie haben immer die Möglichkeit, Cookies in Ihrem Browser nach Ihren
                Wünschen zu verwalten. Wenn Sie beispielsweise nicht wollen, dass Vimeo
                Cookies setzt und so Informationen über Sie sammelt, können Sie in Ihren
                Browser-Einstellungen Cookies jederzeit löschen oder deaktivieren. Je nach
                Browser funktioniert dies ein bisschen anders. Bitte beachten Sie, dass
                möglicherweise nach dem Deaktivieren/Löschen von Cookies diverse Funktionen
                nicht mehr im vollen Ausmaß zur Verfügung stehen. Unter dem Abschnitt
                „Cookies“ finden Sie die entsprechenden Links zu den jeweiligen Anleitungen
                der bekanntesten Browser.
            </p>
            <p>
                Falls Sie ein registriertes Vimeo-Mitglied sind, können Sie auch in den
                Einstellungen bei Vimeo die verwendeten Cookies verwalten.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
                Vimeo-Elemente verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die eingebundenen
                Vimeo-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung erteilt
                haben. Vimeo setzt auch Cookies in Ihrem Browser, um Daten zu speichern.
                Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies genau
                durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien des
                jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                Vimeo verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Vimeo
                sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
                Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
                EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass
                Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn
                diese in Drittländer (wie beispielsweise in die USA) überliefert und dort
                gespeichert werden. Durch diese Klauseln verpflichtet sich Vimeo, bei der
                Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss und die entsprechenden
                Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Vimeo finden Sie
                unter{" "}
                <a
                className="adsimple-112958647"
                href="https://vimeo.com/privacy#international_data_transfers_and_certain_user_rights"
                target="_blank"
                rel="follow noopener"
                >
                https://vimeo.com/privacy#international_data_transfers_and_certain_user_rights
                </a>
                .
            </p>
            <p>
                Mehr über den Einsatz von Cookies bei Vimeo erfahren Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://vimeo.com/cookie_policy?tid=112958647"
                target="_blank"
                rel="follow noopener noreferrer"
                >
                https://vimeo.com/cookie_policy
                </a>
                , Informationen zum Datenschutz bei Vimeo können Sie auf&nbsp;
                <a
                className="adsimple-112958647"
                href="https://vimeo.com/privacy?tid=112958647"
                target="_blank"
                rel="follow noopener noreferrer"
                >
                https://vimeo.com/privacy
                </a>
                &nbsp;nachlesen.
            </p>
            <h2 id="youtube-datenschutzerklaerung" className="adsimple-112958647">
                YouTube Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        YouTube Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Kontaktdaten, Daten zum
                    Nutzerverhalten, Informationen zu Ihrem Gerät und Ihre IP-Adresse
                    können gespeichert werden.
                    <br />
                    Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: Daten bleiben grundsätzlich gespeichert, solange sie
                    für den Dienstzweck nötig sind
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist YouTube?</h3>
            <p>
                Wir haben auf unserer Website YouTube-Videos eingebaut. So können wir Ihnen
                interessante Videos direkt auf unserer Seite präsentieren. YouTube ist ein
                Videoportal, das seit 2006 eine Tochterfirma von Google ist. Betrieben wird
                das Videoportal durch YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066,
                USA. Wenn Sie auf unserer Website eine Seite aufrufen, die ein YouTube-Video
                eingebettet hat, verbindet sich Ihr Browser automatisch mit den Servern von
                YouTube bzw. Google. Dabei werden (je nach Einstellungen) verschiedene Daten
                übertragen. Für die gesamte Datenverarbeitung im europäischen Raum ist
                Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland)
                verantwortlich.
            </p>
            <p>
                Im Folgenden wollen wir Ihnen genauer erklären, welche Daten verarbeitet
                werden, warum wir YouTube-Videos eingebunden haben und wie Sie Ihre Daten
                verwalten oder löschen können.
            </p>
            <p>
                Auf YouTube können die User kostenlos Videos ansehen, bewerten, kommentieren
                und selbst hochladen. Über die letzten Jahre wurde YouTube zu einem der
                wichtigsten Social-Media-Kanäle weltweit. Damit wir Videos auf unserer
                Webseite anzeigen können, stellt YouTube einen Codeausschnitt zur Verfügung,
                den wir auf unserer Seite eingebaut haben.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir YouTube-Videos auf unserer Website?
            </h3>
            <p>
                YouTube ist die Videoplattform mit den meisten Besuchern und dem besten
                Content. Wir sind bemüht, Ihnen die bestmögliche User-Erfahrung auf unserer
                Webseite zu bieten. Und natürlich dürfen interessante Videos dabei nicht
                fehlen. Mithilfe unserer eingebetteten Videos stellen wir Ihnen neben
                unseren Texten und Bildern weiteren hilfreichen Content zur Verfügung. Zudem
                wird unsere Webseite auf der Google-Suchmaschine durch die eingebetteten
                Videos leichter gefunden. Auch wenn wir über Google Ads Werbeanzeigen
                schalten, kann Google – dank der gesammelten Daten – diese Anzeigen wirklich
                nur Menschen zeigen, die sich für unsere Angebote interessieren.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von YouTube gespeichert?
            </h3>
            <p>
                Sobald Sie eine unserer Seiten besuchen, die ein YouTube-Video eingebaut
                hat, setzt YouTube zumindest ein Cookie, das Ihre IP-Adresse und unsere URL
                speichert. Wenn Sie in Ihrem YouTube-Konto eingeloggt sind, kann YouTube
                Ihre Interaktionen auf unserer Webseite meist mithilfe von Cookies Ihrem
                Profil zuordnen. Dazu zählen Daten wie Sitzungsdauer, Absprungrate,
                ungefährer Standort, technische Informationen wie Browsertyp,
                Bildschirmauflösung oder Ihr Internetanbieter. Weitere Daten können
                Kontaktdaten, etwaige Bewertungen, das Teilen von Inhalten über Social Media
                oder das Hinzufügen zu Ihren Favoriten auf YouTube sein.
            </p>
            <p>
                Wenn Sie nicht in einem Google-Konto oder einem Youtube-Konto angemeldet
                sind, speichert Google Daten mit einer eindeutigen Kennung, die mit Ihrem
                Gerät, Browser oder App verknüpft sind. So bleibt beispielsweise Ihre
                bevorzugte Spracheinstellung beibehalten. Aber viele Interaktionsdaten
                können nicht gespeichert werden, da weniger Cookies gesetzt werden.
            </p>
            <p>
                In der folgenden Liste zeigen wir Cookies, die in einem Test im Browser
                gesetzt wurden. Wir zeigen einerseits Cookies, die ohne angemeldetes
                YouTube-Konto gesetzt werden. Andererseits zeigen wir Cookies, die mit
                angemeldetem Account gesetzt werden. Die Liste kann keinen
                Vollständigkeitsanspruch erheben, weil die Userdaten immer von den
                Interaktionen auf YouTube abhängen.
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> YSC
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> b9-CV6ojI5Y112958647-1
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie registriert eine eindeutige ID, um Statistiken des gesehenen Videos
                zu speichern.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach
                Sitzungsende
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> PREF
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> f1=50000000
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie registriert ebenfalls Ihre eindeutige ID. Google bekommt über PREF
                Statistiken, wie Sie YouTube-Videos auf unserer Webseite verwenden.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 8 Monaten
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> GPS
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> 1<br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie registriert Ihre eindeutige ID auf mobilen Geräten, um den
                GPS-Standort zu tracken.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 30
                Minuten
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> VISITOR_INFO1_LIVE
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> 95Chz8bagyU
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie versucht die Bandbreite des Users auf unseren Webseiten (mit
                eingebautem YouTube-Video) zu schätzen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 8
                Monaten
            </p>
            <p>
                Weitere Cookies, die gesetzt werden, wenn Sie mit Ihrem YouTube-Konto
                angemeldet sind:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> APISID
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                zILlvClZSkqGsSwI/AU1aZI6HY7112958647-
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie wird verwendet, um ein Profil über Ihre Interessen zu erstellen.
                Genützt werden die Daten für personalisierte Werbeanzeigen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 2 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> CONSENT
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                YES+AT.de+20150628-20-0
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Das Cookie
                speichert den Status der Zustimmung eines Users zur Nutzung
                unterschiedlicher Services von Google. CONSENT dient auch der Sicherheit, um
                User zu überprüfen und Userdaten vor unbefugten Angriffen zu schützen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum: </strong>nach 19 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> HSID
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> AcRwpgUik9Dveht0I
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie wird verwendet, um ein Profil über Ihre Interessen zu erstellen.
                Diese Daten helfen personalisierte Werbung anzeigen zu können.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 2
                Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> LOGIN_INFO
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> AFmmF2swRQIhALl6aL…
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> In diesem
                Cookie werden Informationen über Ihre Login-Daten gespeichert.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 2
                Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> SAPISID
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                7oaPxoG-pZsJuuF5/AnUdDUIsJ9iJz2vdM
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie funktioniert, indem es Ihren Browser und Ihr Gerät eindeutig
                identifiziert. Es wird verwendet, um ein Profil über Ihre Interessen zu
                erstellen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 2
                Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> SID
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> oQfNKjAsI112958647-
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie speichert Ihre Google-Konto-ID und Ihren letzten Anmeldezeitpunkt in
                digital signierter und verschlüsselter Form.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 2
                Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> SIDCC
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> AN0-TYuqub2JOcDTyL
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong> Dieses
                Cookie speichert Informationen, wie Sie die Webseite nutzen und welche
                Werbung Sie vor dem Besuch auf unserer Seite möglicherweise gesehen haben.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong>&nbsp;nach 3
                Monaten
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Die Daten, die YouTube von Ihnen erhält und verarbeitet werden auf den
                Google-Servern gespeichert. Die meisten dieser Server befinden sich in
                Amerika. Unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.google.com/about/datacenters/locations/?hl=de"
                target="_blank"
                rel="follow noopener"
                >
                https://www.google.com/about/datacenters/locations/?hl=de
                </a>{" "}
                sehen Sie genau wo sich die Google-Rechenzentren befinden. Ihre Daten sind
                auf den Servern verteilt. So sind die Daten schneller abrufbar und vor
                Manipulation besser geschützt.
            </p>
            <p>
                Die erhobenen Daten speichert Google unterschiedlich lang. Manche Daten
                können Sie jederzeit löschen, andere werden automatisch nach einer
                begrenzten Zeit gelöscht und wieder andere werden von Google über längere
                Zeit gespeichert. Einige Daten (wie Elemente aus „Meine Aktivität“, Fotos
                oder Dokumente, Produkte), die in Ihrem Google-Konto gespeichert sind,
                bleiben so lange gespeichert, bis Sie sie löschen. Auch wenn Sie nicht in
                einem Google-Konto angemeldet sind, können Sie einige Daten, die mit Ihrem
                Gerät, Browser oder App verknüpft sind, löschen.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Grundsätzlich können Sie Daten im Google Konto manuell löschen. Mit der 2019
                eingeführten automatischen Löschfunktion von Standort- und Aktivitätsdaten
                werden Informationen abhängig von Ihrer Entscheidung – entweder 3 oder 18
                Monate gespeichert und dann gelöscht.
            </p>
            <p>
                Unabhängig, ob Sie ein Google-Konto haben oder nicht, können Sie Ihren
                Browser so konfigurieren, dass Cookies von Google gelöscht bzw. deaktiviert
                werden. Je nachdem welchen Browser Sie verwenden, funktioniert dies auf
                unterschiedliche Art und Weise. Unter dem Abschnitt „Cookies“ finden Sie die
                entsprechenden Links zu den jeweiligen Anleitungen der bekanntesten Browser.
            </p>
            <p>
                Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser
                so einrichten, dass er Sie immer informiert, wenn ein Cookie gesetzt werden
                soll. So können Sie bei jedem einzelnen Cookie entscheiden, ob Sie es
                erlauben oder nicht.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
                YouTube-Elemente verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet. Wir setzen die eingebundenen
                YouTube-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung erteilt
                haben. YouTube setzt auch Cookies in Ihrem Browser, um Daten zu speichern.
                Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies genau
                durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien des
                jeweiligen Dienstanbieters anzusehen.
            </p>
            <p>
                Youtube verarbeitet Daten von Ihnen u.a. auch in den USA. Youtube bzw.
                Google ist aktiver Teilnehmer des EU-US Data Privacy Frameworks, wodurch der
                korrekte und sichere Datentransfer personenbezogener Daten von EU-Bürgern in
                die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
                Terms), welche auf die Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
                .
            </p>
            <p>
                Da YouTube ein Tochterunternehmen von Google ist, gibt es eine gemeinsame
                Datenschutzerklärung. Wenn Sie mehr über den Umgang mit Ihren Daten erfahren
                wollen, empfehlen wir Ihnen die Datenschutzerklärung unter{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de?tid=112958647"
                target="_blank"
                rel="noopener noreferrer"
                >
                https://policies.google.com/privacy?hl=de.
                </a>
            </p>
            <h2
                id="youtube-similar-audiences-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                YouTube Similar Audiences Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auch das Werbetool YouTube Similar Audiences. Dienstanbieter ist
                das amerikanische Unternehmen Google LLC. Für den europäischen Raum ist das
                Unternehmen Google Ireland Limited (Gordon House, Barrow Street, Dublin 4,
                Irland) verantwortlich.
            </p>
            <p>
                YouTube verarbeitet Daten von Ihnen u.a. auch in den USA. YouTube ist
                aktiver Teilnehmer des EU‑US Data Privacy Frameworks, wodurch der korrekte
                und sichere Datentransfer personenbezogener Daten von EU‑Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie unter:
                <br />
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
            </p>
            <p>
                Zudem verwendet YouTube – wie Google – Standardvertragsklauseln (= Art. 46
                Abs. 2 und 3 DSGVO). Diese von der EU‑Kommission bereitgestellten
                Mustervorlagen stellen sicher, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn sie in Drittländer (z. B. in die USA)
                übermittelt und dort gespeichert werden. Durch das EU‑US Data Privacy
                Framework und die Standardvertragsklauseln verpflichtet sich YouTube, bei
                der Verarbeitung Ihrer relevanten Daten das europäische Datenschutzniveau
                einzuhalten, selbst wenn die Daten in den USA gespeichert, verarbeitet und
                verwaltet werden. Den entsprechenden Durchführungsbeschluss und die
                Standardvertragsklauseln finden Sie u.a. hier:
                <br />
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von YouTube Similar Audiences
                verarbeitet werden, erfahren Sie in der Datenschutzerklärung unter{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://policies.google.com/privacy
                </a>
                .
            </p>
            <h2 id="videokonferenzen-streaming-einleitung" className="adsimple-112958647">
                Videokonferenzen &amp; Streaming Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Videokonferenzen &amp; Streaming Datenschutzerklärung
                        Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Nutzer, die unser Videokonferenzen- oder&nbsp;
                    Streaming-Tool verwenden
                    <br />
                    🤝 Zweck: Kommunikation und Präsentation von Inhalten
                    <br />
                    📓 Verarbeitete Daten: Zugriffsstatistiken die Daten wie etwa Name,
                    Adresse, Kontaktdaten, E-Mail-Adresse, Telefonnummer oder Ihre
                    IP-Adresse enthalten. Mehr Details dazu finden Sie beim jeweils
                    eingesetzten Videokonferenz- oder&nbsp; Streaming-Tool.
                    <br />
                    📅 Speicherdauer: abhängig vom eingesetzten Videokonferenzen-
                    oder&nbsp; Streaming-Tool
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen), Art. 6 Abs. 1 lit. b
                    DSGVO (Vertrag)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">
                Was sind Videokonferenzen &amp; Streamings?
            </h3>
            <p>
                Wir verwenden Softwareprogramme, die es uns ermöglichen Videokonferenzen,
                Onlinemeetings, Webinare, Display-Sharing und/oder Streamings abzuhalten.
                Bei einer Videokonferenz oder einem Streaming werden Informationen
                gleichzeitig über Ton und bewegtes Bild übertragen. Mit Hilfe solcher
                Videokonferenz- oder Streaming-Tools können wir mit Kunden,
                Geschäftspartnern, Klienten und auch Mitarbeitern schnell und einfach über
                das Internet kommunizieren. Natürlich achten wir bei der Auswahl des
                Dienstanbieters auf die vorgegebenen gesetzlichen Rahmenbedingungen.
            </p>
            <p>
                Grundsätzlich können Drittanbieter Daten verarbeiten, sobald Sie mit dem
                Softwareprogramm interagieren. Drittanbieter der Videokonferenz bzw.
                Streaming-Lösungen verwenden Ihre Daten und Metadaten für unterschiedliche
                Zwecke. Die Daten helfen etwa, das Tool sicherer zu machen und das Service
                zu verbessern. Meistens dürfen die Daten auch für eigene Marketingzwecke des
                Drittanbieters verwendet werden.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Videokonferenzen &amp; Streaming auf unserer Website?
            </h3>
            <p>
                Wir wollen mit Ihnen, mit unseren Kunden und Geschäftspartnern auch digital
                schnell, unkompliziert und sicher kommunizieren. Das funktioniert am besten
                mit Videokonferenzlösungen, die ganz einfach zu bedienen sind. Die meisten
                Tools funktionieren auch direkt über Ihren Browser und nach nur wenigen
                Klicks sind Sie mittendrin in einem Videomeeting. Die Tools bieten auch
                hilfreiche Zusatz-Features wie etwa eine Chat- und Screensharing-Funktion
                oder die Möglichkeit Inhalte zwischen Meeting-Teilnehmern zu teilen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Wenn Sie an unserer Videokonferenz bzw. an einem Streaming teilnehmen,
                werden auch Daten von Ihnen verarbeitet und auf den Servern des jeweiligen
                Dienstanbieters gespeichert.
            </p>
            <p>
                Welche Daten genau gespeichert werden, hängt von der verwendeten Lösungen
                ab. Jeder Anbieter speichert und verarbeitet unterschiedliche und
                unterschiedlich viele Daten. Doch in der Regel werden bei den meisten
                Anbietern Ihr Name, Ihre Adresse, Kontaktdaten wie zum Beispiel Ihre
                E-Mail-Adresse oder Ihre Telefonnummer und Ihre IP-Adresse gespeichert.
                Weiter können auch Informationen zu Ihrem verwendeten Gerät, Nutzungsdaten
                wie beispielsweise welche Webseiten Sie besuchen, wann Sie eine Webseite
                besuchen oder auf welche Buttons Sie klicken, gespeichert werden. Auch
                Daten, die innerhalb der Videokonferenz geteilt werden (Fotos, Videos,
                Texte), können gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">
                <span
                className="adsimple-112958647"
                data-sheets-value='{"1":2,"2":"Wo und wie lange werden Daten gespeichert?"}'
                data-sheets-userformat='{"2":769,"3":{"1":0},"11":4,"12":0}'
                >
                Dauer der Datenverarbeitung
                </span>
            </h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten im
                Zusammenhang mit dem verwendeten Dienst, sofern wir weitere Informationen
                dazu haben. Generell verarbeiten wir personenbezogene Daten nur so lange wie
                es für die Bereitstellung unserer Dienstleistungen und Produkte unbedingt
                notwendig ist. Es kann sein, dass der Anbieter nach eigenen Maßgaben Daten
                von Ihnen speichert, worauf wir dann keinen Einfluss haben.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben immer das Recht auf Auskunft, Berichtigung und Löschung Ihrer
                personenbezogenen Daten. Bei Fragen können Sie auch jederzeit
                Verantwortliche des verwendeten Videokonferenzen- bzw. Streamingtools
                kontaktieren. Kontaktdaten finden Sie entweder in unserer spezifischen
                Datenschutzerklärung oder auf der Website des entsprechenden Anbieters.
            </p>
            <p>
                Cookies, die Anbieter für ihre Funktionen verwenden, können Sie in Ihrem
                Browser löschen, deaktivieren oder verwalten. Je nachdem welchen Browser Sie
                verwenden, funktioniert dies auf unterschiedliche Art und Weise. Bitte
                beachten Sie aber, dass dann eventuell nicht mehr alle Funktionen wie
                gewohnt funktionieren.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch die Video bzw.
                Streaming-Lösung verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Zudem können wir auch eine Videokonferenz als Teil unserer Services
                anbieten, wenn dies im Vorfeld mit Ihnen vertraglich vereinbart wurde{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. b DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet, jedoch nur, soweit Sie
                zumindest eingewilligt haben. Die meisten Video- bzw. Streaming-Lösungen
                setzen auch Cookies in Ihrem Browser, um Daten zu speichern. Darum empfehlen
                wir Ihnen, unseren Datenschutztext über Cookies genau durchzulesen und die
                Datenschutzerklärung oder die Cookie-Richtlinien des jeweiligen
                Dienstanbieters anzusehen.
            </p>
            <p>
                Informationen zu speziellen Videokonferenz- und Streaming-Lösungen, erfahren
                Sie – sofern vorhanden – in den folgenden Abschnitten.
            </p>
            <h2 id="microsoft-teams-datenschutzerklaerung" className="adsimple-112958647">
                Microsoft Teams Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website Microsoft Teams, ein Dienst für
                Online-Meetings und Videokonferenzen. Dienstanbieter ist das amerikanische
                Unternehmen Microsoft Corporation, One Microsoft Way, Redmond, WA
                98052-6399, USA.
            </p>
            <p>
                Microsoft verarbeitet Daten von Ihnen u.a. auch in den USA. Microsoft ist
                aktiver Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte
                und sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Microsoft sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Microsoft, bei der Verarbeitung Ihrer relevanten Daten,
                das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den
                USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren
                auf einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss
                und die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Microsoft finden Sie
                unter{" "}
                <a
                className="adsimple-112958647"
                href="https://learn.microsoft.com/en-us/compliance/regulatory/offering-eu-model-clauses"
                target="_blank"
                rel="follow noopener"
                >
                https://learn.microsoft.com/en-us/compliance/regulatory/offering-eu-model-clauses
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Microsoft verarbeitet
                werden, erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://privacy.microsoft.com/de-de/privacystatement?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://privacy.microsoft.com/de-de/privacystatement
                </a>
                .
            </p>
            <h2 id="zoom-datenschutzerklaerung" className="adsimple-112958647">
                Zoom Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Zoom Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Nutzer, die Zoom verwenden
                    <br />
                    🤝 Zweck: ein zusätzliches Service für unsere Website-Besucher
                    <br />
                    📓 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie etwa Name,
                    Adresse, Kontaktdaten, E-Mail-Adresse, Telefonnummer oder Ihre
                    IP-Adresse enthalten. Mehr Details dazu finden Sie weiter unten in
                    dieser Datenschutzerklärung
                    <br />
                    📅 Speicherdauer: Daten werden gespeichert, solange Zoom diese für den
                    Dienstzweck benötigen
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen), Art. 6 Abs. 1 lit. b
                    DSGVO (Vertrag)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Zoom?</h3>
            <p>
                Wir verwenden für unsere Website das Videokonferenz-Tool Zoom des
                amerikanischen Software-Unternehmens Zoom Video Communications. Der
                Firmenhauptsitz ist im kalifornischen San Jose, 55 Almaden Boulevard, 6th
                Floor, CA 95113. Dank „Zoom“ können wir mit Kunden, Geschäftspartnern,
                Klienten und auch Mitarbeitern ganz einfach und ohne Software-Installation
                eine Videokonferenz abhalten. In dieser Datenschutzerklärung gehen wir näher
                auf das Service ein und informieren Sie über die wichtigsten
                datenschutzrelevanten Aspekte.
            </p>
            <p>
                Zoom ist eine der weltweit bekanntesten Videokonferenzlösungen. Mit dem
                Dienst „Zoom Meetings“ können wir beispielsweise mit Ihnen, aber auch mit
                Mitarbeitern oder anderen Usern über einen digitalen Konferenzraum eine
                Online-Videokonferenz abhalten. So können wir sehr einfach digital in
                Kontakt treten, uns über diverse Themen austauschen, Textnachrichten
                schicken oder auch telefonieren. Weiters kann man über Zoom auch den
                Bildschirm teilen, Dateien austauschen und ein Whiteboard nutzen.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Zoom auf unserer Website?
            </h3>
            <p>
                Uns ist es wichtig, dass wir mit Ihnen schnell und unkompliziert
                kommunizieren können. Und genau diese Möglichkeit bietet uns Zoom. Das
                Softwareprogramm funktioniert auch direkt über einen Browser. Das heißt wir
                können Ihnen einfach einen Link schicken und schon mit der Videokonferenz
                starten. Zudem sind natürlich auch Zusatzfunktionen wie Screensharing oder
                das Austauschen von Dateien sehr praktisch.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Zoom gespeichert?
            </h3>
            <p>
                Wenn Sie Zoom verwenden, werden auch Daten von Ihnen erhoben, damit Zoom
                ihre Dienste bereitstellen kann. Das sind einerseits Daten, die Sie dem
                Unternehmen bewusst zur Verfügung stellen. Dazu gehören zum Beispiel Name,
                Telefonnummer oder Ihre E-Mail-Adresse. Es werden aber auch Daten
                automatisch an Zoom übermittelt und gespeichert. Hierzu zählen
                beispielsweise technische Daten Ihres Browsers oder Ihre IP-Adresse. Im
                Folgenden gehen wir genauer auf die Daten ein, die Zoom von Ihnen erheben
                und speichern kann:
            </p>
            <p>
                Wenn Sie Daten wie Ihren Namen, Ihren Benutzernamen, Ihre E-Mail-Adresse
                oder Ihre Telefonnummer angeben, werden diese Daten bei Zoom gespeichert.
                Inhalte, die Sie während der Zoom-Nutzung hochladen werden ebenfalls
                gespeichert. Dazu zählen beispielsweise Dateien oder Chatprotokolle.
            </p>
            <p>
                Zu den technischen Daten, die Zoom automatisch speichert, zählen neben der
                oben bereits erwähnten IP-Adresse auch die MAC-Adresse, weitere Geräte-IDs,
                Gerätetyp, welches Betriebssystem Sie nutzen, welchen Client Sie nutzen,
                Kameratyp, Mikrofon- und Lautsprechertyp. Auch Ihr ungefährer Standort wird
                bestimmt und gespeichert. Des Weiteren speichert Zoom auch Informationen
                darüber wie Sie den Dienst nutzen. Also beispielsweise ob Sie via Desktop
                oder Smartphone „zoomen“, ob Sie einen Telefonanruf oder VoIP nutzen, ob Sie
                mit oder ohne Video teilnehmen oder ob Sie ein Passwort anfordern. Zoom
                zeichnet auch sogenannte Metadaten wie Dauer des Meetings/Anrufs, Beginn und
                Ende der Meetingteilnahme, Meetingname und Chatstatus auf.
            </p>
            <p>
                Zoom erwähnt in der eigenen Datenschutzerklärung, dass das Unternehmen keine
                Werbecookies oder Tracking-Technologien für Ihre Dienste verwenden. Nur auf
                den eigenen Marketing-Websites wie etwa{" "}
                <a
                className="adsimple-112958647"
                href="https://explore.zoom.us/docs/de-de/home.html"
                target="_blank"
                rel="follow noopener"
                >
                https://explore.zoom.us/docs/de-de/home.html
                </a>{" "}
                werden diese Trackingmethoden genutzt. Zoom verkauft personenbezogenen Daten
                nicht weiter und nutzt diese auch nicht für Werbezwecke.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Zoom gibt diesbezüglich keinen konkreten Zeitrahmen bekannt, sondern betont,
                dass die erhobenen Daten solange gespeichert bleiben, wie es zur
                Bereitstellung der Dienste bzw. für die eigenen Zwecke nötig ist. Länger
                werden die Daten nur gespeichert, wenn dies aus rechtlichen Gründen
                gefordert wird.
            </p>
            <p>
                Grundsätzlich speichert Zoom die erhobenen Daten auf amerikanischen Servern,
                aber Daten können weltweit auf unterschiedlichen Rechenzentren eintreffen.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Wenn Sie nicht wollen, dass Daten während des Zoom-Meetings gespeichert
                werden, müssen Sie auf das Meeting verzichten. Sie haben aber auch immer das
                Recht und die Möglichkeit all Ihre personenbezogenen Daten löschen zu
                lassen. Falls Sie ein Zoom-Konto haben, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://support.zoom.us/hc/en-us/articles/201363243-How-Do-I-Delete-Terminate-My-Account"
                >
                https://support.zoom.us/hc/en-us/articles/201363243-How-Do-I-Delete-Terminate-My-Account
                </a>
                eine Anleitung wie Sie Ihr Konto löschen können.
            </p>
            <p>
                Bitte beachten Sie, dass bei der Verwendung dieses Tools Daten von Ihnen
                auch außerhalb der EU gespeichert und verarbeitet werden können. Die meisten
                Drittstaaten (darunter auch die USA) gelten nach derzeitigem europäischen
                Datenschutzrecht als nicht sicher. Daten an unsichere Drittstaaten dürfen
                also nicht einfach übertragen, dort gespeichert und verarbeitet werden,
                sofern es keine passenden Garantien (wie etwa EU-Standardvertragsklauseln)
                zwischen uns und dem außereuropäischen Dienstleister gibt.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Daten von Ihnen durch die Video bzw.
                Streaming-Lösung verarbeitet und gespeichert werden können, gilt diese
                Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. a DSGVO)</strong>
                . Zudem können wir auch eine Videokonferenz als Teil unserer Services
                anbieten, wenn dies im Vorfeld mit Ihnen vertraglich vereinbart wurde{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. b DSGVO)</strong>
                . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres berechtigten
                Interesses{" "}
                <strong className="adsimple-112958647 text-[#787c87]">(Art. 6 Abs. 1 lit. f DSGVO)</strong>
                an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und
                Geschäftspartnern gespeichert und verarbeitet, jedoch nur, soweit Sie
                zumindest eingewilligt haben.
            </p>
            <p>
                Zoom verarbeitet Daten von Ihnen u.a. auch in den USA. Zoom ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Zoom sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2
                und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC)
                sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Zoom, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
                .
            </p>
            <p>
                Wir hoffen Ihnen einen Überblick über die Datenverarbeitung durch Zoom
                geboten zu haben. Es kann natürlich immer auch vorkommen, dass sich die
                Datenschutzrichtlinien des Unternehmens ändern. Daher empfehlen wir Ihnen
                für mehr Informationen zu den verarbeiteten Daten und den
                Standardvertragsklauseln auch die Datenschutzerklärung von Zoom unter{" "}
                <a
                className="adsimple-112958647"
                href="https://explore.zoom.us/de/privacy/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://explore.zoom.us/de/privacy/
                </a>
                .
            </p>
            <h2 id="recruiting-tools-einleitung" className="adsimple-112958647">
                Recruiting Tools Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Recruiting Tools Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Nutzer, die ein Bewerbungsverfahren online abwickeln
                    bzw. ein Recruiting Tool verwenden
                    <br />
                    🤝 Zweck: Abwicklung eines Bewerbungsverfahrens
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa Name, Adresse, Kontaktdaten,
                    E-Mail-Adresse oder Ihre Telefonnummer. Mehr Details dazu finden Sie
                    beim jeweils eingesetzten Recruiting Tool.
                    <br />
                    📅 Speicherdauer: bei erfolgreicher Bewerbung bis zum Ende des
                    Dienstverhältnisses. Anderenfalls werden die Daten nach dem
                    Bewerbungsverfahren gelöscht.
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs 1 lit. b DSGVO (Vertrag), Art. 9 Abs. 2 lit. a. DSGVO
                    (Verarbeitung besonderer Kategorien)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Recruiting Tools?</h3>
            <p>
                Verschiedene Unternehmen bieten Softwareprogramme, die ein
                Bewerbungsverfahren deutlich erleichtern können. Die meisten Systeme bieten
                etwa Filteroptionen, um Datenbanken von potenziellen Kandidaten zu
                durchforsten. So können wir schnell und effizient Mitarbeiter finden, die zu
                unserem Unternehmen passen. Sowohl über Onlineformulare als auch über
                Recruiting Tools werden personenbezogene Daten von Ihnen übertragen,
                gespeichert und verwaltet. In diesem allgemeinen Text beziehen wir uns neben
                Recruiting Tools auch auf das klassische Bewerbungsverfahren per E-Mail bzw.
                Online-Formular. Genauere Informationen zu den Recruiting Tools finden Sie
                in den Datenschutzerklärungen der jeweiligen Anbieter.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir Recruiting Tools?</h3>
            <p>
                Für die Suche nach passenden Bewerbern und für die Administration aller
                Bewerbungsunterlagen nutzen wir, unter Berücksichtigung aller gesetzlichen
                Richtlinien, Softwareprogramme und Plattformen, die sich auf das
                Bewerbungsmanagement spezialisiert haben. Sogenannte Recruiting Tools
                erleichtern in der Regel das Bewerbungsverfahren, indem die Software viele
                administrative Tätigkeiten übernimmt und Prozesse im Bewerbungsverfahren
                optimiert. Dadurch können wir in manchen Fällen schneller geeignete
                Mitarbeiter für unser Unternehmen finden.
            </p>
            <p>
                Für die Bedingungen der Recruitingverfahren verweisen wir im Einzelnen auf
                die jeweiligen Stellenausschreibungen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Wenn Sie sich bei uns bewerben, müssen Sie uns natürlich auch Daten von
                Ihnen zur Verfügung stellen, damit wir die Bewerbung auch entsprechend
                beurteilen können. Welche Informationen Sie uns genau mitteilen, hängt von
                der Stellenausschreibung bzw. von den erforderlichen Angaben im
                Online-Formular ab.
            </p>
            <p>
                In der Regel geht es dabei um Daten wie Name, Adresse, Geburtsdatum und dem
                Nachweis Ihrer für den Job notwendigen Qualifikation. Während des Prozesses
                einer Bewerbung können aber nicht nur die üblichen personenbezogenen Daten,
                wie etwa Name oder Adresse übermittelt werden, sondern auch Informationen zu
                Ihrer Gesundheit oder Ihrer ethnischen Herkunft angefragt werden, damit wir
                und Sie die Rechte in Bezug auf Arbeitsrecht, sozialer Sicherheit und
                Sozialschutz ausüben können und gleichzeitig den dazu entsprechenden
                Pflichten nachkommen können. Diese Daten werden Daten besonderer Kategorie
                genannt.
            </p>
            <p>
                Über das Online-Formular werden die Daten bzw. Ihre Bewerbung verschlüsselt
                an uns gesendet. Sie können Ihre Bewerbung alternativ auch per E-Mail zu uns
                schicken. Wenn Sie sich für diese Variante entscheiden, werden die Daten
                zwar verschlüsselt übertragen, aber vom abgesendeten und empfangenen Server
                nicht verschlüsselt gespeichert.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Die von Ihnen übermittelten Daten können von uns, im Falle einer
                erfolgreichen Bewerbung, für ein Beschäftigungsverhältnis weiterverarbeitet
                werden. Wenn die Bewerbung den Vorstellungen nicht entspricht, löschen wir
                die erhaltenen Daten. Auch wenn Sie Ihre Bewerbung zurückziehen, werden
                diese Daten gelöscht. Sofern Sie einer Aufnahme in unseren Bewerberpool
                zustimmen, speichern wir Ihre in diesem Rahmen erhobenen Daten bis zu ihrem
                Austritt aus dem Bewerberpool. Für den Austritt gelten dieselben Regeln wie
                für den Widerruf Ihrer Einwilligung.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch immer das Recht und die Möglichkeit Ihre Einwilligung zu
                widerrufen. Damit wir noch mögliche Fragen zur Bewerbung beantworten können
                und unseren Nachweispflichten nachkommen können, werden die Daten spätestens
                nach 6 Monaten gelöscht. Rechnungen zu möglichen Reisekostenerstattung
                archivieren wir aufgrund steuerrechtlicher Vorgaben.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn wir Sie in unser Bewerbungspool aufnehmen, passiert das auf der
                Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Wir weisen Sie
                darauf hin, dass Ihre Zustimmung in unser Bewerbungspool freiwillig ist,
                keinen Einfluss auf den Bewerbungsprozess hat und Sie jederzeit die
                Möglichkeit haben, Ihre Einwilligung zu widerrufen.
            </p>
            <p>
                Für den Fall des Schutzes lebenswichtiger Interessen erfolgt die
                Datenverarbeitung gemäß Art. 9 Abs. 2 lit. c. DSGVO. Für Zwecke der
                Gesundheitsversorgung, der Arbeitsmedizin, für die medizinische Diagnostik,
                für die Versorgung oder Behandlung im Gesundheits- oder Sozialbereich oder
                für die Verwaltung von Systemen und Diensten im Gesundheits- oder
                Sozialbereich erfolgt die Verarbeitung personenbezogener Daten gemäß Art. 9
                Abs. 2 lit. h. DSGVO. Wenn Sie freiwillig Daten der besonderen Kategorien
                mitteilen, erfolgt die Verarbeitung auf Grundlage von Art. 9 Abs. 2 lit. a.
                DSGVO.
            </p>
            <p>
                Informationen zu den speziellen Recruiting Tools erhalten Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h2 id="facebook-jobs-datenschutzerklaerung" className="adsimple-112958647">
                Facebook-Jobs Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen das Job-Management-Tool Facebook-Jobs. Dienstanbieter ist das
                amerikanische Unternehmen Meta Platforms Inc. Für den europäischen Raum ist
                das Unternehmen Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand
                Canal Harbour, Dublin 2, Irland verantwortlich.
            </p>
            <p>
                Facebook verarbeitet Daten von Ihnen u.a. auch in den USA. Facebook bzw.
                Meta Platforms ist aktiver Teilnehmer des EU-US Data Privacy Frameworks,
                wodurch der korrekte und sichere Datentransfer personenbezogener Daten von
                EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Facebook sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Facebook, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Facebook Datenverarbeitungsbedingung, welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/legal/terms/dataprocessing"
                >
                https://www.facebook.com/legal/terms/dataprocessing
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Facebook verarbeitet
                werden, erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/policy.php"
                >
                https://www.facebook.com/policy.php
                </a>
                .
            </p>
            <h2
                id="linkedin-recruiter-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                LinkedIn Recruiter Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auf unserer Website das Recruiting Tool LinkedIn Recruiter.
                Dienstanbieter ist das amerikanische Unternehmen LinkedIn Corporation, 2029
                Stierlin Court, Mountain View, CA 94043, USA.
            </p>
            <p>
                LinkedIn verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf
                hin, dass nach Meinung des Europäischen Gerichtshofs derzeit kein
                angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
                kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                LinkedIn sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3
                DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind
                von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                diese Klauseln verpflichtet sich LinkedIn, bei der Verarbeitung Ihrer
                relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn
                die Daten in den USA gespeichert, verarbeitet und verwaltet werden. Diese
                Klauseln basieren auf einem Durchführungsbeschluss der EU-Kommission. Sie
                finden den Beschluss und die entsprechenden Standardvertragsklauseln u.a.
                hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei LinkedIn finden Sie
                unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.linkedin.com/legal/l/customer-sccs"
                target="_blank"
                rel="follow noopener"
                >
                https://www.linkedin.com/legal/l/customer-sccs
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von LinkedIn Recruiter
                verarbeitet werden, erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://de.linkedin.com/legal/privacy-policy"
                >
                https://de.linkedin.com/legal/privacy-policy
                </a>
                .
            </p>
            <h2 id="stepstone-datenschutzerklaerung" className="adsimple-112958647">
                Stepstone Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden StepStone, eine Bewerbermanagement-Software. Dienstanbieter
                ist das österreichische Unternehmen StepStone Österreich GmbH,
                Prinz-Eugen-Straße 8-10, A-1040 Wien, Österreich. Mehr über die Daten, die
                durch die Verwendung von StepStone verarbeitet werden, erfahren Sie in der
                Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.stepstone.at/Ueber-StepStone/rechtliche-hinweise/datenschutzerklarung/"
                >
                https://www.stepstone.at/Ueber-StepStone/rechtliche-hinweise/datenschutzerklarung/
                </a>
                .
            </p>
            <h2 id="single-sign-on-anmeldungen-einleitung" className="adsimple-112958647">
                Single-Sign-On-Anmeldungen Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Single-Sign-On-Anmeldungen Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Vereinfachung des Authentifizierungsprozesses
                    <br />
                    📓 Verarbeitete Daten: Ist stark vom jeweiligen Anbieter abhängig,
                    meist können E-Mail-Adresse und Benutzername gespeichert werden.
                    <br />
                    Mehr Details dazu finden Sie beim jeweils eingesetzten Tool.
                    <br />
                    📅 Speicherdauer: abhängig von den verwendeten Tools
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Artikel 6 Absatz 1 lit. b DSGVO (Vertragserfüllung), Art. 6 Abs. 1
                    lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Single-Sign-On-Anmeldungen?</h3>
            <p>
                Auf unserer Website haben Sie die Möglichkeit sich über ein Userkonto eines
                anderen Anbieters (z.B. über Facebook) schnell und einfach für unser
                Onlineservice anzumelden. Dieses Authentifizierungs-Verfahren nennt man
                unter anderem „Single-Sign-On-Anmeldung“. Dieses Anmeldeverfahren
                funktioniert natürlich nur, wenn Sie bei dem anderen Anbieter registriert
                sind bzw. ein Nutzerkonto haben und die entsprechenden Zugangsdaten in das
                Onlineformular eingeben. In vielen Fällen sind Sie auch schon angemeldet,
                die Zugangsdaten werden automatisch ins Formular eingetragen und Sie müssen
                nur noch über einen Button die Single-Sign-On-Anmeldung bestätigen. Im Zuge
                dieser Anmeldung können auch personenbezogenen Daten von Ihnen verarbeitet
                und gespeichert werden. In diesem Datenschutztext gehen wir allgemein auf
                die Datenverarbeitung durch Single-Sign-On-Anmeldungen ein. Nähere
                Informationen finden Sie in den Datenschutzerklärungen der jeweiligen
                Anbieter.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Single-Sign-On-Anmeldungen?
            </h3>
            <p>
                Wir wollen Ihnen das Leben auf unserer Website so einfach und angenehm wie
                möglich gestalten. Daher bieten wir auch Single-Sign-On-Anmeldungen an. So
                ersparen Sie sich wertvolle Zeit, weil Sie nur eine Authentifizierung
                benötigen. Da Sie sich nur ein Passwort merken müssen und es nur einmal
                übertragen wird, erhöht sich auch die Sicherheit. In vielen Fällen haben Sie
                Ihr Passwort mithilfe von Cookies auch schon automatisch gespeichert und der
                Anmeldeprozess auf unserer Website dauert daher nur ein paar Sekunden.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch Single-Sign-On-Anmeldungen gespeichert?
            </h3>
            <p>
                Obwohl Sie sich über dieses spezielle Anmeldeverfahren auf unserer Website
                anmelden, erfolgt die eigentliche Authentifizierung beim entsprechenden
                Single-Sign-On-Anbieter. Wir als Websitebetreiber erhalten in Zuge der
                Authentifizierung eine Nutzer-ID. Darin wird festgehalten, dass Sie unter
                dieser ID beim entsprechenden Anbieter angemeldet sind. Diese ID kann für
                keine anderen Zwecke verwendet werden. Es können uns auch andere Daten
                übermittelt werden, das hängt aber von den verwendeten
                Single-Sign-On-Anbietern ab. Ebenso hängt es davon ab, welche Daten Sie
                während des Authentifizierungsprozesses freiwillig zur Verfügung stellen und
                welche Daten Sie grundsätzlich in Ihren Einstellungen bei dem Anbieter
                freigeben. Meistens handelt es sich um Daten wie Ihre E-Mail-Adresse und
                Ihrem Benutzernamen. Ihr Passwort, das für die Anmeldung nötig ist, kennen
                wir nicht und wird auch nicht bei uns gespeichert. Für Sie ist es noch
                wichtig zu wissen, dass bei uns gespeicherte Daten durch das
                Anmeldeverfahren automatisch mit den Daten des jeweiligen Nutzerkontos
                abgeglichen werden können.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Beispielsweise speichert die
                Social-Media-Plattform Facebook Daten, bis sie für den eigenen Zweck nicht
                mehr benötigt werden. Kundendaten, die mit den eigenen Userdaten abgeglichen
                werden, werden aber schon innerhalb von zwei Tagen gelöscht. Generell
                verarbeiten wir personenbezogene Daten nur so lange wie es für die
                Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig
                ist.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Single-Sign-On-Anmeldungen zu widerrufen. Das funktioniert
                meist über Opt-Out-Funktionen des Anbieters. Wenn vorhanden, finden Sie in
                unseren Datenschutztexten zu den einzelnen Tools auch Links zu den
                entsprechenden Opt-Out-Funktionen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn es mit Ihnen vereinbart wurde und dies im Rahmen der Vertragserfüllung
                (Artikel 6 Absatz 1 lit. b DSGVO) und der Einwilligung (Artikel 6 Absatz 1
                lit. a DSGVO) erfolgt, können wir das Single-Sign-On-Verfahren auf deren
                Rechtsgrundlagen einsetzen.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse darin, Ihnen ein schnelles und einfaches Anmeldeverfahren zu
                bieten. Die Rechtsgrundlage dafür ist Art. 6 Abs. 1 lit. f DSGVO
                (Berechtigte Interessen). Wir setzen die Single-Sign-On-Anmeldung gleichwohl
                nur ein, soweit Sie eine Einwilligung erteilt haben.
            </p>
            <p>
                Wenn Sie diese Verknüpfung zu dem Anbieter mit der Single-Sign-On-Anmeldung
                nicht mehr haben wollen, lösen Sie bitte diese in Ihrem Userkonto bei dem
                jeweiligen Anbieter auf. Falls Sie auch Daten bei uns löschen wollen, ist
                eine Kündigung Ihrer Registrierung notwendig.
            </p>
            <h2
                id="auth0-single-sign-on-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Auth0 Single-Sign-On Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für die Anmeldung auf unserer Website auch den
                Authentifizierungsdienst Auth0 Single-Sign-On. Dienstanbieter ist das
                amerikanische Unternehmen Auth0 Inc., 10800 NE 8th Street, Suite 700,
                Bellevue, WA 98004, USA.
            </p>
            <p>
                Auth0 verarbeitet Daten von Ihnen u.a. auch in den USA. Auth0 ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Auth0 verarbeitet werden,
                erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.okta.com/privacy-policy/?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://www.okta.com/privacy-policy/
                </a>
                .
            </p>
            <h2
                id="facebook-single-sign-on-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Facebook Single-Sign-On Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für die Anmeldung auf unserer Website auch den
                Authentifizierungsdienst Facebook Single-Sign-On. Dienstanbieter ist das
                amerikanische Unternehmen Meta Platforms Inc. Für den europäischen Raum ist
                das Unternehmen Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand
                Canal Harbour, Dublin 2, Irland verantwortlich.
            </p>
            <p>
                Facebook verarbeitet Daten von Ihnen u.a. auch in den USA. Facebook bzw.
                Meta Platforms ist aktiver Teilnehmer des EU-US Data Privacy Frameworks,
                wodurch der korrekte und sichere Datentransfer personenbezogener Daten von
                EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Facebook sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Facebook, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Facebook Datenverarbeitungsbedingung, welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/legal/terms/dataprocessing"
                >
                https://www.facebook.com/legal/terms/dataprocessing
                </a>
                .
            </p>
            <p>
                Sofern Sie bei Facebook angemeldet sind, können Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/adpreferences/ad_settings"
                >
                https://www.facebook.com/adpreferences/ad_settings
                </a>
                Ihre Einwilligung zur Verwendung von Single-Sign-On-Anmeldungen per
                Opt-Out-Funktion widerrufen. Mehr über die Daten, die durch die Verwendung
                von Facebook verarbeitet werden, erfahren Sie in der Datenschutzerklärung
                auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/policy.php"
                >
                https://www.facebook.com/policy.php
                </a>
                .
            </p>
            <h2
                id="google-single-sign-on-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Google Single-Sign-On Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für die Anmeldung auf unserer Website auch den
                Authentifizierungsdienst Google Single-Sign-On. Dienstanbieter ist das
                amerikanische Unternehmen Facebook Inc. Für den europäischen Raum ist das
                Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4,
                Irland) für alle Google-Dienste verantwortlich.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
                Terms), welche auf die Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
                .
            </p>
            <p>
                Bei Google können Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://adssettings.google.com/authenticated"
                target="_blank"
                rel="follow noopener"
                >
                https://adssettings.google.com/authenticated
                </a>{" "}
                Ihre Einwilligung zur Verwendung von Single-Sign-On-Anmeldungen per
                Opt-Out-Funktion widerrufen. Mehr über die Daten, die durch die Verwendung
                von Google Single-Sign-On verarbeitet werden, erfahren Sie in der Privacy
                Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de"
                target="_blank"
                rel="follow noopener"
                >
                https://policies.google.com/privacy?hl=de
                </a>
                .
            </p>
            <h2
                id="instagram-single-sign-on-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Instagram Single-Sign-On Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für die Anmeldung auf unserer Website auch den
                Authentifizierungsdienst Instagram Single-Sign-On. Dienstanbieter ist das
                amerikanische Unternehmen Instagram Inc., 1601 Willow Road, Menlo Park, CA,
                94025, USA. Instagram ist seit 2012 ein Tochterunternehmen von Meta
                Platforms Inc. und gehört zu den Facebook-Produkten.
            </p>
            <p>
                Instagram verarbeitet Daten von Ihnen u.a. auch in den USA. Instagram bzw.
                Meta Platforms ist aktiver Teilnehmer des EU-US Data Privacy Frameworks,
                wodurch der korrekte und sichere Datentransfer personenbezogener Daten von
                EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Instagram sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Instagram, bei der Verarbeitung Ihrer relevanten Daten,
                das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den
                USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren
                auf einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss
                und die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Sofern Sie bei Meta bzw. Instagram angemeldet sind, können Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.facebook.com/adpreferences/ad_settings"
                >
                https://www.facebook.com/adpreferences/ad_settings
                </a>
                Ihre Einwilligung zur Verwendung von Single-Sign-On-Anmeldungen per
                Opt-Out-Funktion widerrufen. Mehr über die Daten, die durch die Verwendung
                von Instagram/Meta verarbeitet werden, erfahren Sie in der
                Datenschutzerklärung auf
                <a
                className="adsimple-112958647"
                href="https://help.instagram.com/519522125107875"
                >
                https://help.instagram.com/519522125107875
                </a>
                .
            </p>
            <h2
                id="twitter-single-sign-on-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Twitter Single-Sign-On Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für die Anmeldung auf unserer Website auch den
                Authentifizierungsdienst Twitter Single-Sign-On. Dienstanbieter ist das
                amerikanische Unternehmen Twitter Inc. Für den europäischen Raum ist das
                Unternehmen Twitter International Company, One Cumberland Place, Fenian
                Street, Dublin 2 D02 AX07, Irland verantwortlich.
            </p>
            <p>
                Twitter verarbeitet Daten u.a. auch in den USA. Wir weisen darauf hin, dass
                nach Meinung des Europäischen Gerichtshofs derzeit kein angemessenes
                Schutzniveau für den Datentransfer in die USA besteht. Dies kann mit
                verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der
                Datenverarbeitung einhergehen.
            </p>
            <p>
                Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten
                (außerhalb der Europäischen Union, Island, Liechtenstein, Norwegen, also
                insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet
                Twitter von der EU-Kommission genehmigte Standardvertragsklauseln (= Art.
                46. Abs. 2 und 3 DSGVO). Diese Klauseln verpflichten Twitter, das
                EU-Datenschutzniveau bei der Verarbeitung relevanter Daten auch außerhalb
                der EU einzuhalten. Diese Klauseln basieren auf einem Durchführungsbeschluss
                der EU-Kommission. Sie finden den Beschluss sowie die Klauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Bei Twitter können Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://twitter.com/settings/account/personalization"
                >
                https://twitter.com/settings/account/personalization
                </a>
                Ihre Einwilligung zur Verwendung von Single-Sign-On-Anmeldungen per
                Opt-Out-Funktion widerrufen. Mehr über die Daten, die durch die Verwendung
                von Twitter verarbeitet werden, erfahren Sie in der Datenschutzerklärung auf{" "}
                <a className="adsimple-112958647" href="https://twitter.com/de/privacy">
                https://twitter.com/de/privacy
                </a>
                .
            </p>
            <h2
                id="umfrage-und-befragungssysteme-einleitung"
                className="adsimple-112958647"
            >
                Umfrage- und Befragungssysteme Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Umfrage- und Befragungssysteme Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Auswertung von Umfragen auf der Website
                    <br />
                    📓 Verarbeitete Daten: Kontaktdaten, Gerätedaten, Zugriffsdauer und
                    Zeitpunkt, IP-Adressen. Mehr Details dazu finden Sie beim jeweils
                    eingesetzten Umfrage- und Befragungssystem.
                    <br />
                    📅 Speicherdauer: abhängig vom eingesetzten Tool
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">
                Was sind Umfrage- und Befragungssysteme?
            </h3>
            <p>
                Wir führen über unsere Website gerne auch diverse Umfragen und Befragungen
                durch. Ausgewertet werden diese stets anonym. Ein Umfrage- bzw.
                Befragungssystem ist ein in unsere Website eingebundenes Tool, das Ihnen
                Fragen (etwa zu unseren Produkten oder Dienstleistungen) stellt, die Sie,
                sofern Sie teilnehmen, beantworten können. Ihre Antworten werden stets
                anonym ausgewertet. Dabei können allerdings, nach Ihrer Einwilligung zur
                Datenverarbeitung, auch personenbezogene Daten gespeichert und verarbeitet
                werden.
            </p>
            <h3 className="adsimple-112958647">
                Warum nutzen wir Umfrage- und Befragungssysteme?
            </h3>
            <p>
                Wir wollen Ihnen die besten Produkte und Dienstleistungen in unserer Branche
                anbietet. Mit Umfragen bekommen wir von Ihnen perfektes Feedback und
                erfahren, was Sie von uns bzw. unseren Leistungen erwarten. Anhand dieser
                anonymen Auswertungen können wir unsere Produkte bzw. Dienstleistungen
                bestens an Ihre Wünsche und Vorstellungen anpassen. Weiters dienen uns die
                Informationen auch, unsere Werbe- und Marketing-Maßnahmen zielorientierter
                an jene Personen zu richten, die sich auch wirklich für unser Angebot
                interessieren.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Personenbezogene Daten werden nur dann verarbeitet, wenn es für die
                technische Umsetzung notwendig ist bzw. wenn Sie eingewilligt haben, dass
                personenbezogene Daten verarbeitet werden dürfen. Dann wird etwa Ihre
                IP-Adresse gespeichert, damit beispielsweise die Umfrage in Ihrem Browser
                dargestellt werden kann. Es können auch Cookies verwendet werden, damit Sie
                Ihre Umfrage auch nach einem späteren Zeitpunkt problemlos fortsetzen
                können.
            </p>
            <p>
                Wenn Sie der Datenverarbeitung eingewilligt haben, können neben Ihrer
                IP-Adresse auch Kontaktdaten wie Ihre E-Mail-Adresse oder Ihre Telefonnummer
                verarbeitet werden. Auch Daten, die Sie etwa in ein Online-Formular
                eingeben, werden gespeichert und verarbeitet. Manche Anbieter speichern auch
                Informationen zu Ihren besuchten Webseiten (auf unserer Website), wann Sie
                die Umfrage gestartet und beendet haben und diverse technische Informationen
                zu Ihrem Computer.
            </p>
            <h3 className="adsimple-112958647">Wie lange werden Daten gespeichert?</h3>
            <p>
                Wie lange die Daten verarbeitet und gespeichert werden, hängt in erster
                Linie von unseren verwendeten Tools ab. Weiter unten erfahren Sie mehr über
                die Datenverarbeitung der einzelnen Tools. In den Datenschutzerklärungen der
                Anbieter steht üblicherweise genau, welche Daten wie lange gespeichert und
                verarbeitet werden. Grundsätzlich werden personenbezogene Daten nur so lange
                verarbeitet, wie es für die Bereitstellung unserer Dienste nötig ist. Wenn
                Daten in Cookies gespeichert werden, variiert die Speicherdauer stark. Die
                Daten können gleich nach dem Verlassen einer Website wieder gelöscht werden,
                sie können aber auch über mehrere Jahre gespeichert bleiben. Daher sollten
                Sie sich jedes einzelnen Cookie im Detail ansehen, wenn Sie über die
                Datenspeicherung Genaueres wissen wollen. Meistens finden Sie in den
                Datenschutzerklärungen der einzelnen Anbieter auch aufschlussreiche
                Informationen über die einzelnen Cookies.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. eingebetteten Befragungssystemen zu widerrufen.
                Das funktioniert entweder über unser Cookie-Management-Tool oder über andere
                Opt-Out-Funktionen. Zum Beispiel können Sie auch die Datenerfassung durch
                Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
                deaktivieren oder löschen.
            </p>
            <p>
                Da bei Befragungssystemen Cookies zum Einsatz kommen können, empfehlen wir
                Ihnen auch unsere allgemeine Datenschutzerklärung über Cookies. Um zu
                erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet werden,
                sollten Sie die Datenschutzerklärungen der jeweiligen Tools durchlesen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Der Einsatz von Befragungssystemen setzt Ihre Einwilligung voraus, welche
                wir mit unserem Cookie-Popup eingeholt haben. Diese Einwilligung stellt laut{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Umfrage- und Befragungssystemen vorkommen kann, dar.
            </p>
            <p>
                Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes
                Interesse daran, Umfrage zu unserem Thema durchzuführen. Die Rechtsgrundlage
                dafür ist&nbsp;
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen die Tools gleichwohl nur ein, soweit sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Da bei Befragungssystemen Cookies zum Einsatz kommen, empfehlen wir Ihnen
                auch das Lesen unserer allgemeinen Datenschutzerklärung zu Cookies. Um zu
                erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet werden,
                sollten Sie die Datenschutzerklärungen der jeweiligen Tools durchlesen.
            </p>
            <p>
                Informationen zu den einzelnen Befragungssystemen, erhalten Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h2 id="google-formular-datenschutzerklaerung" className="adsimple-112958647">
                Google-Formular Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für unsere Website Google-Formular, ein Service für
                Google-Cloud-Formulare. Dienstanbieter ist das amerikanische Unternehmen
                Google Inc. Für den europäischen Raum ist das Unternehmen Google Ireland
                Limited (Gordon House, Barrow Street Dublin 4, Irland) für alle
                Google-Dienste verantwortlich.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
                Terms), welche den Standardvertragsklauseln entsprechen und auch für
                Google-Formular geltend sind, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/adsprocessorterms/"
                target="_blank"
                rel="noopener"
                >
                https://business.safety.google/adsprocessorterms/
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Google verarbeitet werden,
                erfahren Sie in der Datenschutzerklärung auf{" "}
                <u>
                <a
                    className="adsimple-112958647"
                    href="https://policies.google.com/privacy?tid=112958647"
                    target="_blank"
                    rel="noopener"
                >
                    https://policies.google.com/privacy
                </a>
                .{" "}
                </u>
            </p>
            <h2 id="bewertungsplattformen-einleitung" className="adsimple-112958647">
                Bewertungsplattformen Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Bewertungsplattformen Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website oder einer Bewertungsplattform
                    <br />
                    🤝 Zweck: Feedback zu unseren Produkten und/oder Dienstleistungen
                    <br />
                    📓 Verarbeitete Daten: U.a. IP-Adresse, E-Mail-Adresse, Name. Mehr
                    Details dazu finden Sie weiter unten bzw. bei den jeweils eingesetzten
                    Bewertungsplattformen.
                    <br />
                    📅 Speicherdauer: abhängig von der jeweiligen Plattform
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen),
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Bewertungsplattformen?</h3>
            <p>
                Auf verschiedenen Bewertungsplattformen können Sie unsere Produkte oder
                Dienstleistungen bewerten. Wir sind Teilnehmer mancher dieser Plattformen,
                damit wir Feedback von Ihnen bekommen und so unser Angebot optimieren
                können. Wenn Sie uns über eine Bewertungsplattform bewerten, gelten die
                Datenschutzerklärung und die allgemeinen Geschäftsbedingungen des jeweiligen
                Bewertungs-Service. Sehr häufig müssen Sie sich auch registrieren, um eine
                Bewertung abzugeben. Es können auch Bewertungstechnologien (Widgets) in
                unsere Website eingebunden werden. Durch die Verwendung eines solchen
                eingebundenen Tools werden auch Daten an den entsprechenden Anbieter
                übertragen, verarbeitet und gespeichert.
            </p>
            <p>
                Viele dieser eingebundenen Programme funktionieren nach ähnlichem Prinzip.
                Nachdem Sie bei uns ein Produkt bestellt haben oder eine Dienstleistung in
                Anspruch genommen haben, werden Sie, per E-Mail oder auf der Website,
                gebeten eine Bewertung abzugeben. Sie werden dafür meist über einen Link auf
                eine Bewertungsseite weitergeleitet und können dort einfach und schnell eine
                Bewertung erstellen. Manche Bewertungssysteme bieten auch eine Schnittstelle
                zu diversen Social-Media-Kanälen, um das Feedback mehreren Menschen
                zugänglich zu machen.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Bewertungsplattformen?
            </h3>
            <p>
                Bewertungsplattformen sammeln Feedback und Bewertungen über unsere Angebote.
                Durch Ihre Bewertungen bekommen wir schnell eine entsprechende Rückmeldung
                und können unsere Produkte und/oder Dienstleistungen viel effizienter
                verbessern. Die Bewertungen dienen uns folglich einerseits der Optimierung
                unserer Angebote und andererseits geben sie Ihnen und all unseren
                zukünftigen Kunden einen guten Überblick über die Qualität unserer Produkte
                und Leistungen.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Mithilfe Ihrer Einwilligung übermitteln wir Informationen über Sie und die
                von Ihnen in Anspruch bezogenen Leistungen an die entsprechende
                Bewertungsplattform. Dies machen wir, um sicherzustellen, dass Sie auch
                wirklich eine unserer Leistungen in Anspruch genommen haben. Denn nur dann
                können Sie auch echtes Feedback geben. Die übermittelten Daten dienen
                lediglich der User-Erkennung. Welche Daten genau gespeichert und verarbeitet
                werden, hängt natürlich von den verwendeten Anbietern ab. Meistens werden
                den Bewertungsplattformen auch personenbezogene Daten wie IP-Adresse,
                E-Mail-Adresse oder Ihr Name zur Verfügung gestellt. Es werden auch nach
                Abgabe Ihre Bewertung Bestellinformationen wie etwa die Bestellnummer eines
                erworbenen Artikels an die entsprechende Plattform weitergeleitet. Wenn Ihre
                E-Mail-Adresse übermittelt wird, geschieht dies, damit die
                Bewertungsplattform Ihnen eine Mail nach dem Erwerb eines Produktes senden
                kann. Damit wir auch Ihre Bewertung in unsere Website einbinden können,
                geben wir den Anbietern auch die Information, dass Sie unsere Seite
                aufgerufen haben. Verantwortlich für die erhobenen personenbezogenen Daten
                ist die verwendete Bewertungsplattform.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Genaueres über die Dauer der Datenverarbeitung erfahren Sie weiter unten in
                der entsprechenden Datenschutzerklärung des Anbieters, sofern wir weitere
                Informationen dazu haben. Generell verarbeiten wir personenbezogene Daten
                nur so lange wie es für die Bereitstellung unserer Dienstleistungen und
                Produkte unbedingt notwendig ist. Personenbezogene Daten, die in einer
                Bewertung genannt werden, werden in der Regel von Mitarbeitern der
                verwendeten Plattform anonymisiert und sind somit nur für Administratoren
                des Unternehmens sichtbar. Die erhobenen Daten werden auf den Servern der
                Anbieter gespeichert und bei den meisten Anbietern nach Auftragsende
                gelöscht.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert
                entweder über unser Cookie-Management-Tool oder über andere
                Opt-Out-Funktionen. Zum Beispiel können Sie auch die Datenerfassung durch
                Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
                deaktivieren oder löschen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass eine Bewertungsplattform eingesetzt werden
                darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese
                Einwilligung. Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO
                (Einwilligung) die Rechtsgrundlage für die Verarbeitung personenbezogener
                Daten, wie sie bei der Erfassung durch ein Bewertungsportal vorkommen kann,
                dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, eine
                Bewertungsplattform zu verwenden, um unser Online-Service zu optimieren. Die
                dafür entsprechende Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO
                (Berechtigte Interessen). Wir setzen eine Bewertungsplattform gleichwohl nur
                ein, soweit Sie eine Einwilligung erteilt haben.
            </p>
            <p>
                Wir hoffen, wir konnten Ihnen die wichtigsten allgemeinen Informationen rund
                um die Datenverarbeitung von Bewertungsplattformen näherbringen. Nähere
                Informationen finden Sie weiter unten in den Datenschutztexten bzw. in den
                verlinkten Datenschutzerklärungen des Unternehmens.
            </p>
            <h2
                id="google-kundenrezensionen-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Google Kundenrezensionen Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für unsere Website auch die Bewertungsplattform Google
                Kundenrezensionen. Dienstanbieter ist das amerikanische Unternehmen Google
                Inc. Für den europäischen Raum ist das Unternehmen Google Ireland Limited
                (Gordon House, Barrow Street Dublin 4, Irland) für alle Google-Dienste
                verantwortlich.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Datenverarbeitungsbedingungen für Google Werbeprodukte (Google Ads
                Controller-Controller Data Protection Terms), welche auf die
                Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Google verarbeitet werden,
                erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://policies.google.com/privacy?hl=de
                </a>
                .
            </p>
            <h2 id="provenexpert-datenschutzerklaerung" className="adsimple-112958647">
                ProvenExpert Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für unsere Website auch die Bewertungsplattform ProvenExpert.
                Dienstanbieter ist das deutsche Unternehmen
                <span
                className="adsimple-112958647"
                data-sheets-value='{"1":2,"2":"Expert Systems AG, Quedlinburger Straße 1, 10589 Berlin, Deutschland."}'
                data-sheets-userformat='{"2":769,"3":{"1":0},"11":3,"12":0}'
                >
                Expert Systems AG, Quedlinburger Straße 1, 10589 Berlin, Deutschland.{" "}
                </span>
            </p>
            <p>
                <span
                className="adsimple-112958647"
                data-sheets-value='{"1":2,"2":"belboon GmbH, Weinmeisterstr. 12–14, 10178 Berlin, Deutschland."}'
                data-sheets-userformat='{"2":769,"3":{"1":0},"11":3,"12":0}'
                >
                Mehr über die Daten, die durch die Verwendung von ProvenExpert verarbeitet
                werden, erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                    className="adsimple-112958647"
                    href="https://www.provenexpert.com/de-de/datenschutzbestimmungen/"
                    target="_blank"
                    rel="follow noopener"
                >
                    https://www.provenexpert.com/de-de/datenschutzbestimmungen/
                </a>
                .&nbsp;
                </span>
            </p>
            <h2 id="trusted-shops-datenschutzerklaerung" className="adsimple-112958647">
                Trusted Shops Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen für unsere Website auch die Bewertungsplattform Trusted Shops.
                Dienstanbieter ist das deutsche Unternehmen Trusted Shops GmbH, Subbelrather
                Straße 15c, 50823 Köln, Deutschland.
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Trusted Shops verarbeitet
                werden, erfahren Sie in der Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.trustedshops.de/impressum-datenschutz/#datenschutz"
                >
                https://www.trustedshops.de/impressum-datenschutz/#datenschutz
                </a>
                .
            </p>
            <h2 id="webdesign-einleitung" className="adsimple-112958647">
                Webdesign Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Webdesign Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Verbesserung der Nutzererfahrung
                    <br />
                    📓 Verarbeitete Daten: Welche Daten verarbeitet werden, hängt stark
                    von den verwendeten Diensten ab. Meist handelt es sich etwa um
                    IP-Adresse, technische Daten, Spracheinstellungen,&nbsp;
                    Browserversion, Bildschirmauflösung und Name des Browsers. Mehr
                    Details dazu finden Sie bei den jeweils eingesetzten Webdesign-Tools.
                    <br />
                    📅 Speicherdauer: abhängig von den eingesetzten Tools
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist Webdesign?</h3>
            <p>
                Wir verwenden auf unserer Website verschiedene Tools, die unserem Webdesign
                dienen. Bei Webdesign geht es nicht, wie oft angenommen, nur darum, dass
                unsere Website hübsch aussieht, sondern auch um Funktionalität und Leistung.
                Aber natürlich ist die passende Optik einer Website auch eines der großen
                Ziele professionellen Webdesigns. Webdesign ist ein Teilbereich des
                Mediendesigns und beschäftigt sich sowohl mit der visuellen als auch der
                strukturellen und funktionalen Gestaltung einer Website. Ziel ist es mit
                Hilfe von Webdesign Ihre Erfahrung auf unserer Website zu verbessern. Im
                Webdesign-Jargon spricht man in diesem Zusammenhang von User-Experience (UX)
                und Usability. Unter User Experience versteht man alle Eindrücke und
                Erlebnisse, die der Websitebesucher auf einer Website erfährt. Ein
                Unterpunkt der User Experience ist die Usability. Dabei geht es um die
                Nutzerfreundlichkeit einer Website. Wert gelegt wird hier vor allem darauf,
                dass Inhalte, Unterseiten oder Produkte klar strukturiert sind und Sie
                leicht und schnell finden, wonach Sie suchen. Um Ihnen die bestmögliche
                Erfahrung auf unserer Website zu bieten, verwenden wir auch sogenannte
                Webdesign-Tools von Drittanbietern. Unter die Kategorie „Webdesign“ fallen
                in dieser Datenschutzerklärung also alle Dienste, die unsere Website
                gestalterisch verbessern. Das können beispielsweise Schriftarten, diverse
                Plugins oder andere eingebundene Webdesign-Funktionen sein.
            </p>
            <h3 className="adsimple-112958647">Warum verwenden wir Webdesign-Tools?</h3>
            <p>
                Wie Sie Informationen auf einer Website aufnehmen, hängt sehr stark von der
                Struktur, der Funktionalität und der visuellen Wahrnehmung der Website ab.
                Daher wurde auch für uns ein gutes und professionelles Webdesign immer
                wichtiger. Wir arbeiten ständig an der Verbesserung unserer Website und
                sehen dies auch als erweiterte Dienstleistung für Sie als Websitebesucher.
                Weiters hat eine schöne und funktionierende Website auch wirtschaftliche
                Vorteile für uns. Schließlich werden Sie uns nur besuchen und unsere
                Angebote in Anspruch nehmen, wenn Sie sich rundum wohl fühlen.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch Webdesign-Tools gespeichert?
            </h3>
            <p>
                Wenn Sie unsere Website besuchen, können Webdesign-Elemente in unseren
                Seiten eingebunden sein, die auch Daten verarbeiten können. Um welche Daten
                es sich genau handelt, hängt natürlich stark von den verwendeten Tools ab.
                Weiter unter sehen Sie genau, welche Tools wir für unsere Website verwenden.
                Wir empfehlen Ihnen für nähere Informationen über die Datenverarbeitung auch
                die jeweilige Datenschutzerklärung der verwendeten Tools durchzulesen.
                Meistens erfahren Sie dort, welche Daten verarbeitet werden, ob Cookies
                eingesetzt werden und wie lange die Daten aufbewahrt werden. Durch
                Schriftarten wie etwa Google Fonts werden beispielsweise auch Informationen
                wie Spracheinstellungen, IP-Adresse, Version des Browsers,
                Bildschirmauflösung des Browsers und Name des Browsers automatisch an die
                Google-Server übertragen.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Wie lange Daten verarbeitet werden, ist sehr individuell und hängt von den
                eingesetzten Webdesign-Elementen ab. Wenn Cookies beispielsweise zum Einsatz
                kommen, kann die Aufbewahrungsdauer nur eine Minute, aber auch ein paar
                Jahre dauern. Machen Sie sich diesbezüglich bitte schlau. Dazu empfehlen wir
                Ihnen einerseits unseren allgemeinen Textabschnitt über Cookies sowie die
                Datenschutzerklärungen der eingesetzten Tools. Dort erfahren Sie in der
                Regel, welche Cookies genau eingesetzt werden, und welche Informationen
                darin gespeichert werden. Google-Font-Dateien werden zum Beispiel ein Jahr
                gespeichert. Damit soll die Ladezeit einer Website verbessert werden.
                Grundsätzlich werden Daten immer nur so lange aufbewahrt, wie es für die
                Bereitstellung des Dienstes nötig ist. Bei gesetzlichen Vorschreibungen
                können Daten auch länger gespeichert werden.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur
                Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert
                entweder über unser Cookie-Management-Tool oder über andere
                Opt-Out-Funktionen. Sie können auch die Datenerfassung durch Cookies
                verhindern, indem Sie in Ihrem Browser die Cookies verwalten, deaktivieren
                oder löschen. Unter Webdesign-Elementen (meistens bei Schriftarten) gibt es
                allerdings auch Daten, die nicht ganz so einfach gelöscht werden können. Das
                ist dann der Fall, wenn Daten direkt bei einem Seitenaufruf automatisch
                erhoben und an einen Drittanbieter (wie z. B. Google) übermittelt werden.
                Wenden Sie sich dann bitte an den Support des entsprechenden Anbieters. Im
                Fall von Google erreichen Sie den Support unter
                <a className="adsimple-112958647" href="https://support.google.com/?hl=de">
                https://support.google.com/?hl=de
                </a>
                .
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Webdesign-Tools eingesetzt werden dürfen,
                ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese
                Einwilligung. Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO
                (Einwilligung) die Rechtsgrundlage für die Verarbeitung personenbezogener
                Daten, wie sie bei der Erfassung durch Webdesign-Tools vorkommen kann, dar.
                Von unserer Seite besteht zudem ein berechtigtes Interesse, das Webdesign
                auf unserer Website zu verbessern. Schließlich können wir Ihnen nur dann ein
                schönes und professionelles Webangebot liefern. Die dafür entsprechende
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen). Wir
                setzen Webdesign-Tools gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben. Das wollen wir hier auf jeden Fall nochmals betonen.
            </p>
            <p>
                Informationen zu speziellen Webdesign-Tools erhalten Sie – sofern vorhanden
                – in den folgenden Abschnitten.
            </p>
            <h2 id="adobe-fonts-datenschutzerklaerung" className="adsimple-112958647">
                Adobe Fonts Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website Adobe Fonts, ein
                Webschriftarten-Hosting-Dienst. Dienstanbieter ist das amerikanische
                Unternehmen Adobe Inc. Für den europäischen Raum ist das irische Unternehmen
                Adobe Systems Software Ireland Companies, 4-6 Riverwalk, Citywest Business
                Campus, Dublin 24, Irland, verantwortlich.
            </p>
            <p>
                Adobe verarbeitet Daten von Ihnen u.a. auch in den USA. Adobe ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Adobe sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2
                und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC)
                sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Adobe, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Adobe finden Sie
                unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.adobe.com/at/privacy/eudatatransfers.html"
                target="_blank"
                rel="follow noopener"
                >
                https://www.adobe.com/at/privacy/eudatatransfers.html
                </a>
                .
            </p>
            <p>
                Mehr über die Daten, die durch die Verwendung von Adobe Fonts verarbeitet
                werden, erfahren Sie in der Privacy Policy auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.adobe.com/at/privacy.html?tid=112958647"
                target="_blank"
                rel="noopener"
                >
                https://www.adobe.com/at/privacy.html
                </a>
                <u>. </u>
            </p>
            <h2 id="google-fonts-datenschutzerklaerung" className="adsimple-112958647">
                Google Fonts Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Google Fonts Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa IP-Adresse und CSS- und
                    Schrift-Anfragen
                    <br />
                    Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: Font-Dateien werden bei Google ein Jahr gespeichert
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was sind Google Fonts?</h3>
            <p>
                Auf unserer Website verwenden wir Google Fonts. Das sind die
                “Google-Schriften” der Firma Google Inc. Für den europäischen Raum ist das
                Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4,
                Irland) für alle Google-Dienste verantwortlich.
            </p>
            <p>
                Für die Verwendung von Google-Schriftarten müssen Sie sich nicht anmelden
                bzw. ein Passwort hinterlegen. Weiters werden auch keine Cookies in Ihrem
                Browser gespeichert. Die Dateien (CSS, Schriftarten/Fonts) werden über die
                Google-Domains fonts.googleapis.com und fonts.gstatic.com angefordert. Laut
                Google sind die Anfragen nach CSS und Schriften vollkommen getrennt von
                allen anderen Google-Diensten. Wenn Sie ein Google-Konto haben, brauchen Sie
                keine Sorge haben, dass Ihre Google-Kontodaten, während der Verwendung von
                Google Fonts, an Google übermittelt werden. Google erfasst die Nutzung von
                CSS (Cascading Style Sheets) und der verwendeten Schriftarten und speichert
                diese Daten sicher. Wie die Datenspeicherung genau aussieht, werden wir uns
                noch im Detail ansehen.
            </p>
            <p>
                Google Fonts (früher Google Web Fonts) ist ein Verzeichnis mit über 800
                Schriftarten, die{" "}
                <a
                className="adsimple-112958647"
                href="https://de.wikipedia.org/wiki/Google_LLC?tid=112958647"
                >
                Google
                </a>
                &nbsp;Ihren Nutzern kostenlos zu Verfügung stellen.
            </p>
            <p>
                Viele dieser Schriftarten sind unter der&nbsp;SIL Open Font
                License&nbsp;veröffentlicht, während andere unter
                der&nbsp;Apache-Lizenz&nbsp;veröffentlicht wurden. Beides sind&nbsp;freie
                Software-Lizenzen.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir Google Fonts auf unserer Website?
            </h3>
            <p>
                Mit Google Fonts können wir auf der eigenen Webseite Schriften nutzen, und
                müssen sie nicht auf unserem eigenen Server hochladen. Google Fonts ist ein
                wichtiger Baustein, um die Qualität unserer Webseite hoch zu halten. Alle
                Google-Schriften sind automatisch für das Web optimiert und dies spart
                Datenvolumen und ist speziell für die Verwendung bei mobilen Endgeräten ein
                großer Vorteil. Wenn Sie unsere Seite besuchen, sorgt die niedrige
                Dateigröße für eine schnelle Ladezeit. Des Weiteren sind Google Fonts
                sichere Web Fonts. Unterschiedliche Bildsynthese-Systeme (Rendering) in
                verschiedenen Browsern, Betriebssystemen und mobilen Endgeräten können zu
                Fehlern führen. Solche Fehler können teilweise Texte bzw. ganze Webseiten
                optisch verzerren. Dank des schnellen Content Delivery Network (CDN) gibt es
                mit Google Fonts keine plattformübergreifenden Probleme. Google Fonts
                unterstützt alle gängigen Browser (Google Chrome,&nbsp;Mozilla
                Firefox,&nbsp;Apple Safari,&nbsp;Opera) und funktioniert zuverlässig auf den
                meisten modernen mobilen Betriebssystemen, einschließlich Android 2.2+ und
                iOS 4.2+ (iPhone, iPad, iPod). Wir verwenden die Google Fonts also, damit
                wir unser gesamtes Online-Service so schön und einheitlich wie möglich
                darstellen können.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden von Google gespeichert?
            </h3>
            <p>
                Wenn Sie unsere Webseite besuchen, werden die Schriften über einen
                Google-Server nachgeladen. Durch diesen externen Aufruf werden Daten an die
                Google-Server übermittelt. So erkennt Google auch, dass Sie bzw. Ihre
                IP-Adresse unsere Webseite besucht. Die Google Fonts API wurde entwickelt,
                um Verwendung, Speicherung und Erfassung von Endnutzerdaten auf das zu
                reduzieren, was für eine ordentliche Bereitstellung von Schriften nötig
                ist.&nbsp;API steht übrigens für „Application Programming Interface“ und
                dient unter anderem als Datenübermittler im Softwarebereich.
            </p>
            <p>
                Google Fonts speichert CSS- und Schrift-Anfragen sicher bei Google und ist
                somit geschützt.&nbsp;Durch die gesammelten Nutzungszahlen kann Google
                feststellen, wie gut die einzelnen Schriften ankommen. Die Ergebnisse
                veröffentlicht Google auf internen Analyseseiten, wie beispielsweise Google
                Analytics. Zudem verwendet Google auch Daten des eigenen Web-Crawlers, um
                festzustellen, welche Webseiten Google-Schriften verwenden. Diese Daten
                werden in der BigQuery-Datenbank von Google Fonts veröffentlicht.
                Unternehmer und Entwickler nützen das Google-Webservice&nbsp;BigQuery, um
                große Datenmengen untersuchen und bewegen zu können.
            </p>
            <p>
                Zu bedenken gilt allerdings noch, dass durch jede Google Font Anfrage auch
                Informationen wie&nbsp;Spracheinstellungen, IP-Adresse, Version des
                Browsers, Bildschirmauflösung des Browsers und Name des Browsers automatisch
                an die Google-Server übertragen werden. Ob diese Daten auch gespeichert
                werden, ist nicht klar feststellbar bzw. wird von Google nicht eindeutig
                kommuniziert.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Anfragen für CSS-Assets speichert Google einen Tag lang auf seinen Servern,
                die hauptsächlich außerhalb der EU angesiedelt sind. Das ermöglicht uns,
                mithilfe eines Google-Stylesheets die Schriftarten zu nutzen. Ein Stylesheet
                ist eine Formatvorlage, über die man einfach und schnell z.B. das Design
                bzw. die Schriftart einer Webseite ändern kann.
            </p>
            <p>
                Die Font-Dateien werden bei Google ein Jahr gespeichert. Google verfolgt
                damit das Ziel, die Ladezeit von Webseiten grundsätzlich zu verbessern. Wenn
                Millionen von Webseiten auf die gleichen Schriften verweisen, werden sie
                nach dem ersten Besuch zwischengespeichert und erscheinen sofort auf allen
                anderen später besuchten Webseiten wieder. Manchmal aktualisiert Google
                Schriftdateien, um die Dateigröße zu reduzieren, die Abdeckung von Sprache
                zu erhöhen und das Design zu verbessern.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Jene Daten, die Google für einen Tag bzw. ein Jahr speichert können nicht
                einfach gelöscht werden. Die Daten werden beim Seitenaufruf automatisch an
                Google übermittelt. Um diese Daten vorzeitig löschen zu können, müssen Sie
                den Google-Support auf{" "}
                <a
                className="adsimple-112958647"
                href="https://support.google.com/?hl=de&tid=112958647"
                >
                https://support.google.com/?hl=de&amp;tid=112958647
                </a>
                kontaktieren. Datenspeicherung verhindern Sie in diesem Fall nur, wenn Sie
                unsere Seite nicht besuchen.
            </p>
            <p>
                Anders als andere Web-Schriften erlaubt uns Google uneingeschränkten Zugriff
                auf alle Schriftarten. Wir können also unlimitiert auf ein Meer an
                Schriftarten zugreifen und so das Optimum für unsere Webseite rausholen.
                Mehr zu Google Fonts und weiteren Fragen finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://developers.google.com/fonts/faq?tid=112958647"
                >
                https://developers.google.com/fonts/faq?tid=112958647
                </a>
                . Dort geht zwar Google auf datenschutzrelevante Angelegenheiten ein, doch
                wirklich detaillierte Informationen über Datenspeicherung sind nicht
                enthalten. Es ist relativ schwierig, von Google wirklich präzise
                Informationen über gespeicherten Daten zu bekommen.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Google Fonts eingesetzt werden darf, ist
                die Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung.
                Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch Google Fonts vorkommen kann, dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, Google Font zu
                verwenden, um unser Online-Service zu optimieren. Die dafür entsprechende
                Rechtsgrundlage ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen Google Font gleichwohl nur ein, soweit Sie eine Einwilligung
                erteilt haben.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
                Terms), welche auf die Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
                .
            </p>
            <p>
                Welche Daten grundsätzlich von Google erfasst werden und wofür diese Daten
                verwendet werden, können Sie auch auf{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de&tid=112958647"
                >
                https://www.google.com/intl/de/policies/privacy/
                </a>
                nachlesen.
            </p>
            <h2
                id="google-fonts-lokal-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Google Fonts Lokal Datenschutzerklärung
            </h2>
            <p>
                Auf unserer Website nutzen wir Google Fonts der Firma Google Inc. Für den
                europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon House,
                Barrow Street Dublin 4, Irland) verantwortlich. Wir haben die
                Google-Schriftarten lokal, d.h. auf unserem Webserver – nicht auf den
                Servern von Google – eingebunden. Dadurch gibt es keine Verbindung zu
                Google-Servern und somit auch keine Datenübertragung oder Speicherung.
            </p>
            <h3 className="adsimple-112958647">Was sind Google Fonts?</h3>
            <p>
                Früher nannte man Google Fonts auch Google Web Fonts. Dabei handelt es sich
                um ein interaktives Verzeichnis mit über 800 Schriftarten, die{" "}
                <a
                className="adsimple-112958647"
                href="https://de.wikipedia.org/wiki/Google_LLC?tid=112958647"
                >
                Google
                </a>
                &nbsp;kostenlos bereitstellt. Mit Google Fonts könnte man Schriften nutzen,
                ohne sie auf den eigenen Server hochzuladen. Doch um diesbezüglich jede
                Informationsübertragung zu Google-Servern zu unterbinden, haben wir die
                Schriftarten auf unseren Server heruntergeladen. Auf diese Weise handeln wir
                datenschutzkonform und senden keine Daten an Google Fonts weiter.
            </p>
            <h2 id="content-suchanbieter-einleitung" className="adsimple-112958647">
                Content-Suchanbieter Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Content-Suchanbieter Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Verbesserung der Nutzererfahrung
                    <br />
                    📓 Verarbeitete Daten: Welche Daten verarbeitet werden, hängt stark
                    von den verwendeten Diensten ab. Meist handelt es sich um IP-Adresse,
                    Suchinteressen und/oder technische Daten. Mehr Details dazu finden Sie
                    bei den jeweils eingesetzten Tools.
                    <br />
                    📅 Speicherdauer: abhängig von den eingesetzten Tools
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist ein Content-Suchanbieter?</h3>
            <p>
                Mittlerweile haben wir schon richtig viele Inhalte auf unserer Website
                veröffentlicht. Und natürlich wollen wir nicht, dass diese einfach so in
                Vergessenheit geraten, nur weil sie nicht gefunden werden. Darum nutzen wir
                auf unserer Website einen Content-Suchanbieter. Große Suchmaschinen wie
                Google kennen Sie bestimmt. Bei Content-Suchanbieter handelt es sich im
                Grunde ebenfalls um eine Suchmaschine, die allerdings im Unterschied zu
                Google nicht das ganze Web nach Inhalten durchforstet, sondern nur die
                Website, auf der Sie sich befinden. Über ein Textfeld können Sie Begriffe,
                die zu den gesuchten Inhalten passen, eingeben und das Suchprogramm sucht
                Ihnen die gewünschten Beiträge. Wenn Sie die eingebundene Suchfunktion
                nutzen, können auch personenbezogene Daten von Ihnen verarbeitet werden.
            </p>
            <h3 className="adsimple-112958647">
                Warum nutzen wir einen Content-Suchanbieter?
            </h3>
            <p>
                Wenn Sie sich auf unserer Website umsehen, merken Sie schnell, wie viele
                nützliche Inhalte wir über die Jahre bereits veröffentlicht haben. Da sind
                richtige Schätze dabei und wir wollen, dass Sie diese ohne langem
                Herumklicken auch schnell finden. Mit einer Content-Suchfunktion direkt in
                unserer Website können Sie mit Hilfe von Schlagwörtern, die zum gesuchten
                Thema passen, schnell und einfach die gesuchten Inhalte finden. Dieses
                Feature ist wirklich praktisch und wir sehen es auch als unsere Aufgabe,
                Ihnen das Leben auf unserer Website so angenehm und hilfreich wie möglich zu
                gestalten. Darum haben wir uns dafür entschieden ein Programm für die
                Content-Suche in unsere Website einzubinden.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Wenn Sie die Suchfunktion auf unserer Website nutzen, kann der eingebundene
                Content-Suchanbieter (wie z. B. Algolia Places oder Giphy) automatisch Daten
                von Ihnen erhalten und speichern. Dabei handelt es sich um technische Daten
                zu Ihrem Browser sowie Daten wie zum Beispiel Ihre IP-Adresse, Geräte-ID und
                die eingegebenen Suchbegriffe. Bitte achten Sie darauf, dass es sich bei
                IP-Adressen um personenbezogene Daten handelt. In den Datenschutzerklärungen
                der Anbieter ist zu lesen, dass diese Informationen gesammelt und
                gespeichert werden, um die Sicherheit zu erhöhen und die eigenen Dienste zu
                verbessern. Die automatisch erfassten Nutzungsdaten, die keine
                personenbezogene Daten umfassen und in anonymisierter Form verarbeitet
                werden, können weiters auch zu Analysezwecken eingesetzt werden. Manche
                Anbieter geben diese anonymisierten Daten auch an Dritte weiter. Um
                diesbezüglich Näheres zu erfahren, empfehlen wir Ihnen die konkreten
                Datenschutzerklärungen der einzelnen Anbieter genau durchzulesen. Damit die
                Dienste einwandfrei funktionieren, werden in der Regel auch Cookies in Ihrem
                Browser gesetzt. Mehr über Cookies können Sie in unserem allgemeinen
                Abschnitt „Cookies“ erfahren. Ob und welche Cookies die einzelnen Such-Tools
                verwenden, erfahren Sie – sofern vorhanden – weiter unten oder in den
                entsprechenden Datenschutzerklärungen der eingebundenen Tools.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Grundsätzlich gilt: jeder Content-Suchanbieter verarbeitet unterschiedliche
                Daten. Daher kann in diesem allgemeinen Abschnitt nicht konkret auf die
                Datenverarbeitung der einzelnen Tools eingegangen werden. Für gewöhnlich
                speichern die Dienste aber personenbezogene Daten nur, solange dies für ein
                reibungsloses Funktionieren der Tools nötig ist. Manche Dienste (wie z. B.
                Giphy) bewahren personenbezogene Daten auch länger auf, wenn dies aufgrund
                rechtlicher Verpflichtungen erforderlich ist. In entpersonalisierter Form
                werden Daten bei den meisten Anbietern ebenso länger aufbewahrt. Die
                Content-Suchanbieter können zum Speichern von diversen Daten auch Cookies
                verwenden. In unserem allgemeinen Abschnitt über Cookies erfahren Sie mehr
                darüber. Wenn Sie über die konkreten Cookies, die eine Suchanbieter
                verwendet, etwas wissen wollen, empfehlen wir Ihnen die Datenschutzerklärung
                der von uns verwendeten Anbieter. Meist finden Sie dort eine beispielhafte
                Liste der verwendeten Cookies.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Seien Sie sich immer bewusst: wenn Sie nicht wollen, dürfen keine
                personenbezogenen Daten von Ihnen verarbeitet werden. Immer haben Sie das
                Recht auf Ihre personenbezogenen Daten zuzugreifen und gegen die Nutzung
                Einspruch zu erheben. Auch Ihre Einwilligung können Sie jederzeit über das
                Cookie-Consent-Tool oder über andere Opt-Out-Optionen widerrufen. Verwendete
                Cookies können Sie über Ihren Browser auch ganz einfach selbst verwalten,
                löschen oder deaktivieren. Wenn Sie Cookies löschen, könnte es sein, dass
                ein paar Funktionen des Tools nicht mehr funktionieren. Also darüber bitte
                nicht wundern. Wie Sie in Ihrem Browser die Cookies verwalten, hängt auch
                von Ihrem benutzten Browser ab. Im Abschnitt „Cookies“ finden Sie auch Links
                zu den Anleitungen der wichtigsten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass ein Content-Suchanbieter eingesetzt werden
                darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese
                Einwilligung. Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO
                (Einwilligung) die Rechtsgrundlage für die Verarbeitung personenbezogener
                Daten, wie sie bei der Erfassung durch einen Content-Suchanbieter vorkommen
                kann, dar.
            </p>
            <p>
                Wir haben zudem auch ein berechtigtes Interesse, einen Content-Suchanbieter
                zu verwenden, um unser Service auf unserer Website zu optimieren. Die dafür
                entsprechende Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                Interessen). Wir setzen einen Content-Suchanbieter allerdings immer nur dann
                ein, wenn Sie eine Einwilligung erteilt haben. Das wollen wir an dieser
                Stelle unbedingt nochmals festgehalten haben.
            </p>
            <p>
                Informationen zu speziellen Content-Suchanbieter erhalten Sie – sofern
                vorhanden – in den folgenden Abschnitten.
            </p>
            <h2
                id="benutzerdefinierte-google-suche-datenschutzerklaerung"
                className="adsimple-112958647"
            >
                Benutzerdefinierte Google Suche Datenschutzerklärung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Benutzerdefinierte Google Suche Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Optimierung unserer Serviceleistung
                    <br />
                    📓 Verarbeitete Daten: Daten wie etwa IP-Adresse und eingegebene
                    Suchbegriffe werden bei Google gespeichert
                    <br />
                    Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.
                    <br />
                    📅 Speicherdauer: die Speicherdauer variiert abhängig von den
                    gespeicherten Daten
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">
                Was ist die benutzerdefinierte Google Suche?
            </h3>
            <p>
                Wir haben auf unserer Website das Google-Plug-in zur benutzerdefinierten
                Suche eingebunden. Google ist die größte und bekannteste Suchmaschine
                weltweit und wird von dem US-amerikanische Unternehmen Google Inc.
                betrieben. Für den europäischen Raum ist das Unternehmen Google Ireland
                Limited (Gordon House, Barrow Street Dublin 4, Irland) verantwortlich. Durch
                die benutzerdefinierte Google Suche können Daten von Ihnen an Google
                übertragen werden. In dieser Datenschutzerklärung informieren wir Sie, warum
                wir dieses Plug-in verwenden, welche Daten verarbeitet werden und wie Sie
                diese Datenübertragung verwalten oder unterbinden können.
            </p>
            <p>
                Das Plug-in zur benutzerdefinierten Google Suche ist eine Google-Suchleiste
                direkt auf unserer Website. Die Suche findet wie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://www.google.com?tid=112958647"
                target="_blank"
                rel="follow noopener noreferrer"
                >
                www.google.com
                </a>{" "}
                statt, nur fokussieren sich die Suchergebnisse auf unsere Inhalte und
                Produkte bzw. auf einen eingeschränkten Suchkreis.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir die benutzerdefinierte Google Suche auf unserer Website?
            </h3>
            <p>
                Eine Website mit vielen interessanten Inhalten wird oft so groß, dass man
                unter Umständen den Überblick verliert. Über die Zeit hat sich auch bei uns
                viel wertvolles Material angesammelt und wir wollen als Teil unserer
                Dienstleistung, dass Sie unsere Inhalte so schnell und einfach wie möglich
                finden. Durch die benutzerdefinierte Google-Suche wird das Finden von
                interessanten Inhalten zu einem Kinderspiel. Das eingebaute Google-Plug-in
                verbessert insgesamt die Qualität unserer Website und macht Ihnen das Suchen
                leichter.
            </p>
            <h3 className="adsimple-112958647">
                Welche Daten werden durch die benutzerdefinierte Google Suche gespeichert?
            </h3>
            <p>
                Durch die benutzerdefinierte Google-Suche werden nur Daten von Ihnen an
                Google übertragen, wenn Sie die auf unserer Website eingebaute Google-Suche
                aktiv verwenden. Das heißt, erst wenn Sie einen Suchbegriff in die
                Suchleiste eingeben und dann diesen Begriff bestätigen (z.B. auf „Enter“
                klicken) wird neben dem Suchbegriff auch Ihre IP-Adresse an Google gesandt,
                gespeichert und dort verarbeitet. Anhand der gesetzten Cookies (wie z.B.
                1P_JAR) ist davon auszugehen, dass Google auch Daten zur Webseiten-Nutzung
                erhält. Wenn Sie während Ihrem Besuch auf unserer Webseite, über die
                eingebaute Google-Suchfunktion, Inhalte suchen und gleichzeitig mit Ihrem
                Google-Konto angemeldet sind, kann Google die erhobenen Daten auch Ihrem
                Google-Konto zuordnen. Als Websitebetreiber haben wir keinen Einfluss
                darauf, was Google mit den erhobenen Daten macht bzw. wie Google die Daten
                verarbeitet.
            </p>
            <p>
                Folgende Cookie werden in Ihrem Browser gesetzt, wenn Sie die
                benutzerdefinierte Google Suche verwenden und nicht mit einem Google-Konto
                angemeldet sind:
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> 1P_JAR
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong>{" "}
                2020-01-27-13112958647-5
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong>
                &nbsp;Dieses Cookie sammelt Statistiken zur Website-Nutzung und misst
                Conversions. Eine Conversion entsteht zum Beispiel, wenn ein User zu einem
                Käufer wird. Das Cookie wird auch verwendet, um Usern relevante
                Werbeanzeigen einzublenden.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach einem
                Monat
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> CONSENT
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> WP.282f52112958647-9
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong>&nbsp;Das
                Cookie speichert den Status der Zustimmung eines Users zur Nutzung
                unterschiedlicher Services von Google. CONSENT dient auch der Sicherheit, um
                User zu überprüfen und Userdaten vor unbefugten Angriffen zu schützen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 18 Jahren
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Name:</strong> NID
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Wert:</strong> 196=pwIo3B5fHr-8
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Verwendungszweck:</strong>&nbsp;NID
                wird von Google verwendet, um Werbeanzeigen an Ihre Google-Suche anzupassen.
                Mit Hilfe des Cookies „erinnert“ sich Google an Ihre eingegebenen
                Suchanfragen oder Ihre frühere Interaktion mit Anzeigen. So bekommen Sie
                immer maßgeschneiderte Werbeanzeigen.
                <br />
                <strong className="adsimple-112958647 text-[#787c87]">Ablaufdatum:</strong> nach 6 Monaten
            </p>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung:</strong> Diese Aufzählung
                kann keinen Anspruch auf Vollständigkeit erheben, da Google die Wahl ihrer
                Cookies immer wieder auch verändert.
            </p>
            <h3 className="adsimple-112958647">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Die Google-Server sind auf der ganzen Welt verteilt. Da es sich bei Google
                um ein amerikanisches Unternehmen handelt, werden die meisten Daten auf
                amerikanischen Servern gespeichert. Unter{" "}
                <a
                className="adsimple-112958647"
                href="https://www.google.com/about/datacenters/locations/?hl=de"
                target="_blank"
                rel="follow noopener"
                >
                https://www.google.com/about/datacenters/locations/?hl=de
                </a>
                &nbsp;sehen Sie genau, wo die Google-Server stehen.
                <br />
                Ihre Daten werden auf verschiedenen physischen Datenträgern verteilt.
                Dadurch sind die Daten schneller abrufbar und vor möglichen Manipulationen
                besser geschützt. Google hat auch entsprechende Notfallprogramme für Ihre
                Daten. Wenn es beispielsweise bei Google interne technische Probleme gibt
                und dadurch Server nicht mehr funktionieren, bleibt das Risiko einer
                Dienstunterbrechung und eines Datenverlusts dennoch gering.
                <br />
                Je nach dem um welche Daten es sich handelt, speichert Google diese
                unterschiedlich lange. Manche Daten können Sie selbst löschen, andere werden
                von Google automatisch gelöscht oder anonymisiert. Es gibt aber auch Daten,
                die Google länger speichert, wenn dies aus juristischen oder geschäftlichen
                Gründen erforderlich ist.
            </p>
            <h3 className="adsimple-112958647">
                Wie kann ich meinen Daten löschen bzw. die Datenspeicherung verhindern?
            </h3>
            <p>
                Nach dem Datenschutzrecht der Europäischen Union haben Sie das Recht,
                Auskunft über Ihre Daten zu erhalten, sie zu aktualisieren, zu löschen oder
                einzuschränken. Es gibt einige Daten, die Sie jederzeit löschen können. Wenn
                Sie ein Google-Konto besitzen, können Sie dort Daten zu Ihrer Webaktivität
                löschen bzw. festlegen, dass sie nach einer bestimmten Zeit gelöscht werden
                sollen.
                <br />
                In Ihrem Browser haben Sie zudem die Möglichkeit, Cookies zu deaktivieren,
                zu löschen oder nach Ihren Wünschen und Vorlieben zu verwalten. Unter dem
                Abschnitt „Cookies“ finden Sie die entsprechenden Links zu den jeweiligen
                Anleitungen der bekanntesten Browser.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass die benutzerdefinierte Google Suche
                eingesetzt werden darf, ist die Rechtsgrundlage der entsprechenden
                Datenverarbeitung diese Einwilligung. Diese Einwilligung stellt laut
                <strong className="adsimple-112958647 text-[#787c87]">
                {" "}
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </strong>{" "}
                die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie
                bei der Erfassung durch die benutzerdefinierte Google Suche vorkommen kann,
                dar.
            </p>
            <p>
                Von unserer Seite besteht zudem ein berechtigtes Interesse, die
                benutzerdefinierte Google Suche zu verwenden, um unser Online-Service zu
                optimieren. Die dafür entsprechende Rechtsgrundlage ist{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </strong>
                . Wir setzen die benutzerdefinierte Google Suche gleichwohl nur ein, soweit
                Sie eine Einwilligung erteilt haben.
            </p>
            <p>
                Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver
                Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und
                sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                {" "}
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs.
                2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses –
                SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
            </p>
            <p>
                Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing
                Terms), welche auf die Standardvertragsklauseln verweisen, finden Sie unter{" "}
                <a
                className="adsimple-112958647"
                href="https://business.safety.google/intl/de/adsprocessorterms/"
                target="_blank"
                rel="follow noopener"
                >
                https://business.safety.google/intl/de/adsprocessorterms/
                </a>
            </p>
            <p>
                Wir hoffen wir konnten Ihnen die wichtigsten Informationen rund um die
                Datenverarbeitung durch Google näherbringen. Wenn Sie mehr darüber erfahren
                wollen, empfehlen wir die umfangreiche Datenschutzerklärung von Google unter{" "}
                <a
                className="adsimple-112958647"
                href="https://policies.google.com/privacy?hl=de?tid=112958647"
                target="_blank"
                rel="follow noopener noreferrer"
                >
                https://policies.google.com/privacy?hl=de
                </a>
                .
            </p>
            <h2 id="online-buchungssysteme-einleitung" className="adsimple-112958647">
                Online-Buchungssysteme Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Online-Buchungssysteme Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Verbesserung der Nutzererfahrung und Organisation
                    <br />
                    📓 Verarbeitete Daten: Welche Daten verarbeitet werden, hängt stark
                    von den verwendeten Diensten ab. Meist handelt es sich um IP-Adresse,
                    Kontakt- und Bezahldaten und/oder technische Daten. Mehr Details dazu
                    finden Sie bei den jeweils eingesetzten Tools.
                    <br />
                    📅 Speicherdauer: abhängig von den eingesetzten Tools
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was ist ein Online-Buchungssystem?</h3>
            <p>
                Damit Sie über unsere Website Buchungen vornehmen können, nutzen wir ein
                oder mehrere Buchungssysteme. Termine etwa können so ganz einfach online
                erstellt werden. Ein Buchungssystem ist eine in unsere Website eingebundene
                Softwareanwendung, die verfügbare Ressourcen (wie zum Beispiel freie
                Termine) anzeigt und über die Sie direkt online buchen und meist auch
                bezahlen können. Sie kennen wahrscheinlich solche Buchungssysteme bereits
                aus der Gastronomie oder Hotellerie. Mittlerweile werden solche Systeme aber
                in den verschiedensten Branchen angewandt. Buchungssysteme können je nach
                Tool und Einstellungen sowohl intern für uns als auch für Kunden wie Sie
                genutzt werden. Dabei werden in der Regel auch personenbezogene Daten von
                Ihnen erhoben und gespeichert.
            </p>
            <p>
                Meistens funktioniert die Buchung wie folgt: Sie finden auf unsere Website
                das Buchungssystem, in dem Sie per Mausklick und Angaben Ihrer Daten direkt
                einen Termin für eine Dienstleistung buchen und meist auch gleich bezahlen
                können. Es kann sein, dass Sie über ein Formular verschiedene Angaben über
                Ihre Person eintragen können. Bitte seien Sie sich bewusst, dass alle von
                Ihnen eingegebenen Daten in einer Datenbank gespeichert und verwaltet werden
                können.
            </p>
            <h3 className="adsimple-112958647">
                Warum nutzen wir ein Online-Buchungssystem?
            </h3>
            <p>
                Wir verstehen unsere Website in gewisser Weise auch als freie Dienstleistung
                für Sie. Sie sollen hilfreiche Informationen erhalten und sich auf unsere
                Seite rundum wohl fühlen. Dazu gehört auch ein Online-Service, das Ihnen das
                Buchen von Terminen bzw. Dienstleistungen so einfach wie möglich macht.
                Vorbei sind die Zeiten, in denen Sie umständlich via Telefon oder E-Mail
                tagelang auf eine Buchungsbestätigung warten mussten. Mit einem
                Online-Buchungssystem haben Sie nach wenigen Klicks alles erledigt und
                können sich wieder um andere Dinge kümmern. Auch für uns erleichtert das
                System das Management aller Buchungen und Termine. Daher betrachten wir ein
                solches Buchungssystem sowohl für Sie als auch für uns als absolut sinnvoll.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Welche Daten genau verarbeitet werden, können wir Ihnen in diesem
                allgemeinen Informationstext über Buchungssystem natürlich nicht sagen. Das
                ist stets vom verwendeten Tool und den darin enthaltenen Funktionen und
                Möglichkeiten abhängig. Viele Buchungssysteme bieten neben der herkömmlichen
                Buchungsfunktion auch noch eine Reihe an weiteren Features an. So haben
                beispielsweise viele Systeme auch ein externes Online-Zahlsystem (z. B. von
                Stripe, Klarna oder Paypal) und eine Kalender-Synchronisierungsfunktion
                integriert. Dementsprechend können je nach Funktionen unterschiedliche und
                unterschiedlich viele Daten verarbeitet werden. Für gewöhnlich werden Daten
                wie IP-Adresse, Name und Kontaktdaten, technische Angaben zu Ihrem Gerät und
                Zeitpunkt einer Buchung verarbeitet. Wenn Sie im System auch eine Zahlung
                vornehmen, werden auch Bankdaten wie Kontonummer, Kreditkartennummer,
                Passwörter, TANs usw. gespeichert und an den jeweiligen Zahlungsanbieter
                weitergegeben. Wir empfehlen Ihnen die jeweilige Datenschutzerklärung des
                verwendeten Tools genau durchzulesen, damit Sie wissen, welche Daten von
                Ihnen konkret verarbeitet werden.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Jedes Buchungssystem speichert Daten unterschiedlich lange. Darum können wir
                über die Dauer der Datenverarbeitung hier noch keine konkreten Angaben
                geben. Grundsätzlich werden allerdings personenbezogene Daten immer nur so
                lange gespeichert, wie es zur Bereitstellung der Dienste unbedingt nötig
                ist. Buchungssystem verwenden in der Regel auch Cookies, die Informationen
                unterschiedlich lange speichern. Manche Cookies werden sofort nach Verlassen
                der Seite wieder gelöscht, andere können einige Jahre gespeichert werden. In
                unserem Abschnitt „Cookies“ erfahren Sie mehr darüber. Schauen Sie sich
                bitte auch die jeweiligen Datenschutzerklärungen der Anbieter an. Darin
                sollte erläutert werden, wie lange Ihre Daten im konkreten Fall gespeichert
                werden.
            </p>
            <h3 className="adsimple-112958647">Widerspruchsrecht</h3>
            <p>
                Wenn Sie der Datenverarbeitung durch ein Buchungssystem zugestimmt haben,
                haben Sie natürlich auch immer die Möglichkeit und das Recht diese
                Einwilligung zu widerrufen. Seien Sie sich also bitte stets bewusst, dass
                Sie Rechte in Bezug auf Ihre personenbezogenen Daten haben und diese Rechte
                auch jederzeit wirkend machen können. Wenn Sie nicht wollen, dass
                personenbezogene Daten verarbeitet werden, dann dürfen auch keine
                personenbezogenen Daten verarbeitet werden. So einfach ist das. Am
                einfachsten widerrufen Sie die Datenverarbeitung über ein
                Cookie-Consent-Tool oder über andere angebotene Opt-Out-Funktionen. Die
                Datenspeicherung durch Cookies können Sie zum Beispiel auch direkt in Ihrem
                Browser verwalten. Bis zu Ihrem Widerruf bleibt die Rechtmäßigkeit der
                Datenverwaltung unberührt.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn Sie eingewilligt haben, dass Buchungssysteme eingesetzt werden dürfen,
                ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese
                Einwilligung. Sie stellt laut Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) die
                Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie durch
                Buchungssysteme vorkommen kann, dar.
            </p>
            <p>
                Weiters haben auch wir ein berechtigtes Interesse, Buchungssysteme zu
                verwenden, weil wir damit einerseits unser Kundenservice erweitern und
                andererseits unsere interne Buchungsorganisation optimieren. Die dafür
                entsprechende Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                Interessen). Wir setzen die Tools gleichwohl nur ein, soweit Sie eine
                Einwilligung erteilt haben. Das wollen wir an dieser Stelle unbedingt
                nochmals festgehalten haben.
            </p>
            <p>
                Informationen zu speziellen Buchungssystemen erhalten Sie – sofern vorhanden
                – in den folgenden Abschnitten.
            </p>
            <h2 id="calendly-datenschutzerklaerung" className="adsimple-112958647">
                Calendly Datenschutzerklärung
            </h2>
            <p>
                Wir nutzen auch das Online-Buchungssystem Calendly. Dienstanbieter ist das
                amerikanische Unternehmen Calendly Inc., 115 E. Main St., Ste A1B, Buford,
                GA 30518, USA.
            </p>
            <p>
                Calendly verarbeitet Daten von Ihnen u.a. auch in den USA. Calendly ist
                aktiver Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte
                und sichere Datentransfer personenbezogener Daten von EU-Bürgern in die USA
                geregelt wird. Mehr Informationen dazu finden Sie auf{" "}
                <a
                className="adsimple-112958647"
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                rel="follow noopener"
                >
                https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en
                </a>
                .
            </p>
            <p>
                Zudem verwendet Calendly sogenannte Standardvertragsklauseln (= Art. 46.
                Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses
                – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen
                sicherstellen, dass Ihre Daten auch dann den europäischen
                Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
                beispielsweise in die USA) überliefert und dort gespeichert werden. Durch
                das EU-US Data Privacy Framework und durch die Standardvertragsklauseln
                verpflichtet sich Calendly, bei der Verarbeitung Ihrer relevanten Daten, das
                europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in den USA
                gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf
                einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
                die entsprechenden Standardvertragsklauseln u.a. hier:{" "}
                <a
                className="adsimple-112958647"
                href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                target="_blank"
                rel="follow noopener"
                >
                https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de
                </a>
                .
            </p>
            <p>
                Mehr Informationen zu den Standardvertragsklauseln bei Calendly finden Sie
                in den Datenverarbeitungsbedingungen unter
                <a
                className="adsimple-112958647"
                href="https://calendly.com/dpa"
                target="_blank"
                rel="follow noopener"
                >
                https://calendly.com/dpa
                </a>
                .
            </p>
            <p>
                Wir hoffen, wir konnten Ihnen die wichtigsten Informationen rund um die
                Datenverarbeitung von Calendly näherbringen. Mehr über die Daten, die durch
                die Verwendung von Calendly verarbeitet werden, erfahren Sie in der
                Datenschutzerklärung auf{" "}
                <a
                className="adsimple-112958647"
                href="https://calendly.com/privacy?tid=112958647"
                target="_blank"
                rel="follow noopener"
                >
                https://calendly.com/privacy
                </a>
                .
            </p>
            <h2 id="sonstiges-einleitung" className="adsimple-112958647">
                Sonstiges Einleitung
            </h2>
            <table border={1} cellPadding={15}>
                <tbody>
                <tr>
                    <td>
                    <strong className="adsimple-112958647 text-[#787c87]">
                        Sonstiges Datenschutzerklärung Zusammenfassung
                    </strong>
                    <br />
                    👥 Betroffene: Besucher der Website
                    <br />
                    🤝 Zweck: Verbesserung der Nutzererfahrung
                    <br />
                    📓 Verarbeitete Daten: Welche Daten verarbeitet werden, hängt stark
                    von den verwendeten Diensten ab. Meist handelt es sich um IP-Adresse
                    und/oder technische Daten. Mehr Details dazu finden Sie bei den
                    jeweils eingesetzten Tools.
                    <br />
                    📅 Speicherdauer: abhängig von den eingesetzten Tools
                    <br />
                    ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6
                    Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                    </td>
                </tr>
                </tbody>
            </table>
            <h3 className="adsimple-112958647">Was fällt unter „Sonstiges“?</h3>
            <p>
                Unter die Kategorie „Sonstiges“ fallen jene Dienste, die nicht in eine der
                oben genannten Kategorien passen. Dabei handelt es sich in der Regel um
                diverse Plugins und eingebundene Elemente, die unsere Website verbessern. In
                der Regel werden diese Funktionen von Drittanbietern bezogen und in unsere
                Website eingebunden. Beispielsweise handelt es sich dabei um Websuch-Dienste
                wie Algolia Place, Giphy, Programmable Search Engine oder Onlinedienste für
                Wetterdaten wie etwa OpenWeather.
            </p>
            <h3 className="adsimple-112958647">
                Warum verwenden wir weitere Drittanbieter?
            </h3>
            <p>
                Wir wollen Ihnen mit unserer Website das beste Webangebot in unserer Branche
                bieten. Schon lange ist eine Website nicht bloß eine reine Visitenkarte für
                Unternehmen. Vielmehr ist es ein Ort, der Ihnen behilflich sein soll, zu
                finden wonach Sie suchen. Um stets unsere Website für Sie noch interessanter
                und hilfreicher zu machen, nutzen wir diverse Dienste von Drittanbietern.
            </p>
            <h3 className="adsimple-112958647">Welche Daten werden verarbeitet?</h3>
            <p>
                Immer wenn Elemente in unsere Website eingebunden werden, wird Ihre
                IP-Adresse an den jeweiligen Anbieter übermittelt, gespeichert und dort
                verarbeitet werden. Das ist nötig, weil sonst die Inhalte nicht an Ihren
                Browser gesendet werden und folglich nicht entsprechend dargestellt werden.
                Es kann auch vorkommen, dass Dienstanbieter auch Pixel-Tags bzw. Web-Beacons
                verwenden. Das sind kleine Grafiken auf Websites, die eine Logdatei
                aufzeichnen und auch Analysen dieser Datei erstellen können. Mit den
                erhaltenen Informationen können die Anbieter ihre eigenen Marketingmaßnahmen
                verbessern. Neben Pixel-Tags können solche Informationen (wie beispielsweise
                welchen Button Sie klicken oder wann Sie welche Seite aufrufen) auch in
                Cookies gespeichert werden. Darin können neben Analysedaten zu Ihrem
                Webverhalten auch technische Informationen wie etwa Ihr Browsertyp oder Ihr
                Betriebssystem gespeichert werden. Manche Anbieter können die gewonnenen
                Daten auch mit anderen internen Diensten oder auch mit Drittanbieter
                verknüpfen. Jeder Anbieter pflegt einen anderen Umgang mit Ihren Daten.
                Daher empfehlen wir Ihnen sorgfältig die Datenschutzerklärungen der
                jeweiligen Dienste durchzulesen. Wir sind grundsätzlich bemüht, nur Dienste
                zu verwenden, die mit dem Thema Datenschutz sehr vorsichtig umgehen.
            </p>
            <h3 className="adsimple-112958647">Dauer der Datenverarbeitung</h3>
            <p>
                Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten,
                sofern wir weitere Informationen dazu haben. Generell verarbeiten wir
                personenbezogene Daten nur so lange wie es für die Bereitstellung unserer
                Dienstleistungen und Produkte unbedingt notwendig ist.
            </p>
            <h3 className="adsimple-112958647">Rechtsgrundlage</h3>
            <p>
                Wenn wir Sie um Ihre Einwilligung bitte und Sie auch einwilligen, dass wir
                den Dienst verwenden dürfen, gilt dies als Rechtsgrundlage der Verarbeitung
                Ihrer Daten (Art. 6 Abs. 1 lit. a DSGVO). &nbsp;Zusätzlich zur Einwilligung
                besteht von unserer Seite ein berechtigtes Interesse daran, das Verhalten
                der Websitebesucher zu analysieren und so unser Angebot technisch und
                wirtschaftlich zu verbessern. Die Rechtsgrundlage dafür ist&nbsp;Art. 6 Abs.
                1 lit. f DSGVO (Berechtigte Interessen). Wir setzen die Tools gleichwohl nur
                ein, soweit Sie eine Einwilligung erteilt haben.
            </p>
            <p>
                Informationen zu den speziellen Tools, erhalten Sie – sofern vorhanden – in
                den folgenden Abschnitten.
            </p>
            <h2 id="erklaerung-verwendeter-begriffe" className="adsimple-112958647">
                Erklärung verwendeter Begriffe
            </h2>
            <p>
                Wir sind stets bemüht unsere Datenschutzerklärung so klar und verständlich
                wie möglich zu verfassen. Besonders bei technischen und rechtlichen Themen
                ist das allerdings nicht immer ganz einfach. Es macht oft Sinn juristische
                Begriffe (wie z. B. personenbezogene Daten) oder bestimmte technische
                Ausdrücke (wie z. B. Cookies, IP-Adresse) zu verwenden. Wir möchte diese
                aber nicht ohne Erklärung verwenden. Nachfolgend finden Sie nun eine
                alphabetische Liste von wichtigen verwendeten Begriffen, auf die wir in der
                bisherigen Datenschutzerklärung vielleicht noch nicht ausreichend
                eingegangen sind. Falls diese Begriffe der DSGVO entnommen wurden und es
                sich um Begriffsbestimmungen handelt, werden wir hier auch die DSGVO-Texte
                anführen und gegebenenfalls noch eigene Erläuterungen hinzufügen.
            </p>
            <h2 id="auftragsverarbeiter" className="adsimple-112958647">
                Auftragsverarbeiter
            </h2>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Begriffsbestimmung nach Artikel 4 der DSGVO
                </strong>
            </p>
            <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
            <blockquote>
                <p>
                <em>
                    <strong className="adsimple-112958647 text-[#787c87]">„Auftragsverarbeiter“</strong>{" "}
                    eine natürliche oder juristische Person, Behörde, Einrichtung oder
                    andere Stelle, die personenbezogene Daten im Auftrag des
                    Verantwortlichen verarbeitet;
                </em>
                </p>
            </blockquote>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Erläuterung:</strong> Wir sind als
                Unternehmen und Websiteinhaber für alle Daten, die wir von Ihnen verarbeiten
                verantwortlich. Neben den Verantwortlichen kann es auch sogenannte
                Auftragsverarbeiter geben. Dazu zählt jedes Unternehmen bzw. jede Person,
                die in unserem Auftrag personenbezogene Daten verarbeitet.
                Auftragsverarbeiter können folglich, neben Dienstleistern wie Steuerberater,
                etwa auch Hosting- oder Cloudanbieter, Bezahlungs- oder Newsletter-Anbieter
                oder große Unternehmen wie beispielsweise Google oder Microsoft sein.
            </p>
            <h2 id="einwilligung" className="adsimple-112958647">
                Einwilligung
            </h2>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Begriffsbestimmung nach Artikel 4 der DSGVO
                </strong>
            </p>
            <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
            <blockquote>
                <p>
                <em>
                    <strong className="adsimple-112958647 text-[#787c87]">„Einwilligung“</strong> der
                    betroffenen Person jede freiwillig für den bestimmten Fall, in
                    informierter Weise und unmissverständlich abgegebene Willensbekundung in
                    Form einer Erklärung oder einer sonstigen eindeutigen bestätigenden
                    Handlung, mit der die betroffene Person zu verstehen gibt, dass sie mit
                    der Verarbeitung der sie betreffenden personenbezogenen Daten
                    einverstanden ist;
                </em>
                </p>
            </blockquote>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Erläuterung: </strong>In der Regel
                erfolgt bei Websites eine solche Einwilligung über ein Cookie-Consent-Tool.
                Sie kennen das bestimmt. Immer wenn Sie erstmals eine Website besuchen,
                werden Sie meist über einen Banner gefragt, ob Sie der Datenverarbeitung
                zustimmen bzw. einwilligen. Meist können Sie auch individuelle Einstellungen
                treffen und so selbst entscheiden, welche Datenverarbeitung Sie erlauben und
                welche nicht. Wenn Sie nicht einwilligen, dürfen auch keine personenbezogene
                Daten von Ihnen verarbeitet werden. Grundsätzlich kann eine Einwilligung
                natürlich auch schriftlich, also nicht über ein Tool, erfolgen.
            </p>
            <h2 id="personenbezogene-daten" className="adsimple-112958647">
                Personenbezogene Daten
            </h2>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Begriffsbestimmung nach Artikel 4 der DSGVO
                </strong>
            </p>
            <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
            <blockquote>
                <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                    <em>„personenbezogene Daten“</em>
                </strong>
                <em>
                    {" "}
                    alle Informationen, die sich auf eine identifizierte oder
                    identifizierbare natürliche Person (im Folgenden „betroffene Person“)
                    beziehen; als identifizierbar wird eine natürliche Person angesehen, die
                    direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung
                    wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer
                    Online-Kennung oder zu einem oder mehreren besonderen Merkmalen, die
                    Ausdruck der physischen, physiologischen, genetischen, psychischen,
                    wirtschaftlichen, kulturellen oder sozialen Identität dieser natürlichen
                    Person sind, identifiziert werden kann;
                </em>
                </p>
            </blockquote>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Erläuterung:</strong>{" "}
                Personenbezogene Daten sind also all jene Daten, die Sie als Person
                identifizieren können. Das sind in der Regel Daten wie etwa:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">Name</li>
                <li className="adsimple-112958647">Adresse</li>
                <li className="adsimple-112958647">E-Mail-Adresse</li>
                <li className="adsimple-112958647">Post-Anschrift</li>
                <li className="adsimple-112958647">Telefonnummer</li>
                <li className="adsimple-112958647">Geburtsdatum</li>
                <li className="adsimple-112958647">
                Kennnummern wie Sozialversicherungsnummer, Steueridentifikationsnummer,
                Personalausweisnummer oder Matrikelnummer
                </li>
                <li className="adsimple-112958647">
                Bankdaten wie Kontonummer, Kreditinformationen, Kontostände uvm.
                </li>
            </ul>
            <p>
                Laut Europäischem Gerichtshof (EuGH) zählt auch Ihre{" "}
                <strong className="adsimple-112958647 text-[#787c87]">
                IP-Adresse zu den personenbezogenen Daten
                </strong>
                . IT-Experten können anhand Ihrer IP-Adresse zumindest den ungefähren
                Standort Ihres Geräts und in weiterer Folge Sie als Anschlussinhabers
                feststellen. Daher benötigt auch das Speichern einer IP-Adresse eine
                Rechtsgrundlage im Sinne der DSGVO. Es gibt auch noch sogenannte{" "}
                <strong className="adsimple-112958647 text-[#787c87]">„besondere Kategorien“</strong> der
                personenbezogenen Daten, die auch besonders schützenswert sind. Dazu zählen:
            </p>
            <ul className="adsimple-112958647">
                <li className="adsimple-112958647">rassische und ethnische Herkunft</li>
                <li className="adsimple-112958647">politische Meinungen</li>
                <li className="adsimple-112958647">
                religiöse bzw. weltanschauliche Überzeugungen
                </li>
                <li className="adsimple-112958647">die Gewerkschaftszugehörigkeit</li>
                <li className="adsimple-112958647">
                genetische Daten wie beispielsweise Daten, die aus Blut- oder
                Speichelproben entnommen werden
                </li>
                <li className="adsimple-112958647">
                biometrische Daten (das sind Informationen zu psychischen, körperlichen
                oder verhaltenstypischen Merkmalen, die eine Person identifizieren
                können).
                <br />
                Gesundheitsdaten
                </li>
                <li className="adsimple-112958647">
                Daten zur sexuellen Orientierung oder zum Sexualleben
                </li>
            </ul>
            <h2 id="profiling" className="adsimple-112958647">
                Profiling
            </h2>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Begriffsbestimmung nach Artikel 4 der DSGVO
                </strong>
            </p>
            <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
            <blockquote>
                <p>
                <em>
                    <strong className="adsimple-112958647 text-[#787c87]">„Profiling“</strong> jede Art der
                    automatisierten Verarbeitung personenbezogener Daten, die darin besteht,
                    dass diese personenbezogenen Daten verwendet werden, um bestimmte
                    persönliche Aspekte, die sich auf eine natürliche Person beziehen, zu
                    bewerten, insbesondere um Aspekte bezüglich Arbeitsleistung,
                    wirtschaftliche Lage, Gesundheit, persönliche Vorlieben, Interessen,
                    Zuverlässigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser
                    natürlichen Person zu analysieren oder vorherzusagen;
                </em>
                </p>
            </blockquote>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Erläuterung:</strong> Beim Profiling
                werden verschiedene Informationen über eine Person zusammengetragen, um
                daraus mehr über diese Person zu erfahren. Im Webbereich wird Profiling
                häufig für Werbezwecke oder auch für Bonitätsprüfungen angewandt. Web- bzw.
                Werbeanalyseprogramme sammeln zum Beispiel Daten über Ihre Verhalten und
                Ihre Interessen auf einer Website. Daraus ergibt sich ein spezielles
                Userprofil, mit dessen Hilfe Werbung gezielt an eine Zielgruppe ausgespielt
                werden kann.
            </p>
            <p>&nbsp;</p>
            <h2 id="verantwortlicher" className="adsimple-112958647">
                Verantwortlicher
            </h2>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Begriffsbestimmung nach Artikel 4 der DSGVO
                </strong>
            </p>
            <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
            <blockquote>
                <p>
                <em>
                    <strong className="adsimple-112958647 text-[#787c87]">„Verantwortlicher“</strong> die
                    natürliche oder juristische Person, Behörde, Einrichtung oder andere
                    Stelle, die allein oder gemeinsam mit anderen über die Zwecke und Mittel
                    der Verarbeitung von personenbezogenen Daten entscheidet; sind die
                    Zwecke und Mittel dieser Verarbeitung durch das Unionsrecht oder das
                    Recht der Mitgliedstaaten vorgegeben, so kann der Verantwortliche
                    beziehungsweise können die bestimmten Kriterien seiner Benennung nach
                    dem Unionsrecht oder dem Recht der Mitgliedstaaten vorgesehen werden;
                </em>
                </p>
            </blockquote>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Erläuterung:</strong> In unserem Fall
                sind wir für die Verarbeitung Ihrer personenbezogenen Daten verantwortlich
                und folglich der “Verantwortliche”. Wenn wir erhobene Daten zur Verarbeitung
                an andere Dienstleister weitergeben, sind diese “Auftragsverarbeiter”. Dafür
                muss ein “Auftragsverarbeitungsvertrag (AVV)” unterzeichnet werden.
            </p>
            <p>&nbsp;</p>
            <h2 id="verarbeitung" className="adsimple-112958647">
                Verarbeitung
            </h2>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                Begriffsbestimmung nach Artikel 4 der DSGVO
                </strong>
            </p>
            <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
            <blockquote>
                <p>
                <strong className="adsimple-112958647 text-[#787c87]">
                    <em>„Verarbeitung“</em>
                </strong>
                <em>
                    {" "}
                    jeden mit oder ohne Hilfe automatisierter Verfahren ausgeführten Vorgang
                    oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen
                    Daten wie das Erheben, das Erfassen, die Organisation, das Ordnen, die
                    Speicherung, die Anpassung oder Veränderung, das Auslesen, das Abfragen,
                    die Verwendung, die Offenlegung durch Übermittlung, Verbreitung oder
                    eine andere Form der Bereitstellung, den Abgleich oder die Verknüpfung,
                    die Einschränkung, das Löschen oder die Vernichtung;
                </em>
                </p>
            </blockquote>
            <p>
                <strong className="adsimple-112958647 text-[#787c87]">Anmerkung: </strong>Wenn wir in
                unserer Datenschutzerklärung von Verarbeitung sprechen, meinen wir damit
                jegliche Art von Datenverarbeitung. Dazu zählt, wie oben in der originalen
                DSGVO-Erklärung erwähnt, nicht nur das Erheben sondern auch das Speichern
                und Verarbeiten von Daten.
            </p>
            <h2 id="schlusswort" className="adsimple-112958647">
                Schlusswort
            </h2>
            <p>
                Herzlichen Glückwunsch! Wenn Sie diese Zeilen lesen, haben Sie sich wirklich
                durch unsere gesamte Datenschutzerklärung „gekämpft“ oder zumindest bis hier
                hin gescrollt. Wie Sie am Umfang unserer Datenschutzerklärung sehen, nehmen
                wir den Schutz Ihrer persönlichen Daten, alles andere als auf die leichte
                Schulter.
                <br />
                Uns ist es wichtig, Sie nach bestem Wissen und Gewissen über die
                Verarbeitung personenbezogener Daten zu informieren. Dabei wollen wir Ihnen
                aber nicht nur mitteilen, welche Daten verarbeitet werden, sondern auch die
                Beweggründe für die Verwendung diverser Softwareprogramme näherbringen. In
                der Regel klingen Datenschutzerklärung sehr technisch und juristisch. Da die
                meisten von Ihnen aber keine Webentwickler oder Juristen sind, wollten wir
                auch sprachlich einen anderen Weg gehen und den Sachverhalt in einfacher und
                klarer Sprache erklären. Immer ist dies natürlich aufgrund der Thematik
                nicht möglich. Daher werden die wichtigsten Begriffe am Ende der
                Datenschutzerklärung näher erläutert.
                <br />
                Bei Fragen zum Thema Datenschutz auf unserer Website zögern Sie bitte nicht,
                uns oder die verantwortliche Stelle zu kontaktieren. Wir wünschen Ihnen noch
                eine schöne Zeit und hoffen, Sie auf unserer Website bald wieder begrüßen zu
                dürfen.
            </p>
            <p>Alle Texte sind urheberrechtlich geschützt.</p>
            <p style={{ marginTop: 15 }}>
                Quelle:{" "}
                <a
                href="https://www.adsimple.at/datenschutz-generator/"
                title="Datenschutzerklärung Generator Österreich"
                >
                Datenschutzerklärung
                </a>{" "}
                erstellt mit dem Datenschutz Generator für Österreich von AdSimple
            </p>
        </>
      </section>
      <FooterWrapper />
    </div>
  );
};

export default Datenschutz;